export const ABOUTUS = {
  _id: "mypage",
  title: "About Us",
  title_ar: "About Us",
  slug: "about-us",
  layout: "default",
  metaTitle: "About DHA",
  metaDescription: "About DHA",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "static_home",
      classname: "container",
      props: {
        bannerCard: [
          {
            banner_card_id: "for_individuals",
            type: "G-C",
            image_src:
              "/attachments/medialib/d52536a8-310e-42c6-a80b-2f90182754b3-1758786348892-863265438-health_individual.svg",
            banner_card_href: "javascript:void(0)",
            image_alt: "for_individuals",
            banner_card_title: "For Individuals",
            banner_card_title_ar: "خدمات الأفراد",
            banner_card_description:
              "Access a comprehensive range of educational, medical, and research services.",
            banner_card_description_ar: "احصل على مجموعة متكاملة من التعليمية والطبية والبحثية",
            detail: [
              {
                image_src:
                  "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                header_text: "Request for Overseas Treatment Services",
                header_text_ar: "طلب خدمات العلاج في الخارج",
                left_button_name: "View Service",
                left_button_name_ar: "عرض الخدمة",
                left_button_href: "https://example.com/1",
              },
            ],
          },
          {
            banner_card_id: "For_Health_Professionals",
            type: "G-G",
            banner_card_href: "javascript:void(0)",
            image_alt: "for_health_professionals",
            image_src:
              "/attachments/medialib/cb4b7101-9d76-441c-8c24-7ca1e7afdb30-1758786355042-508993476-health_professional.svg",
            banner_card_title: "For Health Professionals",
            banner_card_title_ar: "خدمات المهنيين الصحيين",
            banner_card_description:
              "Empower your career with proper licensing and training",
            banner_card_description_ar:
              "تابع مسيرتك المهنية بالترخيص والتدريب الملائمين",
            detail: [
              {
                image_src:
                  "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                header_text: "Activate Professional license",
                header_text_ar: "تفعيل الرخصة المهنية",
                left_button_name: "View Service",
                left_button_name_ar: "عرض الخدمة",
                left_button_href: "https://example.com/1",
              },
            ],
          },
          {
            banner_card_id: "for_health_acilities",
            type: "G-F",
            image_src:
              "/attachments/medialib/e39fdc0c-6bf3-4481-a976-666baeb4fdb7-1758786360770-729109822-health_facilities.svg",
            banner_card_href: "javascript:void(0)",
            image_alt: "for_health_acilities",
            banner_card_title: "For Health Facilities",
            banner_card_title_ar: "خدمات المنشآت الصحية",
            banner_card_description:
              "Ensure your facility meets top quality and safety standards",
            banner_card_description_ar:
              "اعتمد منشأتك الصحية وفق أفضل معايير الجودة والسلامة",
            detail: [
              {
                image_src:
                  "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                header_text: "Amend Facility License",
                header_text_ar: "تعديل ترخيص المنشأة",
                left_button_name: "View Service",
                left_button_name_ar: "عرض الخدمة",
                left_button_href: "https://example.com/1",
              },
            ],
          },
          {
            banner_card_id: "for_government_entities",
            type: "G-CP",
            image_src:
              "/attachments/medialib/db74e191-a05e-4984-9d0a-ed6c8b6e99eb-1758786342828-536887505-health_gov.svg",
            banner_card_href: "javascript:void(0)",
            image_alt: "for_government_entities",
            banner_card_title: "For Government Entities",
            banner_card_title_ar: "خدمات الجهات الحكومية",
            banner_card_description:
              "Collaborate with us to deliver better community services",
            banner_card_description_ar:
              "نتعاون معنا لتقديم أفضل الخدمات للمجتمع",
            detail: [
              {
                image_src:
                  "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                header_text:
                  "Medically Auditing applications of car window tinting",
                header_text_ar:
                  "التدقيق الطبي على تطبيقات تظليل نوافذ السيارات",
                left_button_name: "View Service",
                left_button_name_ar: "عرض الخدمة",
                left_button_href: "https://example.com/1",
              },
            ],
          },
          {
            banner_card_id: "for_businesses_corporates",
            type: "G-B",
            image_src:
              "/attachments/medialib/f0f209f3-2ffe-4c3a-9329-9395c56500ac-1758786330908-355306769-health_businesses.svg",
            banner_card_href: "javascript:void(0)",
            image_alt: "for_businesses_corporates",
            banner_card_title: "For Businesses & Corporates",
            banner_card_title_ar: "خدمات الأعمال والشركات",
            banner_card_description:
              "Access regulatory, licensing, and support services for corporates",
            banner_card_description_ar:
              "خدمات تنظيم وترخيص ودعم للشركات والأعمال",
            detail: [
              {
                image_src:
                  "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                header_text:
                  "Request to announce educational and training programs",
                header_text_ar: "طلب الإعلان عن البرامج التعليمية والتدريبية",
                left_button_name: "View Service",
                left_button_name_ar: "عرض الخدمة",
                left_button_href: "https://example.com/1",
              },
            ],
          },
        ],
      },
      // children: [
      //   {
      //     _id: "block10",
      //     type: "div",
      //     classname: "my-6",
      //     children: [
      //       {
      //         _id: "block2",
      //         type: "image",
      //         src: "01_About DHA - Overview.jpg", //heromain
      //         size: "fullwidth",
      //         classname:
      //           "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
      //         alt: "This is a description for the page......",
      //       },
      //     ],
      //   },
      //   {
      //     _id: "block3",
      //     type: "heading",
      //     size: "h2",
      //     text: "Welcome to the page",
      //     text_ar: "Welcome to the page Ar",
      //     classname: "md:!mb-4 mb-2 Medium  text-primary",
      //   },
      //   {
      //     _id: "block4",
      //     type: "heading",
      //     size: "h5",
      //     classname: "Regular text-onSurfaceVariant body",
      //     text: "Dubai Health Authority (DHA) provides complete oversight of the regulation and governance of the healthcare sector within the emirate of Dubai by designing health policies, strategies and standards for developing, regulating, licensing and monitoring the provision of healthcare services provided by the public and private healthcare facilities. DHA mandate also includes governing and managing health insurance, health investment, and health tourism services in the emirate in a way that stimulates steady health economic growth and enhances the health sector's contribution to Dubai's macroeconomic indicators. Furthermore, DHA is responsible for formulating and implementing Public Health policies and programmes in Preventive Medicine and Occupational Health and Safety in a structured manner that ensures protecting and improving the health of Dubai's Population. DHA is also accountable for setting the Medical Education Strategy in Dubai and regulating the provision of medical education, clinical research and trials in coordination with the relevant authorities locally and globally.",
      //     text_ar:
      //       "Ar Dubai Health Authority (DHA) provides complete oversight of the regulation and governance of the healthcare sector within the emirate of Dubai by designing health policies, strategies and standards for developing, regulating, licensing and monitoring the provision of healthcare services provided by the public and private healthcare facilities. DHA mandate also includes governing and managing health insurance, health investment, and health tourism services in the emirate in a way that stimulates steady health economic growth and enhances the health sector's contribution to Dubai's macroeconomic indicators. Furthermore, DHA is responsible for formulating and implementing Public Health policies and programmes in Preventive Medicine and Occupational Health and Safety in a structured manner that ensures protecting and improving the health of Dubai's Population. DHA is also accountable for setting the Medical Education Strategy in Dubai and regulating the provision of medical education, clinical research and trials in coordination with the relevant authorities locally and globally.",
      //   },
      //   {
      //     _id: "block5",
      //     type: "div",
      //     classname: "grid md:grid-cols-2 gap-5 md:!mt-12",
      //     children: [
      //       {
      //         _id: "block6",
      //         type: "div",
      //         classname: "",
      //         children: [
      //           {
      //             _id: "block7",
      //             type: "heading",
      //             size: "h4",
      //             text: "Mission",
      //             text_ar: "Ar Mission",
      //             classname: "text-primary",
      //           },
      //           {
      //             _id: "block8",
      //             type: "custom_components",
      //             custom_components: "TestimonialCard",
      //             text: "Vision",
      //             text_ar: "Ar Vision",
      //             props: {
      //               bg: "#E4EFF3",
      //               icon_library: "material", // material || fas
      //               icon: "visibility", //for material
      //               icon_type: "outlined", // for material
      //               description:
      //                 "Dubai the homeland pioneering in health, happiness and prosperity",
      //               description_ar:
      //                 "Dubai the homeland pioneering in health, happiness and prosperity",
      //             },
      //           },
      //         ],
      //       },
      //       {
      //         _id: "block6",
      //         type: "div",
      //         classname: "",
      //         children: [
      //           {
      //             _id: "block7",
      //             type: "heading",
      //             size: "h4",
      //             text: "Vision",
      //             text_ar: "Ar Vision",
      //             classname: "text-primary",
      //           },
      //           {
      //             _id: "block8",
      //             type: "custom_components",
      //             custom_components: "TestimonialCard",
      //             text: "Vision",
      //             text_ar: " Ar Vision",
      //             props: {
      //               bg: "#E4EFF3",
      //               icon_library: "material", // material || fas
      //               icon: "radar",
      //               icon_type: "outlined", //outlined, rounded, shar
      //               description:
      //                 "Transforming Dubai into a leading healthcare destination by advancing public health and prevention, ensuring universal access to high-value healthcare, and fostering innovation and research.",
      //               description_ar:
      //                 "Transforming Dubai into a leading healthcare destination by advancing public health and prevention, ensuring universal access to high-value healthcare, and fostering innovation and research.",
      //             },
      //           },
      //         ],
      //       },
      //       {
      //         _id: "block9",
      //         type: "heading",
      //         size: "h4",
      //         classname: "text-primary",
      //         text: "Values",
      //         text_ar: "Ar Values",
      //       },
      //     ],
      //   },
      //   {
      //     _id: "block10",
      //     type: "div",
      //     classname:
      //       "grid lg:grid-cols-5 sm:grid-cols-3 grid-cols-2 gap-5 md:!mb-12",
      //     children: [
      //       {
      //         _id: "block6",
      //         type: "div",
      //         classname: "",
      //         children: [
      //           {
      //             _id: "block8",
      //             type: "custom_components",
      //             custom_components: "TestimonialCard",
      //             text: "Vision",
      //             text_ar: "Ar Vision",
      //             props: {
      //               bg: "#FFFFFF",
      //               icon: "groups",
      //               icon_library: "material", // material || fas
      //               icon_type: "outlined",
      //               description: "Human Centered Health Care",
      //               description_ar: "Ar Human Centered Health Care",
      //             },
      //           },
      //         ],
      //       },
      //       {
      //         _id: "block6",
      //         type: "div",
      //         classname: "",
      //         children: [
      //           {
      //             _id: "block8",
      //             type: "custom_components",
      //             custom_components: "TestimonialCard",
      //             text: "Vision",
      //             text_ar: "Ar Vision",
      //             props: {
      //               bg: "#FFFFFF",
      //               icon_library: "material", // material || fas
      //               icon: "manage_accounts",
      //               icon_type: "outlined", //outlined, rounded, sharp
      //               description: "Accountability",
      //               description_ar: "Ar Accountability",
      //             },
      //           },
      //         ],
      //       },
      //       {
      //         _id: "block6",
      //         type: "div",
      //         classname: "",
      //         children: [
      //           {
      //             _id: "block8",
      //             type: "custom_components",
      //             custom_components: "TestimonialCard",
      //             text: "Vision",
      //             text_ar: "Ar Vision",
      //             props: {
      //               bg: "#FFFFFF",
      //               icon: "camera",
      //               icon_library: "material", // material || fas
      //               icon_type: "outlined", //outlined, rounded, sharp
      //               description: "Transparency",
      //               description_ar: "Ar Transparency",
      //             },
      //           },
      //         ],
      //       },
      //       {
      //         _id: "block6",
      //         type: "div",
      //         classname: "",
      //         children: [
      //           {
      //             _id: "block8",
      //             type: "custom_components",
      //             custom_components: "TestimonialCard",
      //             text: "Vision",
      //             text_ar: "Ar Vision",
      //             props: {
      //               bg: "#FFFFFF",
      //               icon: "light_mode",
      //               icon_library: "material", // material || fas
      //               icon_type: "outlined", //outlined, rounded, sharp
      //               description: "Resilience",
      //               description_ar: "Ar Resilience",
      //             },
      //           },
      //         ],
      //       },

      //       {
      //         _id: "block6",
      //         type: "div",
      //         classname: "",
      //         children: [
      //           {
      //             _id: "block8",
      //             type: "custom_components",
      //             custom_components: "TestimonialCard",
      //             text: "Vision",
      //             text_ar: "Ar Vision",
      //             props: {
      //               bg: "#FFFFFF",
      //               icon: "lightbulb",
      //               icon_library: "material", // material || fas
      //               icon_type: "outlined", //outlined, rounded, sharp
      //               description: "Innovation",
      //               description_ar: "Ar Innovation",
      //             },
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     _id: "block3",
      //     type: "heading",
      //     size: "h2",
      //     text: "Director General's Message",
      //     text_ar: "Ar Director General's Message",
      //     classname: "text-primary md:!my-4 my-2",
      //   },
      //   {
      //     _id: "block10",
      //     type: "div",
      //     classname: "lg:flex bg-white rounded-2xl items-center gap-8",
      //     children: [
      //       {
      //         _id: "block2",
      //         type: "image",
      //         src: "DHA-CEO.jpg",
      //         size: "fullwidth",
      //         classname:
      //           "lg:w-2/5 sm:w-3/5  lg:h-1/2  max-h-[580px] object-cover rounded-xl",
      //         alt: "This is a description for the page......",
      //       },
      //       {
      //         _id: "block10",
      //         type: "div",
      //         classname: "flex-1",
      //         children: [
      //           {
      //             _id: "block3",
      //             type: "heading",
      //             size: "h5",
      //             text: "Awadh Seghayer Al Ketbi",
      //             text_ar: "Ar Awadh Seghayer Al Ketbi",
      //             classname: "mb-1",
      //           },
      //           {
      //             _id: "block3",
      //             type: "paragraph",
      //             size: "normal",
      //             text: "Director-General of the Dubai Health Authority",
      //             text_ar: "Ar Director-General of the Dubai Health Authority",
      //             classname: "text-primary body block mb-2",
      //           },
      //           {
      //             _id: "block3",
      //             type: "paragraph",
      //             size: "normal",
      //             text: " The creative minds of our people are the true wealth and driving force behind the remarkable developments and achievements that the UAE and the global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country. Therefore, the authority spares no effort in utilizing the minds of our experienced medical and administrative staff to maintain a happy and healthy society. It is our responsibility to continue on moving forward to reach our goal of making Dubai the preferred global destination for medical treatment and fulfilling the vision of His Highness Shaikh Mohammad Bin Rashid Al Maktoum, Vice President and Prime Minister of the UAE and Ruler of Dubai, of providing a safe heaven for residents and visitors of the city.​​​​​​ Reaching this goal is a natural ambition for Dubai, the flourishing city, which has become a home to people from all over the world, who were inspired by its vision and want to join its movement towards progression. We believe that we are all responsible for the health and safety of our people and are confident in the capabilities of those concerned in the health sector—be it members of our society or public and private organizations—in fulfilling these desired goals. May ‘fruitful partnerships’ be our motto, ‘continuous giving’ be our work ethic and ‘determination’ be the principle that will drive us to perform our mission and national duty in the best way possible",
      //             text_ar:
      //               "Ar The creative minds of our people are the true wealth and driving force behind the remarkable developments and achievements that the UAE and the global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country. Therefore, the authority spares no effort in utilizing the minds of our experienced medical and administrative staff to maintain a happy and healthy society. It is our responsibility to continue on moving forward to reach our goal of making Dubai the preferred global destination for medical treatment and fulfilling the vision of His Highness Shaikh Mohammad Bin Rashid Al Maktoum, Vice President and Prime Minister of the UAE and Ruler of Dubai, of providing a safe heaven for residents and visitors of the city.​​​​​​ Reaching this goal is a natural ambition for Dubai, the flourishing city, which has become a home to people from all over the world, who were inspired by its vision and want to join its movement towards progression. We believe that we are all responsible for the health and safety of our people and are confident in the capabilities of those concerned in the health sector—be it members of our society or public and private organizations—in fulfilling these desired goals. May ‘fruitful partnerships’ be our motto, ‘continuous giving’ be our work ethic and ‘determination’ be the principle that will drive us to perform our mission and national duty in the best way possible",
      //             classname: "text-onSurfaceVariant body mb-4",
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     _id: "block3",
      //     type: "heading",
      //     size: "h2",
      //     text: "Strategic Partners",
      //     text_ar: "Ar Strategic Partners",
      //     classname: "text-primary md:!my-4 my-2",
      //   },
      //   {
      //     _id: "block3",
      //     type: "heading",
      //     size: "h5",
      //     text: " We’re proud to be used by the biggest and best players in the game. Here are only a couple of the companies we’re proud to call our Partners.",
      //     text_ar:
      //       "Ar We’re proud to be used by the biggest and best players in the game. Here are only a couple of the companies we’re proud to call our Partners.",
      //     classname: "text-onSurfaceVariant",
      //   },
      //   {
      //     _id: "block10",
      //     type: "div",
      //     classname:
      //       "grid lg:grid-cols-5 md:grid-cols-3 grid-cols-2 gap-4 my-4",
      //     children: [
      //       {
      //         _id: "block4",
      //         type: "dda-team-member-card",
      //         props: {
      //           image_src: "",
      //           team_member_name: "",
      //           team_member_position: "",
      //           team_member_position_ar: "",
      //           design: "default",
      //           custom_class: "",
      //           component_mode: "",
      //         },
      //       },
      //     ],
      //   },
      //   {
      //     _id: "block4",
      //     type: "review",
      //   },
      // ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "About DHA", icon: "menu_book", url: "" },
  ],
};

export const OurLeaders = {
  _id: "mypage",
  title: "Drug Control",
  title_ar: "Drug Control",
  slug: "about-us",
  layout: "default",
  metaTitle: "Drug Control",
  metaDescription: "Drug Control",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Our Leaders",
          text_ar: "Our Leaders",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block8",
          type: "custom_components",
          custom_components: "TeamMemberCard",
          props: {
            image: "DHA-CEO.jpg",
            name: "Awadh Seghayer Al Ketbi",
            name_ar: "Awadh Seghayer Al Ketbi",
            title: {
              text: "Director-General of the Dubai Health Authority",
              text_ar: "Director-General of the Dubai Health Authority",
              url: "#",
            },
            // title_ar: {
            //   text: "Director-General of the Dubai Health Authority",
            //   text_ar: "Director-General of the Dubai Health Authority",
            //   url: "#",
            // },
            description:
              "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
            description_ar:
              "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
            links: [
              {
                url: "#",
                label: "Website",
                label_ar: "Website",
                icon_library: "fas", // material || fas
                icon: `<svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 256 256"
                      class="text-white bg-black rounded-full p-1 text-2xl"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M214.75,211.71l-62.6-98.38,61.77-67.95a8,8,0,0,0-11.84-10.76L143.24,99.34,102.75,35.71A8,8,0,0,0,96,32H48a8,8,0,0,0-6.75,12.3l62.6,98.37-61.77,68a8,8,0,1,0,11.84,10.76l58.84-64.72,40.49,63.63A8,8,0,0,0,160,224h48a8,8,0,0,0,6.75-12.29ZM164.39,208,62.57,48h29L193.43,208Z"></path>
                    </svg>`,
              },
              {
                url: "#",
                label: "Facebook",
                label_ar: "Facebook",
                icon_library: "fas", // material || fas
                icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg>`,
                // <i class="fa-brands fa-facebook text-white bg-black rounded-full p-1 text-2xl"></i>
              },
              {
                url: "#",
                label: "LinkedIn",
                label_ar: "LinkedIn",
                icon_library: "fas", // material || fas
                icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-md p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>`,
              },
              {
                url: "#",
                label: "Telegram",
                label_ar: "Telegram",
                icon_library: "fas", // material || fas
                icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>`,
              },
            ],
          },
        },
        {
          _id: "block10",
          type: "div",
          classname: "grid xl:grid-cols-2 mt-5 gap-5",
          children: [
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "TeamMemberCard",
              props: {
                image: "Saleh Al Hashimi.png",
                name: "Saleh Al Hashimi",
                name_ar: "Saleh Al Hashimi",
                title: {
                  text: "CEO of Health Regulation Sector",
                  text_ar: "CEO of Health Regulation Sector",
                  url: "#",
                },
                // title_ar: {
                //   text: "CEO of Health Regulation Sector",
                //   text_ar: "CEO of Health Regulation Sector",
                //   url: "#",
                // },
                description:
                  "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
                description_ar:
                  "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
                links: [
                  {
                    url: "#",
                    label: "Website",
                    label_ar: "Website",
                    icon_library: "fas", // material || fas
                    icon: `<svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 256 256"
                      class="text-white bg-black rounded-full p-1 text-2xl"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M214.75,211.71l-62.6-98.38,61.77-67.95a8,8,0,0,0-11.84-10.76L143.24,99.34,102.75,35.71A8,8,0,0,0,96,32H48a8,8,0,0,0-6.75,12.3l62.6,98.37-61.77,68a8,8,0,1,0,11.84,10.76l58.84-64.72,40.49,63.63A8,8,0,0,0,160,224h48a8,8,0,0,0,6.75-12.29ZM164.39,208,62.57,48h29L193.43,208Z"></path>
                    </svg>`,
                  },
                  {
                    url: "#",
                    label: "Facebook",
                    label_ar: "Facebook",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg>`,
                    // <i class="fa-brands fa-facebook text-white bg-black rounded-full p-1 text-2xl"></i>
                  },
                  {
                    url: "#",
                    label: "LinkedIn",
                    label_ar: "LinkedIn",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-md p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>`,
                  },
                  {
                    url: "#",
                    label: "Telegram",
                    label_ar: "Telegram",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>`,
                  },
                ],
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "TeamMemberCard",
              props: {
                image: "Dr. Marwan Al Mulla.png",
                name: "Dr. Marwan Al Mulla",
                name_ar: "Dr. Marwan Al Mulla",
                title: {
                  text: "CEO of Health Regulation Sector",
                  text_ar: "CEO of Health Regulation Sector",
                  url: "#",
                },
                // title_ar: {
                //   text: "CEO of Health Regulation Sector",
                //   text_ar: "CEO of Health Regulation Sector",
                //   url: "#",
                // },
                description:
                  "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
                description_ar:
                  "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
                links: [
                  {
                    url: "#",
                    label: "Website",
                    label_ar: "Website",
                    icon_library: "fas", // material || fas
                    icon: `<svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 256 256"
                      class="text-white bg-black rounded-full p-1 text-2xl"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M214.75,211.71l-62.6-98.38,61.77-67.95a8,8,0,0,0-11.84-10.76L143.24,99.34,102.75,35.71A8,8,0,0,0,96,32H48a8,8,0,0,0-6.75,12.3l62.6,98.37-61.77,68a8,8,0,1,0,11.84,10.76l58.84-64.72,40.49,63.63A8,8,0,0,0,160,224h48a8,8,0,0,0,6.75-12.29ZM164.39,208,62.57,48h29L193.43,208Z"></path>
                    </svg>`,
                  },
                  {
                    url: "#",
                    label: "Facebook",
                    label_ar: "Facebook",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg>`,
                    // <i class="fa-brands fa-facebook text-white bg-black rounded-full p-1 text-2xl"></i>
                  },
                  {
                    url: "#",
                    label: "LinkedIn",
                    label_ar: "LinkedIn",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-md p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>`,
                  },
                  {
                    url: "#",
                    label: "Telegram",
                    label_ar: "Telegram",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>`,
                  },
                ],
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "TeamMemberCard",
              props: {
                image: "Mona Bajman.png",
                name: "Mona Bajman",
                name_ar: "Mona Bajman",
                title: {
                  text: "CEO of Corporate Shared Support Services Sector",
                  text_ar: "CEO of Corporate Shared Support Services Sector",
                  url: "#",
                },
                // title_ar: {
                //   text: "CEO of Corporate Shared Support Services Sector",
                //   text_ar: "CEO of Corporate Shared Support Services Sector",
                //   url: "#",
                // },
                description:
                  "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
                description_ar:
                  "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
                links: [
                  {
                    url: "#",
                    label: "Website",
                    label_ar: "Website",
                    icon_library: "fas", // material || fas
                    icon: `<svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 256 256"
                      class="text-white bg-black rounded-full p-1 text-2xl"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M214.75,211.71l-62.6-98.38,61.77-67.95a8,8,0,0,0-11.84-10.76L143.24,99.34,102.75,35.71A8,8,0,0,0,96,32H48a8,8,0,0,0-6.75,12.3l62.6,98.37-61.77,68a8,8,0,1,0,11.84,10.76l58.84-64.72,40.49,63.63A8,8,0,0,0,160,224h48a8,8,0,0,0,6.75-12.29ZM164.39,208,62.57,48h29L193.43,208Z"></path>
                    </svg>`,
                  },
                  {
                    url: "#",
                    label: "Facebook",
                    label_ar: "Facebook",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg>`,
                    // <i class="fa-brands fa-facebook text-white bg-black rounded-full p-1 text-2xl"></i>
                  },
                  {
                    url: "#",
                    label: "LinkedIn",
                    label_ar: "LinkedIn",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-md p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>`,
                  },
                  {
                    url: "#",
                    label: "Telegram",
                    label_ar: "Telegram",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>`,
                  },
                ],
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "TeamMemberCard",
              props: {
                image: "Fatima Abbas.png",
                name: "Fatima Abbas",
                name_ar: "Fatima Abbas",
                title: {
                  text: "CEO of Strategy & Corporate Development Sector",
                  text_ar: "CEO of Strategy & Corporate Development Sector",
                  url: "#",
                },
                // title_ar: {
                //   text: "CEO of Strategy & Corporate Development Sector",
                //   text_ar: "CEO of Strategy & Corporate Development Sector",
                //   url: "#",
                // },
                description:
                  "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
                description_ar:
                  "The creative minds of our people are the true wealth and driving force. The global city of Dubai have witnessed in the last few years. Dubai Health Authority is aware that developing and taking care of these creative minds is vital, as they are the driving force behind the continuous growth of our country.",
                links: [
                  {
                    url: "#",
                    label: "Website",
                    label_ar: "Website",
                    icon_library: "fas", // material || fas
                    icon: `<svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 256 256"
                      class="text-white bg-black rounded-full p-1 text-2xl"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M214.75,211.71l-62.6-98.38,61.77-67.95a8,8,0,0,0-11.84-10.76L143.24,99.34,102.75,35.71A8,8,0,0,0,96,32H48a8,8,0,0,0-6.75,12.3l62.6,98.37-61.77,68a8,8,0,1,0,11.84,10.76l58.84-64.72,40.49,63.63A8,8,0,0,0,160,224h48a8,8,0,0,0,6.75-12.29ZM164.39,208,62.57,48h29L193.43,208Z"></path>
                    </svg>`,
                  },
                  {
                    url: "#",
                    label: "Facebook",
                    label_ar: "Facebook",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg>`,
                    // <i class="fa-brands fa-facebook text-white bg-black rounded-full p-1 text-2xl"></i>
                  },
                  {
                    url: "#",
                    label: "LinkedIn",
                    label_ar: "LinkedIn",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-md p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>`,
                  },
                  {
                    url: "#",
                    label: "Telegram",
                    label_ar: "Telegram",
                    icon_library: "fas", // material || fas
                    icon: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" class="text-white bg-black rounded-full p-1 text-2xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>`,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "Our Leaders", icon: "menu_book", url: "/aboutus/ourleaders" },
  ],
};

export const CustomerHappinessCharater = {
  _id: "mypage",
  title: "Customer Happiness Center",
  title_ar: "Customer Happiness Center",
  slug: "about-us",
  layout: "default",
  metaTitle: "Customer Happiness Center",
  metaDescription: "Customer Happiness Center",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block2",
          type: "image",
          src: "/attachments/medialib/996db650-6aef-459c-a8e2-05c9d1f27cf0-1755257425532-953194143-01_About DHA - Overview.jpg",
          size: "fullwidth",
          classname: "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
          alt: "This is a description for the page......",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Customer Happiness Charter",
          text_ar: "ميثاق سعادة المتعاملين",
          classname: "md:!mb-4 mb-3 Medium  text-primary",
        },
        {
          _id: "block3",
          type: "paragraph",
          size: "normal",
          text: "Dubai Health Authority is keen on providing excellent and proactive services to achieve customer happiness and exceed their expectations",
          text_ar:
            "تحرص هيئة الصحة بدبي على توفير وتقديم خدمات متميزة واستباقية تحقق رضا وسعادة المتعاملين وتفوق توقعاتهم، وذلك عبر حزمة من القنوات المتنوعة وفي الأوقات المناسبة.",
          classname: "md:!my-4 my-2 Regular text-onSurfaceVariant",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h6",
          text: "We are committed to your happiness:",
          text_ar: "نلـتــزم بإســعــادكــم مــن خــلال:",
          classname: "text-primary Medium",
        },
        {
          _id: "block10",
          type: "div",
          classname:
            "grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-3 md:!my-4 my-2",
          children: [
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will treat you with courtesy, respect, and a smile.",
                team_member_position_ar: "التعامل معكم باهتمام واحترام وبشاشة.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "You will receive high standards of care and a fair service.",
                team_member_position_ar: "تقديم خدمة متميزة وعادلة.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will treat people of determination, with the highest level of service.",
                team_member_position_ar:
                  "التعامل مع أصحاب الهمم وفق أعلى مستويات تقديم الخدمة.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will cater to your needs professionally and to the best of our ability to meet your expectations.",
                team_member_position_ar:
                  "التعامل مع احتياجاتكم وتوقعاتكم بمهنية وبذل أقصى ما بوسعنا لتلبيتها.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will provide our services through a cooperative, knowledgeable staff that can fulfill your needs.",
                team_member_position_ar:
                  "تقديم خدماتنا من خلال فريق عمل متعاون يتمتع بالمعرفة والقدرة على تلبية احتياجاتكم.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will respond to your requests in a timely manner and without delay.",
                team_member_position_ar:
                  "الاستجابة لطلباتكم في الوقت المحدد ودون تأخير.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will reduce the number of steps required to complete a service in the easiest and most efficient manner.",
                team_member_position_ar:
                  "تقليص عدد الإجراءات لنوفر لكم خدمة سريعة وسلسة.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will provide accurate information on the services required and the completion dates.",
                team_member_position_ar:
                  "توفير معلومات دقيقة عن متطلبات الخدمة ومواعيد إنجازها.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will provide you with a multi-channel service and ensure that we serve at your convenience, whenever possible.",
                team_member_position_ar:
                  "توفير الخدمات في الأوقات المناسبة وعبر القنوات الملائمة لكم قدر الإمكان.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We are committed towards the privacy of your information and data.",
                team_member_position_ar:
                  "ضمان خصوصية المعلومات والبيانات الخاصة بكم.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will communicate with you via social media channels and smart channels in a professional and confidential manner.",
                team_member_position_ar:
                  "التعامل معكم من خلال قنوات التواصل الاجتماعي والقنوات الذكية بخصوصية تامة واحترافية عالية.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "If you are not satisfied with the complaint settlement, you can lodge a grievance and we will respond within 8 business days.",
                team_member_position_ar:
                  "في حالة عدم رضاكم عن حل الشكوى يمكنكم رفع تظلم، وسيتم الرد عليكم خلال 8 أيام عمل.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We will deliver smart and high quality services that exceed your expectations.",
                team_member_position_ar:
                  "سنقدم لكم خدمة ذكية عالية الجودة تفوق توقعاتكم.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We commit to provide a safe environment free from any violent or aggressive behaviour.",
                team_member_position_ar:
                  "التزامنا بتوفير بيئة خالية تماماً من العنف والسلوك العدواني الجسدي واللفظي.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src:
                  "/attachments/medialib/e7544d79-6265-4688-ab0d-d6fbd5667c00-1755335316609-302968392-sentimentIcon.svg",
                team_member_position:
                  "We appreciate any suggestions, complaints, and feedback that you may have. Your input is valuable to us as we strive to improve our services. We are committed to addressing your suggestions within 15 business days and responding to your complaints and feedback within 5 business days.",
                team_member_position_ar:
                  "وسنلتزم بالرد على اقتراحاتكم خلال مدة أقصاها 15 يوم عمل، والرد على شكاويكم وملاحظاتكم خلال مدة أقصاها 5 أيام عمل.",
                design: "default",
                custom_class: "",
                component_mode: "",
              },
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h6",
          text: "What we expect from you to deliver services that make you happy:",
          text_ar: "ما نتـوقـعـه منـكم لتـوفـيـر خـدمـات تـحـقـق رضــاكـم:",
          classname: "text-primary Medium md:!my-4 my-2",
        },
        {
          _id: "block1",
          type: "div",
          classname:
            "lg:grid grid-cols-3 lg:divide-x-2 lg:divide-y-0 divide-y-2 divide-outline body",
          children: [
            {
              _id: "block3",
              type: "list",
              type_identifier: "ul",
              classname:
                "list-disc list-inside text-onSurfaceVariant  *:mb-3 lg:!pe-4",
              children: [
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "li",
                  text: "Appreciate efforts of staff members at your service and treat them with mutual respect.",
                  text_ar:
                    "تقدير جهود موظفينا في خدمتكم من خلال التعامل معهم باحترام متبادل.",
                  classname: "",
                },
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "li",
                  text: "Inform us immediately of any changes to information provided or in case of an error.",
                  text_ar:
                    "إعلامنا بأسرع وقت ممكن في حال وجود خطأ أو تعديل في البيانات.",
                  classname: "",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "ul",
              classname:
                "list-disc list-inside text-onSurfaceVariant *:mb-3 lg:!px-4 py-2 lg:!py-0",
              children: [
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "li",
                  text: "Inform us immediately of any changes that may affect service provision.",
                  text_ar:
                    "إبلاغنا بأي تغيير في المعلومات الشخصية أو الظروف المتعلقة بإتمام الخدمة.",
                  classname: "lg:!mt-0 mt-3",
                },
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "li",
                  text: "Respond in a timely manner to queries of staff to ensure timely service and quality.",
                  text_ar:
                    "الرد على استفسارات فريق سعادة المتعاملين ليتمكن من خدمتكم بشكل أفضل وفي الوقت المحدد.",
                  classname: "",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "ul",
              classname:
                "list-disc list-inside text-onSurfaceVariant *:mb-3 lg:!px-4 pt-2 lg:!pt-0",
              children: [
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "li",
                  text: "Respect the Authority and its employees and adhere to the conditions and rules for using social media channels and smart channels.",
                  text_ar:
                    "احترام الهيئة وموظفيها، والالتزام بشروط وقواعد استخدام قنوات التواصل الاجتماعي والقنوات الذكية.",
                  classname: "lg:!mt-0 mt-3",
                },
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "li",
                  text: "Respect DHA employees, as any act or assault will lead to legal action.",
                  text_ar:
                    "احترام موظفي الهيئة، حيث إن أي تصرف أو اعتداء سيعرضكم للمساءلة القانونية.",
                  classname: "",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "About DHA", icon: "menu_book", url: "/aboutus" },
    {
      text: "Customer Happiness Charter",
      icon: "menu_book",
      url: "/aboutus/customerHappinessCharter",
    },
  ],
};

export const CommitmentStatement = {
  _id: "mypage",
  title: "Commitment Statement and Certificates",
  title_ar: "Commitment Statement and Certificates",
  slug: "about-us",
  layout: "default",
  metaTitle: "Commitment Statement and Certificates",
  metaDescription: "Commitment Statement and Certificates",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "/attachments/medialib/4c7d7f5e-ec03-4c0b-839a-81d3db459ae9-1755335578179-204355629-03_About DHA - Commitment Statement and Certificates.jpg",
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Commitment Statement and Certificates",
          text_ar: "بيان الالتزام والشهادات",
          classname: "md:!mb-4 mb-3 Medium  text-primary",
        },
        {
          _id: "block4",
          type: "paragraph",
          size: "noram",
          classname: "md:!my-4 my-2 Regular text-onSurfaceVariant body",
          text: "In alignment with Dubai Health Authority values in Excellence to aspire to achieve the highest standards of excellence and professionalism in the provision of care, the Authority is committed to continually comply with providing the highest standards set by International Bodies and Regulatory Authorities through the achieved certifications.",
          text_ar:
            "تماشياً مع قيم هيئة الصحة بدبي في التميز والسعي لتحقيق أعلى المعايير في هذا المجال والاحتراف في تقديم الرعاية، تلتزم الهيئة بالامتثال في توفير أفضل المواصفات والمعايير من خلال حصولها على الشهادات من الجهات الدولية والتنظيمية المحلية.",
        },
        {
          _id: "block4",
          type: "heading",
          size: "h6",
          classname: "text-primary Medium my-4",
          text: "Commitment Statement",
          text_ar: "بيان الالتزام",
        },
        {
          _id: "block5",
          type: "div",
          classname: "grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-4",
          children: [
            {
              _id: "block6",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName:
                      "Integrated Management System (IMS) Commitment Statement",
                    fileName_ar: "بيان الالتزام بنظام الإدارة المتكاملة (IMS)",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      if (
                        window.location.pathname.includes("en") ||
                        window.location.pathname.includes("EN")
                      ) {
                        window.open(
                          "https://dha.gov.ae/uploads/092024/Integrated Management System (IMS) Commitment Statement2024949430.pdf",
                          "_blank"
                        );
                      } else {
                        window.open(
                          "https://dha.gov.ae/uploads/092024/Integrated Management System (IMS) Commitment Statement2024949430.pdf",
                          "_blank"
                        );
                      }
                    },
                    // fileSize: "78 MB",
                  },
                },
              ],
            },
            {
              _id: "block6",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName:
                      "Knowledge Management System (KMS) Commitment Statement",
                    fileName_ar: "بيان الالتزام بنظم إدارة المعرفة KMS",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      /* handle download */
                      // alert("test");
                      if (
                        window.location.pathname.includes("en") ||
                        window.location.pathname.includes("EN")
                      ) {
                        window.open(
                          "https://dha.gov.ae/uploads/092024/Knowledge Management System_KMS2024956457.pdf",
                          "_blank"
                        );
                      } else {
                        window.open(
                          "https://dha.gov.ae/uploads/092024/Knowledge Management System_KMS2024956457.pdf",
                          "_blank"
                        );
                      }
                    },
                    // fileSize: "78 MB",
                  },
                },
              ],
            },
            {
              _id: "block6",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName:
                      "Innovation Management System (InMS) Commitment Statement",
                    fileName_ar: "بيان الالتزام بإدارة الابتكار",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      /* handle download */
                      if (
                        window.location.pathname.includes("en") ||
                        window.location.pathname.includes("EN")
                      ) {
                        window.open(
                          "https://dha.gov.ae/uploads/122024/InMS commitment statement2024122611.pdf",
                          "_blank"
                        );
                      } else {
                        window.open(
                          "https://dha.gov.ae/uploads/122024/InMS commitment statement2024122611.pdf",
                          "_blank"
                        );
                      }
                    },
                    // fileSize: "78 MB",
                  },
                },
              ],
            },
            {
              _id: "block6",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName: "Governance Standard Commitment Statement",
                    fileName_ar: "بيان الالتزام بنظام إدارة الحوكمة الفعالة",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      /* handle download */
                      if (
                        window.location.pathname.includes("en") ||
                        window.location.pathname.includes("EN")
                      ) {
                        window.open(
                          "https://dha.gov.ae/uploads/092024/Governance System Commitment Statement2024939477.pdf",
                          "_blank"
                        );
                      } else {
                        window.open(
                          "https://dha.gov.ae/uploads/092024/Governance System Commitment Statement2024939477.pdf",
                          "_blank"
                        );
                      }
                    },
                    // fileSize: "78 MB",
                  },
                },
              ],
            },
          ],
        },
        {
          _id: "block4",
          type: "heading",
          size: "h6",
          classname: "text-primary Medium my-4",
          text: "Certificates",
          text_ar: "الشهادات",
        },
        {
          _id: "block5",
          type: "div",
          classname: "grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-4",
          children: [
            {
              _id: "block6",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName:
                      "Handling of customer complaints System certificate ISO 10002:2018",
                    fileName_ar: "شهادة نظام شكاوى المتعاملين  ISO 10002:2018",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      /* handle download */
                      if (
                        window.location.pathname.includes("en") ||
                        window.location.pathname.includes("EN")
                      ) {
                        window.open(
                          "https://dha.gov.ae/uploads/042025/ISO_1000220182025453111.PDF",
                          "_blank"
                        );
                      } else {
                        window.open(
                          "https://dha.gov.ae/uploads/042025/ISO_1000220182025453111.PDF",
                          "_blank"
                        );
                      }
                    },
                    // // fileSize: "78 MB",
                  },
                },
              ],
            },
            {
              _id: "block6",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName:
                      "Knowledge Management System Certificate :ISO 30401:2018",
                    fileName_ar: "شهادة نظام إدارة المعرفة ISO 30401:2018",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      if (
                        window.location.pathname.includes("en") ||
                        window.location.pathname.includes("EN")
                      ) {
                        window.open(
                          "https://dha.gov.ae/uploads/022025/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9 %D9%86%D8%B8%D8%A7%D9%85 %D8%A5%D8%AF%D8%A7%D8%B1%D8%A9 %D8%A7%D9%84%D9%85%D8%B9%D8%B1%D9%81%D8%A9 knowledge managment system202520277.pdf",
                          "_blank"
                        );
                      } else {
                        window.open(
                          "https://dha.gov.ae/uploads/022025/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9 %D9%86%D8%B8%D8%A7%D9%85 %D8%A5%D8%AF%D8%A7%D8%B1%D8%A9 %D8%A7%D9%84%D9%85%D8%B9%D8%B1%D9%81%D8%A9 knowledge managment system202520277.pdf",
                          "_blank"
                        );
                      }
                    },
                    // // fileSize: "78 MB",
                  },
                },
              ],
            },
            {
              _id: "block6",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName:
                      "Innovation Management System Certificate : ISO 56002:2019",
                    fileName_ar: "شهادة نظام إدارة الابتكار ISO 56002:2019",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      /* handle download */
                      if (
                        window.location.pathname.includes("en") ||
                        window.location.pathname.includes("EN")
                      ) {
                        window.open(
                          "https://dha.gov.ae/uploads/022025/Innovation managment system %D8%B4%D9%87%D8%A7%D8%AF%D8%A9 %D9%86%D8%B8%D8%A7%D9%85 %D8%A5%D8%AF%D8%A7%D8%B1%D8%A9 %D8%A7%D9%84%D8%A5%D8%A8%D8%AA%D9%83%D8%A7%D8%B12025230669.pdf",
                          "_blank"
                        );
                      } else {
                        window.open(
                          "https://dha.gov.ae/uploads/022025/Innovation managment system %D8%B4%D9%87%D8%A7%D8%AF%D8%A9 %D9%86%D8%B8%D8%A7%D9%85 %D8%A5%D8%AF%D8%A7%D8%B1%D8%A9 %D8%A7%D9%84%D8%A5%D8%A8%D8%AA%D9%83%D8%A7%D8%B12025230669.pdf",
                          "_blank"
                        );
                      }
                    },
                    // // fileSize: "78 MB",
                  },
                },
              ],
            },
            {
              _id: "block6",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName:
                      "Effective Governance Management Systems Certificate :BS 13500:2013",
                    fileName_ar:
                      "شهادة نظام إدارة الحوكمة الفعالة BS 13500:2013.",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      /* handle download */
                      if (
                        window.location.pathname.includes("en") ||
                        window.location.pathname.includes("EN")
                      ) {
                        window.open(
                          "https://dha.gov.ae/uploads/022025/Effective Governance managment system2025222135.pdf",
                          "_blank"
                        );
                      } else {
                        window.open(
                          "https://dha.gov.ae/uploads/022025/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9 %D9%86%D8%B8%D8%A7%D9%85 %D8%A5%D8%AF%D8%A7%D8%B1%D8%A9 %D8%A7%D9%84%D8%AD%D9%88%D9%83%D9%85%D8%A9 %D8%A7%D9%84%D9%81%D8%B9%D8%A7%D9%84%D8%A92025239358.pdf",
                          "_blank"
                        );
                      }
                    },
                    // // fileSize: "78 MB",
                  },
                },
              ],
            },
            {
              _id: "block6",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName:
                      "Integrated Management System Certificate (ISO 22301:2019, ISO/IEC 27001:2013, 9001:2015)",
                    fileName_ar:
                      "شهادة نظام الإدارة المتكاملة (ISO 22301:2019, ISO/IEC 27001:2013, 9001:2015)",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      /* handle download */
                      if (
                        window.location.pathname.includes("en") ||
                        window.location.pathname.includes("EN")
                      ) {
                        window.open(
                          "https://dha.gov.ae/uploads/022025/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9 %D9%86%D8%B8%D8%A7%D9%85 %D8%A7%D9%84%D8%A7%D8%AF%D8%A7%D8%B1%D8%A9 %D8%A7%D9%84%D9%85%D8%AA%D9%83%D8%A7%D9%85%D9%84%D8%A9 Integerated managment system2025277.PDF",
                          "_blank"
                        );
                      } else {
                        window.open(
                          "https://dha.gov.ae/uploads/022025/%D8%B4%D9%87%D8%A7%D8%AF%D8%A9 %D9%86%D8%B8%D8%A7%D9%85 %D8%A7%D9%84%D8%A7%D8%AF%D8%A7%D8%B1%D8%A9 %D8%A7%D9%84%D9%85%D8%AA%D9%83%D8%A7%D9%85%D9%84%D8%A9 Integerated managment system2025277.PDF",
                          "_blank"
                        );
                      }
                    },
                    // // fileSize: "78 MB",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Commitment Statement and Certificates ",
      icon: "menu_book",
      url: "/aboutus/commitmentStatementsAndCertificates",
    },
  ],
};

export const MedialResearch = {
  _id: "mypage",
  title: "About Us",
  title_ar: "About Us",
  slug: "about-us",
  layout: "default",
  metaTitle: "About DHA",
  metaDescription: "About DHA",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Medical Research",
          text_ar: "Medical Research",
          classname: "md:!my-4 my-2 Medium  text-primary",
        },
        {
          _id: "block3",
          type: "paragraph",
          size: "normal",
          text: " Dubai Health Authority is constantly working to improve the health care services provided in the emirate by keeping abreast of developments and medical solutions, encouraging medical research, and studying methods of diagnosing and treating various diseases. Therefore, it provides the following services to support researchers while ensuring the rights and safety of the human subjects participating in this research:",
          text_ar:
            " Dubai Health Authority is constantly working to improve the health care services provided in the emirate by keeping abreast of developments and medical solutions, encouraging medical research, and studying methods of diagnosing and treating various diseases. Therefore, it provides the following services to support researchers while ensuring the rights and safety of the human subjects participating in this research:",
          classname: "md:!my-4 my-2 Regular text-onSurfaceVariant",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "First Tab",
              title_ar: "First Tab",
              size: "h2",
              classname: "md:!my-4 my-2 Medium  text-primary",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "xl:flex gap-10 mt-5",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "xl:w-3/4",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "The Dubai Scientific Research Ethics Committee (DSREC) acts as the Central Ethics Committee for the Emirate of Dubai. It takes the final decision on health research proposal requests after reviewing them thoroughly during periodic meetings. DSREC recognizes the establishment of Local Ethics Committee within the academic institution, private government, or semi-government health institution or research centre falling under the jurisdiction of the Emirate of Dubai.",
                          text_ar:
                            "The Dubai Scientific Research Ethics Committee (DSREC) acts as the Central Ethics Committee for the Emirate of Dubai. It takes the final decision on health research proposal requests after reviewing them thoroughly during periodic meetings. DSREC recognizes the establishment of Local Ethics Committee within the academic institution, private government, or semi-government health institution or research centre falling under the jurisdiction of the Emirate of Dubai.",
                          classname: "body",
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "For more information on the different types of studies that can be submitted to DSREC by the Local Ethics Committee either for an In-depth Review/Approval or for Final Approval only",
                          text_ar:
                            "For more information on the different types of studies that can be submitted to DSREC by the Local Ethics Committee either for an In-depth Review/Approval or for Final Approval only",
                          classname: "body mt-7",
                        },
                        {
                          _id: "block3",
                          type: "dda-button",
                          props: {
                            button_color: "default-primary",
                            start_icon: "",
                            button_text: "Click Here",
                            button_text_ar: "Click Here",
                            end_icon: "",
                            custom_class: "my-2",
                            component_mode: "",
                            button_id: "button",
                            aria_label: "button",
                            onclick: "console.log('clicked')",
                            button_name: "button",
                            button_name_ar: "button",
                          },
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Any research planned at DHA licensed facilities that don't have Local Ethics Committee must directly be submitted to the DSREC for review and approvl",
                          text_ar:
                            "Any research planned at DHA licensed facilities that don't have Local Ethics Committee must directly be submitted to the DSREC for review and approvl",
                          classname: "body my-5",
                        },
                        {
                          _id: "block3",
                          type: "dda-accordion",
                          props: {
                            design: "bg-border",
                            accordion_icon_class:
                              "material-icons  material-symbols-outlined",
                            accordion_icon_text: "",
                            accordion_icon_text_ar: "",
                            header_text: "Who can apply?",
                            header_text_ar: "Who can apply?",
                            sub_title: "",
                            sub_title_ar: "",
                            body_description:
                              "Researchers, either health professionals or health university/college students, who wish to obtain ethical approval on the research planned at the research sites that fall under the jurisdiction of the emirate of Dubai.",
                            body_description_ar:
                              "Researchers, either health professionals or health university/college students, who wish to obtain ethical approval on the research planned at the research sites that fall under the jurisdiction of the emirate of Dubai.",
                            link_button_text: "",
                            link_button_text_ar: "",
                            custom_class: "",
                            component_mode: "",
                          },
                        },
                        {
                          _id: "block3",
                          type: "dda-accordion",
                          props: {
                            design: "bg-border",
                            accordion_icon_class:
                              "material-icons  material-symbols-outlined",
                            accordion_icon_text: "",
                            accordion_icon_text_ar: "",
                            header_text: "Submission Procedures",
                            header_text_ar: "Submission Procedures",
                            sub_title: "",
                            sub_title_ar: "",
                            link_button_text: "",
                            link_button_text_ar: "",
                            custom_class: "my-4",
                            component_mode: "",
                          },
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: " Submit following documents to (Email DSREC@dha.gov.ae ):",
                              text_ar:
                                " Submit following documents to (Email DSREC@dha.gov.ae ):",
                              classname: "body text-black",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "ul",
                              classname:
                                "text-onSurfaceVariant list-decimal list-inside !my-2 body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Cover letter on headed paper (Addressed by Principal Investigator to DSREC)",
                                  text_ar:
                                    "Cover letter on headed paper (Addressed by Principal Investigator to DSREC)",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Study proposal/Synopsis",
                                  text_ar: "Study proposal/Synopsis",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Questionnaires: If applicable, to be submitted in both English and Arabic",
                                  text_ar:
                                    "Questionnaires: If applicable, to be submitted in both English and Arabic",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Resume of Principal Investigator and Co-Investigators",
                                  text_ar:
                                    "Resume of Principal Investigator and Co-Investigators",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Source of funding, if applicable, please submit supporting documents along with funding requirements",
                                  text_ar:
                                    "Source of funding, if applicable, please submit supporting documents along with funding requirements",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "All relevant enclosures such as Data Collection Tool/Case Report form / proforma/ follow-up cards etc.",
                                  text_ar:
                                    "All relevant enclosures such as Data Collection Tool/Case Report form / proforma/ follow-up cards etc.",
                                  classname: "",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: "Note: If the attachments size exceeds 120 MB, please notify us through DSREC@dha.gov.ae so that we can share with you a secured link to upload the required documents.",
                              text_ar:
                                "Note: If the attachments size exceeds 120 MB, please notify us through DSREC@dha.gov.ae so that we can share with you a secured link to upload the required documents.",
                              classname: "caption text-primary",
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "dda-accordion",
                          props: {
                            design: "bg-border",
                            accordion_icon_class:
                              "material-icons  material-symbols-outlined",
                            accordion_icon_text: "",
                            accordion_icon_text_ar: "",
                            header_text: "Payment Procedures",
                            header_text_ar: "Payment Procedures",
                            sub_title: "",
                            sub_title_ar: "",
                            link_button_text: "",
                            link_button_text_ar: "",
                            custom_class: "my-4",
                            component_mode: "",
                          },
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: "At the end of the application review process, the research coordinator will contact you to proceed with the payment before receiving the DSREC decision letter.",
                              text_ar:
                                "At the end of the application review process, the research coordinator will contact you to proceed with the payment before receiving the DSREC decision letter.",
                              classname: "body",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "ul",
                              classname:
                                "text-onSurfaceVariant list-decimal list-inside body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Payment is accepted through bank transfer to Dubai Health Authority's Bank Account. For details, please",
                                  text_ar:
                                    "Payment is accepted through bank transfer to Dubai Health Authority's Bank Account. For details, please",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "linking",
                                      text: " Click here.",
                                      text_ar: " Click here.",
                                      classname: "text-primary underline",
                                      href: "#",
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Please send the transfer proof (receipt) to DSREC@dha.gov.ae, then payment will be confirmed with the Finance Dept team who will then share the payment voucher.",
                                  text_ar:
                                    "Please send the transfer proof (receipt) to DSREC@dha.gov.ae, then payment will be confirmed with the Finance Dept team who will then share the payment voucher.",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: " An additional AED 20 will be charged as Knowledge and Innovation fees.",
                                  text_ar:
                                    " An additional AED 20 will be charged as Knowledge and Innovation fees.",
                                  classname: "",
                                },
                              ],
                            },
                            // {
                            //   _id: "block3",
                            //   type: "paragraph",
                            //   size: "normal",
                            //   text: "Note: If the attachments size exceeds 120 MB, please notify us through DSREC@dha.gov.ae so that we can share with you a secured link to upload the required documents.",
                            //   text_ar:
                            //     "Note: If the attachments size exceeds 120 MB, please notify us through DSREC@dha.gov.ae so that we can share with you a secured link to upload the required documents.",
                            //   classname: "caption text-primary",
                            // },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block1",
                      type: "div",
                      classname: "xl:w-1/4 *:mb-4 xl:my-0 my-4 ",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block3",
              type: "tabcontent",
              title: "Second Tab",
              title_ar: "Second Tab",
              size: "h2",
              classname: "md:!my-4 my-2 Medium  text-primary",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h2",
                  text: "This is testing",
                  text_ar: "This is testing",
                  classname: "md:!my-4 my-2 Medium  text-primary",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "Medical Research", icon: "home", url: "" },
  ],
};

export const PublicHealth = {
  _id: "mypage",
  title: "Prevention, Vaccination & Immunisation Programme",
  title_ar: "Prevention, Vaccination & Immunisation Programme",
  slug: "about-us",
  layout: "default",
  metaTitle: "Prevention, Vaccination & Immunisation Programm",
  metaDescription: "Prevention, Vaccination & Immunisation Programm",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block2",
          type: "image",
          src: "/attachments/medialib/fb664d70-e275-4406-88e5-223004fb9829-1755338299043-636707913-20_Public Health - Prevention, Vaccination & Immunization Programmes.jpg",
          size: "fullwidth",
          classname: "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
          alt: "This is a description for the page......",
        },
      ],
    },
    {
      _id: "block3",
      type: "heading",
      size: "h2",
      text: "Public Benefits Services",
      text_ar: "خدمات النفع العام",
      classname: "md:!mb-4 mb-3 Medium text-primary",
    },
    {
      _id: "block3",
      type: "paragraph",
      size: "normal",
      text: "Dubai Health Authority is keen to implement a range of public benefit services that are aligned with the objectives of its establishment decree. These services are carried out proactively without the need for a direct request from the customer. <br /> They aim to promote public health, ensure community safety, and enhance the quality of the healthcare system in the Emirate. The services include regulatory, supervisory, educational, and awareness-related functions delivered by the relevant departments within DHA. <br /> This following list has been published to highlight the DHA role in delivering these vital community services and to allow the public to stay informed of its ongoing efforts—without requiring any direct interaction with the service.",
      text_ar: `تحرص هيئة الصحة بدبي على تنفيذ مجموعة من خدمات النفع العام التي تستند إلى أهداف قرار الإنشاء، ويتم تنفيذها بشكل استباقي دون الحاجة إلى تقديم طلب من المتعامل. <br /> تهدف هذه الخدمات إلى تعزيز الصحة العامة، وضمان سلامة المجتمع، ورفع جودة النظام الصحي في الإمارة. وتشمل خدمات تنظيمية، رقابية، تثقيفية، وتوعوية يتم تقديمها من خلال الإدارات المختصة ضمن الهيئة. <br /> القائمة التالية تهدف إلى إبراز دور الهيئة في تقديم هذه الخدمات المجتمعية المهمة، وتمكين أفراد المجتمع من الاطلاع على جهود الهيئة المتواصلة، دون أن يتطلب الأمر التفاعل المباشر مع الخدمة.`,
      classname: "md:!my-4 my-2 Regular text-onSurfaceVariant",
    },
    {
      _id: "block1",
      type: "dda-tabs",
      view: "primary-card",
      props: {
        type: "text",
        hover_style: "dda-tab-underline-filled",
        custom_class: "mb-3 mt-1",
        component_mode: "",
        button_id: "button",
        aria_label: "tabs",
        onclick: "alert()",
        button_name: "button",
        button_name_ar: "button",
      },
      children: [
        {
          _id: "block2",
          type: "tabcontent",
          title: "Healthcare",
          title_ar: "Periodical Medical Checkups",
          isShow_title: false,
          size: "h2",
          classname: "dda-table-container",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "overflow-x-auto",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h2",
                  text: "Health System Management and Governance:",
                  text_ar: "إدارة وحوكمة النظام الصحي",
                  classname: "md:!mb-4 mb-3 Medium text-primary",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `Regulatory and strategic services aimed at improving health system performance through policies, oversight, quality, and healthcare investment.`,
                  text_ar: `خدمات تنظيمية واستراتيجية تهدف إلى تحسين أداء النظام الصحي عبر السياسات، الرقابة، الجودة، والاستثمار الصحي.`,
                  classname: "md:!my-4 my-2 Regular text-onSurfaceVariant",
                },
                {
                  _id: "table1",
                  type: "table",
                  // data_source: "StaticTable",
                  classname: "dda-table w-full min-w-[650px]",
                  children: [
                    {
                      id: "table_header",
                      type: "tableItems",
                      type_identifier: "thead",
                      classname: "body",
                      children: [
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "Bold body",
                              text: "Service Name",
                              text_ar: "Service Name",
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "Bold body",
                              text: "Service Description",
                              text_ar: "Service Description",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "table_body",
                      type: "tableItems",
                      type_identifier: "tbody",
                      classname: "body",
                      // parent_params: `["data"]`,
                      children: [
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Government insurance programmes management (Enaya)",
                                  text_ar:
                                    "إدارة برامج التأمين الحكومية (عناية)",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "A unified system providing government health coverage, aiming to enhance healthcare service quality and facilitate beneficiary access to an integrated network of healthcare providers.",
                                  text_ar:
                                    "نظام موحد لتوفير التغطية الصحية الحكومية، يهدف إلى تعزيز جودة الخدمات الطبية وتسهيل وصول المستفيدين إلى شبكة متكاملة من مزودي الرعاية الصحية.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Regulation and approval of health service prices in Dubai",
                                  text_ar:
                                    "تنظيم واعتماد أسعار الخدمات الصحية في الإمارة",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "A regulatory framework for setting healthcare service prices to ensure balance between service quality and cost efficiency.",
                                  text_ar:
                                    "إطار تنظيمي معتمد لتحديد أسعار الخدمات الصحية بما يضمن التوازن بين جودة الرعاية الصحية وكفاءة الإنفاق.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Health inspection",
                                  text_ar: "التفتيش الصحي",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "A regulatory mechanism ensuring healthcare facilities comply with approved safety and quality standards.",
                                  text_ar:
                                    "آلية رقابية معتمدة لضمان التزام المنشآت الصحية بالمعايير المعتمدة للسلامة والجودة في تقديم الخدمات.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Measuring the quality of healthcare services",
                                  text_ar: "قياس جودة خدمات الرعاية الصحية",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "A comprehensive evaluation system designed to monitor performance indicators and quality levels across healthcare facilities, thereby enhancing patient experience and service outcomes.",
                                  text_ar:
                                    "نظام تقييم شامل يهدف إلى رصد مؤشرات الأداء وجودة الخدمة في مرافق الرعاية الصحية، بما يعزز تجربة المتعامل ويرتقي بمستوى الخدمة.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Supervisory visit to Dubai Private Schools",
                                  text_ar:
                                    "تنفيذ الزيارات الاشرافية والتفتيشية على عيادات المدارس الخاصة بإمارة دبي",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Periodic supervisory visits to evaluate the quality of health services provided at private school clinics and ensure alignment with approved health standards and the implementation of the official school health program.",
                                  text_ar:
                                    "تنفيذ زيارات إشرافية دورية على عيادات المدارس الخاصة في إمارة دبي، وذلك على مدار العام الدراسي بهدف تقييم ومتابعة تنفيذ برنامج الصحة المدرسية.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Health Tourism Promotion",
                                  text_ar: "الترويج للسياحة الصحية",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "A regulatory service aimed at ensuring the quality of services provided to international patients and enhancing Dubai’s position as a medical tourism destination according to approved health standards.",
                                  text_ar:
                                    "خدمة تنظيمية تهدف إلى ضمان جودة الخدمات المقدمة للمرضى الدوليين وتعزيز مكانة دبي كوجهة للسياحة العلاجية وفق معايير صحية معتمدة.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Health Policies, Studies, and Health Investment Policies",
                                  text_ar:
                                    "السياسات والدراسات الصحية وسياسات الاستثمار الصحي",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "A strategic service aimed at developing data-driven health policies and promoting sustainable investment in the healthcare sector.",
                                  text_ar:
                                    "خدمة استراتيجية تهدف إلى تطوير السياسات الصحية المبنية على البيانات وتحفيز الاستثمار المستدام في القطاع الصحي.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block2",
          type: "tabcontent",
          title: "Education and Training",
          title_ar: "Education and Training",
          size: "h2",
          classname: "dda-table-container",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "overflow-x-auto",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h2",
                  text: "Community Health Protection",
                  text_ar: "حماية صحة المجتمع:",
                  classname: "md:!mb-4 mb-3 Medium text-primary",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `
      Preventive and regulatory services aimed at protecting public health and ensuring community safety.
      `,
                  text_ar: `
      خدمات وقائية وتنظيمية تهدف إلى حماية صحة المجتمع من الأمراض والأوبئة وضمان السلامة العامة.
      `,
                  classname: "md:!my-4 my-2 Regular text-onSurfaceVariant",
                },
                {
                  _id: "table1",
                  type: "table",
                  // data_source: "StaticTable",
                  classname: "dda-table w-full min-w-[650px]",
                  children: [
                    {
                      id: "table_header",
                      type: "tableItems",
                      type_identifier: "thead",
                      classname: "body",
                      children: [
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "Bold body",
                              text: "Service Name",
                              text_ar: "Service Name",
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "Bold body",
                              text: "Service Description",
                              text_ar: "Service Description",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "table_body",
                      type: "tableItems",
                      type_identifier: "tbody",
                      classname: "body",
                      // parent_params: `["data"]`,
                      children: [
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Prevention from communicable diseases",
                                  text_ar: "وقاية المجتمع من الأمراض والأوبئة",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "An integrated system for monitoring diseases and epidemics and implementing preventive measures to safeguard community health.",
                                  text_ar:
                                    "منظومة متكاملة لرصد الأمراض والأوبئة واتخاذ التدابير الوقائية اللازمة لحماية صحة المجتمع.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Issuance of Free Pratique Permits for Ships",
                                  text_ar: "إصدار أذونات حرية الحركة للسفن",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "A preventive measure ensuring ships meet public health requirements before being authorized to operate in Dubai’s ports.",
                                  text_ar:
                                    "إجراء وقائي يضمن استيفاء السفن للمتطلبات الصحية قبل السماح لها بمزاولة العمليات في موانئ الإمارة.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Assessment and Monitoring of Dubai Residents’ Health Status",
                                  text_ar:
                                    "تقييم ورصد الحالة الصحية لسكان امارة دبي",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Periodic health studies and analyses providing accurate insights into the general health status of Dubai’s residents to support evidence-based health decisions.",
                                  text_ar:
                                    "دراسات وتحليلات صحية دورية تهدف إلى رسم صورة دقيقة عن الحالة الصحية العامة لسكان الإمارة واتخاذ القرارات الملائمة المستندة إلى البيانات والمعلومات والتقارير.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Development of Public Health Policies – Preventive Medicine and Occupational Health and Safety",
                                  text_ar:
                                    "تطوير برامج وسياسات الصحة العامة - سياسات الطب الوقائي والصحة والسلامة المهنية",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Strategic policies aimed at improving public health indicators and strengthening preventive and occupational health readiness across all community groups.",
                                  text_ar:
                                    "سياسات استراتيجية تهدف إلى رفع مؤشرات الصحة العامة وتعزيز الجاهزية الوقائية والصحة والسلامة المهنية لمختلف فئات المجتمع.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Provision of occupational health and medical fitness legislation issuance services",
                                  text_ar:
                                    "خدمات إصدار التشريعات الخاصة بالصحة المهنية واللياقة الطبية",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Regulatory frameworks aimed at improving occupational health and safety across work environments in line with local and federal best practices, including the preparation, review, and dissemination of relevant legislation.",
                                  text_ar:
                                    "تشريعات وتنظيمات تهدف إلى تعزيز السلامة والصحة المهنية في بيئات العمل، وفقًا لأفضل الممارسات المحلية والاتحادية، وتشمل اعداد ومراجعة واعتماد التشريعات ذات الصلة بالتنسيق مع الجهات المعنية في الدولة وتعميمها على الجهات المستهدفة للتقيد بها وتنفيذها.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Organizing specialized training for health personnel and other responding agencies, in cooperation with strategic partners in the field of disaster and crisis management",
                                  text_ar:
                                    "تنظيم تدريبات تخصصية للكادر الصحي والجهات المستجيبة الأخرى بالتعاون مع الشركاء الاستراتيجيين في مجال إدارة الكوارث والأزمات",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Professional development programs targeting enhanced emergency response capabilities among healthcare professionals and relevant stakeholders during disasters and crises.",
                                  text_ar:
                                    "برامج تطوير مهني تستهدف تعزيز كفاءة الكوادر الصحية والجهات المعنية في الاستجابة السريعة لحالات الكوارث والأزمات.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Organizing and participating in mock exercises in the field of disaster and crisis management",
                                  text_ar:
                                    "تنظيم ومشاركة التمارين الوهمية في مجال إدارة الكوارث والأزمات",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Field simulations designed to test readiness and improve interagency coordination in responding to health emergencies and crisis scenarios.",
                                  text_ar:
                                    "محاكاة ميدانية تستهدف اختبار الجاهزية ورفع مستوى التنسيق في الاستجابة للطوارئ الصحية والتعامل مع السيناريوهات الطارئة خلال أوقات الكوارث والأزمات.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block2",
          type: "tabcontent",
          title: "Public Health and Safety",
          title_ar: "Public Health and Safety",
          size: "h2",
          classname: "dda-table-container",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "overflow-x-auto",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h2",
                  text: "Health Awareness and Education",
                  text_ar: "التوعية والتعليم الصحي:",
                  classname: "md:!mb-4 mb-3 Medium text-primary",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `
      Educational and awareness services targeting schools and the community to promote healthy lifestyles and preventive behaviours.
      `,
                  text_ar: `
      خدمات تعليمية وتوعوية تستهدف المدارس والمجتمع لتعزيز أنماط الحياة الصحية والسلوكيات الوقائية.
      `,
                  classname: "md:!my-4 my-2 Regular text-onSurfaceVariant",
                },
                {
                  _id: "table1",
                  type: "table",
                  // data_source: "StaticTable",
                  classname: "dda-table w-full min-w-[650px]",
                  children: [
                    {
                      id: "table_header",
                      type: "tableItems",
                      type_identifier: "thead",
                      classname: "body",
                      children: [
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "Bold body",
                              text: "Service Name",
                              text_ar: "Service Name",
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "Bold body",
                              text: "Service Description",
                              text_ar: "Service Description",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "table_body",
                      type: "tableItems",
                      type_identifier: "tbody",
                      classname: "body",
                      // parent_params: `["data"]`,
                      children: [
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Awareness and Education Program in Private Schools in Dubai",
                                  text_ar:
                                    "تنظيم وتنفيذ والاشراف على الحملات التثقيفية والتوعوية المختلفة في مدارس دبي الخاصة",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Educational programs targeting the school community to promote healthy and preventive behaviors among students, parents, and educational staff in collaboration with strategic partners.",
                                  text_ar:
                                    "زيارات إشرافية دورية لتقييم جودة الخدمات الصحية في العيادات المدرسية في المدارس الخاصة في الإمارة وضمان توافقها مع الاشتراطات المعتمدة وبما يتضمن تنفيذ برنامج الصحة المدرسية المعتمد.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Provide training general and specialized to medical staff in schools",
                                  text_ar:
                                    "تنظيم تدريبات للكادر الصحي في المدارس",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Specialized workshops designed to enhance the competence and knowledge of school health professionals, ensuring adherence to best health practices within the educational environment.",
                                  text_ar:
                                    "ورش عمل متخصصة تهدف إلى رفع كفاءة الكوادر الصحية المدرسية ورفع معارفهم وضمان تطبيق أفضل المعايير الصحية داخل البيئة المدرسية.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Organizing, implementing and supervising educational and awareness campaings",
                                  text_ar:
                                    "تنظيم وتنفيذ والاشراف على الحملات التثقيفية والتوعوية المختلفة",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "This service involves providing public awareness programs and campaigns aimed at promoting healthy lifestyles and safe behaviors. These campaigns are implemented based on approved plans that address health priorities and target the general public.",
                                  text_ar:
                                    "تشمل هذه الخدمة تقديم خدمات وبرامج توعوية وتثقيفية موجهة لأفراد المجتمع، بهدف تعزيز الوعي الصحي ونشر السلوكيات الصحية السليمة، وذلك من خلال تنفيذ حملات توعوية منظمة وفق خطط معتمدة، تغطي مختلف المواضيع الصحية ذات الأولوية وتستهدف جميع أفراد المجتمع.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Development of medical library resources",
                                  text_ar: "تطوير مصادر المكتبة الطبية",
                                  // text_params: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_1"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "A knowledge system supporting the health sector by providing and updating scientific resources and specialized medical references for healthcare professionals.",
                                  text_ar:
                                    "منظومة معرفية داعمة للقطاع الصحي، تُعنى بتوفير وتحديث المصادر العلمية والمراجع الطبية المتخصصة للكوادر الصحية.",
                                  // text_params: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                  // text_params_ar: `["data_2", "[showData, showData_2]"]`, // ["props", "action", "data", "{parentIndex}", "key{index}"]
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Public Health",
      icon: "home",
      url: "/publichealth/preventionVaccinationAndImmunisationProgrammes",
    },
  ],
};

export const HealthRegulation = {
  _id: "mypage",
  title: "Health Regulation",
  title_ar: "Health Regulation",
  slug: "about-us",
  layout: "default",
  metaTitle: "Health Regulation",
  metaDescription: "Health Regulation",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block2",
          type: "image",
          src: "13_Health Regulation - About Health Regulation.jpg",
          size: "fullwidth",
          classname: "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
          alt: "This is a description for the page......",
        },
        {
          _id: "block10",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block10",
              type: "div",
              classname: "lg:w-3/4",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h2",
                  text: "Health Regulation",
                  text_ar: "Health Regulation",
                  classname: "md:!mb-4 mb-3 Medium  text-primary",
                },
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "The Sector oversees the healthcare facilities and professionals in Dubai, including free zones.",
                  text_ar:
                    "The Sector oversees the healthcare facilities and professionals in Dubai, including free zones.",
                  classname: "md:!my-4 my-2  text-onSurfaceVariant",
                },
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "HRSs main functions are focused on:",
                  text_ar: "HRSs main functions are focused on:",
                  classname: "text-onSurfaceVariant mb-3",
                },
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "ul",
                  classname:
                    "list-inside list-disc text-onSurfaceVariant *:mb-2 body",
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: " Developing regulatory standards, policies and legislations necessary for the sustainable growth and development of the health sector",
                      text_ar:
                        " Developing regulatory standards, policies and legislations necessary for the sustainable growth and development of the health sector",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Issuing licensure of healthcare facilities as we ll as healthcare professionals",
                      text_ar:
                        "Issuing licensure of healthcare facilities as we ll as healthcare professionals",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Supervising and inspecting healthcare professionals and facilities to ensure compliance with healthcare standards, in addition to managing medical complaints.",
                      text_ar:
                        "Supervising and inspecting healthcare professionals and facilities to ensure compliance with healthcare standards, in addition to managing medical complaints.",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Screening tests, by discovering diseases early, can assist to avoid the complications - and the need for more expensive and intrusive treatments later on.",
                      text_ar:
                        "Screening tests, by discovering diseases early, can assist to avoid the complications - and the need for more expensive and intrusive treatments later on.",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Governing the provision of health tourism services in Dubai by establishing and developing the infrastructure, legislation, policies and regulation",
                      text_ar:
                        "Governing the provision of health tourism services in Dubai by establishing and developing the infrastructure, legislation, policies and regulation",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Preparing and adopting the necessary foundations and standards for the governance and management of health informatics",
                      text_ar:
                        "Preparing and adopting the necessary foundations and standards for the governance and management of health informatics",
                      classname: "",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block10",
          type: "div",
          classname: "xl:w-1/4 *:mb-4 xl:my-0 my-4",
          children: [
            {
              _id: "block10",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName: "Health Regulation Service Catalogue",
                    fileName_ar: "Health Regulation Service Catalogue",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      /* handle download */
                      alert("test");
                    },
                    // fileSize: "78 MB",
                  },
                },
              ],
            },
            {
              _id: "block10",
              type: "div",
              classname: "border rounded-lg border-outline py-4 px-3",
              children: [
                {
                  _id: "block8",
                  type: "custom_components",
                  custom_components: "FileDownloadRow",
                  text: "Vision",
                  text_ar: "Vision",
                  props: {
                    fileIcon:
                      "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                    fileName: "Clinical Services Capacity Plan Service",
                    fileName_ar: "Clinical Services Capacity Plan Service",
                    downloadIcon:
                      "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                    onDownload: () => {
                      /* handle download */
                      alert("test");
                    },
                    // fileSize: "78 MB",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Health Regulation ",
      icon: "menu_book",
      url: "/healthregulation/abouthealthregulation",
    },
  ],
};

export const HealthLicensing = {
  _id: "mypage",
  title: "Dubai Health Licensing System (Sheryan)",
  title_ar: "Dubai Health Licensing System (Sheryan)",
  slug: "about-us",
  layout: "default",
  metaTitle: "Dubai Health Licensing System (Sheryan)",
  metaDescription: "Dubai Health Licensing System (Sheryan)",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block2",
          type: "image",
          src: "14_Health Regulation- Dubai Health Licensing System (Sheryan).jpg",
          size: "fullwidth",
          classname: "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
          alt: "This is a description for the page......",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Dubai Health Licensing System (Sheryan)",
          text_ar: "Dubai Health Licensing System (Sheryan)",
          classname: "md:!mb-4 mb-3 Medium  text-primary",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h5",
          text: "Digital gateway for registering and licensing healthcare professionals and facilities in Dubai.",
          text_ar:
            "Digital gateway for registering and licensing healthcare professionals and facilities in Dubai.",
          classname: "md:!my-4 my-2  text-onSurfaceVariant",
        },
        {
          _id: "block10",
          type: "div",
          classname: "grid md:grid-cols-2 gap-4",
          children: [
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                image_src: "",
                header_text: "For Healthcare Professionals",
                header_text_ar: "For Healthcare Professionals",
                date_text: "",
                body_text:
                  "Sheryan platform provides access to registration and licensing services for health professionals to practice in Dubai",
                body_text_ar:
                  "Sheryan platform provides access to registration and licensing services for health professionals to practice in Dubai",
                left_button_name: "View List",
                left_button_href: "https://example.com",
                left_button_rel: "",
                left_button_start_icon: "",
                left_button_end_icon: "",
                left_button_data_fancybox: "",
                custom_class: "dubaiHealthLicensingCard",
                component_mode: "",
              },
            },
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                image_src: "",
                header_text: "For Healthcare Facilities",
                header_text_ar: "For Healthcare Facilities",
                date_text: "",
                body_text:
                  "Sheryan platform helps you setup a license and operate a healthcare facility in Dubai.",
                body_text_ar:
                  "Sheryan platform helps you setup a license and operate a healthcare facility in Dubai.",
                left_button_name: "View List",
                left_button_href: "https://example.com",
                left_button_rel: "",
                left_button_start_icon: "",
                left_button_end_icon: "",
                left_button_data_fancybox: "",
                custom_class: "h-full justify-between dubaiHealthLicensingCard",
                component_mode: "",
              },
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Dubai Health Licensing System (Sheryan)",
      icon: "menu_book",
      url: "/healthregulation/dubaihealthlicensingsystem",
    },
  ],
};

export const DrugControl = {
  _id: "mypage",
  title: "Drug Control",
  title_ar: "Drug Control",
  slug: "about-us",
  layout: "default",
  metaTitle: "Drug Control",
  metaDescription: "Drug Control",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block2",
          type: "image",
          src: "15_Health Regulation - Drug Control.jpg",
          size: "fullwidth",
          classname: "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
          alt: "This is a description for the page......",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Drug Control",
          text_ar: "Drug Control",
          classname: "md:!mb-4 mb-3 Medium  text-primary",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h5",
          text: "Dubai Health Authority (DHA) follows the Ministry of Health and Prevention (MOHAP) in listing the medications in use in UAE, which contain: Narcotic, Controlled & Semi-controlled Medications, Prescription only Medications (POM) & Pharmacist only Medications, Over the Counter Medications (OTC)",
          text_ar:
            "Dubai Health Authority (DHA) follows the Ministry of Health and Prevention (MOHAP) in listing the medications in use in UAE, which contain: Narcotic, Controlled & Semi-controlled Medications, Prescription only Medications (POM) & Pharmacist only Medications, Over the Counter Medications (OTC)",
          classname: "md:!my-4 my-2  text-onSurfaceVariant",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "drug_control", //for dynamic breadcrumbs
          linker_ar: "drug_control", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Processes & Forms Text",
              title_ar: "Processes & Forms Text",
              isShow_title: false,
              size: "h2",
              classname: "",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: "The Drug Control section offers services to pharmacies and health facilities that fulfil their needs. The forms below must be filled out and emailed to ",
                  text_ar:
                    "The Drug Control section offers services to pharmacies and health facilities that fulfil their needs. The forms below must be filled out and emailed to ",
                  classname: "my-4 body",
                  children: [
                    {
                      _id: "block3",
                      type: "linking",
                      text: "drugcontrol@dha.gov.ae",
                      text_ar: "drugcontrol@dha.gov.ae",
                      classname: "text-primary",
                      href: "mailto:drugcontrol@dha.gov.ae",
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",
                    header_text: "Processes & Forms Text",
                    header_text_ar: "Processes & Forms Text",
                    sub_title: "",
                    sub_title_ar: "",
                    body_description: "",
                    body_description_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName:
                          "Hospitals & DSC Class C mandatory emergency medications request form",
                        fileName_ar:
                          "Hospitals & DSC Class C mandatory emergency medications request form",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                    {
                      _id: "block3",
                      type: "htmlTag",
                      tag: "hr",
                      classname: "my-3",
                    },
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName:
                          "Outpatient Polyclinics & DSC Class A, B and CM mandatory emergency medications request form",
                        fileName_ar:
                          "Outpatient Polyclinics & DSC Class A, B and CM mandatory emergency medications request form",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                    {
                      _id: "block3",
                      type: "htmlTag",
                      tag: "hr",
                      classname: "my-3",
                    },
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName:
                          "CD, SCD, POM and General Medication disposal request form",
                        fileName_ar:
                          "CD, SCD, POM and General Medication disposal request form",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                    {
                      _id: "block3",
                      type: "htmlTag",
                      tag: "hr",
                      classname: "my-3",
                    },
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "Narcotic purchase and quota change form",
                        fileName_ar: "Narcotic purchase and quota change form",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                    {
                      _id: "block3",
                      type: "htmlTag",
                      tag: "hr",
                      classname: "my-3",
                    },
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName:
                          "Assign or change Narcotic, CD and SCD medication in-charge request form",
                        fileName_ar:
                          "Assign or change Narcotic, CD and SCD medication in-charge request form",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                    {
                      _id: "block3",
                      type: "htmlTag",
                      tag: "hr",
                      classname: "my-3",
                    },
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "Narcotic disposal request form",
                        fileName_ar: "Narcotic disposal request form",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                    {
                      _id: "block3",
                      type: "htmlTag",
                      tag: "hr",
                      classname: "my-3",
                    },
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "Drug incident report",
                        fileName_ar: "Drug incident report",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Pharmacy self-inspection",
              title_ar: "Pharmacy self-inspection",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "National platform for controlled medications",
              title_ar: "National platform for controlled medications",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Drug Control",
      icon: "home",
      url: "/healthregulation/drugcontrol",
    },
    {
      text: "drug_control", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/healthregulation/drugcontrol",
    },
  ],
};

export const ProjectInitiatives = {
  _id: "mypage",
  title: "Project Initiative",
  title_ar: "Project Initiative",
  slug: "about-us",
  layout: "default",
  metaTitle: "Project Initiative",
  metaDescription: "Project Initiative",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Projects & Initiatives",
          text_ar: "Projects & Initiatives",
          classname: "md:!my-4 my-2 Medium  text-primary",
        },
        {
          _id: "block4",
          type: "heading",
          size: "h5",
          classname: "md:!my-4 my-2 Regular text-onSurfaceVariant",
          text: "In alignment with Dubai Health Authority values in Excellence to aspire to achieve the highest standards of excellence and professionalism in the provision of care",
          text_ar:
            "In alignment with Dubai Health Authority values in Excellence to aspire to achieve the highest standards of excellence and professionalism in the provision of care",
        },
        {
          _id: "block4",
          type: "heading",
          size: "h5",
          classname: "text-primary my-4",
          text: "Initiatives",
          text_ar: "Initiatives",
        },
        {
          _id: "block5",
          type: "div",
          classname: "grid lg:grid-cols-3 md:grid-cols-2 gap-6",
          children: [
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "ImageCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                imgSrc: "",
                imgAlt: "dubaiHousehold",
                title: "Dubai Household Health Survey",
                title_ar: "Dubai Household Health Survey",
                description:
                  "The Dubai Household Health survey is a scientific practice that is regularly implemented by healthcare organisations worldwide.",
                description_ar:
                  "The Dubai Household Health survey is a scientific practice that is regularly implemented by healthcare organisations worldwide.",
                linkTo: "#",
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "ImageCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                imgSrc: "",
                imgAlt: "dubaiHousehold",
                title: "Toghether Transplant Hope",
                title_ar: "Toghether Transplant Hope",
                description:
                  "The National Programme for Donation and Transplantation of Human Organs and Tissues – HAYAT- is a humanitarian initiative that encourages organ and tissue donation.",
                description_ar:
                  "The National Programme for Donation and Transplantation of Human Organs and Tissues – HAYAT- is a humanitarian initiative that encourages organ and tissue donation.",
                linkTo: "#",
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "ImageCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                imgSrc: "",
                imgAlt: "dubaiHousehold",
                title: "Health & Happiness Challenge",
                title_ar: "Health & Happiness Challenge",
                description:
                  "By participating in the Health & Happiness programme, you will not only prioritisze your own health but also contribute to the vitality of the Dubai community",
                description_ar:
                  "By participating in the Health & Happiness programme, you will not only prioritisze your own health but also contribute to the vitality of the Dubai community",
                linkTo: "#",
              },
            },
          ],
        },
        {
          _id: "block4",
          type: "heading",
          size: "h5",
          classname: "text-primary my-4",
          text: "Projects",
          text_ar: "Projects",
        },
        {
          _id: "block5",
          type: "div",
          classname: "grid lg:grid-cols-3 md:grid-cols-2 gap-6",
          children: [
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "ImageCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                imgSrc: "",
                imgAlt: "dubaiHousehold",
                title: "Dubai Household Health Survey",
                title_ar: "Dubai Household Health Survey",
                description:
                  "The Dubai Household Health survey is a scientific practice that is regularly implemented by healthcare organisations worldwide.",
                description_ar:
                  "The Dubai Household Health survey is a scientific practice that is regularly implemented by healthcare organisations worldwide.",
                linkTo: "#",
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "ImageCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                imgSrc: "",
                imgAlt: "dubaiHousehold",
                title: "Toghether Transplant Hope",
                title_ar: "Toghether Transplant Hope",
                description:
                  "The National Programme for Donation and Transplantation of Human Organs and Tissues – HAYAT- is a humanitarian initiative that encourages organ and tissue donation.",
                description_ar:
                  "The National Programme for Donation and Transplantation of Human Organs and Tissues – HAYAT- is a humanitarian initiative that encourages organ and tissue donation.",
                linkTo: "#",
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "ImageCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                imgSrc: "",
                imgAlt: "dubaiHousehold",
                title: "Health & Happiness Challenge",
                title_ar: "Health & Happiness Challenge",
                description:
                  "By participating in the Health & Happiness programme, you will not only prioritisze your own health but also contribute to the vitality of the Dubai community",
                description_ar:
                  "By participating in the Health & Happiness programme, you will not only prioritisze your own health but also contribute to the vitality of the Dubai community",
                linkTo: "#",
              },
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Projects & Initiatives",
      icon: "menu_book",
      url: "/aboutus/projectsAndInitiatives",
    },
  ],
};

export const HealthSector = {
  _id: "mypage",
  title: "Health Sector",
  title_ar: "Health Sector",
  slug: "about-us",
  layout: "default",
  metaTitle: "Health Sector",
  metaDescription: "Health Sector",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Dubai Health Sector Strategies",
          text_ar: "Dubai Health Sector Strategies",
          classname: "md:!my-4 my-2 Medium  text-primary",
        },
        {
          _id: "block5",
          type: "div",
          classname: "grid xl:grid-cols-5 sm:grid-cols-2 gap-4 my-4",
          children: [
            {
              _id: "block3",
              type: "linking",
              // text: " Click here.",
              classname: "",
              href: "#",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    image_src: "",
                    date_text: "08 Dec 2023",
                    custom_class: "cursos-pointer",
                    component_mode: "",
                    class: "hydrated",
                  },
                  children: [
                    {
                      _id: "block5",
                      type: "div",
                      classname: "-mt-4",
                      children: [
                        {
                          _id: "block5",
                          type: "div",
                          classname: "flex justify-between mb-3",
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: "Awareness Guide for Pilgrims",
                              text_ar: "Awareness Guide for Pilgrims",
                              classname: "body Bold text-primary",
                            },
                            {
                              _id: "",
                              type: "icon",
                              icon_library: "fas", // material || fas
                              icon: `<i class='fa-regular fa-circle-arrow-right text-primary text-xl'></i>`, // for fas
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block3",
              type: "linking",
              // text: " Click here.",
              classname: "",
              href: "#",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    image_src: "",
                    date_text: "08 Dec 2023",
                    custom_class: "cursos-pointer",
                    component_mode: "",
                    class: "hydrated",
                  },
                  children: [
                    {
                      _id: "block5",
                      type: "div",
                      classname: "-mt-4",
                      children: [
                        {
                          _id: "block5",
                          type: "div",
                          classname: "flex justify-between mb-3",
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: "Awareness Guide for Pilgrims",
                              text_ar: "Awareness Guide for Pilgrims",
                              classname: "body Bold text-primary",
                            },
                            {
                              _id: "",
                              type: "icon",
                              icon_library: "fas", // material || fas
                              icon: (
                                <i class='fa-regular fa-circle-arrow-right text-primary text-xl'></i>
                              ), // for fas
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block3",
              type: "linking",
              // text: " Click here.",
              classname: "",
              href: "#",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    image_src: "",
                    date_text: "08 Dec 2023",
                    custom_class: "cursos-pointer",
                    component_mode: "",
                    class: "hydrated",
                  },
                  children: [
                    {
                      _id: "block5",
                      type: "div",
                      classname: "-mt-4",
                      children: [
                        {
                          _id: "block5",
                          type: "div",
                          classname: "flex justify-between mb-3",
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: "Awareness Guide for Pilgrims",
                              text_ar: "Awareness Guide for Pilgrims",
                              classname: "body Bold text-primary",
                            },
                            {
                              _id: "",
                              type: "icon",
                              icon_library: "fas", // material || fas
                              icon: (
                                <i class='fa-regular fa-circle-arrow-right text-primary text-xl'></i>
                              ), // for fas
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block3",
              type: "linking",
              // text: " Click here.",
              classname: "",
              href: "#",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    image_src: "",
                    date_text: "08 Dec 2023",
                    custom_class: "cursos-pointer",
                    component_mode: "",
                    class: "hydrated",
                  },
                  children: [
                    {
                      _id: "block5",
                      type: "div",
                      classname: "-mt-4",
                      children: [
                        {
                          _id: "block5",
                          type: "div",
                          classname: "flex justify-between mb-3",
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: "Awareness Guide for Pilgrims",
                              text_ar: "Awareness Guide for Pilgrims",
                              classname: "body Bold text-primary",
                            },
                            {
                              _id: "",
                              type: "icon",
                              icon_library: "fas", // material || fas
                              icon: (
                                <i class='fa-regular fa-circle-arrow-right text-primary text-xl'></i>
                              ), // for fas
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block3",
              type: "linking",
              // text: " Click here.",
              classname: "",
              href: "#",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    image_src: "",
                    date_text: "08 Dec 2023",
                    custom_class: "cursos-pointer",
                    component_mode: "",
                    class: "hydrated",
                  },
                  children: [
                    {
                      _id: "block5",
                      type: "div",
                      classname: "-mt-4",
                      children: [
                        {
                          _id: "block5",
                          type: "div",
                          classname: "flex justify-between mb-3",
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: "Awareness Guide for Pilgrims",
                              text_ar: "Awareness Guide for Pilgrims",
                              classname: "body Bold text-primary",
                            },
                            {
                              _id: "",
                              type: "icon",
                              icon_library: "fas", // material || fas
                              icon: (
                                <i class='fa-regular fa-circle-arrow-right text-primary text-xl'></i>
                              ), // for fas
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Dubai Health Sector Strategies",
      icon: "menu_book",
      url: "/healthdubai/DubaiHealthSectorStrategies",
    },
  ],
};

export const MedicalRegistry = {
  _id: "mypage",
  title: "Medical Registery Detail",
  title_ar: "Medical Registery Detail",
  slug: "about-us",
  layout: "default",
  metaTitle: "Medical Registery Detail",
  metaDescription: "Medical Registery Detail",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Dubai Medical Registry",
          text_ar: "Dubai Medical Registry",
          classname: "md:!my-4 my-2 Medium  text-primary",
        },
        {
          _id: "block5",
          type: "div",
          classname: "flex items-center md:gap-6 gap-3 mb-8 shadow rounded-xl",
          children: [
            {
              _id: "block5",
              type: "div",
              classname:
                "md:w-48 md:h-56 w-32 h-40  overflow-hidden flex-shrink-0",
              children: [
                {
                  _id: "block2",
                  type: "image",
                  src: "DHA-CEO.jpg",
                  size: "fullwidth",
                  classname: "w-full h-full object-cover rounded-s-xl",
                  alt: "Dr. Marwan Al Mulla",
                  // onError: `(e) => {
                  //   e?.target?.style?.display = "none";
                  //   e?.target?.nextSibling?.style?.display = "flex";
                  // }`,
                },
              ],
            },
            {
              _id: "block5",
              type: "div",
              classname: "flex-1",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "Dr. Marwan Al Mulla",
                  text_ar: "Dr. Marwan Al Mulla",
                  classname: "mb-2",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: "Family Medicine",
                  text_ar: "Family Medicine",
                  classname: "body text-onSurfaceVariant",
                },
              ],
            },
          ],
        },
        {
          _id: "block5",
          type: "div",
          classname: "mb-6",
          children: [
            {
              _id: "block5",
              type: "div",
              classname:
                "bg-[#E4EFF3] px-4 py-3 rounded-t-xl border border-outline",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: "Specialities",
                  text_ar: "Specialities",
                  classname: "Medium",
                },
              ],
            },
            {
              _id: "block5",
              type: "div",
              classname:
                "bg-white p-4 rounded-b-xl border border-t-0 border-outline",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "Family Medicine",
                  text_ar: "Family Medicine",
                  classname: "mb-3",
                },
                {
                  _id: "block5",
                  type: "div",
                  classname: "space-y-1 body text-onSurfaceVariant",
                  children: [
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: "Al Badaa Medical Center - PHC",
                      text_ar: "Al Badaa Medical Center - PHC",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: "License: 00212892-002",
                      text_ar: "License: 00212892-002",
                      classname: "",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block5",
          type: "div",
          classname: "mb-6",
          children: [
            {
              _id: "block5",
              type: "div",
              classname:
                "bg-[#E4EFF3] px-4 py-3 rounded-t-xl border border-outline",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: "Experience",
                  text_ar: "Experience",
                  classname: "Medium",
                },
              ],
            },
            {
              _id: "block5",
              type: "div",
              classname:
                "bg-white p-4 rounded-b-xl border border-t-0 border-outline",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "Specialist Family Medicine",
                  text_ar: "Specialist Family Medicine",
                  classname: "mb-3",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: "08 December 2022 - 08 March 2023 (3 Months) , Dubai,UAE",
                  text_ar:
                    "08 December 2022 - 08 March 2023 (3 Months) , Dubai,UAE",
                  classname: "body text-onSurfaceVariant",
                },
              ],
            },
          ],
        },
        {
          _id: "block5",
          type: "div",
          classname: "mb-6",
          children: [
            {
              _id: "block5",
              type: "div",
              classname:
                "bg-[#E4EFF3] px-4 py-3 rounded-t-xl border border-outline",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: "Education",
                  text_ar: "Education",
                  classname: "Medium",
                },
              ],
            },
            {
              _id: "block5",
              type: "div",
              classname:
                "bg-white p-4 rounded-b-xl border border-t-0 border-outline",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "Dubai Medical College",
                  text_ar: "Dubai Medical College",
                  classname: "mb-3",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: "Graduated 2004 , United Arab Emirates (UAE), Dubai",
                  text_ar: "Graduated 2004 , United Arab Emirates (UAE), Dubai",
                  classname: "body text-onSurfaceVariant",
                },
              ],
            },
          ],
        },
        {
          _id: "block5",
          type: "div",
          classname: "mb-8",
          children: [
            {
              _id: "block5",
              type: "div",
              classname:
                "bg-[#E4EFF3] px-4 py-3 rounded-t-xl border border-outline",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: "Languages",
                  text_ar: "Languages",
                  classname: "Medium",
                },
              ],
            },
            {
              _id: "block5",
              type: "div",
              classname:
                "bg-white p-4 rounded-b-xl border border-t-0 border-outline",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "English , Arabic",
                  text_ar: "English , Arabic",
                  classname: "mb-3",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Dubai Medical Registry ",
      icon: "menu_book",
      url: "/healthdubai/dubaiMedicalRegistry",
    },
  ],
};

export const MedicalEducationandResearch = {
  _id: "mypage",
  title: "MedicalEducation and research",
  title_ar: "MedicalEducation and research",
  slug: "about-us",
  layout: "default",
  metaTitle: "MedicalEducation and research",
  metaDescription: "MedicalEducation and research",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "16_Medical Education and Research - About Medical Education.jpg",
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "About Medical Education & Research",
          text_ar: "About Medical Education & Research",
          classname: "md:!mb-4 mb-3 Medium  text-primary",
        },
        {
          _id: "block1",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-4/5",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "p",
                  text: `The Medical Education Department was established in 2001. This
          department aims to provide innovative educational opportunities, which
          will be reflected in the quality of service offered by the health
          sector in the Emirate of Dubai through its different sections, such as
          the Medical Training section, the Medical Education section, the
          Medical Research section, in addition to the Medical Library services.
          <br />
          The Medical Education Department is regarded as one of the most
          esteemed departments within the Dubai Health Authority, responsible
          for governing and overseeing medical education and research in the
          Emirate of Dubai. It also focuses on enhancing the skills and
          technical competence of healthcare professionals employed in Dubai to
          improve the medical and administrative services the Authority provides
          and align them with contemporary requirements.`,
                  text_ar: `The Medical Education Department was established in 2001. This
          department aims to provide innovative educational opportunities, which
          will be reflected in the quality of service offered by the health
          sector in the Emirate of Dubai through its different sections, such as
          the Medical Training section, the Medical Education section, the
          Medical Research section, in addition to the Medical Library services.
          <br />
          The Medical Education Department is regarded as one of the most
          esteemed departments within the Dubai Health Authority, responsible
          for governing and overseeing medical education and research in the
          Emirate of Dubai. It also focuses on enhancing the skills and
          technical competence of healthcare professionals employed in Dubai to
          improve the medical and administrative services the Authority provides
          and align them with contemporary requirements.`,
                  classname: "md:!my-4 my-2 Regular text-onSurfaceVariant body",
                },
              ],
            },
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-1/5",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    header_text:
                      "Medical Education & Research Lows & Regulations",
                    header_text_ar:
                      "Medical Education & Research Lows & Regulations",
                    right_button_name: "View",
                    right_button_href: "https://example.com",
                    right_button_rel: "",
                    right_button_start_icon: "",
                    right_button_end_icon: "",
                    right_button_data_fancybox: "",
                    custom_class: "imageCard",
                    component_mode: "",
                    class: "hydrated",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "About Medical Education & Research ",
      icon: "menu_book",
      url: "/medicalEducationAndResearch",
    },
  ],
};

export const MedicalResearch = {
  _id: "mypage",
  title: "Medical Research",
  title_ar: "Medical Research",
  slug: "about-us",
  layout: "default",
  metaTitle: "Medical Research",
  metaDescription: "Medical Research",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Medical Research",
          text_ar: "Medical Research",
          classname: "md:!my-4 my-2 Medium  text-primary",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h5",
          text: `Dubai Health Authority is constantly working to improve the health care
        services provided in the emirate by keeping abreast of developments and
        medical solutions, encouraging medical research, and studying methods of
        diagnosing and treating various diseases. Therefore, it provides the
        following services to support researchers while ensuring the rights and
        safety of the human subjects participating in this research:`,
          text_ar: `Dubai Health Authority is constantly working to improve the health care
        services provided in the emirate by keeping abreast of developments and
        medical solutions, encouraging medical research, and studying methods of
        diagnosing and treating various diseases. Therefore, it provides the
        following services to support researchers while ensuring the rights and
        safety of the human subjects participating in this research:`,
          classname: "md:!my-4 my-2 Regular text-onSurfaceVariant",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "medical_research", //for dynamic breadcrumbs
          linker_ar: "medical_research", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "DSREC Review Application",
              title_ar: "DSREC Review Application",
              isShow_title: false,
              size: "h2",
              classname: "",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "xl:flex gap-10 mt-5",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "xl:w-3/4",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: `The Dubai Scientific Research Ethics Committee (DSREC) acts as the
              Central Ethics Committee for the Emirate of Dubai. It takes the
              final decision on health research proposal requests after
              reviewing them thoroughly during periodic meetings. DSREC
              recognizes the establishment of Local Ethics Committee within the
              academic institution, private government, or semi-government
              health institution or research centre falling under the
              jurisdiction of the Emirate of Dubai.`,
                          text_ar: `The Dubai Scientific Research Ethics Committee (DSREC) acts as the
              Central Ethics Committee for the Emirate of Dubai. It takes the
              final decision on health research proposal requests after
              reviewing them thoroughly during periodic meetings. DSREC
              recognizes the establishment of Local Ethics Committee within the
              academic institution, private government, or semi-government
              health institution or research centre falling under the
              jurisdiction of the Emirate of Dubai.`,
                          classname: "body",
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: `For more information on the different types of studies that can be
              submitted to DSREC by the Local Ethics Committee either for an
              In-depth Review/Approval or for Final Approval only`,
                          text_ar: `For more information on the different types of studies that can be
              submitted to DSREC by the Local Ethics Committee either for an
              In-depth Review/Approval or for Final Approval only`,
                          classname: "body mt-7",
                        },
                        {
                          _id: "block3",
                          type: "dda-button",
                          props: {
                            button_color: "default-primary",
                            start_icon: "",
                            button_text: "Click Here",
                            button_text_ar: "Click Here",
                            end_icon: "",
                            custom_class: "my-2",
                            component_mode: "",
                            button_id: "button",
                            aria_label: "button",
                            onclick: "console.log('clicked')",
                            button_name: "button",
                            button_name_ar: "button",
                          },
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: `Any research planned at DHA licensed facilities that don't have
              Local Ethics Committee must directly be submitted to the DSREC for
              review and approvl`,
                          text_ar: `Any research planned at DHA licensed facilities that don't have
              Local Ethics Committee must directly be submitted to the DSREC for
              review and approvl`,
                          classname: "body my-5",
                        },
                        {
                          _id: "block3",
                          type: "dda-accordion",
                          props: {
                            design: "bg-border",
                            accordion_icon_class:
                              "material-icons  material-symbols-outlined",
                            accordion_icon_text: "",
                            accordion_icon_text_ar: "",
                            header_text: "Who can apply?",
                            header_text_ar: "Who can apply?",
                            sub_title: "",
                            sub_title_ar: "",
                            body_description:
                              "Researchers, either health professionals or health university/college students, who wish to obtain ethical approval on the research planned at the research sites that fall under the jurisdiction of the emirate of Dubai.",
                            body_description_ar:
                              "Researchers, either health professionals or health university/college students, who wish to obtain ethical approval on the research planned at the research sites that fall under the jurisdiction of the emirate of Dubai.",
                            link_button_text: "",
                            link_button_text_ar: "",
                            custom_class: "",
                            component_mode: "",
                            default_open: true,
                          },
                        },
                        {
                          _id: "block3",
                          type: "dda-accordion",
                          props: {
                            design: "bg-border",
                            accordion_icon_class:
                              "material-icons  material-symbols-outlined",
                            accordion_icon_text: "",
                            accordion_icon_text_ar: "",
                            header_text: "Submission Procedures",
                            header_text_ar: "Submission Procedures",
                            sub_title: "",
                            sub_title_ar: "",
                            link_button_text: "",
                            link_button_text_ar: "",
                            custom_class: "my-4",
                            component_mode: "",
                          },
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Submit following documents to (Email DSREC@dha.gov.ae ):`,
                              text_ar: `Submit following documents to (Email DSREC@dha.gov.ae ):`,
                              classname: "body text-black",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "ul",
                              classname:
                                "text-onSurfaceVariant list-decimal list-inside !my-2 body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Cover letter on headed paper (Addressed by Principal Investigator to DSREC)",
                                  text_ar:
                                    "Cover letter on headed paper (Addressed by Principal Investigator to DSREC)",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Study proposal/Synopsis",
                                  text_ar: "Study proposal/Synopsis",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Questionnaires: If applicable, to be submitted in both English and Arabic",
                                  text_ar:
                                    "Questionnaires: If applicable, to be submitted in both English and Arabic",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Resume of Principal Investigator and Co-Investigators",
                                  text_ar:
                                    "Resume of Principal Investigator and Co-Investigators",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Source of funding, if applicable, please submit supporting documents along with funding requirements",
                                  text_ar:
                                    "Source of funding, if applicable, please submit supporting documents along with funding requirements",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "All relevant enclosures such as Data Collection Tool/Case Report form / proforma/ follow-up cards etc.",
                                  text_ar:
                                    "All relevant enclosures such as Data Collection Tool/Case Report form / proforma/ follow-up cards etc.",
                                  classname: "",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Note: If the attachments size exceeds 120 MB, please notify us
                    through DSREC@dha.gov.ae so that we can share with you a secured
                    link to upload the required documents.`,
                              text_ar: `Note: If the attachments size exceeds 120 MB, please notify us
                    through DSREC@dha.gov.ae so that we can share with you a secured
                    link to upload the required documents.`,
                              classname: "caption text-primary",
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "dda-accordion",
                          props: {
                            design: "bg-border",
                            accordion_icon_class:
                              "material-icons  material-symbols-outlined",
                            accordion_icon_text: "",
                            accordion_icon_text_ar: "",
                            header_text: "Payment Procedure",
                            header_text_ar: "Payment Procedure",
                            sub_title: "",
                            sub_title_ar: "",
                            link_button_text: "",
                            link_button_text_ar: "",
                            custom_class: "my-4",
                            component_mode: "",
                          },
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `At the end of the application review process, the research
                coordinator will contact you to proceed with the payment before
                receiving the DSREC decision letter.`,
                              text_ar: `At the end of the application review process, the research
                coordinator will contact you to proceed with the payment before
                receiving the DSREC decision letter.`,
                              classname: "body",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "ul",
                              classname:
                                "text-onSurfaceVariant list-decimal list-inside body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Payment is accepted through bank transfer to Dubai Health Authority's Bank Account. For details, please",
                                  text_ar:
                                    "Payment is accepted through bank transfer to Dubai Health Authority's Bank Account. For details, please",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "linking",
                                      text: " Click here.",
                                      text_ar: " Click here.",
                                      classname: "text-primary underline",
                                      href: "#",
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "Please send the transfer proof (receipt) to DSREC@dha.gov.ae, then payment will be confirmed with the Finance Dept team who will then share the payment voucher.",
                                  text_ar:
                                    "Please send the transfer proof (receipt) to DSREC@dha.gov.ae, then payment will be confirmed with the Finance Dept team who will then share the payment voucher.",
                                  classname: "",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "li",
                                  text: "An additional AED 20 will be charged as Knowledge and Innovation fees.",
                                  text_ar:
                                    "An additional AED 20 will be charged as Knowledge and Innovation fees.",
                                  classname: "",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block1",
                      type: "div",
                      classname: "xl:w-1/4 *:mb-4 xl:my-0 my-4 ",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "border rounded-lg border-outline py-4 px-3",
                          children: [
                            {
                              _id: "block8",
                              type: "custom_components",
                              custom_components: "FileDownloadRow",
                              text: "Vision",
                              text_ar: "Vision",
                              props: {
                                fileIcon:
                                  "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                                fileName:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                fileName_ar:
                                  "Hospitals & DSC Class C mandatory emergency medications request form",
                                downloadIcon:
                                  "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                                onDownload: () => {
                                  /* handle download */
                                  alert("test");
                                },
                                // fileSize: "78 MB",
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Filing Research Related Complaint",
              title_ar: "Filing Research Related Complaint",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Research Consultation Service",
              title_ar: "Research Consultation Service",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Medical Research",
      icon: "home",
      url: "/medicalEducationAndResearch/medicalResearch",
    },
    {
      text: "medical_research", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/medicalEducationAndResearch/medicalResearch",
    },
  ],
};

export const MedicalEducation = {
  _id: "mypage",
  title: "Medical Education",
  title_ar: "Medical Education",
  slug: "about-us",
  layout: "default",
  metaTitle: "Medical Education",
  metaDescription: "Medical Education",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Medical Education",
          text_ar: "التعليم الطبي",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block3",
          type: "paragraph",
          size: "normal",
          text: "At the Dubai Health Authority, we are committed to delivering advanced, accredited internship, residency, and fellowship programmes that meet the needs of the national medical workforce and support their professional growth in response to the rising demand for specialised healthcare professionals. <br /> Our programmes follow well-established international standards, creating a modern and stimulating educational environment that equips trainees to become competent, healthcare practitioners. They are aligned with nationally and internationally recognised training frameworks, including the National Institute for Health Specialties (NIHS), the Accreditation Council for Graduate Medical Education (ACGME), and the Arab Board of Health Specialisations (ABHS). <br /> We emphasise competency-based training through a structured approach that integrates research, clinical simulation, and soft skills development.  The training process is further supported effective progress tracking, programme evaluation, and continuous quality assurance for medical education at the Authority.",
          text_ar:
            "في هيئة الصحة بدبي، نحرص على توفير برامج تدريبية متقدمة ومعتمدة في مجالي الامتياز والإقامة والزمالة، تلبي احتياجات الكوادر الطبية الوطنية، وتدعم تطورها المهني، في ظل الطلب المتزايد على الكفاءات الصحية المتخصصة. <br /> تعتمد برامجنا على معايير عالمية راسخة، وتركّز على بناء بيئة تعليمية حديثة ومحفّزة، تُعزز من قدرات الأطباء المتدربين، ليصبحوا ممارسين صحيين مؤهلين. تم تصميم البرامج وفقاً لأطر تدريبية معتمدة دولياً ومحلياً، من: المعهد الوطني للتخصصات الصحية NIHS، والمجلس الأمريكي للتعليم العالي ACGME، والمجلس العربي للاختصاصات الصحية، حيث تستند هذه البرامج إلى مبدأ التدريب المبني على الكفاءة، ضمن منهجية منظمة ومتكاملة، تشمل: البحث العلمي، والمحاكاة السريرية، وتطوير المهارات الشخصية. <br /> كما يتم دعم العملية التدريبية، من خلال متابعة تقدم المتدربين، وتقييم فعالية البرامج، وضمان جودة مخرجات التعليم الطبي المستمر في الهيئة.",
          classname: "body mb-4",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "medical_education", //for dynamic breadcrumbs
          linker_ar: "medical_education", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "mb-5",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Dubai Residency Training Programme",
              title_ar: "برنامج دبي التدريبي للتخصصات الطبية",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "lg:flex gap-5",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-4/5",
                      children: [
                        {
                          _id: "block3",
                          type: "dda-accordion",
                          props: {
                            design: "bg-border",
                            accordion_icon_class:
                              "material-icons  material-symbols-outlined",
                            accordion_icon_text: "",
                            accordion_icon_text_ar: "",
                            accordion_header_end_icon: "",
                            accordion_id: "accordionOne",
                            header_text: "Internship Programme",
                            header_text_ar: "برنامج الامتياز",
                            sub_title: "",
                            sub_title_ar: "",
                            body_description: "",
                            body_description_ar: "",
                            link_button_text: "",
                            link_button_text_ar: "",
                            custom_class: "my-3",
                            component_mode: "",
                            default_open: "false",
                          },
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: "As part of the Dubai Health Authority’s strategy to support the healthcare workforce, the Internship Programme offers a one-year clinical training opportunity for graduates of nationally and internationally recognised medical and dental schools. The programme aims to facilitate the transition from academic education to practical application under the supervision of consultants across various specialties, thereby enhancing clinical skills and ensuring continuity of patient care. <br /> Our programmes provide aspiring physicians and dentists with valuable hands-on experience, the opportunity to refine their clinical competencies, and the chance to work alongside distinguished faculty members in a supportive environment. Interns are exposed to a wide range of specialties and clinical settings, enabling them to explore their interests and build a solid foundation for a successful career in healthcare.",
                              text_ar:
                                "انطلاقاً من استراتيجية هيئة الصحة بدبي في دعم الكوادر الصحية، يوفر برنامج الامتياز تدريباً عملياً لمدة عام لخريجي كليات الطب البشري، وطب الأسنان المعترف بها محلياً ودولياً، بهدف تأهيلهم للانتقال من التعليم الأكاديمي إلى التطبيق العملي تحت إشراف استشاريين في مختلف التخصصات، بما يعزز مهاراتهم السريرية، ويضمن استمرارية الرعاية الطبية. وتتيح برامجنا للأطباء الطموحين فرصة اكتساب خبرة عملية قيّمة، وصقل مهاراتهم السريرية، والعمل جنباً إلى جنب مع أعضاء هيئة تدريس مرموقين في بيئة داعمة. كما يُتاح للمتدربين في كل من الطب وطب الأسنان، استكشاف مجموعة متنوعة من التخصصات والبيئات السريرية، مما يساعدهم على تحديد اهتماماتهم وبناء أسس قوية لمسيرة مهنية ناجحة في مجال الرعاية الصحية.",
                              classname: "body mb-4",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-1/5",
                      children: [
                        {
                          _id: "block3",
                          type: "dda-accordion",
                          props: {
                            design: "bg-border",
                            accordion_icon_class:
                              "material-icons  material-symbols-outlined",
                            accordion_icon_text: "",
                            accordion_icon_text_ar: "",
                            accordion_header_end_icon: "",
                            accordion_id: "accordionOne",
                            header_text: "Support",
                            header_text_ar: "Support",
                            sub_title: "",
                            sub_title_ar: "",
                            body_description: "",
                            body_description_ar: "",
                            link_button_text: "",
                            link_button_text_ar: "",
                            custom_class: "my-3",
                            component_mode: "",
                            default_open: "false",
                          },
                          children: [
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `info@dha.gov.ae <br />
                  800 342 Toll free (24/7)`,
                              text_ar: `info@dha.gov.ae <br />
                  800 342 Toll free (24/7)`,
                              classname: "text-onSurfaceVariant -mt-2",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block1",
                  type: "div",
                  classname: "lg:flex gap-5",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-1/5",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "lg:overflow-y-none overflow-y-auto lg:max-h-none max-h-[250px]",
                          children: [
                            {
                              _id: "block100",
                              type: "dda-tabs",
                              view: "primary-card",
                              linker: "education_control",
                              linker_ar: "education_control",
                              props: {
                                type: "text",
                                hover_style: "dda-tab-underline-filled",
                                custom_class: "",
                                component_mode: "",
                                button_id: "button",
                                aria_label: "tabs",
                                onclick: "alert()",
                                tab_type: "dda-vertical-tab",
                                button_name: "button",
                                button_name_ar: "button",
                              },
                              children: [
                                {
                                  title: "Dubai Residency",
                                  title_ar: "Dubai Residency",
                                },
                                {
                                  title: "Basic healthcare program",
                                  title_ar: "Basic healthcare program",
                                },
                                {
                                  title:
                                    "Excluded healthcare services except medical emergencies",
                                  title_ar:
                                    "Excluded healthcare services except medical emergencies",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-4/5",
                      children: [
                        {
                          _id: "block2",
                          type: "tabcontent",
                          useLinker: true,
                          linker: "education_control",
                          linker_ar: "education_control",
                          title: "Dubai Residency",
                          title_ar: "Dubai Residency",
                          isShow_title: false,
                          size: "h2",
                          classname: "",
                          children: [
                            {
                              _id: "block1",
                              type: "div",
                              classname: "lg:w-4/5",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary body md:!mb-4 mb-2",
                                  text: "Registration is open from 18 February until 24 March 2024*",
                                  text_ar:
                                    "Registration is open from 18 February until 24 March 2024*",
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Eligibility Criteria",
                                    header_text_ar: "Eligibility Criteria",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Acceptance Criteria",
                                    header_text_ar: "Acceptance Criteria",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Priority for UAE Nationals in all specialties.",
                                          text_ar:
                                            "Priority for UAE Nationals in all specialties.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining GPA high score in MBBS/MD (transcript should Providing the total score as GPA format),",
                                          text_ar:
                                            "Obtaining GPA high score in MBBS/MD (transcript should Providing the total score as GPA format),",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining a high score in EMREE/ EDREE result",
                                          text_ar:
                                            "Obtaining a high score in EMREE/ EDREE result",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining a high score in Multiple Mini Interviews (MMI)",
                                          text_ar:
                                            "Obtaining a high score in Multiple Mini Interviews (MMI)",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining a high score in Specialty Interview",
                                          text_ar:
                                            "Obtaining a high score in Specialty Interview",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining a high score in English Exam",
                                          text_ar:
                                            "Obtaining a high score in English Exam",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block1",
                                  type: "div",
                                  classname: "dda-table-container",
                                  children: [
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "overflow-x-auto",
                                      children: [
                                        {
                                          _id: "table1",
                                          type: "table",
                                          classname:
                                            "dda-table w-full min-w-[650px]",
                                          children: [
                                            {
                                              id: "table_header",
                                              type: "tableItems",
                                              type_identifier: "thead",
                                              classname: "body",
                                              children: [
                                                {
                                                  _id: "tableTR",
                                                  type: "tableItems",
                                                  type_identifier: "tr",
                                                  classname: "rounded-xl",
                                                  children: [
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "th",
                                                      classname: "Bold body",
                                                      text: "Specialty",
                                                      text_ar: "Specialty",
                                                    },
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "th",
                                                      classname: "Bold body",
                                                      text: "Duration",
                                                      text_ar: "Duration",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                            {
                                              _id: "table_body",
                                              type: "tableItems",
                                              type_identifier: "tbody",
                                              classname: "body",
                                              children: [
                                                {
                                                  _id: "tableTR",
                                                  type: "tableItems",
                                                  type_identifier: "tr",
                                                  classname: "",
                                                  children: [
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "Family Medicine",
                                                          text_ar:
                                                            "Family Medicine",
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "Yes",
                                                          text_ar: "Yes",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "tableTR",
                                                  type: "tableItems",
                                                  type_identifier: "tr",
                                                  classname: "",
                                                  children: [
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "Obstetrics & Gynecology",
                                                          text_ar:
                                                            "Obstetrics & Gynecology",
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "Yes",
                                                          text_ar: "Yes",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "tableTR",
                                                  type: "tableItems",
                                                  type_identifier: "tr",
                                                  classname: "",
                                                  children: [
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "Ortho & Trauma Surgery",
                                                          text_ar:
                                                            "Ortho & Trauma Surgery",
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "Yes",
                                                          text_ar: "Yes",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "tableTR",
                                                  type: "tableItems",
                                                  type_identifier: "tr",
                                                  classname: "",
                                                  children: [
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "Ophthalmology",
                                                          text_ar:
                                                            "Ophthalmology",
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "Yes",
                                                          text_ar: "Yes",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "tableTR",
                                                  type: "tableItems",
                                                  type_identifier: "tr",
                                                  classname: "",
                                                  children: [
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "General Surgery",
                                                          text_ar:
                                                            "General Surgery",
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTH",
                                                      type: "tableItems",
                                                      type_identifier: "td",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "paragraph",
                                                          size: "normal",
                                                          classname: "",
                                                          text: "Yes",
                                                          text_ar: "Yes",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Unified Internship Programme In Dubai",
              title_ar: "Unified Internship Programme In Dubai",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Medical Education",
      icon: "home",
      url: "/medicalEducationAndResearch/medicalEducation",
    },
    {
      text: "medical_education", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/medicalEducationAndResearch/medicalEducation",
    },
  ],
};

export const MedicalLibrary = {
  _id: "mypage",
  title: "Medical Library",
  title_ar: "Medical Library",
  slug: "about-us",
  layout: "default",
  metaTitle: "Medical Library",
  metaDescription: "Medical Library",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "17_Medical Education and Research - Medical Library.jpg",
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Medical Library",
          text_ar: "Medical Library",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block3",
          type: "paragraph",
          size: "normal",
          text: `Dubai Health Authority (DHA) / Medical Education and Research Department
        provides a comprehensive "Electronic Medical Library" to keep in line
        with the latest trends in e-government practices.
        <br />
        The library provides Medical and Health Information Resources of for all
        employees in DHA and the Local Community and trains them to acquire
        high-quality skills. The library seeks to provide up-to-date collections
        of Books, Journals, Clinical and Drug Databases, Continuing Medical
        Education to support all evidence-based Medical Practices, Nursing,
        Para-Medical, Pharmaceutical, Administrative, Residency and Internship
        Programmes.
        <br />
        The library works on developing electronic content through
        subscriptions, ownership, and open content, managing and preparing it to
        support research in DHA through the library portal. It also works on
        providing the necessary requirements for accrediting private hospitals
        in accordance with local and international requirements and professional
        associations.
        <br />
        To access the electronic medical library, please click on the following
        link: `,
          text_ar: `Dubai Health Authority (DHA) / Medical Education and Research Department
        provides a comprehensive "Electronic Medical Library" to keep in line
        with the latest trends in e-government practices.
        <br />
        The library provides Medical and Health Information Resources of for all
        employees in DHA and the Local Community and trains them to acquire
        high-quality skills. The library seeks to provide up-to-date collections
        of Books, Journals, Clinical and Drug Databases, Continuing Medical
        Education to support all evidence-based Medical Practices, Nursing,
        Para-Medical, Pharmaceutical, Administrative, Residency and Internship
        Programmes.
        <br />
        The library works on developing electronic content through
        subscriptions, ownership, and open content, managing and preparing it to
        support research in DHA through the library portal. It also works on
        providing the necessary requirements for accrediting private hospitals
        in accordance with local and international requirements and professional
        associations.
        <br />
        To access the electronic medical library, please click on the following
        link: `,
          classname: "md:!my-4 my-2 Regular text-onSurfaceVariant body",
          children: [
            {
              _id: "block3",
              type: "htmlTag",
              tag: "span",
              text: "http://library.dha.gov.ae",
              text_ar: "http://library.dha.gov.ae",
              classname: "text-primary underline",
            },
            {
              _id: "block3",
              type: "paragraph",
              size: "normal",
              text: "DHA Licensees Library Membership ",
              text_ar: "DHA Licensees Library Membership ",
              classname: "",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  text: "https://library.dha.gov.ae/pages/4769/DHA_Licensee",
                  text_ar: "https://library.dha.gov.ae/pages/4769/DHA_Licensee",
                  classname: "text-primary underline",
                },
              ],
            },
          ],
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "medical_library", //for dynamic breadcrumbs
          linker_ar: "medical_library", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "mb-4 mt-2",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Dubai Medical Journals",
              title_ar: "Dubai Medical Journals",
              isShow_title: false,
              size: "h2",
              classname: "",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "Dubai Medical Journals",
                  text_ar: "Dubai Medical Journals",
                  classname: "text-primary Medium",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `Refered Journals are the first platform for researchers to publish
            their latest findings of scientific research in order for the
            society to learn about their results. Hence, the initiative and
            support of Dubai Health Authority to issue two refereed Medical
            Journals under the name “Dubai Medical Journal” and “Dubai Diabetes
            & Endocrinology Journal". To encourage researchers, the "Open Access
            Content" model has been adopted for both the researcher and reader
            to publish and read without fees.`,
                  text_ar: `Refered Journals are the first platform for researchers to publish
            their latest findings of scientific research in order for the
            society to learn about their results. Hence, the initiative and
            support of Dubai Health Authority to issue two refereed Medical
            Journals under the name “Dubai Medical Journal” and “Dubai Diabetes
            & Endocrinology Journal". To encourage researchers, the "Open Access
            Content" model has been adopted for both the researcher and reader
            to publish and read without fees.`,
                  classname: "body my-3",
                },
                {
                  _id: "block3",
                  type: "dda-pricing-card",
                  props: {
                    image_src: "",
                    header_text: "Aims and Scope",
                    header_text_ar: "Aims and Scope",
                    body_text: `The mission of the Dubai Medical Journal is to encourage innovative research by promoting original scientific research in the fields of medicine,
              health sciences, nursing, pharmaceuticals, and laboratory and other related sciences. Non-clinical subjects related to medicine, especially ethics and 
              complementary medicine as well as social and cultural issues, are also covered.
              As international as Dubai itself, the journal offers a global perspective, but also focusses on the United Arab Emirates. 
              Partnerships with local and international medical and health authorities are envisaged.
              The journal facilitates the dissemination of information through research articles, review articles, case reports, editorials, letters, 
              book reviews, meeting reports, and discussions. An educational corner will help to ensure continuous professional development and education.
                Besides this, the journal also offers a platform for controversies, mythology, and much more.
              The journal recently obtained a Journal Impact Factor of 1.4`,
                    price_period:
                      "Editor-in-Chief Wadeia Sharief – Dubai Health Authority, Dubai, UAE",
                    body_text_ar: `The mission of the Dubai Medical Journal is to encourage innovative research by promoting original scientific research in the fields of medicine,
              health sciences, nursing, pharmaceuticals, and laboratory and other related sciences. Non-clinical subjects related to medicine, especially ethics and 
              complementary medicine as well as social and cultural issues, are also covered.
              As international as Dubai itself, the journal offers a global perspective, but also focusses on the United Arab Emirates. 
              Partnerships with local and international medical and health authorities are envisaged.
              The journal facilitates the dissemination of information through research articles, review articles, case reports, editorials, letters, 
              book reviews, meeting reports, and discussions. An educational corner will help to ensure continuous professional development and education.
                Besides this, the journal also offers a platform for controversies, mythology, and much more.
              The journal recently obtained a Journal Impact Factor of 1.4`,
                    custom_class: "custom-card-bg",
                    component_mode: "",
                    class: "hydrated",
                  },
                },
                {
                  _id: "block1",
                  type: "div",
                  classname: "grid lg:grid-cols-4 sm:grid-cols-2 gap-4 my-4",
                  children: [
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Dubai Diabetes and Endocrinology Journal",
              title_ar: "Dubai Diabetes and Endocrinology Journal",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "Dubai Diabetes and Endocrinology Journal  ",
                  text_ar: "Dubai Diabetes and Endocrinology Journal  ",
                  classname: "text-primary Medium mb-4",
                },
                {
                  _id: "block3",
                  type: "dda-pricing-card",
                  props: {
                    image_src: "",
                    header_text: "Aims and Scope",
                    header_text_ar: "Aims and Scope",
                    body_text: `Dubai Diabetes and Endocrinology Journal​ welcomes original contributions on all aspects of diabetes, endocrinology and metabolism.
             Taking into account that diabetes has become a pandemic, the journal provides a platform for worldwide communication and scientific exchange
              to researchers and clinicians dealing with diabetes. The focus of the journal lies on the publication of papers on morphological, biochemical,
               physiological, pathophysiological, and clinical aspects of research on diabetes and metabolism. In addition to research articles, further types
                of papers such as review articles, case reports, letters, editorials and commentaries make the journal a comprehensive and interesting read.
                 The researcher and practitioner who seeks to stay up-to-date on the developments in the fields of diabetes and metabolism will find a wealth
                  of information in the International Journal of Diabetes and Metabolism.​`,
                    body_text_ar: `Dubai Diabetes and Endocrinology Journal​ welcomes original contributions on all aspects of diabetes, endocrinology and metabolism.
             Taking into account that diabetes has become a pandemic, the journal provides a platform for worldwide communication and scientific exchange
              to researchers and clinicians dealing with diabetes. The focus of the journal lies on the publication of papers on morphological, biochemical,
               physiological, pathophysiological, and clinical aspects of research on diabetes and metabolism. In addition to research articles, further types
                of papers such as review articles, case reports, letters, editorials and commentaries make the journal a comprehensive and interesting read.
                 The researcher and practitioner who seeks to stay up-to-date on the developments in the fields of diabetes and metabolism will find a wealth
                  of information in the International Journal of Diabetes and Metabolism.​`,
                    price_period:
                      "Editor-in-Chief Wadeia Sharief – Dubai Health Authority, Dubai, UAE",
                    custom_class: "my-2 custom-card-bg",
                    component_mode: "",
                    class: "hydrated",
                  },
                },
                {
                  _id: "block1",
                  type: "div",
                  classname: "grid lg:grid-cols-4 sm:grid-cols-2 gap-4 my-4",
                  children: [
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "dda-image-card",
                      props: {
                        custom_class: "h-full",
                      },
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "-mt-4 px-4 pb-4",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Bibliographic Details",
                              text_ar: "Bibliographic Details",
                              classname: "text-primary",
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              text_ar: `Journal Abbreviation: Dubai Med <br />
                  Je-ISSN: 2571-726X (Online) <br />
                  DOI: 10.1159/issn.2571-726X <br />
                  `,
                              classname: "text-onSurfaceVariant body",
                              children: [
                                {
                                  _id: "block3",
                                  type: "htmlTag",
                                  tag: "span",
                                  classname: "text-primary",
                                  text: `www.karger.com/DMJ`,
                                  text_ar: `www.karger.com/DMJ`,
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Medical Library",
      icon: "home",
      url: "/medicalEducationAndResearch/medicalLibrary",
    },
    {
      text: "medical_library", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/medicalEducationAndResearch/medicalLibrary",
    },
  ],
};

export const MedicalTraining = {
  _id: "mypage",
  title: "Medical Training",
  title_ar: "Medical Training",
  slug: "about-us",
  layout: "default",
  metaTitle: "Medical Training",
  metaDescription: "Medical Training",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Medical Training",
          text_ar: "Medical Training",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "medical_training", //for dynamic breadcrumbs
          linker_ar: "medical_training", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Dubai Residency Training Programme",
              title_ar: "Dubai Residency Training Programme",
              isShow_title: false,
              size: "h2",
              classname: "",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `The Medical Education & Research Department provides medical
            education, training, and professional research and development
            opportunities to healthcare professionals in the UAE. The Medical
            Education Section established the Residency Training Programme in
            2006 with the vision of bridging the gap between university medical
            qualifications and medical professional practices.
            <br />
            The programme provides a carefully designed learning platform where
            residents are trained and evaluated continuously to develop their
            skills. In addition, residents can progress consistently in their
            responsibilities and independent practice by their level of
            knowledge and personal well-being under the guidance of healthcare
            consultants with high qualifications and experience.`,
                  text_ar: `The Medical Education & Research Department provides medical
            education, training, and professional research and development
            opportunities to healthcare professionals in the UAE. The Medical
            Education Section established the Residency Training Programme in
            2006 with the vision of bridging the gap between university medical
            qualifications and medical professional practices.
            <br />
            The programme provides a carefully designed learning platform where
            residents are trained and evaluated continuously to develop their
            skills. In addition, residents can progress consistently in their
            responsibilities and independent practice by their level of
            knowledge and personal well-being under the guidance of healthcare
            consultants with high qualifications and experience.`,
                  classname: "md:!my-4 my-2 body text-onSurfaceVariant",
                },
                {
                  _id: "block1",
                  type: "div",
                  classname: "lg:flex gap-10 mt-5",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-1/5",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "lg:overflow-y-none overflow-y-auto lg:max-h-none max-h-[250px]",
                          children: [
                            {
                              _id: "block100",
                              type: "dda-tabs",
                              view: "primary-card",
                              linker: "education_control",
                              linker_ar: "education_control",
                              props: {
                                type: "text",
                                hover_style: "dda-tab-underline-filled",
                                custom_class: "",
                                component_mode: "",
                                button_id: "button",
                                aria_label: "tabs",
                                onclick: "alert()",
                                tab_type: "dda-vertical-tab",
                                button_name: "button",
                                button_name_ar: "button",
                              },
                              children: [
                                {
                                  title: "Dubai Residency",
                                  title_ar: "Dubai Residency",
                                },
                                {
                                  title: "Basic healthcare program",
                                  title_ar: "Basic healthcare program",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-4/5",
                      children: [
                        {
                          _id: "block2",
                          type: "tabcontent",
                          useLinker: true,
                          linker: "education_control",
                          linker_ar: "education_control",
                          title: "Dubai Residency",
                          title_ar: "Dubai Residency",
                          isShow_title: false,
                          size: "h2",
                          classname: "",
                          children: [
                            {
                              _id: "block1",
                              type: "div",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary body md:!mb-4 mb-2",
                                  text: "Registration is open from 18 February until 24 March 2024*",
                                  text_ar:
                                    "Registration is open from 18 February until 24 March 2024*",
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Eligibility Criteria",
                                    header_text_ar: "Eligibility Criteria",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Acceptance Criteria",
                                    header_text_ar: "Acceptance Criteria",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Priority for UAE Nationals in all specialties.",
                                          text_ar:
                                            "Priority for UAE Nationals in all specialties.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining GPA high score in MBBS/MD (transcript should Providing the total score as GPA format),",
                                          text_ar:
                                            "Obtaining GPA high score in MBBS/MD (transcript should Providing the total score as GPA format),",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining a high score in EMREE/ EDREE result",
                                          text_ar:
                                            "Obtaining a high score in EMREE/ EDREE result",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining a high score in Multiple Mini Interviews (MMI)",
                                          text_ar:
                                            "Obtaining a high score in Multiple Mini Interviews (MMI)",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining a high score in Specialty Interview",
                                          text_ar:
                                            "Obtaining a high score in Specialty Interview",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obtaining a high score in English Exam",
                                          text_ar:
                                            "Obtaining a high score in English Exam",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        // {
                        //   _id: "block2",
                        //   type: "tabcontent",
                        //   title: "Basic healthcare program",
                        //   size: "h2",
                        //   classname: "dda-table-container",
                        //   children: [],
                        // },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Unified Internship Programme In Dubai",
              title_ar: "Unified Internship Programme In Dubai",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Medical Training",
      icon: "home",
      url: "/medicalEducationAndResearch/medicalTraining",
    },
    {
      text: "medical_training", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/medicalEducationAndResearch/medicalEducation",
    },
  ],
};

export const TrainingFacility = {
  _id: "mypage",
  title: "Training Facility",
  title_ar: "Training Facility",
  slug: "about-us",
  layout: "default",
  metaTitle: "Training Facility",
  metaDescription: "Training Facility",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Training Facilities",
          text_ar: "Training Facilities",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "medical_training", //for dynamic breadcrumbs
          linker_ar: "medical_training", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Dubai Residency Training Programme",
              title_ar: "Dubai Residency Training Programme",
              isShow_title: false,
              size: "h2",
              classname: "",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `The Medical Education & Research Department provides medical
            education, training, and professional research and development
            opportunities to healthcare professionals in the UAE. The Medical
            Education Section established the Residency Training Programme in
            2006 with the vision of bridging the gap between university medical
            qualifications and medical professional practices.
            <br />
            The programme provides a carefully designed learning platform where
            residents are trained and evaluated continuously to develop their
            skills. In addition, residents can progress consistently in their
            responsibilities and independent practice by their level of
            knowledge and personal well-being under the guidance of healthcare
            consultants with high qualifications and experience.`,
                  text_ar: `The Medical Education & Research Department provides medical
            education, training, and professional research and development
            opportunities to healthcare professionals in the UAE. The Medical
            Education Section established the Residency Training Programme in
            2006 with the vision of bridging the gap between university medical
            qualifications and medical professional practices.
            <br />
            The programme provides a carefully designed learning platform where
            residents are trained and evaluated continuously to develop their
            skills. In addition, residents can progress consistently in their
            responsibilities and independent practice by their level of
            knowledge and personal well-being under the guidance of healthcare
            consultants with high qualifications and experience.`,
                  classname: "md:!my-4 my-2 body text-onSurfaceVariant",
                },

                {
                  _id: "tableTH",
                  type: "paragraph",
                  size: "normal",
                  classname: "text-primary body md:!mb-4 mb-2",
                  text: "Registration is open from 18 February until 24 March 2024*",
                  text_ar:
                    "Registration is open from 18 February until 24 March 2024*",
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",
                    header_text: "Eligibility Criteria",
                    header_text_ar: "Eligibility Criteria",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",
                    header_text: "Acceptance Criteria",
                    header_text_ar: "Acceptance Criteria",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-disc list-inside body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Priority for UAE Nationals in all specialties.",
                          text_ar:
                            "Priority for UAE Nationals in all specialties.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Obtaining GPA high score in MBBS/MD (transcript should Providing the total score as GPA format),",
                          text_ar:
                            "Obtaining GPA high score in MBBS/MD (transcript should Providing the total score as GPA format),",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Obtaining a high score in EMREE/ EDREE result",
                          text_ar:
                            "Obtaining a high score in EMREE/ EDREE result",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Obtaining a high score in Multiple Mini Interviews (MMI)",
                          text_ar:
                            "Obtaining a high score in Multiple Mini Interviews (MMI)",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Obtaining a high score in Specialty Interview",
                          text_ar:
                            "Obtaining a high score in Specialty Interview",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Obtaining a high score in English Exam",
                          text_ar: "Obtaining a high score in English Exam",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Unified Internship Programme In Dubai",
              title_ar: "Unified Internship Programme In Dubai",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Training Facilities",
      icon: "home",
      url: "/medicalEducationAndResearch/trainingFacilities",
    },
    {
      text: "medical_training", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/medicalEducationAndResearch/trainingFacilities",
    },
  ],
};

export const HealthInsurance = {
  _id: "mypage",
  title: "Health Insurance",
  title_ar: "Health Insurance",
  slug: "about-us",
  layout: "default",
  metaTitle: "Health Insurance",
  metaDescription: "Health Insurance",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "10_Health Insurance - About Health Insurance.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "About Health Insurance",
          text_ar: "About Health Insurance",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block10",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block10",
              type: "div",
              classname: "lg:w-4/5",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `Dubai Health Insurance Corporation is affiliated with the Dubai
            Health Authority by Resolution No. (17) of 2018, issued by His
            Highness Sheikh Mohammed bin Rashid Al Maktoum, Vice President and
            Prime Minister of the United Arab Emirates and Ruler of Dubai,
            regarding establishment of Institutions Affiliated to the Dubai
            Health Authority and Determining their competences.<br />The Corporation
            is responsible for managing and supervising health insurance in the
            Emirate of Dubai by applying legislation. To view the tasks
            undertaken by the Dubai Health Insurance Corporation, please check
            the document below:`,
                  text_ar: `Dubai Health Insurance Corporation is affiliated with the Dubai
            Health Authority by Resolution No. (17) of 2018, issued by His
            Highness Sheikh Mohammed bin Rashid Al Maktoum, Vice President and
            Prime Minister of the United Arab Emirates and Ruler of Dubai,
            regarding establishment of Institutions Affiliated to the Dubai
            Health Authority and Determining their competences.<br />The Corporation
            is responsible for managing and supervising health insurance in the
            Emirate of Dubai by applying legislation. To view the tasks
            undertaken by the Dubai Health Insurance Corporation, please check
            the document below:`,
                  classname: "md:!mb-4 mb-3 Regular text-onSurfaceVariant body",
                },
              ],
            },
            {
              _id: "block5",
              type: "div",
              classname: "lg:w-1/5",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    header_text:
                      "Degree No (17) for year 2018 regarding establishment of institution belong to Dubai health corporation and specify its powers",
                    header_text_ar:
                      "Degree No (17) for year 2018 regarding establishment of institution belong to Dubai health corporation and specify its powers",
                    right_button_name: "View",
                    right_button_href: "https://example.com",
                    right_button_rel: "",
                    right_button_start_icon: "",
                    right_button_end_icon: "",
                    right_button_data_fancybox: "",
                    custom_class: "imageCard",
                    component_mode: "",
                    class: "hydrated",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "About Health Insurance",
      icon: "menu_book",
      url: "/healthinsurance",
    },
  ],
};

export const GovermentInsuranceServices = {
  _id: "mypage",
  title: "GovermentInsuranceServices",
  title_ar: "GovermentInsuranceServices",
  slug: "about-us",
  layout: "default",
  metaTitle: "GovermentInsuranceServices",
  metaDescription: "GovermentInsuranceServices",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "11_Health Insurance - Government insurance Services.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Government Insurance Services",
          text_ar: "Government Insurance Services",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block10",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block10",
              type: "div",
              classname: "lg:w-3/4",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `The Emirate of Dubai has unified all government health insurance
            systems under one umbrella, which is the unified health insurance
            system “Enaya”, which is for citizens of the Emirate of Dubai, Dubai
            government employees and their families. This transformation aims to
            surround insurance beneficiaries with one integrated, more advanced
            system and enable them to obtain high-quality medical services and
            high-level health care. <br />
            The unified government health insurance system provides the required
            medical services on a large scale, and beneficiaries can benefit
            from those services provided.`,
                  text_ar: `The Emirate of Dubai has unified all government health insurance
            systems under one umbrella, which is the unified health insurance
            system “Enaya”, which is for citizens of the Emirate of Dubai, Dubai
            government employees and their families. This transformation aims to
            surround insurance beneficiaries with one integrated, more advanced
            system and enable them to obtain high-quality medical services and
            high-level health care. <br />
            The unified government health insurance system provides the required
            medical services on a large scale, and beneficiaries can benefit
            from those services provided.`,
                  classname: "md:!mb-4 mb-3 Regular text-onSurfaceVariant body",
                },
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: `Unifying government insurance programme “Enaya”`,
                  text_ar: `Unifying government insurance programme “Enaya”`,
                  classname: "Medium md:!my-4 my-2",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `
                  The unified health insurance system, “Enaya”, included “Saada”
            insurance and other government insurance in Dubai. This
            transformation aims to surround insurance beneficiaries with one
            integrated, more advanced system and enable them to obtain
            high-quality medical services and high-level health care.The unified
            government health insurance system provides the required medical
            services on a large scale through third-party administration.
                  `,
                  text_ar: `
                  The unified health insurance system, “Enaya”, included “Saada”
            insurance and other government insurance in Dubai. This
            transformation aims to surround insurance beneficiaries with one
            integrated, more advanced system and enable them to obtain
            high-quality medical services and high-level health care.The unified
            government health insurance system provides the required medical
            services on a large scale through third-party administration.
                  `,
                  classname: "body md:!my-4 my-2",
                },
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: `Beneficiaries of the Unified Health Insurance Programme can
            communicate directly with the Dubai Health Authority or the Human
            Resources Department employees to obtain more information.`,
                  text_ar: `Beneficiaries of the Unified Health Insurance Programme can
            communicate directly with the Dubai Health Authority or the Human
            Resources Department employees to obtain more information.`,
                  classname: "text-primary Medium",
                },
              ],
            },
            {
              _id: "block10",
              type: "div",
              classname: "lg:w-1/4",
              children: [
                {
                  _id: "block10",
                  type: "div",
                  classname:
                    "border rounded-lg border-outline py-4 px-3 lg:!my-0 my-4",
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "Enaya Beneficiary Guide",
                        fileName_ar: "Enaya Beneficiary Guide",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block10",
          type: "div",
          classname:
            "grid md:grid-cols-2 gap-10 lg:!my-12 my-8 items-center bg-[#E4EFF3] p-6 rounded-2xl",
          children: [
            {
              _id: "block10",
              type: "div",
              classname: "",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  text: "DHA Mobile Application",
                  text_ar: "DHA Mobile Application",
                  classname: "text-primary text-lg",
                },
                {
                  _id: "block3",
                  type: "heading",
                  size: "h2",
                  text: "Welcome to your new digital reality.",
                  text_ar: "Welcome to your new digital reality.",
                  classname: "my-3",
                },
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: "Let us help you take you from zero to serious business and beyond. Our no-strings attached free trial lets you test our product today.",
                  text_ar:
                    "Let us help you take you from zero to serious business and beyond. Our no-strings attached free trial lets you test our product today.",
                  classname: "text-onSurfaceVariant",
                },
                {
                  _id: "block10",
                  type: "div",
                  classname: "flex gap-5 my-5",
                  children: [
                    {
                      _id: "block3",
                      type: "linking",
                      text: "",
                      text_ar: "",
                      classname: "px-4 py-3  rounded-md border border-outline",
                      href: "#",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: [
                        {
                          _id: "block2",
                          type: "image",
                          src: "Applelogo.png",
                          size: "fullwidth",
                          classname: "",
                          alt: "Apple Logo",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "linking",
                      text: "",
                      text_ar: "",
                      classname: "px-4 py-3  rounded-md border border-outline",
                      href: "#",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: [
                        {
                          _id: "block2",
                          type: "image",
                          src: "PlayStoreLogo.png",
                          size: "fullwidth",
                          classname: "",
                          alt: "Apple Logo",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "image",
              src: "Devices.png",
              size: "fullwidth",
              classname: "md:ms-auto",
              alt: "Devices",
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "About Health Insurance",
      icon: "menu_book",
      url: "/healthinsurance",
    },
  ],
};

export const SpecialProgrammes = {
  _id: "mypage",
  title: "Special Programmes",
  title_ar: "Special Programmes",
  slug: "about-us",
  layout: "default",
  metaTitle: "Special Programmes",
  metaDescription: "Special Programmes",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Special Programs",
          text_ar: "Special Programs",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h5",
          text: `The Dubai Health Authority provides specialised programmes for patients
        with more focus on outcome of care, such as the “Ejada” programme. It
        also supports patients through accreditation standards, such as the
        “BASMA” programme`,
          text_ar: `The Dubai Health Authority provides specialised programmes for patients
        with more focus on outcome of care, such as the “Ejada” programme. It
        also supports patients through accreditation standards, such as the
        “BASMA” programme`,
          classname: "Regular text-onSurfaceVariant md:!mb-4 mb-3",
        },
        {
          _id: "block3",
          type: "dda-pricing-card",
          props: {
            image_src: "",
            header_text: "BASMA Programme",
            header_text_ar: "BASMA Programme",
            body_text: `The BASMA programme was launched in January 2018 to support cancer and hepatitis C patients, to reduce cancer deaths and to ensure complete
             recovery from hepatitis C cases in the Emirate of Dubai.The programme currently includes breast cancer, colorectal cancer and cervical cancer,
             which are among the types that witness high rates of cure in the case of early detection and hepatitis (hepatitis B and hepatitis C).`,
            price_period:
              "Treatment is provided at specialized medical services centers accredited by the Dubai Health Authority.",
            custom_class: "special-program-card",
            body_text_ar: `The BASMA programme was launched in January 2018 to support cancer and hepatitis C patients, to reduce cancer deaths and to ensure complete
             recovery from hepatitis C cases in the Emirate of Dubai.The programme currently includes breast cancer, colorectal cancer and cervical cancer,
             which are among the types that witness high rates of cure in the case of early detection and hepatitis (hepatitis B and hepatitis C).`,
            component_mode: "",
            class: "hydrated",
          },
        },
        {
          _id: "block3",
          type: "dda-image-card",
          props: {
            custom_class: "h-full my-5",
            component_mode: "",
            class: "hydrated",
          },
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "-mt-4 px-4 pb-4",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: `Objectives of the "BASMA" Programme:`,
                  text_ar: `Objectives of the "BASMA" Programme:`,
                  classname: "text-primary",
                },
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "ul",
                  classname: "text-onSurfaceVariant body list-disc list-inside",
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Reducing the death rate through early detection and treatment.",
                      text_ar:
                        "Reducing the death rate through early detection and treatment.",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Alleviating the social and economic burdens of high-cost diseases.",
                      text_ar:
                        "Alleviating the social and economic burdens of high-cost diseases.",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: `To provide the necessary support to patients with cancer,
              hepatitis, and any other diseases determined by the mechanism
              stipulated and in line with the insurance coverage for each member
              of the programme.`,
                      text_ar: `To provide the necessary support to patients with cancer,
              hepatitis, and any other diseases determined by the mechanism
              stipulated and in line with the insurance coverage for each member
              of the programme.`,
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Improving patients' quality of life.",
                      text_ar: "Improving patients' quality of life.",
                      classname: "",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block3",
          type: "dda-pricing-card",
          props: {
            image_src: "",
            header_text: "EJADA Programme",
            header_text_ar: "EJADA Programme",
            body_text: `The EJADA programme was launched in November 2022 as a mechanism of modern techniques and tools to measure health quality indicators in the Emirate 
            of Dubai to provide high-quality services in line with global indicators while reducing expenses and measuring the extent of patient benefit.Recently, we have 
            begun to employ artificial intelligence technology to identify members of society most at risk of contracting diseases before they occur and reduce the
             complications of the disease in the event of infection`,
            body_text_ar: `The EJADA programme was launched in November 2022 as a mechanism of modern techniques and tools to measure health quality indicators in the Emirate 
            of Dubai to provide high-quality services in line with global indicators while reducing expenses and measuring the extent of patient benefit.Recently, we have 
            begun to employ artificial intelligence technology to identify members of society most at risk of contracting diseases before they occur and reduce the
             complications of the disease in the event of infection`,
            custom_class: "special-program-card special-program-card-extra",
            component_mode: "",
            class: "hydrated",
          },
        },
        {
          _id: "block1",
          type: "div",
          classname: "grid lg:grid-cols-2 gap-4 my-4",
          children: [
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                custom_class: "h-full",
                component_mode: "",
                class: "hydrated",
              },
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "-mt-4 px-4 pb-4",
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h5",
                      text: `Objectives of the "BASMA" Programme:`,
                      text_ar: `Objectives of the "BASMA" Programme:`,
                      classname: "text-primary",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant body list-disc list-inside",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Reducing the death rate through early detection and treatment.",
                          text_ar:
                            "Reducing the death rate through early detection and treatment.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Alleviating the social and economic burdens of high-cost diseases.",
                          text_ar:
                            "Alleviating the social and economic burdens of high-cost diseases.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `To provide the necessary support to patients with cancer,
              hepatitis, and any other diseases determined by the mechanism
              stipulated and in line with the insurance coverage for each member
              of the programme.`,
                          text_ar: `To provide the necessary support to patients with cancer,
              hepatitis, and any other diseases determined by the mechanism
              stipulated and in line with the insurance coverage for each member
              of the programme.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Improving patients' quality of life.",
                          text_ar: "Improving patients' quality of life.",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                custom_class: "h-full",
                component_mode: "",
                class: "hydrated",
              },
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "-mt-4 px-4 pb-4",
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h5",
                      text: `Expected Results of the "EJADA" programme:`,
                      text_ar: `Expected Results of the "EJADA" programme:`,
                      classname: "text-primary",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant body list-disc list-inside",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "High-quality services at lower expenses.",
                          text_ar: "High-quality services at lower expenses.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Measurements of the extent to which the patient benefits from the health services provided.",
                          text_ar:
                            "Measurements of the extent to which the patient benefits from the health services provided.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Reduction of incidence of chronic diseases as a result of early detection.`,
                          text_ar: `Reduction of incidence of chronic diseases as a result of early detection.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Reduction in disease side effects.",
                          text_ar: "Reduction in disease side effects.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Did you find the content of this page helpful?",
                          text_ar:
                            "Did you find the content of this page helpful?",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Special Programs",
      icon: "menu_book",
      url: "/healthinsurance/specialprogrammes",
    },
  ],
};

export const HealthInsurancePermitServicesData = {
  table_title: "",
  data: [
    {
      company_name: "Qatar Insurance Company",
      contact_number: "800 4742",
      insurance_price: "597",
      registration_link: "https://example.com",
      benifit_network: "https://example.com",
    },
    {
      company_name: "Cigna Insurance Middle East",
      contact_number: "800 4742",
      insurance_price: "597",
      registration_link: "https://example.com",
      benifit_network: "https://example.com",
    },
    {
      company_name: "Union Insurance Company",
      contact_number: "800 4742",
      insurance_price: "597",
      registration_link: "https://example.com",
      benifit_network: "https://example.com",
    },
    {
      company_name: "Sukoon",
      contact_number: "800 4742",
      insurance_price: "597",
      registration_link: "https://example.com",
      benifit_network: "https://example.com",
    },
    {
      company_name: "Dubai National Insurance Company",
      contact_number: "800 4742",
      insurance_price: "597",
      registration_link: "https://example.com",
      benifit_network: "https://example.com",
    },
  ],
};

export const HealthInsurancePermitServices = {
  _id: "mypage",
  title: "Health Insurance Permit Services",
  title_ar: "Health Insurance Permit Services",
  slug: "about-us",
  layout: "default",
  metaTitle: "Health Insurance Permit Services",
  metaDescription: "Health Insurance Permit Services",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Health Insurance Permit Services",
          text_ar: "Health Insurance Permit Services",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h5",
          text: `The Dubai Health Insurance System (ISAHD) has three basic pillars:`,
          text_ar: `The Dubai Health Insurance System (ISAHD) has three basic pillars:`,
          classname: "Regular text-onSurfaceVariant md:!mb-4 mb-3",
        },
        {
          _id: "block1",
          type: "div",
          classname: "grid md:grid-cols-3 gap-7 mb-6",
          children: [
            {
              _id: "block3",
              type: "dda-banner-card",
              props: {
                image_src: "",
                banner_card_title: "Step Name",
                banner_card_title_ar: "Step Name",
                banner_card_description:
                  "Firstly, provide advice on insurance coverage, laws and any other relevant questions",
                banner_card_description_ar:
                  "Firstly, provide advice on insurance coverage, laws and any other relevant questions",
                onclick: "console.log('clicked')",
                custom_class: "",
              },
            },
            {
              _id: "block3",
              type: "dda-banner-card",
              props: {
                image_src: "",
                banner_card_title: "Step Name",
                banner_card_title_ar: "Step Name",
                banner_card_description:
                  "Second: Monitoring and introducing improvements in the sustainable, high-quality health care system.",
                banner_card_description_ar:
                  "Second: Monitoring and introducing improvements in the sustainable, high-quality health care system.",
                onclick: "console.log('clicked')",
                custom_class: "",
              },
            },
            {
              _id: "block3",
              type: "dda-banner-card",
              props: {
                image_src: "",
                banner_card_title: "Step Name",
                banner_card_title_ar: "Step Name",
                banner_card_description:
                  "Third: Playing a major role in the licensing process for insurance companies, brokers and claims management companies.",
                banner_card_description_ar:
                  "Third: Playing a major role in the licensing process for insurance companies, brokers and claims management companies.",
                onclick: "console.log('clicked')",
                custom_class: "",
              },
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h4",
          text: `Basic Packages`,
          classname: "Regular text-primary my-5",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "insurance_permit", //for dynamic breadcrumbs
          linker_ar: "insurance_permit", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "mb-3 mt-1",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Qualified Insurance Companies",
              title_ar: "Qualified Insurance Companies",
              isShow_title: false,
              size: "h2",
              classname: "",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "dda-table-container",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "overflow-x-auto",
                      children: [
                        {
                          _id: "table1",
                          type: "table",
                          classname: "dda-table w-full min-w-[650px]",
                          children: [
                            {
                              id: "table_header",
                              type: "tableItems",
                              type_identifier: "thead",
                              classname: "body",
                              children: [
                                {
                                  _id: "tableTR",
                                  type: "tableItems",
                                  type_identifier: "tr",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body rounded-ss-lg",
                                      text: "Insurance Company Name",
                                      text_ar: "Insurance Company Name",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "Contact Number",
                                      text_ar: "Contact Number",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "Insurance Price",
                                      text_ar: "Insurance Price",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "Registration Link",
                                      text_ar: "Registration Link",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body rounded-se-lg",
                                      text: "Benefit Network",
                                      text_ar: "Benefit Network",
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              _id: "table_body",
                              type: "tableItems",
                              type_identifier: "tbody",
                              classname: "body",
                              parent_params: `["data"]`,
                              children: [
                                {
                                  _id: "tableTR",
                                  type: "tableItems",
                                  type_identifier: "tr",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text_params: `["company_name"]`,
                                          text_params_ar: `["company_name"]`,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text_params: `["contact_number"]`,
                                          text_params_ar: `["contact_number"]`,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text_params: `["insurance_price"]`,
                                          text_params_ar: `["insurance_price"]`,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "dda-button",
                                          props: {
                                            button_color: "default-tertiary",
                                            start_icon: "",
                                            button_text: "View Service",
                                            button_text_ar: "View Service",
                                            end_icon: "",
                                            custom_class: "",
                                            component_mode: "",
                                            button_id: "button",
                                            aria_label: "button",
                                            isReplace: true,
                                            onclick: `() =>
                                              (window.location.href =
                                                "["registration_link"]")`,
                                            button_name: "button",
                                            button_name_ar: "button",
                                            class: "hydrated",
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "dda-button",
                                          props: {
                                            button_color: "default-primary",
                                            start_icon: "",
                                            button_text: "Start Service",
                                            button_text_ar: "Start Service",
                                            end_icon: "",
                                            custom_class: "",
                                            component_mode: "",
                                            button_id: "button",
                                            aria_label: "button",
                                            isReplace: true,
                                            onclick: `() =>
                                              (window.location.href =
                                                "["benifit_network"]")`,
                                            button_name: "button",
                                            button_name_ar: "button",
                                            class: "hydrated",
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Benefits and Insurance Packages",
              title_ar: "Benefits and Insurance Packages",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [
                {
                  _id: "tableTH",
                  type: "paragraph",
                  size: "normal",
                  classname: "text-primary body mb-3",
                  text: "Annual upper aggregate claims limit (including any coinsurance is 150,000 AED.",
                  text_ar:
                    "Annual upper aggregate claims limit (including any coinsurance is 150,000 AED.",
                },
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: "Geographic scope of coverage:",
                  text_ar: "Geographic scope of coverage:",
                  classname: "",
                },
                {
                  _id: "block10",
                  type: "div",
                  classname: "mb-3",
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname: "list-disc list-inside",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "For Basic healthcare services, within the Emirate of Dubai (and other emirates or countries at the discretion of the insurer).",
                          text_ar:
                            "For Basic healthcare services, within the Emirate of Dubai (and other emirates or countries at the discretion of the insurer).",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "For Emergency medical treatment (Including Ambulance Charges), within all emirates of the UAE.",
                          text_ar:
                            "For Emergency medical treatment (Including Ambulance Charges), within all emirates of the UAE.",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block10",
                  type: "div",
                  classname: "mb-3",
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Provider network:",
                      text_ar: "Provider network:",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname: "list-disc list-inside",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Limited network is acceptable.",
                          text_ar: "Limited network is acceptable.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "The network must provide reasonable geographic access for the insured in relation to place of work and residence.",
                          text_ar:
                            "The network must provide reasonable geographic access for the insured in relation to place of work and residence.",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },

                {
                  _id: "block10",
                  type: "div",
                  classname: "lg:flex gap-5 my-4",
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: "lg:w-1/5",
                      children: [
                        {
                          _id: "block10",
                          type: "div",
                          classname:
                            "lg:overflow-y-none overflow-y-auto lg:max-h-none max-h-[250px]",
                          children: [
                            {
                              _id: "block100",
                              type: "dda-tabs",
                              view: "primary-card",
                              linker: "benifit_control",
                              linker_ar: "benifit_control",
                              props: {
                                type: "text",
                                hover_style: "dda-tab-underline-filled",
                                custom_class: "",
                                component_mode: "",
                                aria_label: "tabs",
                                button_id: "button",
                                tab_type: "dda-vertical-tab",
                                button_name: "button",
                                button_name_ar: "button",
                              },
                              children: [
                                {
                                  title: "Pre-existing Conditions",
                                  title_ar: "Pre-existing Conditions",
                                },
                                {
                                  title:
                                    "Basic healthcare services: In-patient treatment",
                                  title_ar:
                                    "Basic healthcare services: In-patient treatment",
                                },
                                {
                                  title:
                                    "Basic Healthcare Services: Out-patient services",
                                  title_ar:
                                    "Basic Healthcare Services: Out-patient services",
                                },
                                {
                                  title: "Maternity Services",
                                  title_ar: "Maternity Services",
                                },
                                {
                                  title:
                                    "Preventive Services, Vaccines and Immunizations",
                                  title_ar:
                                    "Preventive Services, Vaccines and Immunizations",
                                },
                                {
                                  title:
                                    "Excluded healthcare services except medical emergencies",
                                  title_ar:
                                    "Excluded healthcare services except medical emergencies",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block10",
                      type: "div",
                      classname: "lg:w-4/5 lg:my-0 my-4",
                      children: [
                        {
                          _id: "block2",
                          type: "tabcontent",
                          useLinker: true,
                          linker: "benifit_control",
                          linker_ar: "benifit_control",
                          title: "Pre-existing Conditions",
                          title_ar: "Pre-existing Conditions",
                          isShow_title: false,
                          size: "h2",
                          classname: "",
                          children: [
                            {
                              _id: "block10",
                              type: "div",
                              classname: "dda-table-container",
                              children: [
                                {
                                  _id: "block10",
                                  type: "div",
                                  classname: "overflow-x-auto",
                                  children: [
                                    {
                                      _id: "table1",
                                      type: "table",
                                      classname:
                                        "dda-table w-full min-w-[650px]",
                                      children: [
                                        {
                                          id: "table_header",
                                          type: "tableItems",
                                          type_identifier: "thead",
                                          classname: "body",
                                          children: [
                                            {
                                              _id: "tableTR",
                                              type: "tableItems",
                                              type_identifier: "tr",
                                              classname: "rounded-xl",
                                              children: [
                                                {
                                                  _id: "tableTH",
                                                  type: "tableItems",
                                                  type_identifier: "th",
                                                  classname:
                                                    "Bold body rounded-ss-lg",
                                                  text: "Benefits",
                                                  text_ar: "Benefits",
                                                },
                                                {
                                                  _id: "tableTH",
                                                  type: "tableItems",
                                                  type_identifier: "th",
                                                  classname: "Bold body",
                                                  text: "Conditions",
                                                  text_ar: "Conditions",
                                                },
                                                {
                                                  _id: "tableTH",
                                                  type: "tableItems",
                                                  type_identifier: "th",
                                                  classname:
                                                    "Bold body rounded-se-lg",
                                                  text: "Coinsurance and Limits",
                                                  text_ar:
                                                    "Coinsurance and Limits",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "table_body",
                                          type: "tableItems",
                                          type_identifier: "tbody",
                                          classname: "body",
                                          children: [
                                            {
                                              _id: "tableTR",
                                              type: "tableItems",
                                              type_identifier: "tr",
                                              classname: "",
                                              children: [
                                                {
                                                  _id: "tableTH",
                                                  type: "tableItems",
                                                  type_identifier: "td",
                                                  classname: "",
                                                  children: [
                                                    {
                                                      _id: "tableTH",
                                                      type: "paragraph",
                                                      size: "normal",
                                                      classname: "",
                                                      text: "Pre-existing conditions must be covered Cover cannot be denied due to pre-existing conditions",
                                                      text_ar:
                                                        "Pre-existing conditions must be covered Cover cannot be denied due to pre-existing conditions",
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "tableTH",
                                                  type: "tableItems",
                                                  type_identifier: "td",
                                                  classname: "",
                                                  children: [
                                                    {
                                                      _id: "tableTH",
                                                      type: "paragraph",
                                                      size: "normal",
                                                      classname: "",
                                                      text: "Treatment for chronic and pre-existing conditions may be excluded during the first 6 months of membership of an individual’s first scheme within the UAE. (Here “scheme” includes any and all schemes providing cover for medical expenses whether or not it is self-funded or on an insured basis). In all other cases, pre-existing conditions must be covered from date of enrolment.",
                                                      text_ar:
                                                        "Treatment for chronic and pre-existing conditions may be excluded during the first 6 months of membership of an individual’s first scheme within the UAE. (Here “scheme” includes any and all schemes providing cover for medical expenses whether or not it is self-funded or on an insured basis). In all other cases, pre-existing conditions must be covered from date of enrolment.",
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "tableTH",
                                                  type: "tableItems",
                                                  type_identifier: "td",
                                                  classname: "",
                                                  children: [
                                                    {
                                                      _id: "tableTH",
                                                      type: "paragraph",
                                                      size: "normal",
                                                      classname: "text-primary",
                                                      text: "Not Applicable",
                                                      text_ar: "Not Applicable",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "paragraph",
                              size: "normal",
                              text: `Where a pre-existing or chronic condition develops into an
                    emergency, within the 6-month exclusion period, this must be
                    covered up to the annual aggregate limit.`,
                              text_ar: `Where a pre-existing or chronic condition develops into an
                    emergency, within the 6-month exclusion period, this must be
                    covered up to the annual aggregate limit.`,
                              classname: "body text-primary my-4",
                            },
                          ],
                        },
                        {
                          _id: "block2",
                          type: "tabcontent",
                          useLinker: true,
                          linker: "benifit_control",
                          linker_ar: "benifit_control",
                          title:
                            "Basic healthcare services: In-patient treatment",
                          title_ar:
                            "Basic healthcare services: In-patient treatment",
                          isShow_title: false,
                          size: "h2",
                          classname: "dda-table-container",
                          children: [],
                        },
                        {
                          _id: "block2",
                          type: "tabcontent",
                          useLinker: true,
                          linker: "benifit_control",
                          linker_ar: "benifit_control",
                          title:
                            "Basic Healthcare Services: Out-patient services",
                          title_ar:
                            "Basic Healthcare Services: Out-patient services",
                          isShow_title: false,
                          size: "h2",
                          classname: "dda-table-container",
                          children: [],
                        },
                        {
                          _id: "block2",
                          type: "tabcontent",
                          useLinker: true,
                          linker: "benifit_control",
                          linker_ar: "benifit_control",
                          title: "Maternity Services",
                          title_ar: "Maternity Services",
                          isShow_title: false,
                          size: "h2",
                          classname: "dda-table-container",
                          children: [],
                        },
                        {
                          _id: "block2",
                          type: "tabcontent",
                          useLinker: true,
                          linker: "benifit_control",
                          linker_ar: "benifit_control",
                          title:
                            "Preventive Services, Vaccines and Immunizations",
                          title_ar:
                            "Preventive Services, Vaccines and Immunizations",
                          isShow_title: false,
                          size: "h2",
                          classname: "dda-table-container",
                          children: [],
                        },
                        {
                          _id: "block2",
                          type: "tabcontent",
                          useLinker: true,
                          linker: "benifit_control",
                          linker_ar: "benifit_control",
                          title:
                            "Excluded healthcare services except medical emergencies",
                          title_ar:
                            "Excluded healthcare services except medical emergencies",
                          isShow_title: false,
                          size: "h2",
                          classname: "dda-table-container",
                          children: [],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Health Insurance Permit Services",
      icon: "home",
      url: "/healthinsurance/healthInsurancePermitServices",
    },
    {
      text: "insurance_permit", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/healthinsurance/healthInsurancePermitServices",
    },
  ],
};

export const ISAHDData = {
  table_title: "",
  data: [
    {
      file_name: "Dubai Annual Health Statistical Report 2016",
      file_size: "78 MB",
      published_date: "22/12/2021",
      documents: "https://example.com",
    },
    {
      file_name: "Dubai Annual Health Statistical Report 2016",
      file_size: "78 MB",
      published_date: "22/12/2021",
      documents: "https://example.com",
    },
    {
      file_name: "Dubai Annual Health Statistical Report 2016",
      file_size: "78 MB",
      published_date: "22/12/2021",
      documents: "https://example.com",
    },
    {
      file_name: "Dubai Annual Health Statistical Report 2016",
      file_size: "78 MB",
      published_date: "22/12/2021",
      documents: "https://example.com",
    },
    {
      file_name: "Dubai Annual Health Statistical Report 2016",
      file_size: "78 MB",
      published_date: "22/12/2021",
      documents: "https://example.com",
    },
    {
      file_name: "Dubai Annual Health Statistical Report 2016",
      file_size: "78 MB",
      published_date: "22/12/2021",
      documents: "https://example.com",
    },
    {
      file_name: "Dubai Annual Health Statistical Report 2016",
      file_size: "78 MB",
      published_date: "22/12/2021",
      documents: "https://example.com",
    },
  ],
};

export const ISAHD = {
  _id: "mypage",
  title: "ISAHD",
  title_ar: "ISAHD",
  slug: "about-us",
  layout: "default",
  metaTitle: "ISAHD",
  metaDescription: "ISAHD",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "12_Health Insurance - Monitoring and Evaluation.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "ISAHD",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block1",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-4/5",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `Insurance System for Advancing Healthcare in Dubai (ISAHD) is a
            comprehensive initiative of the Dubai Health Authority (DHA)
            intended to provide sustainable high quality healthcare in Dubai for
            nationals, residents and visitors, in a quest to become the #1
            healthcare system in the world. ISAHD, in Arabic means ‘bringing
            happiness’, inspired by UAE Vice President, Prime Minister and Ruler
            of Dubai, His Highness Sheikh Mohammed bin Rashid Al Maktoum towards
            the government main role in bringing happiness to its people.`,
                  text_ar: `Insurance System for Advancing Healthcare in Dubai (ISAHD) is a
            comprehensive initiative of the Dubai Health Authority (DHA)
            intended to provide sustainable high quality healthcare in Dubai for
            nationals, residents and visitors, in a quest to become the #1
            healthcare system in the world. ISAHD, in Arabic means ‘bringing
            happiness’, inspired by UAE Vice President, Prime Minister and Ruler
            of Dubai, His Highness Sheikh Mohammed bin Rashid Al Maktoum towards
            the government main role in bringing happiness to its people.`,
                  classname: "md:!mb-4 mb-3 Regular body",
                },
              ],
            },
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-1/5 mb-4",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    header_text: "Health Insurance Lows & Regulations",
                    header_text_ar: "Health Insurance Lows & Regulations",
                    right_button_name: "View",
                    right_button_href: "https://example.com",
                    right_button_rel: "",
                    right_button_start_icon: "",
                    right_button_end_icon: "",
                    right_button_data_fancybox: "",
                    custom_class: "imageCard",
                    component_mode: "",
                    class: "hydrated",
                  },
                },
              ],
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h5",
          text: `The Dubai Health Insurance System (ISAHD) has three basic pillars:`,
          text_ar: `The Dubai Health Insurance System (ISAHD) has three basic pillars:`,
          classname: "Regular text-onSurfaceVariant md:!mb-4 mb-3",
        },
        {
          _id: "block10",
          type: "div",
          classname: "grid md:grid-cols-3 gap-7 mb-6",
          children: [
            {
              _id: "block3",
              type: "dda-banner-card",
              props: {
                image_src: "",
                banner_card_title: "Step Name",
                banner_card_title_ar: "Step Name",
                banner_card_description:
                  "Firstly, provide advice on insurance coverage, laws and any other relevant questions",
                banner_card_description_ar:
                  "Firstly, provide advice on insurance coverage, laws and any other relevant questions",
                onclick: "console.log('clicked')",
                custom_class: "",
              },
            },
            {
              _id: "block3",
              type: "dda-banner-card",
              props: {
                image_src: "",
                banner_card_title: "Step Name",
                banner_card_title_ar: "Step Name",
                banner_card_description:
                  "Second: Monitoring and introducing improvements in the sustainable, high-quality health care system.",
                banner_card_description_ar:
                  "Second: Monitoring and introducing improvements in the sustainable, high-quality health care system.",
                onclick: "console.log('clicked')",
                custom_class: "",
              },
            },
            {
              _id: "block3",
              type: "dda-banner-card",
              props: {
                image_src: "",
                banner_card_title: "Step Name",
                banner_card_title_ar: "Step Name",
                banner_card_description:
                  "Third: Playing a major role in the licensing process for insurance companies, brokers and claims management companies.",
                banner_card_description_ar:
                  "Third: Playing a major role in the licensing process for insurance companies, brokers and claims management companies.",
                onclick: "console.log('clicked')",
                custom_class: "",
              },
            },
          ],
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "isahd_permit", //for dynamic breadcrumbs
          linker_ar: "isahd_permit", //for dynamic breadcrumbs
          view: "primary-card",
          data_source: "/api/content/listCategory",
          parent_params: `["Data"]`, // if not loop through all the data don't pass this (if need to loop thorugh pass)
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "mb-3 mt-1",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title_params: `["label"]`,
              title_params_ar: `["label"]`,
              accessable_linker: {
                name: "categoryItem",
                name_ar: "categoryItem",
                use: `["guid"]`,
              }, //to link with table item to call with category dguid
              isShow_title: false,
              size: "h2",
              classname: "",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "dda-table-container",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "overflow-x-auto",
                      children: [
                        {
                          _id: "table1",
                          type: "table",
                          data_source: `/api/content/getDocumentsByCategory/["categoryItem"]`, // data source name and source item
                          classname: "dda-table w-full min-w-[650px]",
                          children: [
                            {
                              id: "table_header",
                              type: "tableItems",
                              type_identifier: "thead",
                              classname: "body",
                              children: [
                                {
                                  _id: "tableTR",
                                  type: "tableItems",
                                  type_identifier: "tr",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "#",
                                      text_ar: "#",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "File Name",
                                      text_ar: "File Name",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "File Size",
                                      text_ar: "File Size",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "Published Date",
                                      text_ar: "Published Date",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "Documents",
                                      text_ar: "Documents",
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              _id: "table_body",
                              type: "tableItems",
                              type_identifier: "tbody",
                              classname: "body",
                              parent_params: `["data"]`,
                              children: [
                                {
                                  _id: "tableTR",
                                  type: "tableItems",
                                  type_identifier: "tr",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "text-primary",
                                          text: "{index}", // in order to show 1, 2, 3, 4,
                                          text_ar: "{index}", // in order to show 1, 2, 3, 4,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text_params: `["name"]`,
                                          text_params_ar: `["name"]`,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text_params: `["fileSize"]`,
                                          text_params_ar: `["fileSize"]`,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text_params: `["createdAt"]`,
                                          text_params_ar: `["createdAt"]`,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "dda-button",
                                          props: {
                                            button_color: "default-tertiary",
                                            start_icon: "",
                                            button_text: "Download",
                                            button_text_ar: "Download",
                                            end_icon: "",
                                            custom_class: "",
                                            component_mode: "",
                                            button_id: "button",
                                            aria_label: "button",
                                            isReplace: true,
                                            onclick: `() =>
                                              (window.location.href =
                                                "["filename"]")`,
                                            button_name: "button",
                                            button_name_ar: "button",
                                            class: "hydrated",
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Participating Insurances",
              title_ar: "Participating Insurances",
              // title_params: `["Data", "[1]","label"]`,
              // title_params_ar: `["Data", "[1]","label"]`,
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "HASD",
              title_ar: "HASD",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "dda-table-container",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "overflow-x-auto",
                      children: [
                        {
                          _id: "table1",
                          type: "table",
                          data_source: "/api/content/getDocumentsByCategory/",
                          classname: "dda-table w-full min-w-[650px]",
                          children: [
                            {
                              id: "table_header",
                              type: "tableItems",
                              type_identifier: "thead",
                              classname: "body",
                              children: [
                                {
                                  _id: "tableTR",
                                  type: "tableItems",
                                  type_identifier: "tr",
                                  classname: "rounded-xl",
                                  children: [
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "#",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "File Name",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "File Size",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body",
                                      text: "Published Date",
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "th",
                                      classname: "Bold body rounded-se-lg",
                                      text: "Documents",
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              _id: "table_body",
                              type: "tableItems",
                              type_identifier: "tbody",
                              classname: "body",
                              parent_params: `["data"]`,
                              children: [
                                {
                                  _id: "tableTR",
                                  type: "tableItems",
                                  type_identifier: "tr",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text: "{index}", // in order to show 1, 2, 3, 4,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text_params: `["file_name"]`,
                                          text_params_ar: `["file_name"]`,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text_params: `["file_size"]`,
                                          text_params_ar: `["file_size"]`,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "paragraph",
                                          size: "normal",
                                          classname: "",
                                          text_params: `["published_date"]`,
                                          text_params_ar: `["published_date"]`,
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTH",
                                      type: "tableItems",
                                      type_identifier: "td",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "dda-button",
                                          props: {
                                            button_color: "default-tertiary",
                                            start_icon: "",
                                            button_text: "Download",
                                            button_text_ar: "Download",
                                            end_icon: "",
                                            custom_class: "",
                                            component_mode: "",
                                            button_id: "button",
                                            aria_label: "button",
                                            isReplace: true,
                                            onclick: `() =>
                                              (window.location.href =
                                                "["documents"]")`,
                                            button_name: "button",
                                            button_name_ar: "button",
                                            class: "hydrated",
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "ISAHD",
      icon: "home",
      url: "/healthinsurance/isahd",
    },
    {
      text: "isahd_permit", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/healthinsurance/isahd",
    },
  ],
};

export const HealthTourism = {
  _id: "mypage",
  title: "Health Tourism",
  title_ar: "Health Tourism",
  slug: "about-us",
  layout: "default",
  metaTitle: "Health Tourism",
  metaDescription: "Health Tourism",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "23_Investment & Health Tourism - About Health Tourism.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "About Health Tourism",
          text_ar: "About Health Tourism",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block1",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-3/4",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "Your gateway to high-quality healthcare services and an unparalleled holiday experience in Dubai",
                  text_ar:
                    "Your gateway to high-quality healthcare services and an unparalleled holiday experience in Dubai",
                  classname: "md:!mb-4 mb-3 Regular text-onSurfaceVariant",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: ` Dubai is one of the world's fastest developing and flourishing
            cities. The city has become a model of prosperity, creating a better
            future in health.
            <br />
            Dubai strives to meet the needs of those searching for an
            exceptional treatment experience and an ideal healing environment
            which promotes well-being and happiness.`,
                  text_ar: ` Dubai is one of the world's fastest developing and flourishing
            cities. The city has become a model of prosperity, creating a better
            future in health.
            <br />
            Dubai strives to meet the needs of those searching for an
            exceptional treatment experience and an ideal healing environment
            which promotes well-being and happiness.`,
                  classname: "md:!mb-4 mb-2 body",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `DHA aims to be a market leader in the field of Health tourism and
            promotes high-quality medical services for elective treatments in
            niche specialities such as Dental, Ophthalmology, Orthopedic,
            Fertility, Cosmetic, Gynecology and Wellness, along with an
            unparalleled holiday experience in the world’s most dynamic city,
            Dubai.`,
                  text_ar: `DHA aims to be a market leader in the field of Health tourism and
            promotes high-quality medical services for elective treatments in
            niche specialities such as Dental, Ophthalmology, Orthopedic,
            Fertility, Cosmetic, Gynecology and Wellness, along with an
            unparalleled holiday experience in the world’s most dynamic city,
            Dubai.`,
                  classname: "md:!mb-4 mb-2 body",
                  children: [
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `The Health Tourism Department, under DHA, is responsible for
              planning, supervising and developing the Health Tourism ecosystem
              in Dubai. It is dedicated to collaborating with public and private
              sectors to promote Dubai as a global health tourism destination.`,
                      text_ar: `The Health Tourism Department, under DHA, is responsible for
              planning, supervising and developing the Health Tourism ecosystem
              in Dubai. It is dedicated to collaborating with public and private
              sectors to promote Dubai as a global health tourism destination.`,
                      classname: "md:!mb-4 mb-2 body",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Dubai Health Experience (DXH) was launched in April 2016 under the
              Dubai Health Authority (DHA) to provide health travellers with an
              unforgettable voyage across an impressive spectrum of premier
              accredited clinics and hospitals.`,
                      text_ar: `Dubai Health Experience (DXH) was launched in April 2016 under the
              Dubai Health Authority (DHA) to provide health travellers with an
              unforgettable voyage across an impressive spectrum of premier
              accredited clinics and hospitals.`,
                      classname: "md:!mb-4 mb-2 body",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Dubai Health Experience allows you to fully "Embrace Life"`,
                      text_ar: `Dubai Health Experience allows you to fully "Embrace Life"`,
                      classname: "md:!mb-4 mb-2 body",
                    },
                  ],
                },
              ],
            },
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-1/4 md:w-1/2",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "border rounded-lg border-outline py-4 px-3",
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "DXH Brochure",
                        fileName_ar: "DXH Brochure",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-button",
                  props: {
                    button_color: "default-primary",
                    start_icon: "",
                    button_text: "Specialties",
                    button_text_ar: "Specialties",
                    end_icon: "",
                    custom_class: "w-full my-3",
                    component_mode: "",
                    button_id: "button",
                    aria_label: "button",
                    onclick: "console.log('clicked')",
                    button_name: "button",
                    button_name_ar: "button",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "About Health Tourism", icon: "menu_book", url: "/healthTourism" },
  ],
};

export const InvestingHealthCareCenter = {
  _id: "mypage",
  title: "Investing Health care center",
  title_ar: "Investing Health care center",
  slug: "about-us",
  layout: "default",
  metaTitle: "Investing Health care center",
  metaDescription: "Investing Health care center",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "24_Investment & Health Tourism -Investing in the Healthcare Sector in Dubai.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Investing in the Healthcare Sector in Dubai",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block1",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-3/4",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: "Who Are We",
                  text_ar: "Who Are We",
                  classname: "mb-2 text-primary Medium",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `The investment and PPP department was established in 2017 to promote
            Dubai as a viable and competitive hub for investment in healthcare.
            It released its strategy in 2018 focusing on the following
            initiatives:`,
                  text_ar: `The investment and PPP department was established in 2017 to promote
            Dubai as a viable and competitive hub for investment in healthcare.
            It released its strategy in 2018 focusing on the following
            initiatives:`,
                  classname: "my-2 body",
                },
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "ul",
                  classname:
                    "list-inside list-disc text-onSurfaceVariant *:mb-1 body",
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Investment Promotion and PPP facilitation",
                      text_ar: "Investment Promotion and PPP facilitation",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Inward Investment Government",
                      text_ar: "Inward Investment Government",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Health Investment Guidelines",
                      text_ar: "Health Investment Guidelines",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Commercial Incentives and Policies",
                      text_ar: "Commercial Incentives and Policies",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Enabling Healthcare Regulations",
                      text_ar: "Enabling Healthcare Regulations",
                      classname: "",
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: "What We Do",
                  classname: "md:!mt-6 mt-3 Medium text-primary",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `The Investments & Public Private Partnership’s Department at Dubai
            Health Authority aims to provide the best service for investors to
            enable sustainable public-private models in Dubai. Its role is
            therefore to support DHA’s objective of providing healthcare in line
            with global best practices, fostering innovation in all
            health-related sectors and becoming a medical hub for the region by
            attracting investors and encouraging them to contribute to the
            development of targeted areas.`,
                  text_ar: `The Investments & Public Private Partnership’s Department at Dubai
            Health Authority aims to provide the best service for investors to
            enable sustainable public-private models in Dubai. Its role is
            therefore to support DHA’s objective of providing healthcare in line
            with global best practices, fostering innovation in all
            health-related sectors and becoming a medical hub for the region by
            attracting investors and encouraging them to contribute to the
            development of targeted areas.`,
                  classname: "my-2 body",
                },
                {
                  _id: "block3",
                  type: "heading",
                  size: "h6",
                  text: "Investment Focus Areas",
                  text_ar: "Investment Focus Areas",
                  classname: "md:!mt-6 mt-3 Medium text-primary",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `The focus areas to support the development of Dubai's health
            ecosystem are identified in the short to mid-term <br />
            Focus areas for the next 2-3 years`,
                  text_ar: `The focus areas to support the development of Dubai's health
            ecosystem are identified in the short to mid-term <br />
            Focus areas for the next 2-3 years`,
                  classname: "my-2 body Regular",
                },
              ],
            },
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-1/4",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "border rounded-lg border-outline py-4 px-3",
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "Dubai Health Investment Guide",
                        fileName_ar: "Dubai Health Investment Guide",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block10",
          type: "div",
          classname: "grid lg:grid-cols-3 md:grid-cols-2 gap-4 mt-4",
          children: [
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                custom_class: "h-full",
                component_mode: "",
                class: "hydrated",
              },
              children: [
                {
                  _id: "block10",
                  type: "div",
                  classname: "-mt-4 px-4 pb-4",
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h5",
                      text: "Identified continuum of care fields",
                      text_ar: "Identified continuum of care fields",
                      classname: "text-primary",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant body list-disc list-inside",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Mental health",
                          text_ar: "Mental health",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Rehabilitation and physical therapy",
                          text_ar: "Rehabilitation and physical therapy",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Long-term and extended care",
                          text_ar: "Long-term and extended care",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Tertiary care for diabetes, cardiology and oncology",
                          text_ar:
                            "Tertiary care for diabetes, cardiology and oncology",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Chronic disease management",
                          text_ar: "Chronic disease management",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                custom_class: "h-full",
                component_mode: "",
                class: "hydrated",
              },
              children: [
                {
                  _id: "block10",
                  type: "div",
                  classname: "-mt-4 px-4 pb-4",
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h5",
                      text: "Supported by the health system, evolution and technology",
                      text_ar:
                        "Supported by the health system, evolution and technology",
                      classname: "text-primary",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant body list-disc list-inside",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Innovations in primary care",
                          text_ar: "Innovations in primary care",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Home-based care",
                          text_ar: "Home-based care",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Diagnostic health and remote monitoring",
                          text_ar: "Diagnostic health and remote monitoring",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Urgent care clinics",
                          text_ar: "Urgent care clinics",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Ambulatory care",
                          text_ar: "Ambulatory care",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                custom_class: "h-full",
                component_mode: "",
                class: "hydrated",
              },
              children: [
                {
                  _id: "block10",
                  type: "div",
                  classname: "-mt-4 px-4 pb-4",
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h5",
                      text: "Focus areas for the next 3-5 years",
                      text_ar: "Focus areas for the next 3-5 years",
                      classname: "text-primary",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant body list-disc list-inside",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Prevention and pharmacy beyond the pill",
                          text_ar: "Prevention and pharmacy beyond the pill",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Precision medicine and genetics",
                          text_ar: "Precision medicine and genetics",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Population health management",
                          text_ar: "Population health management",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Nursing homes and pallative care",
                          text_ar: "Nursing homes and pallative care",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Investing in the Healthcare Sector in Dubai",
      icon: "menu_book",
      url: "/healthTourism/investingInHealthSectorInDubai",
    },
  ],
};

export const MedicalInDubai = {
  _id: "mypage",
  title: "Health Care in Duabi",
  title_ar: "Health Care in Duabi",
  slug: "about-us",
  layout: "default",
  metaTitle: "Health Care in Duabi",
  metaDescription: "Health Care in Duabi",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Medical in Dubai",
          text_ar: "Medical in Dubai",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block1",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-4/5",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "Dubai is home to world-class, internationally accredited healthcare institutions that offer innovation and integrated care model that delivers a fulfilling patient experience.",
                  text_ar:
                    "Dubai is home to world-class, internationally accredited healthcare institutions that offer innovation and integrated care model that delivers a fulfilling patient experience.",
                  classname: "md:!mb-4 mb-3 Regular text-onSurfaceVariant",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `The highly advanced infrastructure of healthcare service providers
            provides a range of specialties covering elective procedures in
            cosmetic treatment & surgery, orthopaedics and sports medicine,
            ophthalmology, dental, dermatology, wellness and preventive health
            check-ups, as well as assisted reproductive techniques and weight
            loss management and surgeries. Dubai offers not only infrastructure
            but also a pool of skilled and licensed healthcare professionals who
            have established their credentials as leaders worldwide.`,
                  text_ar: `The highly advanced infrastructure of healthcare service providers
            provides a range of specialties covering elective procedures in
            cosmetic treatment & surgery, orthopaedics and sports medicine,
            ophthalmology, dental, dermatology, wellness and preventive health
            check-ups, as well as assisted reproductive techniques and weight
            loss management and surgeries. Dubai offers not only infrastructure
            but also a pool of skilled and licensed healthcare professionals who
            have established their credentials as leaders worldwide.`,
                  classname: "md:!my-4 my-2 body",
                },
              ],
            },
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-1/5",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    header_text: "DXH Group Members",
                    header_text_ar: "DXH Group Members",
                    right_button_name: "DXH Group Members",
                    right_button_name_ar: "DXH Group Members",
                    right_button_href: "https://example.com",
                    right_button_rel: "",
                    right_button_start_icon: "",
                    right_button_end_icon: "",
                    right_button_data_fancybox: "",
                    custom_class: "imageCard",
                    component_mode: "",
                    class: "hydrated",
                  },
                },
              ],
            },
          ],
        },
        {
          _id: "block10",
          type: "div",
          classname: "grid lg:grid-cols-3 sm:grid-cols-2 gap-4 my-4",
          children: [
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                image_src:
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s",
                header_text: "Integrated Health Centres",
                header_text_ar: "Integrated Health Centres",
                date_text: "",
                body_text:
                  "Dubai Health Authority offers an exceptional healing environ Holistic Wellness..",
                body_text_ar:
                  "Dubai Health Authority offers an exceptional healing environ Holistic Wellness..",
                custom_class: "",
              },
            },
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                image_src:
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s",
                header_text: "Holistic Wellness",
                header_text_ar: "Holistic Wellness",
                date_text: "",
                body_text:
                  "Holistic wellness retreats for relaxation, weight loss, diabetes management and other",
                body_text_ar:
                  "Holistic wellness retreats for relaxation, weight loss, diabetes management and other",
                custom_class: "",
              },
            },
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                image_src:
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s",
                header_text: "Journey to Dubai",
                header_text_ar: "Journey to Dubai",
                date_text: "",
                body_text:
                  "Do you know that Your journey to Dubai can begin before you arrive and continue with ongoing..",
                body_text_ar:
                  "Do you know that Your journey to Dubai can begin before you arrive and continue with ongoing..",
                custom_class: "",
              },
            },
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                image_src:
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s",
                header_text: "Journey to Dubai",
                header_text_ar: "Journey to Dubai",
                date_text: "",
                body_text:
                  "Do you know that Your journey to Dubai can begin before you arrive and continue with ongoing..",
                body_text_ar:
                  "Do you know that Your journey to Dubai can begin before you arrive and continue with ongoing..",
                custom_class: "",
              },
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Medical in Dubai",
      icon: "menu_book",
      url: "/healthTourism/medicalindubai",
    },
  ],
};

export const WellnessInDubai = {
  _id: "mypage",
  title: "Wellness in Duabi",
  title_ar: "Wellness in Duabi",
  slug: "about-us",
  layout: "default",
  metaTitle: "Wellness in Duabi",
  metaDescription: "Wellness in Duabi",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Wellness in Dubai",
          text_ar: "Wellness in Dubai",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block1",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-4/5",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h5",
                  text: "Distinct experiences in health, beauty and vitality.",
                  text_ar:
                    "Distinct experiences in health, beauty and vitality.",
                  classname: "md:!mb-4 mb-3 Regular text-onSurfaceVariant",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `Dubai aims to provide a rich-quality experience and a holistic
            approach to overall wellbeing. It offers activities and programmes
            promising and delivering healing, personal growth and intense
            pampering and relaxation in the safest and most secure environment.`,
                  text_ar: `Dubai aims to provide a rich-quality experience and a holistic
            approach to overall wellbeing. It offers activities and programmes
            promising and delivering healing, personal growth and intense
            pampering and relaxation in the safest and most secure environment.`,
                  classname: "md:!my-4 my-2 body",
                },
              ],
            },
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-1/5",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    header_text: "Wellness Partners",
                    header_text_ar: "Wellness Partners",
                    right_button_name: "Wellness Partners",
                    right_button_name_ar: "Wellness Partners",
                    right_button_href: "https://example.com",
                    right_button_rel: "",
                    right_button_start_icon: "",
                    right_button_end_icon: "",
                    right_button_data_fancybox: "",
                    custom_class: "imageCard",
                    component_mode: "",
                    class: "hydrated",
                  },
                },
              ],
            },
          ],
        },
        {
          _id: "block10",
          type: "div",
          classname: "grid lg:grid-cols-3 sm:grid-cols-2 gap-4 my-4",
          children: [
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                image_src:
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s",
                header_text: "Integrated Health Centres",
                header_text_ar: "Integrated Health Centres",
                date_text: "",
                body_text:
                  "Dubai Health Authority offers an exceptional healing environ Holistic Wellness..",
                body_text_ar:
                  "Dubai Health Authority offers an exceptional healing environ Holistic Wellness..",
                custom_class: "",
              },
            },
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                image_src:
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s",
                header_text: "Holistic Wellness",
                header_text_ar: "Holistic Wellness",
                date_text: "",
                body_text:
                  "Holistic wellness retreats for relaxation, weight loss, diabetes management and other",
                body_text_ar:
                  "Holistic wellness retreats for relaxation, weight loss, diabetes management and other",
                custom_class: "",
              },
            },
            {
              _id: "block3",
              type: "dda-image-card",
              props: {
                image_src:
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s",
                header_text: "Journey to Dubai",
                header_text_ar: "Journey to Dubai",
                date_text: "",
                body_text:
                  "Do you know that Your journey to Dubai can begin before you arrive and continue with ongoing..",
                body_text_ar:
                  "Do you know that Your journey to Dubai can begin before you arrive and continue with ongoing..",
                custom_class: "",
              },
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Wellness in Dubai",
      icon: "menu_book",
      url: "/healthTourism/wellnessindubai",
    },
  ],
};

export const AboutPublicHealth = {
  _id: "mypage",
  title: "Public Health",
  title_ar: "Public Health",
  slug: "about-us",
  layout: "default",
  metaTitle: "Public Health",
  metaDescription: "Public Health",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "18_Public Health - About Public Health.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "About Public Health",
          text_ar: "About Public Health",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block3",
          type: "paragraph",
          size: "normal",
          text: `Public Health is responsible for assessing and monitoring the health
        status of the population, developing and following the implementation of
        strategic policies and programmes, research and studies necessary to
        improve the health status of the population and protect community
        members from diseases and health risks with main functions focused on:`,
          text_ar: `Public Health is responsible for assessing and monitoring the health
        status of the population, developing and following the implementation of
        strategic policies and programmes, research and studies necessary to
        improve the health status of the population and protect community
        members from diseases and health risks with main functions focused on:`,
          classname: "md:!my-4 my-2 Regular text-onSurfaceVariant body",
        },
        {
          _id: "block1",
          type: "div",
          classname:
            "grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-3 md:!my-4 my-2",
          children: [
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src: "",
                team_member_position: "School Health Programmes",
                team_member_position_ar: "School Health Programmes",
                design: "default",
                custom_class: "",
                component_mode: "",
                class: "hydrated",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src: "",
                team_member_position: "Vaccination & immunisation",
                team_member_position_ar: "Vaccination & immunisation",
                design: "default",
                custom_class: "",
                component_mode: "",
                class: "hydrated",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src: "",
                team_member_position: "Health Promotion",
                team_member_position_ar: "Health Promotion",
                design: "default",
                custom_class: "",
                component_mode: "",
                class: "hydrated",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src: "",
                team_member_position: "Occupational Health",
                team_member_position_ar: "Occupational Health",
                design: "default",
                custom_class: "",
                component_mode: "",
                class: "hydrated",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src: "",
                team_member_position: "Programmes & Studies",
                team_member_position_ar: "Programmes & Studies",
                design: "default",
                custom_class: "",
                component_mode: "",
                class: "hydrated",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src: "",
                team_member_position: "Communicable Diseases",
                team_member_position_ar: "Communicable Diseases",
                design: "default",
                custom_class: "",
                component_mode: "",
                class: "hydrated",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src: "",
                team_member_position: "Non Communicable Diseases",
                team_member_position_ar: "Non Communicable Diseases",
                design: "default",
                custom_class: "",
                component_mode: "",
                class: "hydrated",
              },
            },
            {
              _id: "block4",
              type: "dda-team-member-card",
              props: {
                image_src: "",
                team_member_position: "Health Emergency & Disasters Management",
                team_member_position_ar:
                  "Health Emergency & Disasters Management",
                design: "default",
                custom_class: "",
                component_mode: "",
                class: "hydrated",
              },
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "About Public Health", icon: "menu_book", url: "/publichealth" },
  ],
};

export const CommunityEngagementProgrammes = {
  _id: "mypage",
  title: "Community Engagement Program",
  title_ar: "Community Engagement Program",
  slug: "about-us",
  layout: "default",
  metaTitle: "Community Engagement Program",
  metaDescription: "Community Engagement Program",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "19_Public Health - Community Engagment Programmes.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Community Engagement Programmes",
          text_ar: "Community Engagement Programmes",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block3",
          type: "paragraph",
          size: "normal",
          text: `It is an approach in which individuals and communities are empowered to
        take an active role in their health and participate as a driving force
        in the decisions and structures that impact their health and well-being.
        This is implemented through addressing health-related issues, promoting
        well-being, and acting on health determinants.Community engagement
        involves building relationships based on trust and working together to
        develop more effective health behaviours, interventions, programmes,
        services, environments and policies. It is intended to address local
        matters and use opportunities, identify and implement more effective
        programmes, and use local resources and networks to achieve healthy
        communities and increase well-being across all community groups.`,
          text_ar: `It is an approach in which individuals and communities are empowered to
        take an active role in their health and participate as a driving force
        in the decisions and structures that impact their health and well-being.
        This is implemented through addressing health-related issues, promoting
        well-being, and acting on health determinants.Community engagement
        involves building relationships based on trust and working together to
        develop more effective health behaviours, interventions, programmes,
        services, environments and policies. It is intended to address local
        matters and use opportunities, identify and implement more effective
        programmes, and use local resources and networks to achieve healthy
        communities and increase well-being across all community groups.`,
          classname: "md:!my-4 my-2 Regular text-onSurfaceVariant body",
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Community Engagement Programmes",
      icon: "menu_book",
      url: "/publicHealth/communityEngagementProgrammes",
    },
  ],
};

export const OccupationHealth = {
  _id: "mypage",
  title: "Occupation Health",
  title_ar: "Occupation Health",
  slug: "about-us",
  layout: "default",
  metaTitle: "Occupation Health",
  metaDescription: "Occupation Health",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "22_Public Health - Occupational Health.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Occupational Health",
          text_ar: "Occupational Health",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h5",
          text: `Occupational health is an area of work in public health to promote and
        maintain the highest degree of physical, mental, and social well-being
        of all occupations. `,
          text_ar: `Occupational health is an area of work in public health to promote and
        maintain the highest degree of physical, mental, and social well-being
        of all occupations. `,
          classname: "md:!my-4 my-2 Regular text-onSurfaceVariant",
        },
        {
          _id: "block3",
          type: "list",
          type_identifier: "ul",
          classname: "list-disc list-inside text-onSurfaceVariant *:mb-3 body",
          children: [
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              text: "Maintain and promote workers' health and well-being.",
              text_ar: "Maintain and promote workers' health and well-being.",
              classname: "",
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              text: "Protect professional workers and community health by monitoring, preventing transmission, and limiting the spread of communicable diseases in the emirate of Dubai.",
              text_ar:
                "Protect professional workers and community health by monitoring, preventing transmission, and limiting the spread of communicable diseases in the emirate of Dubai.",
              classname: "",
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              text: "Identify public health problems and priority health risks.",
              text_ar:
                "Identify public health problems and priority health risks.",
              classname: "",
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              text: "Protect workers’ health by raising their health standards and protecting them from occupational dangers, diseases, and work accidents.",
              text_ar:
                "Protect workers’ health by raising their health standards and protecting them from occupational dangers, diseases, and work accidents.",
              classname: "",
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              text: "Raise awareness of risks and develop surveillance and preparedness mechanisms to confront public health risks.",
              text_ar:
                "Raise awareness of risks and develop surveillance and preparedness mechanisms to confront public health risks.",
              classname: "",
            },
          ],
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "occupational_health", //for dynamic breadcrumbs
          linker_ar: "occupational_health", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "mt-2",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Scope of Work",
              title_ar: "Scope of Work",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [
                {
                  _id: "block3",
                  type: "heading",
                  size: "h4",
                  text: "Scope of Work",
                  text_ar: "Scope of Work",
                  classname: "Regular mt-4",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `Along with the expanding workforce of the UAE comes the importance of
        Occupational Health in protecting workers from health hazards in the
        workplace.`,
                  text_ar: `Along with the expanding workforce of the UAE comes the importance of
        Occupational Health in protecting workers from health hazards in the
        workplace.`,
                  classname: "body Bold my-2",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `Occupational health reflects the essential focus of modern public
        health, aiming at:`,
                  text_ar: `Occupational health reflects the essential focus of modern public
        health, aiming at:`,
                  classname: "body Bold my-2",
                },
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "ul",
                  classname:
                    "list-disc list-inside text-onSurfaceVariant *:mb-3 body",
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: `Taking care of workers’ health, raising their health standards, and
          protecting them from occupational dangers, diseases, and work
          accidents.`,
                      text_ar: `Taking care of workers’ health, raising their health standards, and
          protecting them from occupational dangers, diseases, and work
          accidents.`,
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: `Raising awareness of risks and developing surveillance and
          preparedness mechanisms to confront public health risks.`,
                      text_ar: `Raising awareness of risks and developing surveillance and
          preparedness mechanisms to confront public health risks.`,
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: `Develop national policies and action plans and build institutional
          capacities on occupational health.`,
                      text_ar: `Develop national policies and action plans and build institutional
          capacities on occupational health.`,
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: `Scale up the coverage with essential interventions for prevention and
          control of occupational and work-related diseases and injuries and
          occupational health services.`,
                      text_ar: `Scale up the coverage with essential interventions for prevention and
          control of occupational and work-related diseases and injuries and
          occupational health services.`,
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: `Ensure collaboration with other relevant national health programmes
          such as those dealing with communicable and non-communicable diseases,
          prevention of injuries, health promotion, mental health, environmental
          health, and health systems development.`,
                      text_ar: `Ensure collaboration with other relevant national health programmes
          such as those dealing with communicable and non-communicable diseases,
          prevention of injuries, health promotion, mental health, environmental
          health, and health systems development.`,
                      classname: "",
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Community Involvement",
              title_ar: "Community Involvement",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title:
                "Occupational health aims to prevent work-related illness and injury",
              title_ar:
                "Occupational health aims to prevent work-related illness and injury",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Occupational Health",
      icon: "home",
      url: "/publichealth/occupationalHealth",
    },
    {
      text: "occupational_health",
      useLinker: true,
      icon: "menu_book",
      url: "/publichealth/occupationalHealth",
    },
  ],
};

export const DubaiChallenge = {
  _id: "mypage",
  title: "Dubai Challenge",
  title_ar: "Dubai Challenge",
  slug: "about-us",
  layout: "default",
  metaTitle: "Dubai Challenge",
  metaDescription: "Dubai Challenge",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Dubai Challenge: The Experience of Tackling the Covid-19 Pandemic",
          text_ar:
            "Dubai Challenge: The Experience of Tackling the Covid-19 Pandemic",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block3",
          type: "heading",
          size: "h5",
          text: `Health promotion and awareness aims to raise community awareness
        regarding health risks, ways to prevent diseases, and how to follow
        healthy lifestyles.
        <br />
        Additionally, developing and creating educational and awareness
        materials, including publications, workshops, and community campaigns,
        is one of the core responsibilities of health promotion and awareness
        personnel.`,
          text_ar: `Health promotion and awareness aims to raise community awareness
        regarding health risks, ways to prevent diseases, and how to follow
        healthy lifestyles.
        <br />
        Additionally, developing and creating educational and awareness
        materials, including publications, workshops, and community campaigns,
        is one of the core responsibilities of health promotion and awareness
        personnel.`,
          classname: "md:!my-4 my-2  text-onSurfaceVariant Regular",
        },
        {
          _id: "block1",
          type: "div",
          classname: "dda-card",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "dda-row no-gutters",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "dda-col-md-3 p-0 position-relative",
                  children: [
                    {
                      _id: "block2",
                      type: "image",
                      src: "covid.png", //heromain
                      size: "fullwidth",
                      classname: "dda-card-img md:!h-full !h-[230px]",
                      alt: "card-img-1",
                    },
                  ],
                },

                {
                  _id: "block1",
                  type: "div",
                  classname: "dda-col-md-9",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname:
                        "dda-card-body justify-between h-full px-0 md:!px-[1.25rem]",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "dda-d-flex",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h5",
                              text: "The Experience of Tackling the Covid-19 Pandemic",
                              text_ar:
                                "The Experience of Tackling the Covid-19 Pandemic",
                              classname:
                                "dda-card-title dda-flex dda-align-center dda-justify-space text-primary",
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: `The book aimed to monitor and reflect the huge efforts made by
                Dubai to address the COVID-19 pandemic. DHA has played a
                pioneering and distinguished role in cooperation and full
                coordination with many governmental and private departments and
                institutions in the Emirate of Dubai. These efforts have
                resulted in remarkable success in a unique and rare experience
                dealing with the pandemic, as the world has recognised this.`,
                          text_ar: `The book aimed to monitor and reflect the huge efforts made by
                Dubai to address the COVID-19 pandemic. DHA has played a
                pioneering and distinguished role in cooperation and full
                coordination with many governmental and private departments and
                institutions in the Emirate of Dubai. These efforts have
                resulted in remarkable success in a unique and rare experience
                dealing with the pandemic, as the world has recognised this.`,
                          classname:
                            "dda-card-text dda-flex dda-align-center body",
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname: "dda-flex dda-align-center gap-4",
                          children: [
                            {
                              _id: "block3",
                              type: "dda-button",
                              props: {
                                button_color: "default-tertiary",
                                start_icon: "",
                                button_text: "View Book",
                                button_text_ar: "View Book",
                                end_icon: "",
                                custom_class: "",
                                component_mode: "",
                                button_id: "button",
                                aria_label: "button",
                                onclick: "console.log('clicked')",
                                button_name: "button",
                                button_name_ar: "button",
                                class: "hydrated",
                              },
                            },
                            {
                              _id: "block3",
                              type: "dda-button",
                              props: {
                                button_color: "default-tertiary",
                                start_icon: "",
                                button_text: "Download Book",
                                button_text_ar: "Download Book",
                                end_icon: "",
                                custom_class: "ms-3",
                                component_mode: "",
                                button_id: "button",
                                aria_label: "button",
                                onclick: "console.log('clicked')",
                                button_name: "button",
                                button_name_ar: "button",
                                class: "hydrated",
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block1",
          type: "div",
          classname: "dda-card my-4",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "dda-row no-gutters",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "dda-col-md-3 p-0 position-relative",
                  children: [
                    {
                      _id: "block2",
                      type: "image",
                      src: "covid.png", //heromain
                      size: "fullwidth",
                      classname: "dda-card-img md:!h-full !h-[230px]",
                      alt: "card-img-1",
                    },
                  ],
                },

                {
                  _id: "block1",
                  type: "div",
                  classname: "dda-col-md-9",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname:
                        "dda-card-body justify-between h-full px-0 md:!px-[1.25rem]",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "dda-d-flex",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h5",
                              text: "Covid-19 Vaccination Card Update/ Issue Request",
                              text_ar:
                                "Covid-19 Vaccination Card Update/ Issue Request",
                              classname:
                                "dda-card-title dda-flex dda-align-center dda-justify-space text-primary",
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: `The book aimed to monitor and reflect the huge efforts made by
                Dubai to address the COVID-19 pandemic. DHA has played a
                pioneering and distinguished role in cooperation and full
                coordination with many governmental and private departments and
                institutions in the Emirate of Dubai. These efforts have
                resulted in remarkable success in a unique and rare experience
                dealing with the pandemic, as the world has recognised this.`,
                          text_ar: `The book aimed to monitor and reflect the huge efforts made by
                Dubai to address the COVID-19 pandemic. DHA has played a
                pioneering and distinguished role in cooperation and full
                coordination with many governmental and private departments and
                institutions in the Emirate of Dubai. These efforts have
                resulted in remarkable success in a unique and rare experience
                dealing with the pandemic, as the world has recognised this.`,
                          classname:
                            "dda-card-text dda-flex dda-align-center body",
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname: "dda-flex dda-align-center gap-4",
                          children: [
                            {
                              _id: "block3",
                              type: "dda-button",
                              props: {
                                button_color: "default-tertiary",
                                start_icon: "",
                                button_text: "Apply Now",
                                button_text_ar: "Apply Now",
                                end_icon: "",
                                custom_class: "",
                                component_mode: "",
                                button_id: "button",
                                aria_label: "button",
                                onclick: "console.log('clicked')",
                                button_name: "button",
                                button_name_ar: "button",
                                class: "hydrated",
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Dubai Challenge: The Experience of Tackling the Covid-19 Pandemic",
      icon: "menu_book",
      url: "/publicHealth/dubaiChallenge",
    },
  ],
};

export const ProgrammesAndPublishedArticles = {
  _id: "mypage",
  title: "Programmes And Published Articles",
  title_ar: "Programmes And Published Articles",
  slug: "about-us",
  layout: "default",
  metaTitle: "Programmes And Published Articles",
  metaDescription: "Programmes And Published Articles",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "21_Public Health - Programmes and Published Articles.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Programs and Published Articles",
          text_ar: "Programs and Published Articles",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block1",
          type: "div",
          classname: "xl:flex gap-4",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "xl:w-3/4",
              children: [
                {
                  _id: "block4",
                  type: "heading",
                  size: "h6",
                  classname: "Medium md:!my-4 my-2",
                  text: "Core Function",
                  text_ar: "Core Function",
                },
                {
                  _id: "block3",
                  type: "list",
                  type_identifier: "ul",
                  classname:
                    "list-inside text-onSurfaceVariant list-disc *:mb-2 body Regular",
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Develop and update public health standards and guidelines related to social, economic and cultural factors.",
                      text_ar:
                        "Develop and update public health standards and guidelines related to social, economic and cultural factors.",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Developing public health policies and their follow-up to improve and enhance the health status of the population.",
                      text_ar:
                        "Developing public health policies and their follow-up to improve and enhance the health status of the population.",
                      classname: "",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "li",
                      text: "Preparing and implementing studies related to public health and non-communicable diseases",
                      text_ar:
                        "Preparing and implementing studies related to public health and non-communicable diseases",
                      classname: "",
                    },
                  ],
                },
              ],
            },
            {
              _id: "block1",
              type: "div",
              classname:
                "xl:w-1/4 gap-4 flex xl:flex-col md:flex-row flex-col xl:my-0 my-4",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "border rounded-lg border-outline py-4 px-3",
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName:
                          "Hospitals & DSC Class C mandatory emergency medications request form",
                        fileName_ar:
                          "Hospitals & DSC Class C mandatory emergency medications request form",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
                {
                  _id: "block1",
                  type: "div",
                  classname: "border rounded-lg border-outline py-4 px-3",
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName:
                          "Hospitals & DSC Class C mandatory emergency medications request form",
                        fileName_ar:
                          "Hospitals & DSC Class C mandatory emergency medications request form",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Programs and Published Articles",
      icon: "menu_book",
      url: "/publicHealth/ProgrammesAndPublishedArticles",
    },
  ],
};

export const DHASurveys = {
  _id: "mypage",
  title: "DHA Surveys",
  title_ar: "DHA Surveys",
  slug: "about-us",
  layout: "default",
  metaTitle: "DHA Surveys",
  metaDescription: "DHA Surveys",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "08_Open data - DHA Surveys.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Open Data",
          text_ar: "Open Data",
          classname: "md:!mb-4 mb-3 Medium text-primary",
        },
        {
          _id: "block1",
          type: "div",
          classname: "lg:flex gap-6",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "lg:w-3/4",
              children: [
                {
                  _id: "block4",
                  type: "heading",
                  size: "h6",
                  classname: "Medium mb-2",
                  text: "eHealth",
                  text_ar: "eHealth",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `According to WHO and DHA, eHealth is defined as the use of
            information and communication technologies in support of health and
            health-related fields. It is employed to overcome geographical and
            economic challenges. eHealth applications include disease diagnosis
            and treatment, data management, education, and facilitating
            communication between patients and healthcare providers. <br />
            eHealth is an emerging field in the intersection of medical
            informatics, public health and business, referring to health
            services and information delivered or enhanced through the Internet
            and related technologies.
            <br />
            In a broader sense, the term characterizes not only a technical
            development but also a state of mind, a way of thinking, an
            attitude, and a global thinking to improve health care locally,
            regionally, and worldwide using information and communication
            technology.`,
                  text_ar: `According to WHO and DHA, eHealth is defined as the use of
            information and communication technologies in support of health and
            health-related fields. It is employed to overcome geographical and
            economic challenges. eHealth applications include disease diagnosis
            and treatment, data management, education, and facilitating
            communication between patients and healthcare providers. <br />
            eHealth is an emerging field in the intersection of medical
            informatics, public health and business, referring to health
            services and information delivered or enhanced through the Internet
            and related technologies.
            <br />
            In a broader sense, the term characterizes not only a technical
            development but also a state of mind, a way of thinking, an
            attitude, and a global thinking to improve health care locally,
            regionally, and worldwide using information and communication
            technology.`,
                  classname: "body md:!mb-6 mb-4",
                },
                {
                  _id: "block4",
                  type: "heading",
                  size: "h6",
                  classname: "Medium mb-2",
                  text: "The Electronic Medical Record Adoption Model (EMRAM) Survey",
                  text_ar:
                    "The Electronic Medical Record Adoption Model (EMRAM) Survey",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: `The Electronic Medical Record Adoption Model (EMRAM) Survey Dubai
            Health Authority and HIMSS (Healthcare Information and Management
            Systems Society) carry out annual surveys across the Private and
            Public Hospitals in the Emirate of Dubai, which are under the
            jurisdiction of DHA, to determine the electronic efficiency of
            hospitals. Dubai has been the first city in the Middle East to
            conduct and complete the EMRAM survey since 2011. The survey is the
            first step in the DHA’s aim to ensure all hospitals in the Emirate
            of Dubai eventually adopt the electronic model, facilitating better
            healthcare services to the community.`,
                  text_ar: `The Electronic Medical Record Adoption Model (EMRAM) Survey Dubai
            Health Authority and HIMSS (Healthcare Information and Management
            Systems Society) carry out annual surveys across the Private and
            Public Hospitals in the Emirate of Dubai, which are under the
            jurisdiction of DHA, to determine the electronic efficiency of
            hospitals. Dubai has been the first city in the Middle East to
            conduct and complete the EMRAM survey since 2011. The survey is the
            first step in the DHA’s aim to ensure all hospitals in the Emirate
            of Dubai eventually adopt the electronic model, facilitating better
            healthcare services to the community.`,
                  classname: "body md:!mb-6 mb-4",
                },
              ],
            },
            {
              _id: "block1",
              type: "div",
              classname: "xl:w-1/4 *:mb-4 xl:my-0 my-4",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "border rounded-lg border-outline py-4 px-3",
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "Dubai Household Health Survey",
                        fileName_ar: "Dubai Household Health Survey",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
                {
                  _id: "block1",
                  type: "div",
                  classname: "border rounded-lg border-outline py-4 px-3",
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "Clinical Services Capacity Plan Study",
                        fileName_ar: "Clinical Services Capacity Plan Study",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
                {
                  _id: "block1",
                  type: "div",
                  classname: "border rounded-lg border-outline py-4 px-3",
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "Dubai Health Profile",
                        fileName_ar: "Dubai Health Profile",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
                {
                  _id: "block1",
                  type: "div",
                  classname: "border rounded-lg border-outline py-4 px-3",
                  children: [
                    {
                      _id: "block8",
                      type: "custom_components",
                      custom_components: "FileDownloadRow",
                      text: "Vision",
                      text_ar: "Vision",
                      props: {
                        fileIcon:
                          "/attachments/medialib/a113be3f-0874-442f-9e85-e6ca0d04bec0-1755335842181-14196722-File_Type.svg",
                        fileName: "EMRAM HIMSS Solution",
                        fileName_ar: "EMRAM HIMSS Solution",
                        downloadIcon:
                          "/attachments/medialib/d9942098-215b-41c3-bdc6-d434596c5518-1755335850179-9319492-file_download.svg",
                        onDownload: () => {
                          /* handle download */
                          alert("test");
                        },
                        // fileSize: "78 MB",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h6",
          text: "The following hospitals participated in the EMRAM Survey in Dubai:",
          text_ar:
            "The following hospitals participated in the EMRAM Survey in Dubai:",
          classname: "Medium mb-5",
        },
        {
          _id: "block3",
          type: "list",
          type_identifier: "ul",
          classname:
            "grid md:grid-cols-2 lg:grid-cols-3 gap-2 list-disc list-inside border rounded-2xl !p-4 body",
          children: [
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Dubai Hospital",
                  text_ar: "Dubai Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Hatta Hospital",
                  text_ar: "Hatta Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Rashid Hospital",
                  text_ar: "Rashid Hospital",
                },
              ],
            },

            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Latifa Hospital",
                  text_ar: "Latifa Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Al Jalila Children’s Specialty Hospital",
                  text_ar: "Al Jalila Children’s Specialty Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Adam Vital Hospital",
                  text_ar: "Adam Vital Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Al Garhoud Private Hospital",
                  text_ar: "Al Garhoud Private Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Mirdif private Hospital",
                  text_ar: "Mirdif private Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Al Tadawi Specialty Hospital",
                  text_ar: "Al Tadawi Specialty Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Al Zahra Hospital",
                  text_ar: "Al Zahra Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "American Academy of Cosmetic Surgery Hospital",
                  text_ar: "American Academy of Cosmetic Surgery Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "American Hospital Dubai",
                  text_ar: "American Hospital Dubai",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Aster Cedars Hospital Jebel Ali",
                  text_ar: "Aster Cedars Hospital Jebel Ali",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Aster Hospital",
                  text_ar: "Aster Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Aster Hospital Sonapur",
                  text_ar: "Aster Hospital Sonapur",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Barraquer Eye Hospital",
                  text_ar: "Barraquer Eye Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Bella Roma Specialty Hospital",
                  text_ar: "Bella Roma Specialty Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Burjeel Hospital For Advanced Surgery ",
                  text_ar: "Burjeel Hospital For Advanced Surgery ",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Medeor 24X7 Hospital",
                  text_ar: "Medeor 24X7 Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Canadian Specialist Hospital",
                  text_ar: "Canadian Specialist Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Clemenceau Medical Center",
                  text_ar: "Clemenceau Medical Center",
                },
              ],
            },

            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Dr Sulaiman Al Habib Hospital",
                  text_ar: "Dr Sulaiman Al Habib Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Dubai London Hospital",
                  text_ar: "Dubai London Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Dubai London Specialty Hospital",
                  text_ar: "Dubai London Specialty Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Emirates Specialty Hospital",
                  text_ar: "Emirates Specialty Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Emirates Hospital",
                  text_ar: "Emirates Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Fakeeh University Hospital",
                  text_ar: "Fakeeh University Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Gargash Hospital",
                  text_ar: "Gargash Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "International Modern Hospital",
                  text_ar: "International Modern Hospital",
                },
              ],
            },

            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Iranian Hospital Dubai",
                  text_ar: "Iranian Hospital Dubai",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Kings College Hospital London",
                  text_ar: "Kings College Hospital London",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Medcare Hospital",
                  text_ar: "Medcare Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Medcare Orthopedics And Spine Hospital",
                  text_ar: "Medcare Orthopedics And Spine Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Medcare Women And Child Hospital",
                  text_ar: "Medcare Women And Child Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Mediclinic City Hospital",
                  text_ar: "Mediclinic City Hospital",
                },
              ],
            },

            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Mediclinic Parkview Hospital",
                  text_ar: "Mediclinic Parkview Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Mediclinic Welcare Hospital",
                  text_ar: "Mediclinic Welcare Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Neuro Spinal Hospital",
                  text_ar: "Neuro Spinal Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Cosmesurge Plastic Surgery Hospital",
                  text_ar: "Cosmesurge Plastic Surgery Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "NMC. Specialty Hospital ",
                  text_ar: "NMC. Specialty Hospital ",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "NMC Royal Hospital",
                  text_ar: "NMC Royal Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Novomed Specialized Surgical Hospital",
                  text_ar: "Novomed Specialized Surgical Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Prime Hospital",
                  text_ar: "Prime Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Quttainah Specialized Hospital",
                  text_ar: "Quttainah Specialized Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Saudi German Hospital ",
                  text_ar: "Saudi German Hospital ",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Valiant Clinic and Hospital",
                  text_ar: "Valiant Clinic and Hospital",
                },
              ],
            },
            {
              _id: "block3",
              type: "list",
              type_identifier: "li",
              classname: "text-primary",
              children: [
                {
                  _id: "block3",
                  type: "htmlTag",
                  tag: "span",
                  classname: "",
                  text: "Zulekha Hospital ",
                  text_ar: "Zulekha Hospital ",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "Open Data", icon: "menu_book", url: "/opendata/dhasurveys" },
  ],
};

export const AnnualHealthStatisticBook2 = {
  _id: "component_7368cdc1-d510-4e73-ad7f-31be595cfdba",
  title: "Annual Health Statistic Book",
  title_ar: "Annual Health Statistic Book",
  slug: "about-us",
  layout: "default",
  metaTitle: "Annual Health Statistic Book",
  metaDescription: "Annual Health Statistic Book",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "component_79cbff98-00ba-4d24-96c4-7c0a3d81454f",
      type: "div",
      classname: "",
      children: [
        {
          _id: "component_1b5fc6b0-b77d-43c4-81e7-16699b3ec135",
          type: "dda-breadcrumb",
          breadCrumb_item: [
            { text: "Home", icon: "home", url: "/" },
            {
              text: "Annual Health Statistic Book",
              icon: "menu_book",
              url: "/opendata/annualhealthstatisticbook",
            },
          ],
        },
        {
          _id: "component_4f84438c-c0a5-4222-b918-7d6794bfda2a",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "component_23582db2-f713-4000-91b5-b831fbbb3d60",
              type: "image",
              src: "/attachments/medialib/eae157d4-16f2-4651-ae75-9e814b016587-1756382309229-852898976-09_Open data - Annual Health Statistic Book.jpg",
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "component_90b3bad2-aaa5-4513-89ee-c316ae3a5f85",
          type: "heading",
          size: "h2",
          text: "Annual Health Statistic Books",
          text_ar: "Annual Health Statistic Books",
          classname: "md:!mb-4 mb-3 Medium  text-primary",
        },
        {
          _id: "component_f42c8be0-fc83-46d3-964e-fa19f24311df",
          type: "paragraph",
          size: "normal",
          text: "The Annual Health Statistical Yearbook is an official publication issued regularly by the Dubai Health Authority (DHA). It includes analysis of health-related data across the Emirate. This publication aims to provide an accurate and up-to-date picture of the healthcare landscape in Dubai by presenting key health indicators such as birth and death rates, and utilisation of healthcare services. It also includes detailed information on the healthcare infrastructure, human resources, and the performance efficiency of health institutions. The yearbook serves as a reliable reference for policymakers and researchers, supporting evidence-based planning and health policy development. Furthermore, it reflects the DHA\u2019s commitment to transparency and open data, that enhances the healthcare services. <br /><br />",
          text_ar:
            "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a \u0647\u0648 \u0625\u0635\u062f\u0627\u0631 \u0631\u0633\u0645\u064a \u062f\u0648\u0631\u064a \u064a\u0635\u062f\u0631 \u0639\u0646 \u0647\u064a\u0626\u0629 \u0627\u0644\u0635\u062d\u0629 \u0641\u064a \u062f\u0628\u064a\u060c \u0648\u064a\u062a\u0636\u0645\u0646 \u062a\u062d\u0644\u064a\u0644\u0627\u062a \u0644\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0645\u062a\u0639\u0644\u0642\u0629 \u0628\u0627\u0644\u0635\u062d\u0629 \u0639\u0644\u0649 \u0645\u0633\u062a\u0648\u0649 \u0627\u0644\u0625\u0645\u0627\u0631\u0629. \u0648\u064a\u0647\u062f\u0641 \u0647\u0630\u0627 \u0627\u0644\u0625\u0635\u062f\u0627\u0631 \u0625\u0644\u0649 \u062a\u0642\u062f\u064a\u0645 \u0635\u0648\u0631\u0629 \u062f\u0642\u064a\u0642\u0629 \u0648\u062d\u062f\u064a\u062b\u0629 \u0644\u0644\u0645\u0634\u0647\u062f \u0627\u0644\u0635\u062d\u064a \u0641\u064a \u062f\u0628\u064a\u060c \u0645\u0646 \u062e\u0644\u0627\u0644 \u0639\u0631\u0636 \u0645\u0624\u0634\u0631\u0627\u062a \u0635\u062d\u064a\u0629 \u0631\u0626\u064a\u0633\u064a\u0629 \u0645\u062b\u0644 \u0645\u0639\u062f\u0644\u0627\u062a \u0627\u0644\u0645\u0648\u0627\u0644\u064a\u062f \u0648\u0627\u0644\u0648\u0641\u064a\u0627\u062a\u060c \u0648\u0627\u0644\u0623\u0645\u0631\u0627\u0636 \u0627\u0644\u0645\u0646\u062a\u0634\u0631\u0629\u060c \u0648\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u062e\u062f\u0645\u0627\u062a \u0627\u0644\u0635\u062d\u064a\u0629. \u0643\u0645\u0627 \u064a\u062a\u0636\u0645\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062a \u062a\u0641\u0635\u064a\u0644\u064a\u0629 \u062d\u0648\u0644 \u0627\u0644\u0628\u0646\u064a\u0629 \u0627\u0644\u062a\u062d\u062a\u064a\u0629 \u0644\u0644\u0631\u0639\u0627\u064a\u0629 \u0627\u0644\u0635\u062d\u064a\u0629\u060c \u0648\u0627\u0644\u0645\u0648\u0627\u0631\u062f \u0627\u0644\u0628\u0634\u0631\u064a\u0629\u060c \u0648\u0643\u0641\u0627\u0621\u0629 \u0623\u062f\u0627\u0621 \u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062a \u0627\u0644\u0635\u062d\u064a\u0629. \u0648\u064a\u0645\u062b\u0644 \u0627\u0644\u0643\u062a\u0627\u0628 \u0645\u0631\u062c\u0639\u0627\u064b \u0645\u0648\u062b\u0648\u0642\u0627\u064b \u0644\u0635\u0646\u0651\u0627\u0639 \u0627\u0644\u0633\u064a\u0627\u0633\u0627\u062a \u0648\u0627\u0644\u0628\u0627\u062d\u062b\u064a\u0646\u060c \u0648\u0627\u0644\u0645\u0633\u062a\u062b\u0645\u0631\u064a\u0646\u060c \u062d\u064a\u062b \u064a\u062f\u0639\u0645 \u0627\u0644\u062a\u062e\u0637\u064a\u0637 \u0627\u0644\u0642\u0627\u0626\u0645 \u0639\u0644\u0649 \u0627\u0644\u0623\u062f\u0644\u0629 \u0648\u062a\u0637\u0648\u064a\u0631 \u0627\u0644\u0633\u064a\u0627\u0633\u0627\u062a \u0627\u0644\u0635\u062d\u064a\u0629. \u0643\u0645\u0627 \u064a\u0639\u0643\u0633 \u0627\u0644\u062a\u0632\u0627\u0645 \u0647\u064a\u0626\u0629 \u0627\u0644\u0635\u062d\u0629 \u0628\u062f\u0628\u064a \u0628\u0645\u0628\u0627\u062f\u0626 \u0627\u0644\u0634\u0641\u0627\u0641\u064a\u0629 \u0648\u0625\u062a\u0627\u062d\u0629 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0645\u0641\u062a\u0648\u062d\u0629 \u0627\u0644\u062a\u064a \u062a\u0633\u0647\u0645 \u0641\u064a \u062a\u0639\u0632\u064a\u0632 \u062c\u0648\u062f\u0629 \u0627\u0644\u062e\u062f\u0645\u0627\u062a \u0627\u0644\u0635\u062d\u064a\u0629. <br /><br />",
          classname: "body",
        },
        {
          _id: "component_e500a129-342e-48c0-9dac-8c0d881b98ae",
          type: "div",
          classname: "dda-table-container",
          children: [
            {
              _id: "component_233bb2f9-71d1-4bd3-b73c-87ec32c19d2d",
              type: "div",
              classname: "overflow-x-auto",
              children: [
                {
                  _id: "component_070f4aac-102c-4eae-b665-7b980ffcba7c",
                  type: "table",
                  classname: "dda-table w-full min-w-[650px]",
                  children: [
                    {
                      id: "table_header",
                      type: "tableItems",
                      type_identifier: "thead",
                      classname: "body",
                      children: [
                        {
                          _id: "component_7589772c-a4ba-4ef8-8f4f-fedb7a1bc0fe",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_c0c9e3a7-d8c8-4cd2-ad91-647ded7dbe26",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "",
                              text: "#",
                              text_ar: "#",
                            },
                            {
                              _id: "component_a7c30f22-a6b2-4cf7-b59c-51d490bd2520",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "",
                              text: "File Name",
                              text_ar: "File Name",
                            },
                            {
                              _id: "component_b6430222-88c9-460c-9a88-8f4f260d02ad",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "",
                              text: "Documents",
                              text_ar: "Documents",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "component_9a4320a9-834f-4cf4-924e-0f6dd150cee2",
                      type: "tableItems",
                      type_identifier: "tbody",
                      classname: "body",
                      children: [
                        {
                          _id: "component_bb3a545e-82dc-4adc-9c47-1a58b3e15025",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_288c2415-acc5-4482-8468-bc0e09e05b50",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_79521630-8fa2-4819-8570-2fc9dc2e576b",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "1",
                                  text_ar: "1",
                                },
                              ],
                            },
                            {
                              _id: "component_8bfccdfa-1a95-482e-aa73-2f57090b7bb8",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_bdc1ca36-ca5f-42a5-8862-635e9ad26522",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Dubai Health Statistical Yearbook 2023 ",
                                  text_ar:
                                    " \u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a \u0644\u0625\u0645\u0627\u0631\u0629 \u062f\u0628\u064a 2023 ",
                                },
                              ],
                            },
                            {
                              _id: "component_b59fd4ee-57cf-45e0-bb21-aafdacc7f7e7",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_7ee84dfe-7ba5-4a30-96b0-a220a3d2629d",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_cd9760ac-09fe-4109-8ee4-1c031edbc383",
                                    aria_label: "button",

                                    onclick: `() =>(window.location.href = 'https://www.dha.gov.ae/uploads/032025/Dubai%20Health%20Statistical%20Yearbook%2020232025319704.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_dc6970b7-866f-4bcf-8edb-5759a93de6f5",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_6d17f3c7-7f65-446d-ae3b-bb4efd6d9387",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_9b54d82f-218b-4ca7-a5ca-bd53ab034893",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "2",
                                  text_ar: "2",
                                },
                              ],
                            },
                            {
                              _id: "component_ba6b4c19-c03b-4159-a6f6-7aceeb363b42",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_e0dd2e45-2d3e-4000-95d0-503577f3ffd2",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Dubai Health Statistical Yearbook 2022 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a \u0644\u0625\u0645\u0627\u0631\u0629 \u062f\u0628\u064a 2022",
                                },
                              ],
                            },
                            {
                              _id: "component_a640052f-e684-461d-afd4-71afdfe11bf5",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_3dd86c83-3a5d-4051-bc69-8f78ce42eee8",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_e0fe5c21-ff7d-4cb1-acdd-8aa6a1003ad2",
                                    aria_label: "button",

                                    onclick: `() =>(window.location.href = 'https://www.dha.gov.ae/uploads/122024/Dubai%20Health%20Statistical%20Annual%20Book%20-%20202220241221356.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_0caeb394-e5a5-4364-b56a-d7e7c5055f47",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_8e16f45a-946b-4770-90d1-9653b22147ff",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_137cb65a-c771-4acb-915b-3ece2638a82a",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "3",
                                  text_ar: "3",
                                },
                              ],
                            },
                            {
                              _id: "component_79823237-f1d5-479a-89e4-f77badf8dd06",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_5d54788d-314a-4678-a081-cb873592b76b",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Dubai Health Statistical Yearbook 2021 ",
                                  text_ar:
                                    "\u0627\u0644\u062f\u0644\u064a\u0644 \u0627\u0644\u0625\u0631\u0634\u0627\u062f\u064a \u0644\u0645\u0624\u0634\u0631\u0627\u062a \u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a \u0644\u0625\u0645\u0627\u0631\u0629 \u062f\u0628\u064a ",
                                },
                              ],
                            },
                            {
                              _id: "component_d09874f2-e1f8-43fd-9313-2c85467b4483",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_3109d95f-0f29-4ae0-bbc5-8664a7fc506c",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_79fbac1f-b9b4-446b-bbd0-9f08ae17c283",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/102022/Dubai%20Health%20Statistical%20Yearbook_2120221043805.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_602bf020-de98-472a-a4e6-8d096cd18507",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_36052b48-a4c0-4a5e-bf4c-15d5cfb454ff",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_9e100945-187e-4872-91d1-471baf74eab1",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "4",
                                  text_ar: "4",
                                },
                              ],
                            },
                            {
                              _id: "component_86d58332-1296-4795-b6df-713297a13f3e",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_02a0ee53-a724-431b-84ce-b94445e347b1",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2020 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2020 ",
                                },
                              ],
                            },
                            {
                              _id: "component_b50981dc-0e17-4bf8-8b76-240cb732943f",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_6565eb40-b72a-44a0-b84a-d6af0a407b15",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_91e73914-4b0e-4a5d-8028-98d982719e2f",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/032022/Annual%20%20Health%20Statistics%20%20Book%2020202022326320.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_9eaa9346-92f0-4d68-ae70-3e3d04193558",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_f848d757-d952-47f1-801b-739b14a39b8f",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_5f6afdac-bbf4-43f7-80f2-af665ec4fd5f",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "5",
                                  text_ar: "5",
                                },
                              ],
                            },
                            {
                              _id: "component_b3dd9ea7-6100-45bc-89d0-b85bc7c8b0f4",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_03c4d94c-22fa-4ad5-824f-cce85fd8151e",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2019 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2019 ",
                                },
                              ],
                            },
                            {
                              _id: "component_194a07d1-4e1e-4e19-b053-0dea396c69e9",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_2053a33d-fb10-4333-9ed1-136f335d7ee6",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_8098c9cf-39f3-4d54-a9f6-21b749b74332",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/ed4de2c9-c89d-40cf-9621-b517dc382a8a.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_2dba949c-49e8-4d3a-a962-648c08b4fe5c",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_13e4d1df-31f0-446c-9cd4-824bca416dac",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_f612a315-402b-4ab0-abc8-7cf5dd834ca8",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "6",
                                  text_ar: "6",
                                },
                              ],
                            },
                            {
                              _id: "component_bf33f686-cade-415c-b8da-d2591d660812",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_0cfca191-96bb-449d-8245-90d9bcaab85d",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Dubai Annual Health Statistical Report 2018 ",
                                  text_ar:
                                    "\u0627\u0644\u062a\u0642\u0631\u064a\u0631 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a \u0644\u0625\u0645\u0627\u0631\u0629\u202f\u062f\u0628\u064a 2018   ",
                                },
                              ],
                            },
                            {
                              _id: "component_8b6c641c-b515-4b1c-910a-b72732e90a2a",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_f016c3a6-a0c8-4094-8d88-a10fe54a22a1",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_d3e03c67-4fed-4386-8d74-1d5ed4512900",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/ffd2f271-6e00-481e-9657-57bc5f05b736.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_28b7c8b8-86bb-4dbb-a17b-b4e812e13079",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_c6e9bfea-4b31-4457-b0be-0b60d2805fd8",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_8ec64112-5243-4f86-81f6-49af10f2e691",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "7",
                                  text_ar: "7",
                                },
                              ],
                            },
                            {
                              _id: "component_eb7141c1-8d7b-40f3-b1fc-c8f036d43395",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_14abb066-57ed-4999-8f01-4be1bfbca9d7",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Dubai Annual Health Statistical Report 2017 ",
                                  text_ar:
                                    "\u0627\u0644\u062a\u0642\u0631\u064a\u0631 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a \u0644\u0625\u0645\u0627\u0631\u0629\u202f\u062f\u0628\u064a 2017 ",
                                },
                              ],
                            },
                            {
                              _id: "component_7de82cc9-08af-4f5e-8f99-073b77310a64",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_e153b4c3-9eb2-42f3-8d96-66835c01ad86",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_4f6654e5-33d5-42e4-adc0-101ea94697c0",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/610ed46f-939a-4957-a20e-ee01a1061789.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_9226dab2-070f-4be0-824c-a742173faa21",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_3d6feedd-efd9-47ab-8a67-e511cdd62244",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_3885ac18-ed35-4c78-8e7a-329f91d4010c",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "8",
                                  text_ar: "8",
                                },
                              ],
                            },
                            {
                              _id: "component_50c3b027-a41a-4eed-99d6-7e159c919649",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_60178a17-56b6-4d9e-ae44-7c341d266784",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Dubai Annual Health Statistical Report 2016  ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2016  ",
                                },
                              ],
                            },
                            {
                              _id: "component_d66ef748-b5c1-4612-bb09-e21193544db4",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_ea3c3cc0-2b84-4be7-b48f-52297d16e673",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_6112abd0-dcee-4618-8ad3-f458f6a3212e",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/b73870ae-a9e8-4ace-972d-22aa00bc6123.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_5b5a3ece-3500-4bf6-971b-802fbe0f07de",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_ebe84d8b-6512-497b-b830-fc3f4964c1dd",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_32711201-f4fa-4699-acde-e3523d4171e8",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "9",
                                  text_ar: "9",
                                },
                              ],
                            },
                            {
                              _id: "component_a86d04d6-a775-4e54-8c9f-b252dc76f16f",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_c3bdcd90-9a7e-4bab-8649-3130a0ea4158",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2015 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2015  ",
                                },
                              ],
                            },
                            {
                              _id: "component_f06b2221-ca8b-4868-9755-4ed59e5a2207",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_05394ff1-58f1-45e3-9776-a7a3d4f4e890",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_2be78988-2fc4-4e1d-a3ff-bb6aad9fb015",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/907c58d0-14f6-465f-b0ab-20103478db17.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_48d06b3a-f172-4081-91fe-78f128f2fc42",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_3b6cbe3c-28de-4ac4-b982-3b0e93f5bbc2",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_de025d34-021e-4fa4-9300-36ba36e4f99b",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "10",
                                  text_ar: "10",
                                },
                              ],
                            },
                            {
                              _id: "component_512ddc86-b57a-4588-a632-310007739ab6",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_cf7a4294-7486-44fe-b7ee-887987871c69",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2014 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2014  ",
                                },
                              ],
                            },
                            {
                              _id: "component_28cb3c2e-aba5-4183-9256-0b72228976d8",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_02f6bd98-56ba-489f-8da0-bc9dd9e79d52",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_2d58ad0c-0fd2-40ea-8f3b-80c319fda29d",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/0feaa147-249d-47f7-8bc1-a524bc7c5669.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_da9d5ba1-9a01-4fe7-97a5-df92f0bf1273",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_d4e82563-6f2e-4efb-9fde-f5c167fbc4cc",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_bc84a45e-6bfb-4849-8d88-e3fb776577c5",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "11",
                                  text_ar: "11",
                                },
                              ],
                            },
                            {
                              _id: "component_8fa5c378-9c9e-42d3-aceb-fcc42b022480",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_1d25a123-6c8e-4d2c-a8c2-819989143f17",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2013 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2013  ",
                                },
                              ],
                            },
                            {
                              _id: "component_f305792c-5cbc-4cc9-aa4e-4ad05784b445",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_732b5300-379b-487c-afb0-4c4fccd9ebb0",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_815f1b27-091d-489d-a597-6e4970eba9bd",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/888ac3cc-3a10-4ef9-8b9d-d75fd449188a.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_86fe28a0-0812-4a39-927f-1715849c4b5d",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_4cd5cea4-f9b7-45bd-9621-f67782eb0dd6",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_f45176a4-8e0a-4132-b6a0-49e65d0b2e17",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "12",
                                  text_ar: "12",
                                },
                              ],
                            },
                            {
                              _id: "component_333c66ee-dbb0-4e5f-96b7-1019cbda29ef",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_dc0bfb00-2c71-414f-bff0-d3db5ed9ef61",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2012 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2012  ",
                                },
                              ],
                            },
                            {
                              _id: "component_95dc0f43-bff6-43fc-8ae6-dbf058ab561b",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_af0ef0b3-9eca-4c2e-b294-082c9e225539",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_04ef1b9e-8c35-46ff-b3e5-e6eac25a8474",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/1183187d-ec02-4cb1-95c2-1b54545ba164.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_8dbcdcd0-3a3a-45a0-9a1d-f43285ef6db3",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_6e70e43c-a2bc-4a06-98eb-8ddecec8fc08",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_1a33a814-9b8c-4750-b641-68518a87d4f3",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "13",
                                  text_ar: "13",
                                },
                              ],
                            },
                            {
                              _id: "component_77e3e412-330c-4595-9512-cbea4b789a9e",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_c4de9269-464e-48f4-824c-3c20e971628b",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2011 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2011  ",
                                },
                              ],
                            },
                            {
                              _id: "component_33bcd4cd-5ca5-477f-96a4-1e7f1d06f5fa",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_a6b57ae5-016c-4c40-aab4-391e0bda3ffb",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_fe6f9f1a-31bf-4412-9187-11ea97e4e6f7",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/2321f663-a72f-4d19-bca4-47d62dcfb36a.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_40facace-4e16-4337-8584-dc6e4f8673b1",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_524ab00d-3402-44ec-b04c-240205cb412a",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_b98d04dd-0ac5-44ff-ab39-15cd9ca1a349",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "14",
                                  text_ar: "14",
                                },
                              ],
                            },
                            {
                              _id: "component_376c5240-3bbf-4093-9e2d-2b5e50769e1d",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_5324b8b3-00d1-431a-afde-1498bb667c36",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2010 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2010  ",
                                },
                              ],
                            },
                            {
                              _id: "component_1659de88-8ec4-450e-875b-1328025010b5",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_ac23705d-f747-41d2-b84a-5ea269a37834",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_deed0e07-bbaf-4368-a652-b3f7c630de3a",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/4eba8a16-d3bc-4cdf-ab1f-be2a35d7fbee.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_493501d3-b56a-430e-ba44-c405be4f13b7",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_f68cf37c-eb9c-4b34-82cb-42d5556d3d81",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_eb60b90f-e069-42a2-920b-22ae81315172",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "14",
                                  text_ar: "14",
                                },
                              ],
                            },
                            {
                              _id: "component_9e44c65c-6b29-4821-978d-09b6fd1c8822",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_403419f2-3090-40c1-95f6-139ab914b4a5",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2009 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2009  ",
                                },
                              ],
                            },
                            {
                              _id: "component_32e6f7b7-45d3-4608-9f63-3744e868d04c",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_dcdab661-0dfd-4ff6-8392-3abed608bf42",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_2327b904-8ffa-4b27-9f2a-c0f7e59fa1a3",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/1a4d9e26-0c2b-44d6-b090-02ffa429ca2c.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_cda3a28b-428c-4a6a-ac01-31a972d923dc",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_fbea8585-8d74-490d-8db5-9c2046fd9403",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_082cafd7-77e0-45d1-9b4f-1251c5dc1024",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "15",
                                  text_ar: "15",
                                },
                              ],
                            },
                            {
                              _id: "component_262948ce-d201-465e-9c02-fa7bd6595dca",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_aba745c4-cb38-46aa-9171-e1844bf1006f",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2008 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2008  ",
                                },
                              ],
                            },
                            {
                              _id: "component_2c88bce6-bd68-4163-a76e-929bb361dc0f",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_ba1fba34-ed94-4764-ade0-c55ea058ba45",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_0fa5ee1f-dbb1-48ff-b4fa-401909878b61",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://www.dha.gov.ae/uploads/122021/82f6c5a1-5b92-4335-9158-4b1b5d19241d.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_02817a8a-0bed-458f-998e-b3c073de58a7",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_9352af5d-6441-4feb-9337-1c9334b746cd",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_e53446db-9f9b-43d2-a6ec-afb7bef7ad65",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "16",
                                  text_ar: "16",
                                },
                              ],
                            },
                            {
                              _id: "component_4b939672-4797-43a2-9403-02783b3af58b",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_c5353cff-df39-4e64-958e-d292bce5eb84",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2007 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2007  ",
                                },
                              ],
                            },
                            {
                              _id: "component_12dc424f-807e-420b-8e0d-93af6159fdf1",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_c5264173-2e45-4e5b-83d6-edadc24164de",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_ff7bf14f-b0d7-4162-a162-9e6fbb58f052",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/82f6c5a1-5b92-4335-9158-4b1b5d19241d.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_7e0672af-394a-4400-bf08-b0f4d7ae2258",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_94715e41-a4a3-43dc-8e7e-ccadfff9ac2d",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_1e2b5d9c-3f53-409a-9532-e4c6b14db8c4",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "17",
                                  text_ar: "17",
                                },
                              ],
                            },
                            {
                              _id: "component_913367ea-8e20-416c-b438-c5b888c25a55",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_650a5abd-88eb-4b91-a5eb-f81b2d061e49",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2006 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2006  ",
                                },
                              ],
                            },
                            {
                              _id: "component_6ca4efd9-843f-4bb3-8922-1b603a3138c6",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_1f5b2468-a721-4141-bdbf-af91d914c7ee",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_cf634fae-8437-4ba0-b8fe-a0356566177e",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/d2d2c56e-4ce8-4b92-b99a-b7c8d6e2f259.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_df19ae3a-876d-4acd-afc2-24a0c7d1ab40",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_5870c568-3426-4ac2-bd6b-69744fb10a26",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_578d6263-2cde-44f0-addd-b8fe0b7b902c",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "18",
                                  text_ar: "18",
                                },
                              ],
                            },
                            {
                              _id: "component_d9b70c22-45e6-47dd-aa98-1add1ee3aa96",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_65fcf727-2bc7-463a-a202-8fe94059699e",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2005 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2005  ",
                                },
                              ],
                            },
                            {
                              _id: "component_cda09e31-4d2e-4209-9e04-fee0316569ca",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_8b1f494d-ff34-4f7d-8289-2f8f4463deba",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_3d85d9af-cf6f-4e1e-b203-cb563107c0d7",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/9162b750-a9f3-4a72-8905-36587c37dff5.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_df502e56-e806-40cd-8c43-8205b818d211",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_0e27f310-d288-48d3-bbd8-ac7fd53047b6",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_8bd22a53-7822-4f3c-9f06-0495a0b29fc0",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "19",
                                  text_ar: "19",
                                },
                              ],
                            },
                            {
                              _id: "component_36976214-573a-4364-895f-008b155be4e6",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_2673fd42-7db5-4e18-a6bd-4dee1aca582e",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2004 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2004  ",
                                },
                              ],
                            },
                            {
                              _id: "component_6bbc3209-52d6-4899-b01d-a1140963e3c8",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_be858e0f-c316-442c-a71b-0d8792f6379a",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_b83f6a06-d960-4341-9725-1fa6804cd0fb",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href = 'https://dha.gov.ae/uploads/122021/65f75149-386f-4f91-ac2f-b632d9e5f904.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "component_34e239f0-7dc4-4a7e-aebc-a7a1051feaf0",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "component_9867b040-89ac-481b-9f50-fb0859b1ba34",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_f8875b24-2e6a-47fc-9d44-8611a1f17023",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "20",
                                  text_ar: "20",
                                },
                              ],
                            },
                            {
                              _id: "component_a3b92c9d-f566-4b8a-9d43-1840165cc01d",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_f813bc95-e877-4baa-afd6-027627853a8a",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text: "Annual Health Statistic Book 2003 ",
                                  text_ar:
                                    "\u0627\u0644\u0643\u062a\u0627\u0628 \u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a \u0627\u0644\u0635\u062d\u064a \u0627\u0644\u0633\u0646\u0648\u064a 2003  ",
                                },
                              ],
                            },
                            {
                              _id: "component_b6fd21c5-9c83-48bd-b84d-3586f1575112",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "component_b6a97bd3-94f2-49be-907b-bc400b44da1a",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id:
                                      "component_efcd997c-2f36-4db8-9a7b-cb41810f2846",
                                    aria_label: "button",

                                    onclick: `() => (window.location.href ='https://dha.gov.ae/uploads/122021/d8e0c02e-d562-4875-85d0-3aa8973784c9.pdf')`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [],
};

export const AnnualHealthStatisticBook = {
  _id: "mypage",
  title: "Annual Health Statistic Book",
  title_ar: "Annual Health Statistic Book",
  slug: "about-us",
  layout: "default",
  metaTitle: "Annual Health Statistic Book",
  metaDescription: "Annual Health Statistic Book",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block10",
          type: "div",
          classname: "my-6",
          children: [
            {
              _id: "block2",
              type: "image",
              src: "09_Open data - Annual Health Statistic Book.jpg", //heromain
              size: "fullwidth",
              classname:
                "w-full h-[200px] md:h-[300px] object-cover rounded-xl",
              alt: "This is a description for the page......",
            },
          ],
        },
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Annual Health Statistic Books",
          text_ar: "Annual Health Statistic Books",
          classname: "md:!mb-4 mb-3 Medium  text-primary",
        },
        {
          _id: "block1",
          type: "div",
          classname: "dda-table-container",
          children: [
            {
              _id: "block1",
              type: "div",
              classname: "overflow-x-auto",
              children: [
                {
                  _id: "table1",
                  type: "table",
                  classname: "dda-table w-full min-w-[650px]",
                  children: [
                    {
                      id: "table_header",
                      type: "tableItems",
                      type_identifier: "thead",
                      classname: "body",
                      children: [
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "",
                              text: "#",
                              text_ar: "#",
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "",
                              text: "File Name",
                              text_ar: "File Name",
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "",
                              text: "File Size",
                              text_ar: "File Size",
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "",
                              text: "Published Date",
                              text_ar: "Published Date",
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "th",
                              classname: "",
                              text: "Documents",
                              text_ar: "Documents",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "table_body",
                      type: "tableItems",
                      type_identifier: "tbody",
                      classname: "body",
                      parent_params: `["data"]`,
                      children: [
                        {
                          _id: "tableTR",
                          type: "tableItems",
                          type_identifier: "tr",
                          classname: "",
                          children: [
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "text-primary",
                                  text: "{index}", // in order to show 1, 2, 3, 4,
                                  text_ar: "{index}", // in order to show 1, 2, 3, 4,
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text_params: `["file_name"]`,
                                  text_params_ar: `["file_name"]`,
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text_params: `["file_size"]`,
                                  text_params_ar: `["file_size"]`,
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "tableTH",
                                  type: "paragraph",
                                  size: "normal",
                                  classname: "",
                                  text_params: `["published_date"]`,
                                  text_params_ar: `["published_date"]`,
                                },
                              ],
                            },
                            {
                              _id: "tableTH",
                              type: "tableItems",
                              type_identifier: "td",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "dda-button",
                                  props: {
                                    button_color: "default-tertiary",
                                    start_icon: "",
                                    button_text: "Download",
                                    button_text_ar: "Download",
                                    end_icon: "",
                                    custom_class: "",
                                    component_mode: "",
                                    button_id: "button",
                                    aria_label: "button",
                                    isReplace: true,
                                    onclick: `() =>
                                              (window.location.href =
                                                "["documents"]")`,
                                    button_name: "button",
                                    button_name_ar: "button",
                                    class: "hydrated",
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Annual Health Statistic Book",
      icon: "menu_book",
      url: "/opendata/annualhealthstatisticbook",
    },
  ],
};

export const MediaCenter = {
  _id: "mypage",
  title: "Media Center",
  title_ar: "Media Center",
  slug: "about-us",
  layout: "default",
  metaTitle: "Media Center",
  metaDescription: "Media Center",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Media Center",
          text_ar: "Media Center",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block3",
          type: "linking",
          // text: " Click here.",
          classname: "cursor-pointer",
          href: "/mediaCenter/mediaCenterDetails",
          children: [
            {
              _id: "block5",
              type: "div",
              classname:
                "md:flex bg-[#ADADAD]/10 rounded-xl hover:shadow-md transition-all",
              children: [
                {
                  _id: "block5",
                  type: "div",
                  classname: "md:w-1/3",
                  children: [
                    {
                      _id: "block2",
                      type: "image",
                      src: "mediaCenter.png",
                      size: "fullwidth",
                      classname:
                        "md:rounded-s-xl md:rounded-se-none rounded-t-xl md:h-full h-[200px] w-full object-cover",
                      alt: "news image",
                    },
                  ],
                },
                {
                  _id: "block5",
                  type: "div",
                  classname: "md:w-2/3 p-5 flex flex-col justify-around gap-2",
                  children: [
                    {
                      _id: "block5",
                      type: "div",
                      classname: "flex justify-between gap-6",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h5",
                          text: "Dubai Health Authority Launches Professional Diploma Programme for Health Facility Inspectors in Collaboration with Sharjah University",
                          text_ar:
                            "Dubai Health Authority Launches Professional Diploma Programme for Health Facility Inspectors in Collaboration with Sharjah University",
                          classname: "text-primary",
                        },
                        {
                          _id: "",
                          type: "icon",
                          icon_library: "fas", // material || fas
                          icon: `<i class="fa-solid fa-circle-arrow-right text-primary text-2xl shrink-0"></i>`, // for fas
                        },
                      ],
                    },

                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: "The Dubai Health Authority (DHA) announced today the launch of a Professional Diploma Programme for Health Facility Inspectors in Dubai, in collaboration with Sharjah University. This initiative is part of the DHA's ongoing efforts to enhance education, training, and scientific knowledge among its staff, enabling them to carry out their duties in line with global best practices in the health sector.",
                      text_ar:
                        "The Dubai Health Authority (DHA) announced today the launch of a Professional Diploma Programme for Health Facility Inspectors in Dubai, in collaboration with Sharjah University. This initiative is part of the DHA's ongoing efforts to enhance education, training, and scientific knowledge among its staff, enabling them to carry out their duties in line with global best practices in the health sector.",
                      classname: "body text-onSurfaceVariant",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: "Monday, November 18, 2024",
                      text_ar: "Monday, November 18, 2024",
                      classname: "capton",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          _id: "block5",
          type: "div",
          classname: "mt-8 grid lg:grid-cols-3 sm:grid-cols-2 gap-8",
          children: [
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "EventVariantCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                image: "",
                date: { month: "Oct", day: "26" },
                title: "World-class Quality",
                title_ar: "World-class Quality",
                description:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                description_ar:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                link: "/mediaCenter/mediaCenterDetails",
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "EventVariantCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                image: "",
                date: { month: "Oct", day: "26" },
                title: "World-class Quality",
                title_ar: "World-class Quality",
                description:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                description_ar:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                link: "/mediaCenter/mediaCenterDetails",
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "EventVariantCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                image: "",
                date: { month: "Oct", day: "26" },
                title: "World-class Quality",
                title_ar: "World-class Quality",
                description:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                description_ar:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                link: "/mediaCenter/mediaCenterDetails",
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "EventVariantCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                image: "",
                date: { month: "Oct", day: "26" },
                title: "World-class Quality",
                title_ar: "World-class Quality",
                description:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                description_ar:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                link: "/mediaCenter/mediaCenterDetails",
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "EventVariantCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                image: "",
                date: { month: "Oct", day: "26" },
                title: "World-class Quality",
                title_ar: "World-class Quality",
                description:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                description_ar:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                link: "/mediaCenter/mediaCenterDetails",
              },
            },
            {
              _id: "block8",
              type: "custom_components",
              custom_components: "EventVariantCard",
              text: "Vision",
              text_ar: "Vision",
              props: {
                image: "",
                date: { month: "Oct", day: "26" },
                title: "World-class Quality",
                title_ar: "World-class Quality",
                description:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                description_ar:
                  "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
                link: "/mediaCenter/mediaCenterDetails",
              },
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "Media Center", icon: "menu_book", url: "/mediaCenter" },
  ],
};

export const TermsAndCondition = {
  _id: "mypage",
  title: "Terms and condition",
  title_ar: "Terms and condition",
  slug: "about-us",
  layout: "default",
  metaTitle: "Terms and condition",
  metaDescription: "Terms and condition",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "pravicy_pollicy", //linker text to identify which linker to use
          text_ar: "pravicy_pollicy", //linker text to identify which linker to use
          useLinker: true,
          classname: "md:!my-4 my-2 Medium  text-primary",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "pravicy_pollicy", //for dynamic breadcrumbs
          linker_ar: "pravicy_pollicy", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "mb-3 mt-1",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Privacy Policy",
              title_ar: "Privacy Policy",
              isShow_title: false,
              size: "h2",
              classname: "",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "",
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Policy",
                      text_ar: "Policy",
                      classname: "text-primary  Medium	mt-2",
                    },
                    {
                      _id: "block1",
                      type: "div",
                      classname: "text-onSurfaceVariant body",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: `
                          DHA understands and respects users' privacy, and it is committed
              to protecting it. By visiting the DHA Portal and using DHA Smart
              Applications, users agree to the practices stated in this policy.
              Please read our Privacy Policy carefully to understand how we
              collect and use information.`,
                          text_ar: `DHA understands and respects users' privacy, and it is committed
              to protecting it. By visiting the DHA Portal and using DHA Smart
              Applications, users agree to the practices stated in this policy.
              Please read our Privacy Policy carefully to understand how we
              collect and use information.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: `Information collection`,
                          text_ar: `Information collection`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: `Some non-identifiable information is collected automatically while
              surfing our website or using smartphone applications, such as:`,
                          text_ar: `Some non-identifiable information is collected automatically while
              surfing our website or using smartphone applications, such as:`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname: "list-inside list-disc",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "The IP address you are using to access the website.",
                              text_ar:
                                "The IP address you are using to access the website.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "The type of web browser used as well as the time and date of the visit.",
                              text_ar:
                                "The type of web browser used as well as the time and date of the visit.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "The pages you view on the website.",
                              text_ar: "The pages you view on the website.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "Geographical location.",
                              text_ar: "Geographical location.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "Mobile device information (such as your mobile device ID, model), operating system, and version information.",
                              text_ar:
                                "Mobile device information (such as your mobile device ID, model), operating system, and version information.",
                              classname: "",
                            },
                          ],
                        },
                        {
                          _id: "tableTH",
                          type: "paragraph",
                          size: "normal",
                          classname: "mt-4",
                          text: "Identifiable information is collected voluntarily, such as when the user:",
                          text_ar:
                            "Identifiable information is collected voluntarily, such as when the user:",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname: "list-inside list-disc",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "Sends personal information such as name, date of birth, email id, phone number.",
                              text_ar:
                                "Sends personal information such as name, date of birth, email id, phone number.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "Completes an online suggestions or complaints form.",
                              text_ar:
                                "Completes an online suggestions or complaints form.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "Applies for a job through our e-job service.",
                              text_ar:
                                "Applies for a job through our e-job service.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "Registers with the online forum.",
                              text_ar: "Registers with the online forum.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "Uses online services such as Health services, or the Licensing and other DHA electronic Services.",
                              text_ar:
                                "Uses online services such as Health services, or the Licensing and other DHA electronic Services.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "We may request access or permission to your location while you are using our Smart App, to provide certain location-based services. Your location may be used and shared with Dubai Health Authority (DHA), if location permission is granted, to provide following services:",
                              text_ar:
                                "We may request access or permission to your location while you are using our Smart App, to provide certain location-based services. Your location may be used and shared with Dubai Health Authority (DHA), if location permission is granted, to provide following services:",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "When a patient generates an SOS alert or callback requests from the app",
                              text_ar:
                                "When a patient generates an SOS alert or callback requests from the app",
                              classname: "indent-5",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "Location sharing is not mandatory for all these services to work but will help DHA in providing more accurate and timely response to your requests in Dubai. If you wish to change our access or permissions, you may do so in your device's settings.",
                              text_ar:
                                "Location sharing is not mandatory for all these services to work but will help DHA in providing more accurate and timely response to your requests in Dubai. If you wish to change our access or permissions, you may do so in your device's settings.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "We may request access or permission to certain features from your mobile device, including your mobile device's bluetooth, microphone, camera, phone number, and other features. If you wish to change our access or permissions, you may do so in your device's settings.",
                              text_ar:
                                "We may request access or permission to certain features from your mobile device, including your mobile device's bluetooth, microphone, camera, phone number, and other features. If you wish to change our access or permissions, you may do so in your device's settings.",
                              classname: "",
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              text: "We may request to send you push notifications regarding your account or certain features of the Smart App. If you wish to opt-out from receiving these types of communications, you may turn them off in your device's settings.",
                              text_ar:
                                "We may request to send you push notifications regarding your account or certain features of the Smart App. If you wish to opt-out from receiving these types of communications, you may turn them off in your device's settings.",
                              classname: "",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Calendar",
                      text_ar: "Calendar",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Application may ask for Calendar permission to schedule calls with
            paramedics staff.`,
                      text_ar: `Application may ask for Calendar permission to schedule calls with
            paramedics staff.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Application may ask for Calendar permission to add appointments to
            your device calendar.`,
                      text_ar: `Application may ask for Calendar permission to add appointments to
            your device calendar.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Camera",
                      text_ar: "Camera",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `This permission has been used to access the device camera for
            processing OCR on user’s identification documents.`,
                      text_ar: `This permission has been used to access the device camera for
            processing OCR on user’s identification documents.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `This permission is being used in DHA App to access the device camera
            for the patient to join to video conference service with the
            physicians.`,
                      text_ar: `This permission is being used in DHA App to access the device camera
            for the patient to join to video conference service with the
            physicians.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Storage and Photos/Media/Files",
                      text_ar: "Storage and Photos/Media/Files",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Storage permission is needed in order to store captured images from
            the camera and then later access those images for the OCR purpose.`,
                      text_ar: `Storage permission is needed in order to store captured images from
            the camera and then later access those images for the OCR purpose.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Storage permission is needed in DHA App to access image, audio,
            video and files from your device to upload on the smart app`,
                      text_ar: `Storage permission is needed in DHA App to access image, audio,
            video and files from your device to upload on the smart app`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Microphone permission",
                      text_ar: "Microphone permission",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Allows accessing and recording microphone audio from the User's
            device to enable Calling and Chatting feature with Paramedics staff.`,
                      text_ar: `Allows accessing and recording microphone audio from the User's
            device to enable Calling and Chatting feature with Paramedics staff.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Allows accessing microphone audio from the User's device to enable
            video conference with the physicians in DHA App.`,
                      text_ar: `Allows accessing microphone audio from the User's device to enable
            video conference with the physicians in DHA App.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Activity Recognition permission",
                      text_ar: "Activity Recognition permission",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `DHA Application may ask for Activity Recognition Permission to read
            and track your physical activity (such has walking, biking or moving
            in a vehicle), sleep, heartrate and blood pressure data from Google
            Health Kit and view the same in DHA App.`,
                      text_ar: `DHA Application may ask for Activity Recognition Permission to read
            and track your physical activity (such has walking, biking or moving
            in a vehicle), sleep, heartrate and blood pressure data from Google
            Health Kit and view the same in DHA App.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Wi-Fi Connection Information",
                      text_ar: "Wi-Fi Connection Information",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Allows the app to view information about Wi-Fi networking, such as
            whether Wi-Fi is enabled and names of connected Wi-Fi devices.`,
                      text_ar: `Allows the app to view information about Wi-Fi networking, such as
            whether Wi-Fi is enabled and names of connected Wi-Fi devices.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Cookies",
                      text_ar: "Cookies",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Cookies are used to customize users visit and enhance the user
            surfing experience. It is possible to set most web browsers to
            reject cookies, accept, or delete these files. However, the refusal
            or removing cookies may obstruct your user experience.`,
                      text_ar: `Cookies are used to customize users visit and enhance the user
            surfing experience. It is possible to set most web browsers to
            reject cookies, accept, or delete these files. However, the refusal
            or removing cookies may obstruct your user experience.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Links to Other Site",
                      text_ar: "Links to Other Site",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `The DHA website and smart apps have links to third party websites.
            DHA has no control over other websites and thus the DHA Privacy
            Policy does not apply to them. Users are encouraged to read third
            party privacy policies prior to providing any personal information
            to third party websites.`,
                      text_ar: `The DHA website and smart apps have links to third party websites.
            DHA has no control over other websites and thus the DHA Privacy
            Policy does not apply to them. Users are encouraged to read third
            party privacy policies prior to providing any personal information
            to third party websites.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Social Media",
                      text_ar: "Social Media",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Users of social media (e.g., Facebook.com, Twitter.com,
            LinkedIn.com, Instagram etc.) shall be respectful of the larger
            community by complying with the terms and policies of each Social
            Media Host.
            <br />
            Users are encouraged to contribute comments that are respectful and
            for further discussion on our social media sites, but users shall
            avoid making comments that might be considered Confrontational,
            Offensive, Discriminatory, Profane, Off-topic, Spam (i.e.,
            unsolicited promotion of a third-party business), Misprivacy-leading
            and Fake.
            <br />
            DHA reserves the right to remove comments or content on our social
            media sites that fit into any one of the above categories, or for
            any other reason, to preserve the integrity of our social media
            sites. We may block further posting on our social media sites by any
            individual who violates this Privacy Policy.
            <br />
            Any comments or content posted by the users do not reflect, in any
            way, DHA’s opinion.`,
                      text_ar: `Users of social media (e.g., Facebook.com, Twitter.com,
            LinkedIn.com, Instagram etc.) shall be respectful of the larger
            community by complying with the terms and policies of each Social
            Media Host.
            <br />
            Users are encouraged to contribute comments that are respectful and
            for further discussion on our social media sites, but users shall
            avoid making comments that might be considered Confrontational,
            Offensive, Discriminatory, Profane, Off-topic, Spam (i.e.,
            unsolicited promotion of a third-party business), Misprivacy-leading
            and Fake.
            <br />
            DHA reserves the right to remove comments or content on our social
            media sites that fit into any one of the above categories, or for
            any other reason, to preserve the integrity of our social media
            sites. We may block further posting on our social media sites by any
            individual who violates this Privacy Policy.
            <br />
            Any comments or content posted by the users do not reflect, in any
            way, DHA’s opinion.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Information Security Controls",
                      text_ar: "Information Security Controls",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `DHA has implemented appropriate controls to protect and safeguard
            the privacy of user’s personal information shared or collected by
            DHA.`,
                      text_ar: `DHA has implemented appropriate controls to protect and safeguard
            the privacy of user’s personal information shared or collected by
            DHA.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: ` Where appropriate, encryption methods are used to protect
            information, which is deemed sensitive, or any other data that
            should remain secure to meet Federal, Local or DHA’s legal
            requirements.`,
                      text_ar: ` Where appropriate, encryption methods are used to protect
            information, which is deemed sensitive, or any other data that
            should remain secure to meet Federal, Local or DHA’s legal
            requirements.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Modifications",
                      text_ar: "Modifications",
                      classname: "text-primary  Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `DHA reserves the right to modify or amend the Privacy Policy at any
            time and the effective date will be posted at the beginning of the
            Privacy Policy. It is advisable to check the Privacy Policy on a
            regular basis for any changes.`,
                      text_ar: `DHA reserves the right to modify or amend the Privacy Policy at any
            time and the effective date will be posted at the beginning of the
            Privacy Policy. It is advisable to check the Privacy Policy on a
            regular basis for any changes.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: ` If you have questions about the DHA Privacy Policy, please contact
            us via e-mail at:`,
                      text_ar: ` If you have questions about the DHA Privacy Policy, please contact
            us via e-mail at:`,
                      children: [
                        {
                          _id: "block3",
                          type: "linking",
                          text: " info@dha.gov.ae",
                          text_ar: " info@dha.gov.ae",
                          classname: "text-primary",
                          href: "mailto::info@dha.gov.ae",
                        },
                      ],
                      classname: "text-onSurfaceVariant body",
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Terms & Conditions",
              title_ar: "Terms & Conditions",
              isShow_title: false,
              size: "h2",
              classname: "",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "",
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "​​​​​Dubai Government Terms and Conditions of Use",
                      text_ar:
                        "​​​​​Dubai Government Terms and Conditions of Use",
                      classname: "text-primary Medium mt-2",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Your access to, and use of, the DHA website (the "Site") is subject
            to the following terms and conditions, as well as U.A.E. laws. Your
            access to the Site is in consideration for your agreement to these
            Terms and Conditions of Use, whether or not you are a registered
            user. By accessing, browsing, and using the Site, you accept,
            without limitation or qualification, these Terms and Conditions of
            Use.
            <br />
            DHA maintains the right to modify these Terms and Conditions of Use
            and may do so by posting notice of such modifications on this page.
            Any modification is effective immediately upon posting, unless
            otherwise stated. Your continued use of the Site following the
            posting of any modification signifies your acceptance of such
            modification. You should periodically visit this page to review the
            current Terms and Conditions of Use.`,
                      text_ar: `Your access to, and use of, the DHA website (the "Site") is subject
            to the following terms and conditions, as well as U.A.E. laws. Your
            access to the Site is in consideration for your agreement to these
            Terms and Conditions of Use, whether or not you are a registered
            user. By accessing, browsing, and using the Site, you accept,
            without limitation or qualification, these Terms and Conditions of
            Use.
            <br />
            DHA maintains the right to modify these Terms and Conditions of Use
            and may do so by posting notice of such modifications on this page.
            Any modification is effective immediately upon posting, unless
            otherwise stated. Your continued use of the Site following the
            posting of any modification signifies your acceptance of such
            modification. You should periodically visit this page to review the
            current Terms and Conditions of Use.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Conduct",
                      text_ar: "Conduct",
                      classname: "text-primary Medium mt-2",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `You agree to access and use the Site only for lawful purposes. You
            are solely responsible for the knowledge of and adherence to any and
            all laws, statutes, rules and regulations pertaining to your use of
            the Site. By accessing the Site, you agree that you will not:`,
                      text_: `You agree to access and use the Site only for lawful purposes. You
            are solely responsible for the knowledge of and adherence to any and
            all laws, statutes, rules and regulations pertaining to your use of
            the Site. By accessing the Site, you agree that you will not:`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "list-inside list-disc text-onSurfaceVariant body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Use the Site to commit a criminal offense or to encourage others
              to engage in any conduct which would constitute a criminal offense
              or give rise to civil liability.`,
                          text_ar: `Use the Site to commit a criminal offense or to encourage others
              to engage in any conduct which would constitute a criminal offense
              or give rise to civil liability.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Post or transmit any discriminatory, libelous, harassing,
              defamatory, obscene, pornographic or otherwise unlawful content.`,
                          text_ar: `Post or transmit any discriminatory, libelous, harassing,
              defamatory, obscene, pornographic or otherwise unlawful content.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Use the Site to impersonate other parties or entities.`,
                          text_ar: `Use the Site to impersonate other parties or entities.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Use the Site to upload any content that contains a software virus,
              "Trojan Horse" or any other computer code, files or programs that
              may alter, damage or interrupt the functionality of the Site or
              the hardware or software of any other person who accesses the
              Site.`,
                          text_ar: `Use the Site to upload any content that contains a software virus,
              "Trojan Horse" or any other computer code, files or programs that
              may alter, damage or interrupt the functionality of the Site or
              the hardware or software of any other person who accesses the
              Site.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Upload, post, email or otherwise transmit any materials that you
              do not have a right to transmit under any law or under a
              contractual relationship.`,
                          text_ar: `Upload, post, email or otherwise transmit any materials that you
              do not have a right to transmit under any law or under a
              contractual relationship.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Alter, damage or delete any content posted on the site.`,
                          text_ar: `Alter, damage or delete any content posted on the site.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Disrupt the normal flow of communication in any way.`,
                          text_ar: `Disrupt the normal flow of communication in any way.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Claim a relationship with or represent any business, association
              or other organization with which you are not authorized to claim
              such a relationship or represent.`,
                          text_ar: `Claim a relationship with or represent any business, association
              or other organization with which you are not authorized to claim
              such a relationship or represent.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Post or transmit any unsolicited advertising, promotional
              materials or other forms of solicitation.`,
                          text_ar: `Post or transmit any unsolicited advertising, promotional
              materials or other forms of solicitation.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Post any material that infringes upon or violates the intellectual
              property rights of another.`,
                          text_ar: `Post any material that infringes upon or violates the intellectual
              property rights of another.`,
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: `Collect or store personal information about others.`,
                          text_ar: `Collect or store personal information about others.`,
                          classname: "",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Registration",
                      text_ar: "Registration",
                      classname: "text-primary Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Certain portions of the Site are limited to registered users and/or
            allow a user to request support or services online by entering
            personal information. You agree that any information provided to us
            in these areas will be complete and accurate, that you will not
            register under the name of, nor attempt to enter the Site under the
            name of, another person, and that you will not adopt a user name
            that DHA, in its sole discretion, deems offensive.`,
                      text_ar: `Certain portions of the Site are limited to registered users and/or
            allow a user to request support or services online by entering
            personal information. You agree that any information provided to us
            in these areas will be complete and accurate, that you will not
            register under the name of, nor attempt to enter the Site under the
            name of, another person, and that you will not adopt a user name
            that DHA, in its sole discretion, deems offensive.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Termination of Use",
                      text_ar: "Termination of Use",
                      classname: "text-primary Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `DHA may, in its sole discretion, terminate or suspend your access
                  to, and use of, this Site without notice and for any reason,
                  including the violation of these Terms and Conditions of Use or for
                  other conduct which Dubai eGovernment, in its sole discretion,
                  believes is unlawful or harmful to others. In the event of
                  termination, you will no longer be authorized to access the Site and
                  DHA will use any means possible to enforce this termination.`,
                      text_ar: `DHA may, in its sole discretion, terminate or suspend your access
                  to, and use of, this Site without notice and for any reason,
                  including the violation of these Terms and Conditions of Use or for
                  other conduct which Dubai eGovernment, in its sole discretion,
                  believes is unlawful or harmful to others. In the event of
                  termination, you will no longer be authorized to access the Site and
                  DHA will use any means possible to enforce this termination.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Other Site Links",
                      text_ar: "Other Site Links",
                      classname: "text-primary Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `Some links on the Site lead to websites that are not operated by
            DHA. DHA does not control these websites nor do we review or control
            their content. DHA provides these links to users for convenience.
            These links are not an endorsement of products, services or
            information, and do not imply an association between DHA and the
            operators of the linked websites. When you select a link to an
            outside website you are subject to the terms and conditions of the
            owner/sponsors of that website.`,
                      text_ar: `Some links on the Site lead to websites that are not operated by
            DHA. DHA does not control these websites nor do we review or control
            their content. DHA provides these links to users for convenience.
            These links are not an endorsement of products, services or
            information, and do not imply an association between DHA and the
            operators of the linked websites. When you select a link to an
            outside website you are subject to the terms and conditions of the
            owner/sponsors of that website.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Content",
                      text_ar: "Content",
                      classname: "text-primary Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `DHA reserves the right to monitor any content that you provide, but
            shall not be obligated to do so. Although DHA cannot monitor all
            postings on the Site, we reserve the right (but assume no
            obligation) to delete, move or edit any postings that violate these
            terms and conditions. United Arab Emirates and foreign copyright
            laws as well as international conventions protect the contents of
            the Site. You agree to abide by all copyright notices posted on the
            Site.`,
                      text_ar: `DHA reserves the right to monitor any content that you provide, but
            shall not be obligated to do so. Although DHA cannot monitor all
            postings on the Site, we reserve the right (but assume no
            obligation) to delete, move or edit any postings that violate these
            terms and conditions. United Arab Emirates and foreign copyright
            laws as well as international conventions protect the contents of
            the Site. You agree to abide by all copyright notices posted on the
            Site.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Indemnity",
                      text_ar: "Indemnity",
                      classname: "text-primary Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `You agree to defend, indemnify and hold harmless DHA and all of its
            employees and agents from any and all liabilities incurred in
            connection with any claim arising from any breach by you of these
            Terms and Conditions of Use, including reasonable attorneys' fees
            and costs. You agree to cooperate fully in the defense of any such
            claim. DHA reserves the right to assume, at its own expense, the
            exclusive defense and control of any matter otherwise subject to
            indemnification by you. You agree not to settle any matter without
            the written consent of Dubai eGovernment.`,
                      text_ar: `You agree to defend, indemnify and hold harmless DHA and all of its
            employees and agents from any and all liabilities incurred in
            connection with any claim arising from any breach by you of these
            Terms and Conditions of Use, including reasonable attorneys' fees
            and costs. You agree to cooperate fully in the defense of any such
            claim. DHA reserves the right to assume, at its own expense, the
            exclusive defense and control of any matter otherwise subject to
            indemnification by you. You agree not to settle any matter without
            the written consent of Dubai eGovernment.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Disclaimer of Warranty",
                      text_ar: "Disclaimer of Warranty",
                      classname: "text-primary Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `You expressly understand and agree that your use of the Site, or any
            material available through this Site, is at your own risk. Neither
            DHA nor its employees warrant that the Site will be uninterrupted,
            problem-free, free of omissions or error-free, nor do they make any
            warranty as to the results that may be obtained from the use of the
            Site. The content and function of the Site is provided to you "as
            is", without warranties of any kind, either expressed or implied,
            including, but not limited to, warranties of title, merchantability,
            fitness for a particular purpose, use or currency.`,
                      text_ar: `You expressly understand and agree that your use of the Site, or any
            material available through this Site, is at your own risk. Neither
            DHA nor its employees warrant that the Site will be uninterrupted,
            problem-free, free of omissions or error-free, nor do they make any
            warranty as to the results that may be obtained from the use of the
            Site. The content and function of the Site is provided to you "as
            is", without warranties of any kind, either expressed or implied,
            including, but not limited to, warranties of title, merchantability,
            fitness for a particular purpose, use or currency.`,
                      classname: "text-onSurfaceVariant body",
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h6",
                      text: "Limitation of Liability",
                      text_ar: "Limitation of Liability",
                      classname: "text-primary Medium mt-4",
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: `In no event will DHA or its employees be liable for any incidental,
            indirect, special, punitive, exemplary or consequential damages,
            arising out of your use of, or inability to use, the Site, including
            without limitation, loss of revenue or anticipated profits, loss of
            goodwill, loss of business, loss of data, computer failure or
            malfunction or any other damages.`,
                      text_ar: `In no event will DHA or its employees be liable for any incidental,
            indirect, special, punitive, exemplary or consequential damages,
            arising out of your use of, or inability to use, the Site, including
            without limitation, loss of revenue or anticipated profits, loss of
            goodwill, loss of business, loss of data, computer failure or
            malfunction or any other damages.`,
                      classname: "text-onSurfaceVariant body",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "pravicy_pollicy",
      icon: "menu_book",
      useLinker: true,
      url: "/privacyTermsAndConditions",
    },
  ],
};

export const SiteMap = {
  _id: "mypage",
  title: "Site Map",
  title_ar: "Site Map",
  slug: "about-us",
  layout: "default",
  metaTitle: "Site Map",
  metaDescription: "Site Map",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "SiteMap",
          text_ar: "SiteMap",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block5",
          type: "div",
          classname: "",
          children: [
            {
              _id: "block7",
              type: "heading",
              size: "h6",
              text: "Main Menu",
              text_ar: "Main Menu",
              classname: "Medium my-4",
            },
            {
              _id: "block6",
              type: "div",
              classname: "grid md:grid-cols-3 gap-4",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "About DHA",
                          text_ar: "About DHA",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "DHA Overview",
                                  text_ar: "DHA Overview",
                                  classname: "hover:underline",
                                  href: "/aboutus",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Our Leaders",
                                  text_ar: "Our Leaders",
                                  classname: "hover:underline",
                                  href: "/aboutus/ourleaders",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Projects and Initiatives",
                                  text_ar: "Projects and Initiatives",
                                  classname: "hover:underline",
                                  href: "/aboutus/projectsAndInitiatives",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Commitment Statement and Certificates",
                                  text_ar:
                                    "Commitment Statement and Certificates",
                                  classname: "hover:underline",
                                  href: "/aboutus/commitmentStatementsAndCertificates",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Customer Happiness Charter",
                                  text_ar: "Customer Happiness Charter",
                                  classname: "hover:underline",
                                  href: "/aboutus/customerHappinessCharter",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "Health in Dubai",
                          text_ar: "Health in Dubai",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Overview: Health in Dubai",
                                  text_ar: "Overview: Health in Dubai",
                                  classname: "hover:underline",
                                  href: "/health/overview",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Dubai Health Strategies & Studies",
                                  text_ar: "Dubai Health Strategies & Studies",
                                  classname: "hover:underline",
                                  href: "/health/strategies",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Dubai Health Facilities and Professionals",
                                  text_ar:
                                    "Dubai Health Facilities and Professionals",
                                  classname: "hover:underline",
                                  href: "/health/facilities",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "Policies and Regulations",
                          text_ar: "Policies and Regulations",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Health Regulatory Documents",
                                  text_ar: "Health Regulatory Documents",
                                  classname: "hover:underline",
                                  href: "/policiesRegulationsAndCirculars/healthRegulatoryDocuments",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Health Insurance Laws and Regulations",
                                  text_ar:
                                    "Health Insurance Laws and Regulations",
                                  classname: "hover:underline",
                                  href: "#",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Circulars",
                                  text_ar: "Circulars",
                                  classname: "hover:underline",
                                  href: "/policiesRegulationsAndCirculars/circulars",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "Open Data",
                          text_ar: "Open Data",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "DHA Surveys",
                                  text_ar: "DHA Surveys",
                                  classname: "hover:underline",
                                  href: "/opendata/dhasurveys",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Annual Health Statistic Book",
                                  text_ar: "Annual Health Statistic Book",
                                  classname: "hover:underline",
                                  href: "/opendata/annualhealthstatisticbook",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "Others Links",
                          text_ar: "Others Links",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Media Center",
                                  text_ar: "Media Center",
                                  classname: "hover:underline",
                                  href: "/mediaCenter",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Contact Us",
                                  text_ar: "Contact Us",
                                  classname: "hover:underline",
                                  href: "/contactus",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Circulars",
                                  text_ar: "Circulars",
                                  classname: "hover:underline",
                                  href: "/policiesRegulationsAndCirculars/circulars",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block7",
              type: "heading",
              size: "h6",
              text: "Burger Menu",
              text_ar: "Burger Menu",
              classname: "Medium my-4",
            },
            {
              _id: "block6",
              type: "div",
              classname: "grid md:grid-cols-3 gap-4",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "Health Insurance",
                          text_ar: "Health Insurance",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "About Health Insurance",
                                  text_ar: "About Health Insurance",
                                  classname: "hover:underline",
                                  href: "/healthInsurance",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Government Insurance Services (Enaya)",
                                  text_ar:
                                    "Government Insurance Services (Enaya)",
                                  classname: "hover:underline",
                                  href: "/healthInsurance/governmentInsuranceServices",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Special Programmes",
                                  text_ar: "Special Programmes",
                                  classname: "hover:underline",
                                  href: "/healthInsurance/specialProgrammes",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Health Insurance Permit Services",
                                  text_ar: "Health Insurance Permit Services",
                                  classname: "hover:underline",
                                  href: "/healthInsurance/healthInsurancePermitServices",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Monitoring and Evaluation",
                                  text_ar: "Monitoring and Evaluation",
                                  classname: "hover:underline",
                                  href: "#",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "Health Regulation",
                          text_ar: "Health Regulation",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "About Health Regulation",
                                  text_ar: "About Health Regulation",
                                  classname: "hover:underline",
                                  href: "/healthregulation/abouthealthregulation",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Dubai Health Licensing System (Sheryan)",
                                  text_ar:
                                    "Dubai Health Licensing System (Sheryan)",
                                  classname: "hover:underline",
                                  href: "/healthregulation/dubaihealthlicensingsystem",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Health Professionals",
                                  text_ar: "Health Professionals",
                                  classname: "hover:underline",
                                  href: "#",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Health Facilities",
                                  text_ar: "Health Facilities",
                                  classname: "hover:underline",
                                  href: "#",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Drug Control",
                                  text_ar: "Drug Control",
                                  classname: "hover:underline",
                                  href: "/healthregulation/drugcontrol",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "Medical Education and Research",
                          text_ar: "Medical Education and Research",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Medical Education",
                                  text_ar: "Medical Education",
                                  classname: "hover:underline",
                                  href: "/medicalEducationAndResearch",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Dubai Residency Training Programme",
                                  text_ar: "Dubai Residency Training Programme",
                                  classname: "hover:underline",
                                  href: "/medicalEducationAndResearch/medicalEducation",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Unified Internship Programme in Dubai",
                                  text_ar:
                                    "Unified Internship Programme in Dubai",
                                  classname: "hover:underline",
                                  href: "/medicalEducationAndResearch/medicalEducation",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Fellowship Training Program",
                                  text_ar: "Fellowship Training Program",
                                  classname: "hover:underline",
                                  href: "#",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "About Medical Education & Research",
                                  text_ar: "About Medical Education & Research",
                                  classname: "hover:underline",
                                  href: "/medicalEducationAndResearch/medicalResearch",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Medical Training",
                                  text_ar: "Medical Training",
                                  classname: "hover:underline",
                                  href: "/medicalEducationAndResearch/medicalTraining",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Training Facilities",
                                  text_ar: "Training Facilities",
                                  classname: "hover:underline",
                                  href: "/medicalEducationAndResearch/trainingFacilities",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "Public Health",
                          text_ar: "Public Health",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "About Public Health",
                                  text_ar: "About Public Health",
                                  classname: "hover:underline",
                                  href: "/publicHealth",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Community Engagement Programmes",
                                  text_ar: "Community Engagement Programmes",
                                  classname: "hover:underline",
                                  href: "/publicHealth/communityEngagementProgrammes",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Prevention, Vaccination, & Immunisation Programmes",
                                  text_ar:
                                    "Prevention, Vaccination, & Immunisation Programmes",
                                  classname: "hover:underline",
                                  href: "/publicHealth/preventionVaccinationAndImmunisationProgrammes",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Covid-19",
                                  text_ar: "Covid-19",
                                  classname: "hover:underline",
                                  href: "/publicHealth/dubaiChallenge",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Health Promotion and Awareness",
                                  text_ar: "Health Promotion and Awareness",
                                  classname: "hover:underline",
                                  href: "/publicHealth/healthPromotionAndAwareness",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Health Education",
                                  text_ar: "Health Education",
                                  classname: "hover:underline",
                                  href: "/publicHealth/healthPromotionAndAwareness",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Health Nutrition",
                                  text_ar: "Health Nutrition",
                                  classname: "hover:underline",
                                  href: "/publicHealth/healthPromotionAndAwareness",
                                },
                              ],
                            },

                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Occupational Health",
                                  text_ar: "Occupational Health",
                                  classname: "hover:underline",
                                  href: "/publicHealth/occupationalHealth",
                                },
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "ul",
                                  classname: "list-disc list-inside indent-4",
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "li",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "Scope of Work",
                                          text_ar: "Scope of Work",
                                          classname: "hover:underline",
                                          href: "/publicHealth/occupationalHealth",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "li",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "Community Involvement",
                                          text_ar: "Community Involvement",
                                          classname: "hover:underline",
                                          href: "/publicHealth/occupationalHealth",
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "ComPreventing Work-Related Illness and Injury",
                                  text_ar:
                                    "ComPreventing Work-Related Illness and Injury",
                                  classname: "hover:underline",
                                  href: "#",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "heading",
                          size: "h6",
                          text: "Investment and Health Tourism",
                          text_ar: "Investment and Health Tourism",
                          classname: "text-primary Medium",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname:
                            "list-disc list-inside text-onSurfaceVariant",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "About Health Tourism",
                                  text_ar: "About Health Tourism",
                                  classname: "hover:underline",
                                  href: "/healthTourism",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Investing in the Healthcare Sector in Dubai",
                                  text_ar:
                                    "Investing in the Healthcare Sector in Dubai",
                                  classname: "hover:underline",
                                  href: "/healthTourism/investingInHealthSectorInDubai",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Medical in Dubai",
                                  text_ar: "Medical in Dubai",
                                  classname: "hover:underline",
                                  href: "/healthTourism/medicalInDubai",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Wellness in Dubai",
                                  text_ar: "Wellness in Dubai",
                                  classname: "hover:underline",
                                  href: "/healthTourism/wellnessInDubai",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block7",
              type: "heading",
              size: "h6",
              text: "Fixed Footer",
              text_ar: "Fixed Footer",
              classname: "Medium my-4",
            },
            {
              _id: "block6",
              type: "div",
              classname: "grid md:grid-cols-3 gap-4",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "linking",
                          classname: "",
                          href: "/faq",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "FAQ",
                              text_ar: "FAQ",
                              classname: "text-primary Medium hover:underline",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "linking",
                          classname: "hover:underline",
                          href: "/sitemap",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Site Map",
                              text_ar: "Site Map",
                              classname: "text-primary Medium hover:underline",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "linking",
                          classname: "hover:underline",
                          href: "/privacyTermsAndConditions",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Terms and Conditions",
                              text_ar: "Terms and Conditions",
                              classname: "text-primary Medium hover:underline",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: " px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "linking",
                          classname: "hover:underline",
                          href: "/privacyTermsAndConditions",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Privacy Policy",
                              text_ar: "Privacy Policy",
                              classname: "text-primary Medium hover:underline",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block7",
              type: "heading",
              size: "h6",
              text: "Others",
              text_ar: "Others",
              classname: "Medium my-4",
            },
            {
              _id: "block6",
              type: "div",
              classname: "grid md:grid-cols-3 gap-4",
              children: [
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: "px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "linking",
                          classname: "hover:underline",
                          href: "/",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Home Page",
                              text_ar: "Home Page",
                              classname: "text-primary Medium hover:underline",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: "px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "linking",
                          classname: "hover:underline",
                          href: "/services",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Services",
                              text_ar: "Services",
                              classname: "text-primary Medium hover:underline",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-image-card",
                  props: {
                    custom_class: "h-full",
                  },
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: "px-4 pb-4",
                      children: [
                        {
                          _id: "block3",
                          type: "linking",
                          classname: "hover:underline",
                          href: "/login",
                          children: [
                            {
                              _id: "block3",
                              type: "heading",
                              size: "h6",
                              text: "Login",
                              text_ar: "Login",
                              classname: "text-primary Medium hover:underline",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "SiteMap", icon: "menu_book", url: "/sitemap" },
  ],
};

export const MediaCenter_static_with_api = {
  _id: "mypage",
  title: "Media Center",
  slug: "mediaCenter",
  layout: "default",
  metaTitle: "Media Center",
  metaDescription: "Media Center",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block1",
          type: "static_news",
          props: {
            title: "Media Center",
            title_ar: "Media Center",
          },
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "Media Center", icon: "menu_book", url: "/mediaCenter" },
  ],
};

export const MediaCenterDetail_with_api = {
  _id: "mypage",
  title: "Media Center Detail",
  slug: "mediaCenter/mediaCenterDetails",
  layout: "default",
  metaTitle: "Media Center Detail",
  metaDescription: "Media Center Detail",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block1",
          type: "static_news_detail",
          props: {
            title: "News Details",
            title_ar: "News Details",
          },
          detail_id: "ed56dfcb-7793-44f6-9978-42374833e2fa",
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "News Details",
      icon: "menu_book",
      url: "/mediaCenter/mediaCenterDetails",
    },
  ],
};

export const FAQ_static_with_api = {
  _id: "mypage",
  title: "FAQ",
  slug: "faqs",
  layout: "default",
  metaTitle: "FAQ",
  metaDescription: "FAQ",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block1",
          type: "static_faq",
          props: {
            header: "Frequently Asked Questions",
            header_ar: "Frequently Asked Questions",
            body: "Our FAQ area is the best place to look to find answers to your questions. Our community and support team constantly updates the questions and answers.",
            body_ar:
              "Our FAQ area is the best place to look to find answers to your questions. Our community and support team constantly updates the questions and answers.",
            search_input_placeholder: "Search",
            search_input_placeholder_ar: "Search",
            search_input_label: "What are you looking for?",
            search_input_label_ar: "What are you looking for?",
            search_button_text: "Search",
            search_button_text_ar: "Search",
            expand_section_text: "Expand All",
            expand_section_text_ar: "Expand All",
            collpase_section_text: "Collpase All",
            collpase_section_text_ar: "Collpase All",
          },
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "FAQ",
      icon: "menu_book",
      url: "/faqs",
    },
  ],
};

export const Circular_static_with_api = {
  _id: "mypage",
  title: "Circular",
  slug: "policiesRegulationsAndCirculars/circulars",
  layout: "default",
  metaTitle: "Circular",
  metaDescription: "Circular",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block1",
          type: "static_circular",
          props: {
            title: "Circulars",
            title_ar: "Circulars",
            search_input_placeholder: "Search",
            search_input_placeholder_ar: "Search",
            search_input_label: "What are you looking for?",
            search_input_label_ar: "What are you looking for?",
            table_header: "Date",
            table_header_ar: "Date",
            table_header_1: "File Name",
            table_header_1_ar: "File Name",
            table_header_2: "File Size",
            table_header_2_ar: "File Size",
            table_header_3: "Reference Number",
            table_header_3_ar: "Reference Number",
            view_documents: "View Documents",
            view_documents_ar: "View Documents",
            search_button_text: "Search",
            search_button_text_ar: "Search",
          },
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Circulars",
      icon: "menu_book",
      url: "/policiesRegulationsAndCirculars/circulars",
    },
  ],
};

export const RegulartoryDocuments_static_with_api = {
  _id: "mypage",
  title: "RegulartoryDocuments",
  slug: "policiesRegulationsAndCirculars/healthRegulatoryDocuments",
  layout: "default",
  metaTitle: "RegulartoryDocuments",
  metaDescription: "RegulartoryDocuments",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block1",
          type: "static_regulatory",
          props: {
            title: "Health Regulatory Documents",
            title_ar: "Health Regulatory Documents",
            body: `This page includes the relevant health Laws, Policies, Circulars,
        Standards and Guidelines for all Health Facilities and Health
        Professionals Licensed by Dubai Health Authority. These documents are
        also intended to provide a framework for safe, high quality and good
        ethical practice.
        <br />
        It is important to note that the law is of utmost importance, and it
        takes precedence over any other documents. As such, it is the primary
        responsibility of healthcare establishments and professionals to ensure
        they fully comply with the provisions specified in the law`,
            body_ar: `This page includes the relevant health Laws, Policies, Circulars,
        Standards and Guidelines for all Health Facilities and Health
        Professionals Licensed by Dubai Health Authority. These documents are
        also intended to provide a framework for safe, high quality and good
        ethical practice.
        <br />
        It is important to note that the law is of utmost importance, and it
        takes precedence over any other documents. As such, it is the primary
        responsibility of healthcare establishments and professionals to ensure
        they fully comply with the provisions specified in the law`,
            search_input_placeholder: "Search",
            search_input_placeholder_ar: "Search",
            search_input_label: "What are you looking for?",
            search_input_label_ar: "What are you looking for?",
            search_button_text: "Search",
            search_button_text_ar: "Search",
            expand_section_text: "Expand All",
            expand_section_text_ar: "Expand All",
            collpase_section_text: "Collpase All",
            collpase_section_text_ar: "Collpase All",
          },
        },
      ],
    },
  ],
};
export const promotionAwareness_static_with_api = {
  _id: "mypage",
  title: "Promotion Awareness",
  slug: "publicHealth/healthPromotionAndAwareness",
  layout: "default",
  metaTitle: "Promotion Awareness",
  metaDescription: "Promotion Awareness",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block1",
          type: "static_promotion_awareness",
          props: {
            header: "Health Promotion and Awareness",
            header_ar: "Health Promotion and Awareness",
            body: `Health promotion and awareness aims to raise community awareness
        regarding health risks, ways to prevent diseases, and how to follow
        healthy lifestyles.
        <br />
        Additionally, developing and creating educational and awareness
        materials, including publications, workshops, and community campaigns,
        is one of the core responsibilities of health promotion and awareness
        personnel.`,
            body_ar: `Health promotion and awareness aims to raise community awareness
        regarding health risks, ways to prevent diseases, and how to follow
        healthy lifestyles.
        <br />
        Additionally, developing and creating educational and awareness
        materials, including publications, workshops, and community campaigns,
        is one of the core responsibilities of health promotion and awareness
        personnel.`,
            search_input_placeholder: "Search",
            search_input_placeholder_ar: "Search",
            select_input_placeholder: "Sort by A-Z",
            select_input_placeholder_ar: "Sort by A-Z",
            show_less: "Show Less",
            show_less_ar: "Show Less",
            show_all: "Show All",
            show_all_ar: "Show All",
          },
        },
      ],
    },
  ],
};

export const search_static_with_api = {
  _id: "mypage",
  title: "Search",
  slug: "search",
  layout: "default",
  metaTitle: "Search",
  metaDescription: "Search",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block1",
          type: "static_search",
          props: {
            header: "Health Promotion and Awareness",
            header_ar: "Health Promotion and Awareness",
            body: `Health promotion and awareness aims to raise community awareness
        regarding health risks, ways to prevent diseases, and how to follow
        healthy lifestyles.
        <br />
        Additionally, developing and creating educational and awareness
        materials, including publications, workshops, and community campaigns,
        is one of the core responsibilities of health promotion and awareness
        personnel.`,
            body_ar: `Health promotion and awareness aims to raise community awareness
        regarding health risks, ways to prevent diseases, and how to follow
        healthy lifestyles.
        <br />
        Additionally, developing and creating educational and awareness
        materials, including publications, workshops, and community campaigns,
        is one of the core responsibilities of health promotion and awareness
        personnel.`,
            search_input_placeholder: "Search",
            search_input_placeholder_ar: "Search",
            select_input_placeholder: "Sort by A-Z",
            select_input_placeholder_ar: "Sort by A-Z",
            show_less: "Show Less",
            show_less_ar: "Show Less",
            show_all: "Show All",
            show_all_ar: "Show All",
          },
        },
      ],
    },
  ],
};

export const OverviewHealthInDubai_static_with_api = {
  _id: "mypage",
  title: "Overview Health in Dubai",
  slug: "about-us",
  layout: "default",
  metaTitle: "Overview Health in Dubai",
  metaDescription: "Overview Health in Dubai",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block1",
          type: "static_overview_health",
          props: {
            timelineData: [
              {
                year: 1934,
                image: require("../../assets/images/healthInDubai51.png"),
                cards: [
                  {
                    title: "1st Health centre",
                    title_ar: "1st Health centre",
                    description: "opened in AL Ras area",
                    description_ar: "opened in AL Ras area",
                    color1: "border-primary",
                  },
                ],
                color: "border-primary",
              },
              {
                year: 1951,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "AL Maktoum Hospital",
                    title_ar: "AL Maktoum Hospital",
                    description: "12 Beds",
                    description_ar: "12 Beds",
                    color1: "border-primary",
                  },
                ],
                color: "border-primary",
              },
              {
                year: 1970,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title:
                      "Department of Health and Medical Services established",
                    title_ar:
                      "Department of Health and Medical Services established",
                    color1: "border-[#80bc00]",
                  },
                ],
                color: "border-[#80bc00]",
              },
              {
                year: 1973,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "Rashid Hospital",
                    title_ar: "Rashid Hospital",
                    description: "Opened 393 beds",
                    description_ar: "Opened 393 beds",
                    color1: "border-primary",
                    color2: "border-outline",
                  },
                  {
                    description: "1st Private Hospital Established",
                    description_ar: "1st Private Hospital Established",
                  },
                ],
                color: "border-primary",
              },
              {
                year: 1975,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "5 Primary healthcare centers",
                    title_ar: "5 Primary healthcare centers",
                    description: "Opened",
                    description_ar: "Opened",
                    color1: "border-primary",
                  },
                ],
                color: "border-primary",
              },
              {
                year: 1983,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "Dubai Hospital",
                    title_ar: "Dubai Hospital",
                    description: "Opened 625 beds",
                    description_ar: "Opened 625 beds",
                    color1: "border-primary",
                  },
                ],
                color: "border-primary",
              },
              {
                year: 1986,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "Latifa Hospital",
                    title_ar: "Latifa Hospital",
                    description: "Opened (Al Wasel previously) 369 Beds",
                    description_ar: "Opened (Al Wasel previously) 369 Beds",
                    color1: "border-primary",
                  },
                  {
                    title: "2 Primary healthcare centers",
                    title_ar: "2 Primary healthcare centers",
                    description: "Opened",
                    description_ar: "Opened",
                    color2: "border-primary",
                  },
                ],
                color: "border-primary",
              },
              {
                year: 2000,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "6 Hospitals",
                    title_ar: "6 Hospitals",
                    description: "500 Clinics",
                    description_ar: "500 Clinics",
                    color1: "border-outline",
                  },
                ],
                color: "border-outline",
              },
              {
                year: 2007,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "Transformed to Dubai Health Authority​",
                    title_ar: "Transformed to Dubai Health Authority​",
                    color1: "border-[#80bc00]",
                  },
                ],
                color: "border-[#80bc00]",
              },
              {
                year: 2010,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "Hatta Hospital",
                    title_ar: "Hatta Hospital",
                    description: "Opened 70 Beds",
                    description_ar: "Opened 70 Beds",
                    color1: "border-primary",
                  },
                ],
                color: "border-primary",
              },
              {
                year: 2018,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "28 Hospitals",
                    title_ar: "28 Hospitals",
                    description: "1778 Clinics",
                    description_ar: "1778 Clinics",
                    color1: "border-outline",
                  },
                ],
                color: "border-outline",
              },
              {
                year: 2022,
                image: require("../../assets/images/healthInDubai73.png"),
                cards: [
                  {
                    title: "52 Hospitals",
                    title_ar: "52 Hospitals",
                    description: "4,482 health facilities",
                    description_ar: "4,482 health facilities",
                    color1: "border-primary",
                  },
                ],
                color: "border-primary",
              },
            ],
            title: "Overview : Health in Dubai",
            title_ar: "Overview : Health in Dubai",
            chip_2: "Public",
            chip_2_ar: "Public",
            chip: "DHA",
            chip_ar: "DHA",
            chip_1: "Private",
            chip_1_ar: "Private",
          },
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "Health in Dubai", icon: "menu_book", url: "/healthdubai" },
  ],
};

export const Services_static_with_api = {
  _id: "component_948e55bd-1059-4e99-9433-833a705518d5",
  title: "Media Center",
  slug: "services",
  layout: "default",
  metaTitle: "Media Center",
  metaDescription: "Media Center",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "component_e5ecf5fb-6058-444e-a2f6-f9a12ae41973",
      type: "div",
      classname: "",
      children: [
        {
          _id: "f8f88ba2-505c-48d3-969a-49eb26863aeb",
          type: "dda-breadcrumb",
          breadCrumb_item: [
            { text: "Home", icon: "home", url: "/" },
            { text: "Services", icon: "menu_book", url: "/services" },
          ],
        },
        {
          _id: "component_4a64f48a-8a18-44c5-98fc-fc9389864d00",
          type: "static_services",
          props: {
            title: "Our Services",
            title_ar: "Our Services",
            all_service: "All Services",
            all_service_ar: "All Services",
            search_input_placeholder: "Find a service",
            search_input_placeholder_ar: "Find a service",
            select_input_placeholder: "Sort by A-Z",
            select_input_placeholder_ar: "Sort by A-Z",
          },
        },
      ],
    },
  ],
  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    { text: "Services", icon: "menu_book", url: "/services" },
  ],
};

export const Home_static_with_api = {
  _id: "mypage",
  title: "Home",
  slug: "home",
  layout: "default",
  metaTitle: "Home",
  metaDescription: "Home",
  metaKeywords: "",
  seoImageUrl: "",
  isHome: true,
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "my-6",
      children: [
        {
          _id: "block1",
          type: "static_home",
          props: {
            bannerCard: [
              {
                banner_card_id: "for_individuals",
                image_src:
                  "/attachments/medialib/1b09e6f7-6cc9-4ba1-9b57-fa515a949194-1756475736310-641313368-person_outline.svg",
                banner_card_href: "javascript:void(0)",
                image_alt: "for_individuals",
                banner_card_title: "For Individuals",
                banner_card_title_ar: "للأفراد",
                banner_card_description: "",
                banner_card_description_ar: "",
                detail: [
                  {
                    image_src:
                      "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                    header_text: "Request for Overseas Treatment Services",
                    header_text_ar: "طلب خدمات العلاج في الخارج",
                    left_button_name: "View Service",
                    left_button_name_ar: "عرض الخدمة",
                    left_button_href: "https://example.com/1",
                  },
                ],
              },
              {
                banner_card_id: "For_Health_Professionals",
                banner_card_href: "javascript:void(0)",
                image_alt: "for_health_professionals",
                image_src:
                  "/attachments/medialib/8627736a-f2e2-4b1c-91ba-8110f9ee3cf9-1756475744373-387027151-volunteer_activism.svg",
                banner_card_title: "For Health Professionals",
                banner_card_title_ar: "للمهنيين الصحيين",
                banner_card_description: "",
                banner_card_description_ar: "",
                detail: [
                  {
                    image_src:
                      "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                    header_text: "Activate Professional license",
                    header_text_ar: "تفعيل الرخصة المهنية",
                    left_button_name: "View Service",
                    left_button_name_ar: "عرض الخدمة",
                    left_button_href: "https://example.com/1",
                  },
                ],
              },
              {
                banner_card_id: "for_health_acilities",
                image_src:
                  "/attachments/medialib/7db1f580-131d-40ef-9079-53b79d15dfd6-1756475755345-967533147-hotel.svg",
                banner_card_href: "javascript:void(0)",
                image_alt: "for_health_acilities",
                banner_card_title: "For Health Facilities",
                banner_card_title_ar: "للمرافق الصحية",
                banner_card_description: "",
                banner_card_description_ar: "",
                detail: [
                  {
                    image_src:
                      "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                    header_text: "Amend Facility License",
                    header_text_ar: "تعديل ترخيص المنشأة",
                    left_button_name: "View Service",
                    left_button_name_ar: "عرض الخدمة",
                    left_button_href: "https://example.com/1",
                  },
                ],
              },
              {
                banner_card_id: "for_government_entities",
                image_src:
                  "/attachments/medialib/f3e671f6-c079-48a6-bd19-8dc213e31f89-1756475761303-704608793-masks.svg",
                banner_card_href: "javascript:void(0)",
                image_alt: "for_government_entities",
                banner_card_title: "For Government Entities",
                banner_card_title_ar: "للجهات الحكومية",
                banner_card_description: "",
                banner_card_description_ar: "",
                detail: [
                  {
                    image_src:
                      "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                    header_text:
                      "Medically Auditing applications of car window tinting",
                    header_text_ar:
                      "التدقيق الطبي على تطبيقات تظليل نوافذ السيارات",
                    left_button_name: "View Service",
                    left_button_name_ar: "عرض الخدمة",
                    left_button_href: "https://example.com/1",
                  },
                ],
              },
              {
                banner_card_id: "for_businesses_corporates",
                image_src:
                  "/attachments/medialib/d15ecec5-ba8d-44af-9571-c05eb53ef342-1756475768165-932103337-shopping_bag.svg",
                banner_card_href: "javascript:void(0)",
                image_alt: "for_businesses_corporates",
                banner_card_title: "For Businesses & Corporates",
                banner_card_title_ar: "للشركات والمؤسسات",
                banner_card_description: "",
                banner_card_description_ar: "",
                detail: [
                  {
                    image_src:
                      "/attachments/medialib/0fe25e02-e08b-4879-bde2-4b8628bd1270-1756374733029-725969409-01_About%20DHA%20-%20Overview.jpg",
                    header_text:
                      "Request to announce educational and training programs",
                    header_text_ar:
                      "طلب الإعلان عن البرامج التعليمية والتدريبية",
                    left_button_name: "View Service",
                    left_button_name_ar: "عرض الخدمة",
                    left_button_href: "https://example.com/1",
                  },
                ],
              },
            ],
            mobile_title: "DHA Mobile Application",
            mobile_title_ar: "تطبيق هيئة الصحة بدبي للهاتف المحمول",
            mobile_subtitle: "Welcome to your new digital reality.",
            mobile_subtitle_ar: "مرحباً بكم في واقعكم الرقمي الجديد.",
            mobile_body:
              "Let us help you take you from zero to serious business and beyond. Our no-strings attached free trial lets you test our product today.",
            mobile_body_ar:
              "دعنا نساعدك على الانتقال من الصفر إلى العمل الجاد وما بعده. تتيح لك فترة التجربة المجانية لدينا، دون أي شروط، اختبار منتجنا اليوم.",
            latest_media: "Latest Media",
            latest_media_ar: "أحدث الوسائط",
            latest_media_body:
              "Here’s a quick glance over our latest blog posts and media articles written by our team members, staff and guest writers.",
            latest_media_body_ar:
              "فيما يلي نظرة سريعة على أحدث منشورات مدونتنا والمقالات الإعلامية التي كتبها أعضاء فريقنا وموظفونا والكتاب الضيوف.",
            media_button: "View All",
            media_button_ar: "عرض الكل",
          },
        },
      ],
    },
  ],
  breadcrumbs: [],
};

const Header = {
  _id: "mypage",
  title: "Header",
  slug: "about-us",
  layout: "default",
  metaTitle: "Header",
  metaDescription: "Header",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block3",
      type: "dda-header",
      props: {
        ["first-logo-href"]: "https://www.dubai.gov.ae",
        ["first-logo-src"]:
          "https://www.dof.gov.ae/Style Library/img/gov-logo.svg",
        ["first-logo-white-src"]:
          "https://www.dof.gov.ae/Style Library/img/gov-logo-white.svg",
        ["first-logo-alt"]: "Dubai-Digital-Authority",
        ["second-logo-href"]: "https://www.dubai.gov.ae",
        ["second-logo-src"]: require("../../assets/images/dha-logo-color.svg")
          .default,
        ["second-logo-white-src"]:
          require("../../assets/images/dha-logo-white.svg").default,
        ["second-logo-alt"]: "Dubai-Digital-Authority",
        ["hamburger_menu_button_name"]: "Menu",
        ["search_button_name"]: "search_button_name",
        ["search_input_name"]: "search_input_name",
        ["search_input_placeholder"]: "Search",
        ["search_tooltip"]: "Search",
        ["searchfunctionality"]: () => alert("test"),
        ["mobile-menu-search-id"]: "mobileSearch",
        ["mobile-menu-search-url"]: "javascript:void(0)",
        ["use-predesigned-accessibility-menu"]: "true",
        ["accessibility_button_id"]: "accessibility_button_id",
        ["accessibility_button_icon_family"]:
          "material-icons  material-symbols-outlined",
        ["accessibility_button_icon_name"]: "accessible_forward",
        accessibility_button_text: "accessibility_button_text",
        toggle_accessibility_button_name: "toggle_accessibility_button_name",
        close_accessibility_button_name: "close_accessibility_button_name",
        accessibilitymenufunctionality:
          "() =&gt; console.log('Accessibility Menu Functionality')",
        contrast_title: "Contrast",
        contrast_description: "Select your preferred contrast setting",
        contrast_noraml_text: "Normal",
        contrast_color_blind_text: "Colours Blind",
        contrast_red_weakness_text: "Red Weakness",
        contrast_green_weakness_text: "Green Weakness",
        screen_reader_title: "Screen Reader",
        screen_reader_description:
          "Listen to the content of the page by clicking play or listen",
        text_size_title: "Text Size",
        text_size_description:
          "Use the buttons below to increase or decrease the text size",
        close_sidebar_button_name: "close_sidebar_button_name",
        language_text: "العربية",
        language_button_name: "language_button_name",
        language_tooltip: "Language",
        ["login-text"]: "Login",
        ["login-link"]: "/login",
        ["login_tooltip"]: "Login",
        ["login-icon"]: "account_circle",
        readspeakerlink: "app-eu.readspeaker.com",
        languageswitch: "() =&gt; console.log('Language Switcher')",
        smtextsize: "() =&gt; console.log('Small Text')",
        basetextsize: "() =&gt; console.log('Base Text')",
        lgtextsize: "() =&gt; console.log('Large Text')",
        normalcontrast: "() =&gt; console.log('Normal Text')",
        blindcontrast: "() =&gt; console.log('Blind Text')",
        redcontrast: "() =&gt; console.log('Red Text')",
        greencontrast: "() =&gt; console.log('Green Text')",
        close_menu_button_name: "close_menu_button_name",
        ["quick-links"]: `[
        {"headerMenuLabel":"Home","active":"true","url":"/"},
        {"headerMenuLabel":"About DHA","menuLabel":"About DHA","url":"javascript:void(0)",
        "type":"dda_default_submenu",
            "children":[
            {"headerMenuLabel":"DHA Overview","url":"/aboutus"},
            {"headerMenuLabel":"Our Leaders","url":"/aboutus/ourleaders"},
            {"headerMenuLabel":"Customer Happiness Charter","url":"/aboutus/customerHappinessCharter"},
            {"headerMenuLabel":"Commitment Statement and Certificates","url":"/aboutus/commitmentStatementsAndCertificates"},
            {"headerMenuLabel":"Projects & Initiatives","url":"/aboutus/projectsAndInitiatives"} ]},
        {"headerMenuLabel":"Health in Dubai","menuLabel":"Health in Dubai","url":"javascript:void(0)",
         "type":"dda_default_submenu",
            "children":[
            {"headerMenuLabel":"Overview: Health in Dubai","url":"/healthdubai"},
            {"headerMenuLabel":"Dubai Health Sector Strategies","url":"/healthdubai/DubaiHealthSectorStrategies"},
            {"headerMenuLabel":"Dubai Medical Registry","url":"/healthdubai/dubaiMedicalRegistry"}]},
         {"headerMenuLabel":"Policies, Regulations and Circulars","menuLabel":"Policies, Regulations and Circulars","url":"javascript:void(0)",
          "type":"dda_default_submenu",
            "children":[
            {"headerMenuLabel":"Health Regulatory Documents","url":"/policiesRegulationsAndCirculars/healthRegulatoryDocuments"},
            {"headerMenuLabel":"Circulars","url":"/policiesRegulationsAndCirculars/circulars"}]},
        {"headerMenuLabel":"Open Data","menuLabel":"Open Data","url":"javascript:void(0)",
         "type":"dda_default_submenu",
            "children":[
            {"headerMenuLabel":"Open Data","url":"/opendata/dhasurveys"},
            {"headerMenuLabel":"Annual Health Statistics Books","url":"/opendata/annualhealthstatisticbook"}]}
        ]`,
        ["side-main-menu-title"]: "Main Menu",
        ["side-menu-items"]: `[
        {"label":"Services","href":"/services","subMenu":[]},
        {"label":"Health Insurance","href":"/healthinsurance",
          "subMenu":[
          {"headerLabel":"Health Insurance","label":"About Health Insurance","href":"/healthinsurance"},
          {"headerLabel":"Health Insurance","label":"ISAHD","href":"/healthinsurance/isahd"},
          {"headerLabel":"Health Insurance","label":"Special Programes","href":"/healthinsurance/specialprogrammes"},
          {"headerLabel":"Health Insurance","label":"Health Insurance Permit Services","href":"/healthinsurance/healthInsurancePermitServices"},
          {"headerLabel":"Health Insurance","label":"Government Insurance Services","href":"/healthinsurance/governmentInsuranceServices"}]},
        {"label":"Health Regulation","href":"/healthregulation/abouthealthregulation",
          "subMenu":[
          {"headerLabel":"Health Regulation","label":"About Health Regulation","href":"/healthregulation/abouthealthregulation"},
          {"headerLabel":"Health Regulation","label":"Dubai Health Licensing System","href":"/healthregulation/dubaihealthlicensingsystem"},
          {"headerLabel":"Health Regulation","label":"Drug Control","href":"/healthregulation/drugcontrol"}]},
        {"label":"Medical Education & Research","href":"/medicalEducationAndResearch",
        "subMenu":[
        {"headerLabel":"Medical Education & Research","label":"About Medical Education & Research","href":"/medicalEducationAndResearch"},
        {"headerLabel":"Medical Education & Research","label":"Medical Education","href":"/medicalEducationAndResearch",
            "subMenu":[
            {"headerLabel":"Medical Education","label":"Dubai Residency Training Programme","href":"/medicalEducationAndResearch/medicalEducation"},
            {"headerLabel":"Medical Education & Research","label":"Unified Internship Programme In Dubai","href":"medicalEducationAndResearch/medicalEducation"}]},
          {"headerLabel":"Medical Training","label":"Medical Training","href":"#",
            "subMenu":[{"headerLabel":"Medical Training","label":"Dubai Residency Training Programme","href":"/medicalEducationAndResearch/medicalTraining"},
            {"headerLabel":"Medical Education & Research","label":"Unified Internship Programme In Dubai","href":"/medicalEducationAndResearch/medicalTraining"}]},
          {"headerLabel":"Medical Education & Research","label":"Medical Research","href":"/medicalEducationAndResearch/medicalResearch"},
          {"headerLabel":"Medical Education & Research","label":"Medical Library","href":"/medicalEducationAndResearch/medicalLibrary"},
          {"headerLabel":"Medical Education & Research","label":"Training Facilities","href":"/medicalEducationAndResearch/trainingFacilities"}]},
        {"label":"Public Health","href":"/publichealth",
          "subMenu":[
          {"headerLabel":"Public Health","label":"About Public Health","href":"/publichealth"},
          {"headerLabel":"Public Health","label":"Community Engagement Programmes","href":"/publicHealth/communityEngagementProgrammes"},
          {"headerLabel":"Public Health","label":"Occupational Health","href":"/publichealth/occupationalHealth"},
          {"headerLabel":"Public Health","label":"Health Promotion and Awareness","href":"/publicHealth/healthPromotionAndAwareness"},
          {"headerLabel":"Public Health","label":"Programs and Published Articles","href":"/publicHealth/ProgrammesAndPublishedArticles"},
          {"headerLabel":"Public Health","label":"Prevention, Vaccination & Immunisation Programmes","href":"/publichealth/preventionVaccinationAndImmunisationProgrammes"},
          {"headerLabel":"Public Health","label":"Dubai Challenge","href":"/publicHealth/dubaiChallenge"}]},
        {"label":"Investment & Health Tourism","href":"#",
          "subMenu":[
          {"headerLabel":"Investment & Health Tourism","label":"About Health Tourism","href":"/healthTourism"},
          {"headerLabel":"Investment & Health Tourism","label":"Wellness in Dubai","href":"/healthTourism/wellnessindubai"},
          {"headerLabel":"Investment & Health Tourism","label":"Medical in Dubai","href":"/healthTourism/medicalindubai"},
          {"headerLabel":"Investment & Health Tourism","label":"Investing in the Healthcare Sector in Dubai","href":"/healthTourism/investingInHealthSectorInDubai"}]}]`,
        ["hide-other-menu"]: "false",
        header_default_submenu: "true",
        ["side-other-menu-title"]: "Other Links",
        ["other-menu-items"]: `[{"label":"Home","href":"/","subMenu":[]},
        {"label":"Media Center","href":"/mediaCenter","subMenu":[]},
        {"label":"Contact Us","href":"/contactus","subMenu":[]},
        {"label":"Site Map","href":"/sitemap","subMenu":[]},
        {"label":"FAQ","href":"/faqs","subMenu":[]},
        {"label":"Privacy Policy","href":"/privacyTermsAndConditions","subMenu":[]}]`,
      },
    },
  ],
};

export const Footer = {
  _id: "mypage",
  title: "Footer",
  slug: "about-us",
  layout: "default",
  metaTitle: "Footer",
  metaDescription: "Footer",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block10",
      type: "div",
      classname: "",
      children: [
        {
          _id: "block3",
          type: "dda-sticky-footer",
          props: {
            ["happiness-icon-href"]: "#",
            ["happiness-icon-id"]: "Happiness",
            ["happiness-icon-src"]: require("../../assets/images/icn-happy.svg")
              .default,
            ["happiness-icon-alt"]: "Happiness",
            ["happiness-icon-tooltip"]: "Happiness",
            ["happiness-icon-click"]: "console.log('Happiness icon clicked')",
            ["accessibility-icon-href"]: "#",
            ["accessibility-icon-id"]: "uggestionsComplaints",
            ["accessibility-icon-src"]:
              require("../../assets/images/icn-complaints.svg").default,
            ["accessibility-icon-alt"]: "Suggestions and complaints",
            ["accessibility-icon-tooltip"]: "Suggestions &amp; complaints",
            ["accessibility-icon-click"]:
              "console.log('Suggestion AE icon clicked')",
            ["services-icon-href"]: "/services",
            ["services-icon-id"]: "footerServices",
            ["services-icon-src"]:
              require("../../assets/images/icn-grid-view.svg").default,
            ["services-icon-alt"]: "Services",
            ["services-icon-tooltip"]: "Services",
            ["services-icon-text"]: "Services",
            ["services-icon-click"]: "console.log('Services icon clicked')",
            ["hide-middle-section"]: "true",
            ["middle-link"]: `[{"LogoTooltip":"Middlelink","href":"#","src":"static/media/public_images/digital-logo.svg","alt":"DDA"},{"LogoTooltip":"Middlelink","href":"#","src":"static/media/public_images/digital-logo.svg","alt":"DDA"},{"LogoTooltip":"Middlelink","href":"#","src":"static/media/public_images/digital-logo.svg","alt":"DDA"}]'
        ,["right-link"]:'[{"RightLinkTooltip":"Submit a Complaint","itemId":"itemID","href":"#","alt":"DDA","LinkText":"Submit a Complaint","IconFamily":"material-icons","IconName":"announcement"},
      ,  {"RightLinkTooltip":"Media Center","itemId":"itemID","href":"/mediaCenter","alt":"DDA","LinkText":"Media Center","IconFamily":"material-icons","IconName":"feed"},
      ,  {"RightLinkTooltip":"Contact Us","itemId":"itemID","href":"/contactus","alt":"DDA","LinkText":"Contact Us","IconFamily":"material-icons","IconName":"mail"}]`,
            ["ai-icon-href"]: "javascript:void(0)",
            ["ai-icon-id"]: "aiIconID",
            ["ai-icon-src"]: require("../../assets/images/DubaiAI.svg").default,
            ["ai-icon-alt"]: "Digital AI",
            ["ai-icon-tooltip"]: "Digital AI",
            ["ai-icon-on-click"]: "console.log('AI icon clicked')",
            ["chat-icon-href"]: "javascript:void(0)",
            ["chat-icon-id"]: "chatID",
            ["chat-icon-src"]:
              require("../../assets/images/icn-chat_bubble_outline.svg")
                .default,
            ["chat-icon-alt"]: "Online Chat",
            ["chat-icon-tooltip"]: "Online Chat",
            ["chat-icon-on-click"]: "console.log('Chat Icon clicked')",
            ["more-icon-family"]: "material-icons",
            ["more-icon"]: "more_horiz",
          },
        },
        {
          _id: "block3",
          type: "htmlTag",
          tag: "footer",
          classname: "WB-footer mb-[75px] shadow-top",
          children: [
            {
              _id: "block10",
              type: "div",
              classname: "md:w-[90vw] px-[20px] m-auto line-seperater",
              children: [
                {
                  _id: "block10",
                  type: "div",
                  classname: "grid lg:grid-cols-4 sm:grid-cols-2 gap-4",
                  children: [
                    {
                      _id: "block10",
                      type: "div",
                      classname: "mb-3",
                      children: [
                        {
                          _id: "block2",
                          type: "image",
                          src: "dha-logo-color.svg",
                          size: "fullwidth",
                          classname: "entt-logo -mt-[15px]",
                          alt: "This is a description for the page......",
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Design outstanding interfaces with advanced Figma features in a matter of minutes.",
                          text_ar:
                            "Design outstanding interfaces with advanced Figma features in a matter of minutes.",
                          classname: "dda-fs-title-sm mt-[10px]",
                        },
                      ],
                    },
                    {
                      _id: "block10",
                      type: "div",
                      classname: "mb-3",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Resources",
                          text_ar: "Resources",
                          classname:
                            "dda-fs-title-sm dda-fw-700 dda-color-black mb-3",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname: "footer-menu",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "About DHA",
                                  text_ar: "About DHA",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "/aboutus",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Submit Complaint",
                                  text_ar: "Submit Complaint",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "#",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "E-Complaint (Wassel Sotak)",
                                  text_ar: "E-Complaint (Wassel Sotak)",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "#",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Careers",
                                  text_ar: "Careers",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "#",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "E-Services",
                                  text_ar: "E-Services",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "#",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block10",
                      type: "div",
                      classname: "mb-3",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Help",
                          text_ar: "Help",
                          classname:
                            "dda-fs-title-sm dda-fw-700 dda-color-black mb-3",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "ul",
                          classname: "footer-menu",
                          children: [
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "FAQs",
                                  text_ar: "FAQs",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "/faqs",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Accessibility",
                                  text_ar: "Accessibility",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "#",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Site Map",
                                  text_ar: "Site Map",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "/sitemap",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Privacy Policy",
                                  text_ar: "Privacy Policy",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "/privacyTermsAndConditions",
                                },
                              ],
                            },
                            {
                              _id: "block3",
                              type: "list",
                              type_identifier: "li",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "linking",
                                  text: "Terms & Conditions",
                                  text_ar: "Terms & Conditions",
                                  classname: "dda-fs-title-sm dda-fw-400",
                                  href: "/privacyTermsAndConditions",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block10",
                      type: "div",
                      classname: "mb-3",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Get Email Notifications",
                          text_ar: "Get Email Notifications",
                          classname:
                            "dda-fs-title-sm dda-fw-700 dda-color-black mb-3",
                        },
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Sign up to our e-mail newsletter to receive the latest news & updates.",
                          text_ar:
                            "Sign up to our e-mail newsletter to receive the latest news & updates.",
                          classname: "dda-fs-title-sm mb-4",
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname: "dda-flex",
                          children: [
                            {
                              _id: "block3",
                              type: "dda-button",
                              props: {
                                button_color: "default-primary",
                                start_icon: "",
                                button_text: "Contact Us",
                                end_icon: "",
                                custom_class: "my-2",
                                component_mode: "",
                                button_id: "button",
                                aria_label: "button",
                                onclick: () =>
                                  (window.location.href = "/contactus"),
                                button_name: "button",
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block10",
              type: "div",
              classname: "w-[90vw] px-[20px] m-auto pt-4",
              children: [
                {
                  _id: "block10",
                  type: "div",
                  classname:
                    "flex flex-wrap gap-4 align-center justify-between",
                  children: [
                    {
                      _id: "tableTH",
                      type: "paragraph",
                      size: "normal",
                      classname: "dda-fs-title-sm",
                      text: "© 2025 Dubai Health Authority . All Rights Reserved. Last Modification: 06-11-2024",
                      text_ar:
                        "© 2025 Dubai Health Authority . All Rights Reserved. Last Modification: 06-11-2024",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname: "flex align-center gap-5",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          classname: "",
                          children: [
                            {
                              _id: "block3",
                              type: "linking",
                              classname: "",
                              href: "#",
                              children: [
                                {
                                  _id: "block2",
                                  type: "image",
                                  // src: "dha-logo-color.svg",
                                  url: "",
                                  size: "fullwidth",
                                  alt: "This is a description for the page......",
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          classname: "",
                          children: [
                            {
                              _id: "block3",
                              type: "linking",
                              classname: "",
                              href: "#",
                              children: [
                                {
                                  _id: "block2",
                                  type: "image",
                                  // src: "dha-logo-color.svg",
                                  url: "",
                                  size: "fullwidth",
                                  alt: "This is a description for the page......",
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          classname: "",
                          children: [
                            {
                              _id: "block3",
                              type: "linking",
                              classname: "",
                              href: "#",
                              children: [
                                {
                                  _id: "block2",
                                  type: "image",
                                  // src: "dha-logo-color.svg",
                                  url: "",
                                  size: "fullwidth",
                                  alt: "This is a description for the page......",
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          classname: "",
                          children: [
                            {
                              _id: "block3",
                              type: "linking",
                              classname: "",
                              href: "#",
                              children: [
                                {
                                  _id: "block2",
                                  type: "image",
                                  // src: "dha-logo-color.svg",
                                  url: "",
                                  size: "fullwidth",
                                  alt: "This is a description for the page......",
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          classname: "",
                          children: [
                            {
                              _id: "block3",
                              type: "linking",
                              classname: "",
                              href: "#",
                              children: [
                                {
                                  _id: "block2",
                                  type: "image",
                                  // src: "dha-logo-color.svg",
                                  url: "",
                                  size: "fullwidth",
                                  alt: "This is a description for the page......",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const richtext_editor = {
  _id: "mypage",
  title: "Search",
  slug: "about-us",
  layout: "default",
  metaTitle: "Search",
  metaDescription: "Search",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Wellness in Dubai",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
      ],
    },
    {
      _id: "e6511d51-6918-4516-8902-7e9d10c222ad",
      type: "richtext",
      text: "Director-General of the Dubai Health Authority",
      text_params: "",
      classname: "py-2",
      children: [],
      text_ar:
        '<ol><li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>نعشساي</li><li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>شسهايشستناي</li><li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>شساينستشاي</li><li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>شسهاياس</li></ol>',
    },
  ],
};

export const MedicalEducationUpdates = {
  _id: "mypage",
  title: "Medical Education",
  title_ar: "Medical Education",
  slug: "about-us",
  layout: "default",
  metaTitle: "Medical Education",
  metaDescription: "Medical Education",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Medical Education",
          text_ar: "التعليم الطبي",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block3",
          type: "paragraph",
          size: "normal",
          text: "At the Dubai Health Authority, we are committed to delivering advanced, accredited internship, residency, and fellowship programmes that meet the needs of the national medical workforce and support their professional growth in response to the rising demand for specialised healthcare professionals. <br /> Our programmes follow well-established international standards, creating a modern and stimulating educational environment that equips trainees to become competent, healthcare practitioners. They are aligned with nationally and internationally recognised training frameworks, including the National Institute for Health Specialties (NIHS), the Accreditation Council for Graduate Medical Education (ACGME), and the Arab Board of Health Specialisations (ABHS). <br /> We emphasise competency-based training through a structured approach that integrates research, clinical simulation, and soft skills development.  The training process is further supported effective progress tracking, programme evaluation, and continuous quality assurance for medical education at the Authority.",
          text_ar:
            "في هيئة الصحة بدبي، نحرص على توفير برامج تدريبية متقدمة ومعتمدة في مجالي الامتياز والإقامة والزمالة، تلبي احتياجات الكوادر الطبية الوطنية، وتدعم تطورها المهني، في ظل الطلب المتزايد على الكفاءات الصحية المتخصصة. <br /> تعتمد برامجنا على معايير عالمية راسخة، وتركّز على بناء بيئة تعليمية حديثة ومحفّزة، تُعزز من قدرات الأطباء المتدربين، ليصبحوا ممارسين صحيين مؤهلين. تم تصميم البرامج وفقاً لأطر تدريبية معتمدة دولياً ومحلياً، من: المعهد الوطني للتخصصات الصحية NIHS، والمجلس الأمريكي للتعليم العالي ACGME، والمجلس العربي للاختصاصات الصحية، حيث تستند هذه البرامج إلى مبدأ التدريب المبني على الكفاءة، ضمن منهجية منظمة ومتكاملة، تشمل: البحث العلمي، والمحاكاة السريرية، وتطوير المهارات الشخصية. <br /> كما يتم دعم العملية التدريبية، من خلال متابعة تقدم المتدربين، وتقييم فعالية البرامج، وضمان جودة مخرجات التعليم الطبي المستمر في الهيئة.",
          classname: "md:!my-4 my-2 Medium text-onSurfaceVariant",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "medical_education", //for dynamic breadcrumbs
          linker_ar: "medical_education", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "mb-5",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Dubai Residency Training Programme",
              title_ar: "برنامج دبي التدريبي للتخصصات الطبية",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "lg:flex gap-5",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-1/5",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "lg:overflow-y-none overflow-y-auto lg:max-h-none max-h-[250px]",
                          children: [
                            {
                              _id: "block100",
                              type: "dda-tabs",
                              view: "primary-card",
                              linker: "medical_control",
                              linker_ar: "medical_control",
                              props: {
                                type: "text",
                                hover_style: "dda-tab-underline-filled",
                                custom_class: "",
                                component_mode: "",
                                button_id: "button",
                                aria_label: "tabs",
                                onclick: "alert()",
                                tab_type: "dda-vertical-tab",
                                button_name: "button",
                                button_name_ar: "button",
                              },
                              children: [
                                {
                                  title: "Internship Programme",
                                  title_ar: "برنامج الامتياز",
                                },
                                {
                                  title: "Residency Programme",
                                  title_ar: "برنامج الإقامة",
                                },
                                {
                                  title: "Fellowship programme",
                                  title_ar: "برنامج الزمالة",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-4/5",
                      children: [
                        {
                          _id: "block2",
                          type: "tabcontent",
                          isShow_title: false,
                          linker: "medical_control",
                          linker_ar: "medical_control",
                          title: "Internship Programme",
                          title_ar: "برنامج الامتياز",
                          size: "h2",
                          classname: "dda-table-container",
                          children: [
                            {
                              _id: "block1",
                              type: "div",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "paragraph",
                                  size: "normal",
                                  text: "As part of the Dubai Health Authority’s strategy to support the healthcare workforce, the Internship Programme offers a one-year clinical training opportunity for graduates of nationally and internationally recognised medical and dental schools. The programme aims to facilitate the transition from academic education to practical application under the supervision of consultants across various specialties, thereby enhancing clinical skills and ensuring continuity of patient care. <br /> Our programmes provide aspiring physicians and dentists with valuable hands-on experience, the opportunity to refine their clinical competencies, and the chance to work alongside distinguished faculty members in a supportive environment. Interns are exposed to a wide range of specialties and clinical settings, enabling them to explore their interests and build a solid foundation for a successful career in healthcare.",
                                  text_ar:
                                    "انطلاقاً من استراتيجية هيئة الصحة بدبي في دعم الكوادر الصحية، يوفر برنامج الامتياز تدريباً عملياً لمدة عام لخريجي كليات الطب البشري، وطب الأسنان المعترف بها محلياً ودولياً، بهدف تأهيلهم للانتقال من التعليم الأكاديمي إلى التطبيق العملي تحت إشراف استشاريين في مختلف التخصصات، بما يعزز مهاراتهم السريرية، ويضمن استمرارية الرعاية الطبية. وتتيح برامجنا للأطباء الطموحين فرصة اكتساب خبرة عملية قيّمة، وصقل مهاراتهم السريرية، والعمل جنباً إلى جنب مع أعضاء هيئة تدريس مرموقين في بيئة داعمة. كما يُتاح للمتدربين في كل من الطب وطب الأسنان، استكشاف مجموعة متنوعة من التخصصات والبيئات السريرية، مما يساعدهم على تحديد اهتماماتهم وبناء أسس قوية لمسيرة مهنية ناجحة في مجال الرعاية الصحية.",
                                  classname: "body mb-4",
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Medical Internship",
                                    header_text_ar: "الامتياز في الطب العام",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Programme Summery",
                                      text_ar: "نبذه عن البرنامج",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Duration: 12 months",
                                          text_ar: "المدة: 12 شهراً.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Training Capacity: 145 seats",
                                          text_ar:
                                            "السعة التدريبية: 145 مقعداً تدريبياً.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Accreditation: National Institute for Health Specialties",
                                          text_ar:
                                            "الاعتماد: المعهد الوطني للتخصصات الصحية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Training Sites: 17 training sites accredited by DHA.",
                                          text_ar:
                                            "المراكز التدريبية: 17 مستشفى معتمد من قبل هيئة الصحة في دبي",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text:
                                      "Academic Curriculum for Medical Internship",
                                    header_text_ar:
                                      "المنهج الأكاديمي للطب العام",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "dda-table-container",
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "overflow-x-auto",
                                          children: [
                                            {
                                              _id: "table1",
                                              type: "table",
                                              classname:
                                                "dda-table w-full min-w-[650px]",
                                              children: [
                                                {
                                                  id: "table_header",
                                                  type: "tableItems",
                                                  type_identifier: "thead",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "rounded-xl",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "Department",
                                                          text_ar: "الأقسام",
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "Specialty",
                                                          text_ar: "التخصص",
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "Training Duration",
                                                          text_ar:
                                                            "مدة التدريب",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "table_body",
                                                  type: "tableItems",
                                                  type_identifier: "tbody",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          colSpan: "",
                                                          rowSpan: "4",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Medical Divisions",
                                                              text_ar: "الطبية",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Internal Medicine",
                                                              text_ar:
                                                                "الطب الباطني",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "2 months",
                                                              text_ar: "شهرين",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Paediatrics",
                                                              text_ar:
                                                                "طب الأطفال",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "2 months",
                                                              text_ar: "شهرين",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Psychiatry",
                                                              text_ar:
                                                                "الطب النفسي",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1 month",
                                                              text_ar: "شهر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Family Medicine",
                                                              text_ar:
                                                                "طب الأسرة",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1 month",
                                                              text_ar: "شهر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          colSpan: "",
                                                          rowSpan: "3",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Surgical Divisions",
                                                              text_ar:
                                                                "الأقسام الجراحية",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "General Surgery",
                                                              text_ar:
                                                                "الجراحة العامة",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "2 months",
                                                              text_ar: "شهرين",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Obstetrics and Gynaecology",
                                                              text_ar:
                                                                "التوليد وأمراض النساء",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1 month",
                                                              text_ar: "شهر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Emergency",
                                                              text_ar:
                                                                "طب الطوارئ",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1 month",
                                                              text_ar: "شهر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          colSpan: "2",
                                                          rowSpan: "",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Elective",
                                                              text_ar:
                                                                "اختياري",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "3 Months in various specialties",
                                                              text_ar:
                                                                "3 شهور في تخصصات مختلفة",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Dental Internship",
                                    header_text_ar: "الامتياز في طب الاسنان",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Programme Summery",
                                      text_ar: "نبذه عن البرنامج",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Duration: 12 months",
                                          text_ar: "المدة: 12 شهراً.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Training Capacity: 145 seats",
                                          text_ar:
                                            "السعة التدريبية: 145 مقعداً تدريبياً.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Training Sites: 7 training sites accredited by DHA.",
                                          text_ar:
                                            "المراكز التدريبية: 7 منشئات صحية مرخصة من قبل هيئة الصحة معتمدة كمركز تدريبي لبرنامج الامتياز",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text:
                                      "Academic Curriculum for Dental Internship",
                                    header_text_ar:
                                      "المنهج الأكاديمي لطب الأسنان",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "dda-table-container",
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "overflow-x-auto",
                                          children: [
                                            {
                                              _id: "table1",
                                              type: "table",
                                              classname:
                                                "dda-table w-full min-w-[650px]",
                                              children: [
                                                {
                                                  id: "table_header",
                                                  type: "tableItems",
                                                  type_identifier: "thead",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "rounded-xl",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "#",
                                                          text_ar: "#",
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "Specialty",
                                                          text_ar: "التخصص",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "table_body",
                                                  type: "tableItems",
                                                  type_identifier: "tbody",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1",
                                                              text_ar: "1",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Endodontics",
                                                              text_ar:
                                                                "علاج جذور الأسنان (الاندودونتكس)",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "2",
                                                              text_ar: "2",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Orthodontics",
                                                              text_ar:
                                                                "تقويم الأسنان",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "3",
                                                              text_ar: "3",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Gum Disease",
                                                              text_ar:
                                                                "أمراض اللثة",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "4",
                                                              text_ar: "4",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Dental Implants (Prosthodontics)",
                                                              text_ar:
                                                                "التركيبات السنية (الاستعاضة السنية)",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "5",
                                                              text_ar: "5",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Paediatric Dentistry",
                                                              text_ar:
                                                                "طب أسنان الأطفال",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "6",
                                                              text_ar: "6",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Oral and Maxillofacial Surgery",
                                                              text_ar:
                                                                "جراحة الفم والوجه والفكين",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "7",
                                                              text_ar: "7",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "General Dentistry",
                                                              text_ar:
                                                                "عيادة طب الأسنان العام",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Programme timetable:",
                                    header_text_ar: "الجدول الزمني",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "dda-table-container",
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "overflow-x-auto",
                                          children: [
                                            {
                                              _id: "table1",
                                              type: "table",
                                              classname:
                                                "dda-table w-full min-w-[650px]",
                                              children: [
                                                {
                                                  _id: "table_body",
                                                  type: "tableItems",
                                                  type_identifier: "tbody",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Online Registration Opens",
                                                              text_ar:
                                                                "فتح باب التسجيل",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "February",
                                                              text_ar: "فبراير",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Registration Closes",
                                                              text_ar:
                                                                "إغلاق باب التسجيل",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "March",
                                                              text_ar: "مارس",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Interviews",
                                                              text_ar:
                                                                "المقابلات الشخصية",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "May",
                                                              text_ar: "مايو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Cross Match",
                                                              text_ar:
                                                                "التنسيق والمطابقة",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "June",
                                                              text_ar: "يونيو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Announcement of Acceptance Lists",
                                                              text_ar:
                                                                "الإعلان عن أسماء المقبولين",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Medical Internship – July Dental Internship – August",
                                                              text_ar:
                                                                "الطب البشري -يوليوطب الأسنان -أغسطس",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Commencement",
                                                              text_ar:
                                                                "بداية العام الأكاديمي",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Medical Internship: August Dental Internship: September",
                                                              text_ar:
                                                                "الطب البشري -أغسطس طب الأسنان -سبتمبر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Acceptance Criteria",
                                    header_text_ar: "معايير القبول",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Academic Criteria",
                                      text_ar: "المعايير الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Qualification – Bachelor’s degree or equivalent in Medicine or Dentistry from a recognized college listed in the WHO Directory of Approved Health Institutions.",
                                          text_ar:
                                            "شهادة بكالوريوس أو ما يعادلها في الطب أو طب الأسنان، من كلية معترف بها ومدرجة ضمن دليل منظمة الصحة العالمية (WHO)، للمؤسسات الصحية المعتمدة، بالإضافة إلى السجل الدراسي، موضحاً التقييم النهائي للمعدل التراكمي GPA، للطلاب الدارسين في دولة الإمارات العربية المتحدة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Graduation Timeline – Candidates should be within two years of graduating from medical or dental school.",
                                          text_ar:
                                            "يجب أن يكون المرشحون، قد تخرجوا من كلية الطب/طب الأسنان خلال عامين.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Medical Internship Only – IFOM Clinical Science Examination results are preferable.",
                                          text_ar:
                                            "يُفضل تقديم نتائج اختبار IFOM Clinical Science، وينطبق ذلك على برنامج الامتياز الطبي فقط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "International Graduates – For degrees awarded outside the UAE, an Educational Credential Evaluators (ECE) – General with Grade Average evaluation is required to standardize GPA. More information: ",
                                          text_ar:
                                            "الحصول على تقييم (ECE)، للخريجين الحاصلين على درجة علمية من خارج دولة الإمارات العربية المتحدة، للحصول على معدل تراكمي قياسي ",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "www.ece.org.",
                                              text_ar: "(http://www.ece.org)",
                                              classname:
                                                "hover:underline text-primary",
                                              href: "http://www.ece.org",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "English Language Proficiency",
                                    header_text_ar: "معايير اللغة الإنجليزية",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h6",
                                      text: "IELTS Academic:",
                                      text_ar: "أيلتس أكاديمي:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Minimum overall score: 6.0",
                                          text_ar: "درجة 6 أو أكثر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "A single test report is required; combined scores will not be accepted. ",
                                          text_ar:
                                            "يجب تقديم شهادة واحدة فقط، ولا تُقبل الدرجات المجمعة.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h6",
                                      text: "TOEFL iBT:",
                                      text_ar: "توفل TOEFL iBT:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Minimum score: 80",
                                          text_ar: "80 درجة أو أكثر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Paper-based TOEFL (PBT) is not accepted",
                                          text_ar: "لا يُقبل اختبار PBT.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h6",
                                      text: "EmSAT – English:",
                                      text_ar: "امسات إنجليزي:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Minimum score: 1525",
                                          text_ar: "1525أو أكثر.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Note:",
                                      text_ar: "ملاحظة:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Applicants are exempt from the English language certificate validity requirement. if they graduated from an educational institution within the UAE, or if, in the case of institutions outside the UAE, they provide an official letter from the university confirming that English was the language of instruction for their academic program.",
                                      text_ar:
                                        "يتم إعفاء المتقدمين من شرط صلاحية شهادة اللغة الإنجليزية، في حال تخرجهم من مؤسسة تعليمية داخل الدولة أو إرفاق خطاب رسمي من الجامعة يُؤكد أن لغة التدريس في البرنامج الأكاديمي كانت الإنجليزية للمؤسسات التعليمية خارج الدولة.",
                                      classname: "body mb-4",
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Portfolio Criteria",
                                    header_text_ar: "معايير الإنجازات",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "IFOM Clinical Science Exam",
                                          text_ar:
                                            "اختبار العلوم السريرية - IFOM Clinical Science Exam",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: For Medical Internship candidates only.",
                                                      text_ar:
                                                        "شروط الأهلية: مخصص فقط لمرشحي برنامج الامتياز الطبي.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted: Results released after the application submission deadline.",
                                                      text_ar:
                                                        "غير مقبول: النتائج التي تصدر بعد الموعد النهائي، لتقديم الطلبات لن تُقبل.",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research Activity",
                                          text_ar: "النشاط البحثي",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Examples: Writing a proposal, collecting data, analysing data, writing a manuscript, case study, etc.",
                                                      text_ar:
                                                        "أمثلة: كتابة مقترح بحثي، جمع البيانات، تحليل البيانات، كتابة مخطوطة، دراسة حالة، وغيرها.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: Must have occurred since entering medical or dental school (date must be indicated on the certificate).",
                                                      text_ar:
                                                        "الصلاحية: يجب أن يكون النشاط قد تم منذ الالتحاق بكلية الطب، أو طب الأسنان (يُشترط أن يكون تاريخ النشاط موضحًا في الشهادة).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publications",
                                          text_ar: "المنشورات العلمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Must be in a peer-reviewed journal (can be the same entry as the research activity).",
                                                      text_ar:
                                                        "شروط الأهلية: يجب أن تكون المنشورات في مجلة علمية مُحكمة. يمكن أن تكون نفس المنشورات ضمن النشاط البحثي.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted: Abstracts, thesis studies, or draft manuscripts.",
                                                      text_ar:
                                                        "الصلاحية: يجب أن تكون المنشورات قد تمت منذ الالتحاق بكلية الطب، أو طب الأسنان (يُشترط أن يكون التاريخ موضحًا).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Presentation at a Scientific Event",
                                          text_ar: "تقديم عرض في فعالية علمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Conference, symposium, workshop, etc.",
                                                  text_ar:
                                                    "أمثلة: مؤتمر، ندوة، ورشة عمل، إلخ.",
                                                  classname:
                                                    "text-onSurfaceVariant body",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-inside space-y-3 list-disc body",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Must be health-related",
                                                      text_ar:
                                                        "شروط الأهلية: يجب أن تكون الفعالية ذات صلة بالمجال الصحي.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted: Attendance certificates and presentations given during academic days or grand rounds at the university.",
                                                      text_ar:
                                                        "غير مقبول: شهادات الحضور، أو العروض المقدمة ضمن أيام أكاديمية أو جلسات داخل الجامعة.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: Must have occurred since entering medical or dental school (date must be indicated on the certificate).",
                                                      text_ar:
                                                        "الصلاحية: يجب أن يكون النشاط قد تم منذ الالتحاق بكلية الطب، أو طب الأسنان (مع ضرورة وجود التاريخ في الشهادة).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary Social / Community Activities",
                                          text_ar:
                                            "الأنشطة التطوعية الاجتماعية / المجتمعية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Examples: Participating in, organising, or speaking at a community engagement event. The activity must be health-related, such as health awareness campaigns.",
                                                      text_ar:
                                                        "أمثلة: المشاركة في تنظيم أو التحدث في فعالية مجتمعية توعوية صحية مثل حملات التوعية.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Activities must be organised or supervised by universities, official health associations, or government-licensed organisations.",
                                                      text_ar:
                                                        "شروط الأهلية: يجب أن تكون الأنشطة منظمة أو تحت إشراف الجامعات، جمعيات صحية رسمية، أو جهات حكومية مرخصة.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Target Audience: General public.",
                                                      text_ar:
                                                        "الفئة المستهدفة: عامة المجتمع.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: The activity must have taken place since entering medical/dental school, and the certificate/letter must indicate the date.",
                                                      text_ar:
                                                        "الصلاحية: يجب أن يكون النشاط قد تم منذ الالتحاق بكلية الطب، أو طب الأسنان (ويجب توضيح التاريخ في الشهادة أو الخطاب المرفق).",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted:",
                                                      text_ar: "غير مقبول: ",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "block1",
                                                          type: "div",
                                                          classname: "px-3",
                                                          children: [
                                                            {
                                                              _id: "block3",
                                                              type: "list",
                                                              type_identifier:
                                                                "ul",
                                                              classname:
                                                                "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                              children: [
                                                                {
                                                                  _id: "block3",
                                                                  type: "list",
                                                                  type_identifier:
                                                                    "li",
                                                                  text: "Activities conducted at the university for fellow students.",
                                                                  text_ar:
                                                                    "الأنشطة التي تُقام داخل الجامعة لزملاء الطلبة غير مقبولة.",
                                                                  classname: "",
                                                                },
                                                                {
                                                                  _id: "block3",
                                                                  type: "list",
                                                                  type_identifier:
                                                                    "li",
                                                                  text: "Volunteering to organise a conference or a workshop.",
                                                                  text_ar:
                                                                    "كما أن التطوع في تنظيم مؤتمر أو ورشة غير معتمد.",
                                                                  classname: "",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Skill Enhancement Courses",
                                          text_ar: "دورات تطوير المهارات",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Examples: Basic Life Support, Advanced Life Support, Point-of-Care Ultrasound Certificate (POCUS), Leadership, Quality, etc.",
                                                      text_ar:
                                                        "أمثلة: الإنعاش القلبي الأساسي (BLS)، الإنعاش القلبي المتقدم (ALS)، شهادة الموجات فوق الصوتية على نقطة الرعاية (POCUS)، القيادة، الجودة، وغيرها.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Online courses are accepted.",
                                                      text_ar:
                                                        "شروط الأهلية: يتم قبول الدورات الإلكترونية.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted: Certificates of completion for entrance examinations or preparatory courses.",
                                                      text_ar:
                                                        "غير مقبول: شهادات إتمام لدورات تحضيرية لاختبارات القبول.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: The course must have been completed since entering medical/dental school, and the certificate must indicate the date. ",
                                                      text_ar:
                                                        "الصلاحية: يجب أن تكون الدورة قد أُخذت بعد الالتحاق بكلية الطب، أو طب الأسنان (ويجب توضيح التاريخ بالشهادة).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic Awards",
                                          text_ar: "الجوائز الأكاديمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Examples: Dean’s List, Best Paper, Best Research, Best Presentation, etc.",
                                                      text_ar:
                                                        "أمثلة: قائمة العميد، أفضل ورقة بحثية، أفضل بحث، أفضل عرض تقديمي، إلخ.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Must be related to academic or research achievements.",
                                                      text_ar:
                                                        "شروط الأهلية: يجب أن تكون متعلقة بإنجاز أكاديمي أو بحثي.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted:",
                                                      text_ar: "غير مقبول:",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "block1",
                                                          type: "div",
                                                          classname: "px-3",
                                                          children: [
                                                            {
                                                              _id: "block3",
                                                              type: "list",
                                                              type_identifier:
                                                                "ul",
                                                              classname:
                                                                "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                              children: [
                                                                {
                                                                  _id: "block3",
                                                                  type: "list",
                                                                  type_identifier:
                                                                    "li",
                                                                  text: "Photographs of physical awards.",
                                                                  text_ar:
                                                                    "صور الجوائز الفعلية.",
                                                                  classname: "",
                                                                },
                                                                {
                                                                  _id: "block3",
                                                                  type: "list",
                                                                  type_identifier:
                                                                    "li",
                                                                  text: "Graduation certificates indicating honours.",
                                                                  text_ar:
                                                                    "شهادات التخرج، التي تشير إلى مرتبة الشرف لا تُحتسب.",
                                                                  classname: "",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: The award must have been received since entering medical/dental school, and the certificate/letter must indicate the date.",
                                                      text_ar:
                                                        "الصلاحية: يجب أن تكون الجائزة قد حصل عليها الطالب بعد دخوله كلية الطب، أو طب الأسنان (ويُشترط وجود التاريخ في الشهادة أو الخطاب).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Documents Required",
                                    header_text_ar: "المستندات المطلوبة",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Identification Documents",
                                      text_ar: "المستندات الشخصية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Valid passport copy.",
                                          text_ar: "نسخة من جواز السفر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Emirates ID card (if applicable).",
                                          text_ar:
                                            "صورة من الهوية الإماراتية سارية المفعول إن وجدت.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Family Book (UAE nationals only) / Mother’s Family Book (for children of UAE national mothers).",
                                          text_ar:
                                            "صورة من خلاصة القيد لمواطني دولة الإمارات / خلاصة قيد الأم (لأبناء المواطنات) / المرسوم لحاملي المراسيم.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Residency permit (if applicable).",
                                          text_ar: "صورة من التأشيرة. إن وجدت.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Academic Documents",
                                      text_ar: "المستندات الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Undergraduate degree certificate. If the certificate has not yet been issued, a letter of enrolment confirming the expected completion date will suffice.",
                                          text_ar:
                                            "شهادة البكالوريوس: في حال لم تصدر الشهادة بعد، يُقبل خطاب إثبات تسجيل من الجامعة يوضح تاريخ التخرج المتوقع.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Undergraduate academic transcript. A notarised English translation is required for documents originally issued in a language other than Arabic or English.",
                                          text_ar:
                                            "السجل الأكاديمي (كشف الدرجات): يجب تقديم ترجمة قانونية باللغة الإنجليزية لأي مستندات صادرة بلغة غير العربية أو الإنجليزية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Results of an English proficiency test (attained within the last two years) – if applicable.",
                                          text_ar:
                                            "نتائج اختبار كفاءة اللغة الإنجليزية (صادرة خلال آخر سنتين) – إن كان ذلك مطلوبًا.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Copy of curriculum vitae.",
                                          text_ar: "السيرة الذاتية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "ECE evaluation is required for graduates who obtained their degree outside the United Arab Emirates.",
                                          text_ar:
                                            "تقييم (ECE) للخريجين الحاصلين على درجة علمية خارج دولة الإمارات العربية المتحدة،",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Note:",
                                      text_ar: "ملاحظات:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "px-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "For applicants with a degree awarded outside the UAE, Educational Credential Evaluators (ECE) – General with Grade Average evaluation is required to evaluate the transcripts and establish a standard GPA ",
                                              text_ar:
                                                "-للمتقدمين الحاصلين على شهادة جامعية من خارج دولة الإمارات العربية المتحدة، يجب تقديم تقييم رسمي للسجل الأكاديمي من ECE  ",
                                              classname: "",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "linking",
                                                  text: "(www.ece.org).",
                                                  text_ar: "(www.ece.org)",
                                                  classname:
                                                    "hover:underline text-primary",
                                                  href: "http://www.ece.org",
                                                  target: "_blank",
                                                  rel: "noopener noreferrer",
                                                },
                                                {
                                                  _id: "block3",
                                                  size: "normal",
                                                  type: "paragraph",
                                                  text: "",
                                                  text_ar:
                                                    "– فئة 'General with Grade Average'.",
                                                  classname: "",
                                                },
                                              ],
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "This GPA will be used when shortlisting applicants.",
                                              text_ar:
                                                "يُستخدم هذا المعدل التراكمي الموحد (GPA) لأغراض المفاضلة بين المتقدمين أثناء مرحلة الاختيار.",
                                              classname: "",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Portfolio Documents",
                                      text_ar: "مستندات الإنجازات",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Candidates must ensure that all required documents (where applicable) are prepared prior to submission.",
                                          text_ar:
                                            "يجب على المتقدمين التأكد من تجهيز كافة الوثائق المطلوبة (عند الاقتضاء) قبل التقديم.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Research Activity",
                                      text_ar: "النشاط البحثي",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "IRB approval letter (if available).",
                                          text_ar:
                                            "خطاب موافقة لجنة الأخلاقيات (IRB) – إن وُجد.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research proposal.",
                                          text_ar: "المقترح البحثي.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Publication in a Peer-Reviewed Journal",
                                      text_ar: "النشر في مجلة علمية محكّمة",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Link to the article.",
                                          text_ar: "رابط المقال.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Copy of the published manuscript.",
                                          text_ar: "نسخة من المخطوطة المنشورة.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Presentation in a Scientific Event",
                                      text_ar: "العرض في فعالية علمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of participation as a presenter (oral or poster presentation).",
                                          text_ar:
                                            "شهادة مشاركة كمقدم (عرض شفهي أو ملصق علمي",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Voluntary Social/Community Activities",
                                      text_ar: "الأنشطة التطوعية المجتمعية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of participation.",
                                          text_ar: "شهادة مشاركة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates issued by volunteers.ae and Wellness on Wheels are accepted.",
                                          text_ar:
                                            "تُقبل الشهادات الصادرة من volunteers.ae و Wellness on Wheels.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "A maximum of two activities may be submitted.",
                                          text_ar: "يُقبل حد أقصى نشاطين فقط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Skill Enhancement Courses",
                                      text_ar: "دورات تطوير المهارات",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of attendance or completion.",
                                          text_ar:
                                            "شهادة حضور أو إتمام الدورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "A maximum of two courses may be submitted.",
                                          text_ar: "يُقبل حد أقصى دورتين فقط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Academic Awards",
                                      text_ar: "الجوائز الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates of academic achievements or awards",
                                          text_ar:
                                            "شهادات الإنجاز الأكاديمي أو الجوائز.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Note:",
                                      text_ar: "ملاحظات:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "If the certificate is in a language other than English or Arabic, a notarised translation must be attached.",
                                          text_ar:
                                            "إذا كانت الشهادة بلغة غير الإنجليزية أو العربية، يجب إرفاق ترجمة موثقة.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Selection Process",
                                    header_text_ar: "إجراءات القبول",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "All complete applications will be reviewed by the Admissions Committee.",
                                          text_ar:
                                            "سيتم مراجعة جميع الطلبات المكتملة من قبل لجنة القبول.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "An application will be considered complete once all required documents are successfully submitted through the online portal and the application fee is paid.",
                                          text_ar:
                                            "يُعتبر الطلب مكتملًا عند رفع جميع المستندات المطلوبة بنجاح، عبر البوابة الإلكترونية وتسديد رسوم التقديم.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "The committee will consider all aspects of your application, including your GPA and other academic and scholarly activities listed on your CV. ",
                                          text_ar:
                                            "تأخذ اللجنة بعين الاعتبار جميع جوانب الطلب، بما في ذلك المعدل التراكمي (GPA)، إلى جانب الأنشطة الأكاديمية والعلمية الأخرى المدرجة في السيرة الذاتية.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text:
                                      "Medical Internship - Shortlisting Process",
                                    header_text_ar:
                                      "آلية تقييم طلب الامتياز الطبي",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "GPA: 50%",
                                          text_ar: "المعدل التراكمي GPA: 50%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Interview: 30%",
                                          text_ar: "المقابلات الشخصية: 30%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Portfolio: 20%",
                                          text_ar:
                                            "ملف الإنجازات Portfolio: 20%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Medical Internship Portfolio Evaluation",
                                          text_ar:
                                            "تقييم ملف الإنجازات لامتياز الطبي.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "The portfolio will be evaluated according to the following criteria: ",
                                      text_ar:
                                        "سيتم تقييم ملف الإنجاز وفقًا للمعايير التالية:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "IFOM Part 2 :",
                                      text_ar: "اختبار IFOM الجزء الثاني:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "1 point (if score <40)",
                                          text_ar:
                                            "1 نقطة إذا كانت الدرجة أقل من 40.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "2 points (if score is 41–80)",
                                          text_ar:
                                            "2 نقطتان إذا كانت الدرجة بين 41 و80.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "3 points (if score ≥81)",
                                          text_ar:
                                            "3 نقاط إذا كانت الدرجة 81 أو أكثر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research activity – 4 points",
                                          text_ar: "النشاط البحثي: 4 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publication – 7 points",
                                          text_ar: "المنشورات العلمية: 7 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary social/community activities (max two) - 4 points each",
                                          text_ar:
                                            "الأنشطة التطوعية المجتمعية (بحد أقصى نشاطين): 4 نقاط لكل نشاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Skill enhancement courses (max two) - 4 Points each",
                                          text_ar:
                                            "دورات تطوير المهارات (بحد أقصى دورتين): 4 نقاط لكل دورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic Awards - 6 Points",
                                          text_ar:
                                            "الجوائز الأكاديمية: 6 نقاط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text:
                                      "Dental Internship – Shortlisting Process",
                                    header_text_ar:
                                      "آلية تقييم ملف الامتياز (طب الأسنان)",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "GPA: 50%",
                                          text_ar: "المعدل التراكمي GPA: 50%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Interview: 30%",
                                          text_ar: "المقابلات الشخصية: 30%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Portfolio: 20%",
                                          text_ar:
                                            "ملف الإنجازات Portfolio: .20%",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Dental Internship Portfolio Evaluation",
                                          text_ar:
                                            "تقييم ملف الإنجازات لامتياز طب الأسنان",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "The portfolio will be evaluated according to the following criteria: ",
                                      text_ar:
                                        "سيتم تقييم ملف الإنجاز وفقًا للمعايير التالية:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research activity – 2 points",
                                          text_ar: "النشاط البحثي: 2 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publication – 4 points)",
                                          text_ar: "المنشورات العلمية: 4 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Presentation in a scientific event – 2 points",
                                          text_ar:
                                            "تقديم عرض في فعالية علمية: 2 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary social/community activities (max two) - 2 points each",
                                          text_ar:
                                            "الأنشطة التطوعية المجتمعية (بحد أقصى نشاطين): 2 نقاط لكل نشاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Extra-curricular courses (max two) - 2 points each",
                                          text_ar:
                                            "دورات تطوير المهارات (بحد أقصى دورتين): 2 نقاط لكل دورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic Awards - 4 points",
                                          text_ar:
                                            "الجوائز الأكاديمية: 4 نقاط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "After the application deadline, candidates will be notified.",
                                      text_ar:
                                        "بعد انقضاء الموعد النهائي للتقديم، سيتم إخطار المتقدمين بنتائج التقييم.",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Ranking will be based on merit; Accordingly, candidates will be informed via email of their admission decision Cross Match",
                                      text_ar:
                                        "سيتم تحديد الترتيب النهائي، استنادًا إلى الجدارة، وعليه سيتم إخطار المتقدمين بقرار القبول عبر البريد الإلكتروني، بعد إتمام عملية المطابقة (Cross Match).",
                                      classname: "body text-primary",
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Fees",
                                    header_text_ar: "الرسوم",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Registration and review fees:",
                                      text_ar: "رسوم تقديم ومراجعة الطلب:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "AED 220 for processing the application (non-refundable).",
                                          text_ar:
                                            "220درهماً رسوم تقـــديم الطلب. (غير مستردة)",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Training fees: ",
                                      text_ar: "رسوم التدريب:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "For Medical: 30,000 dirhams",
                                          text_ar: "للطب العام 30,000 درهم.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "For Dental: subject to the training hospital’s fees",
                                          text_ar:
                                            "طب الأسنان بناء على المركز التدريبي وقد تختلف حسب المستشفى التدريبي.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "For further enquiries or in case of any technical issues, please contact us through the following channels:",
                                      text_ar:
                                        "لمزيد من الاستفسارات، أو في حال وجود أي مشكلات تقنية، يُرجى التواصل عبر القنوات التالية:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Email: ",
                                          text_ar: "البريد الإلكتروني: ",
                                          classname:
                                            "body text-onSurfaceVariant inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: " info@dha.gov.ae",
                                          text_ar: " info@dha.gov.ae",
                                          classname: "text-primary inline",
                                          href: "mailto::info@dha.gov.ae",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Contact no: ",
                                          text_ar: "الهاتف: ",
                                          classname:
                                            "body text-onSurfaceVariant inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "800342",
                                          text_ar: "800342",
                                          classname: "text-primary inline",
                                          href: "tel:+971800342",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "To register for the Internship Training Programme during the registration period, please click on the following link: ",
                                          text_ar:
                                            "للتسجيل في برنامج الامتياز خلال فترة التسجيل، اضغط على الرابط التالي: ",
                                          classname:
                                            "body text-onSurfaceVarient inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "Click here to apply",
                                          text_ar: "اضغط هنا للتقديم",
                                          classname:
                                            "hover:underline text-primary underlined inline",
                                          href: "https://mawaheb.dha.gov.ae/admin/servicesByCategory/3",
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname: "",
                          children: [
                            {
                              _id: "block2",
                              type: "tabcontent",
                              isShow_title: false,
                              linker: "medical_control",
                              linker_ar: "medical_control",
                              title: "Residency Programme",
                              title_ar: "برنامج الإقامة",
                              size: "h2",
                              classname: "dda-table-container",
                              children: [
                                {
                                  _id: "block1",
                                  type: "div",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "The medical residency programmes in the private healthcare sector of the Emirate of Dubai, under the supervision of the Dubai Health Authority,  offer ambitious physicians a distinguished opportunity to gain advanced clinical training, enhance their professional skills, and acquire diverse hands-on experience across various specialties  Accredited by local and international accreditation bodies such as the Arab Board of Health Specializations, the National Institute for Health Specialties, and the American Council for Graduation Medical Education International ACGME-I. Under the guidance of experienced consultants and in state-of-the-art medical facilities the training duration ranges between 4 to 5 years, depending on the specialty., residents undergo a structured, competency-based training program designed to gradually prepare them for independent clinical practice. These diverse and accredited programs aim to develop a new generation of healthcare leaders.",
                                      text_ar:
                                        "تقدم برامج الإقامة الطبية في القطاع الصحي الخاص بإمارة دبي، تحت إشراف هيئة الصحة بدبي، فرصة مميزة للأطباء الطموحين لاكتساب تدريب سريري متقدم، وتنمية مهاراتهم المهنية، والحصول على خبرة عملية متنوعة في مختلف التخصصات الصحية المعهد الوطني للاختصاصات الصحية والمجلس الأمريكي للتعليم العالي وبإشراف استشاريين ذوي خبرة، وفي مرافق طبية حديثة، تتراوح مدة التدريب بين 4 الى 5 سنوات بحسب التخصص، يخضع الأطباء المقيمون لبرنامج تدريبي منظم قائم على الكفاءة. ويهدف إلى تأهيلهم تدريجيًا للممارسة السريرية المستقلة. وتعمل هذه البرامج المتنوعة والمعتمدة على إعداد جيل جديد من قادة الرعاية الصحية.",
                                      classname: "body mb-4",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Accredited Medical Specialties in Private Hospitals Licensed and accredited as a training center by the Dubai Health Authority in the Emirate of Dubai:",
                                      text_ar:
                                        "التخصصات الطبية المعتمدة في المستشفيات الخاصة  المرخصة والمعتمدة كمركز تدريبي من قبل هيئة الصحة في امارة دبي:",
                                      classname: "body mb-4 text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Pediatrics",
                                          text_ar: "طب الأطفال",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Family Medicine",
                                          text_ar: "طب الأسرة",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Internal Medicine",
                                          text_ar: "الطب الباطني",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "General Surgery",
                                          text_ar: "الجراحة العامة",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obstetrics & Gynaecology",
                                          text_ar: "طب النساء والولادة ",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Orthopedics & Trauma",
                                          text_ar: "طب الحوادث والكسور ",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Emergency Medicine",
                                          text_ar: "طب الطوارئ",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Anaesthesiology & Critical Care",
                                          text_ar:
                                            "طب التخدير والعناية المركزة",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Anatomical Pathology",
                                          text_ar: "طب علم الأمراض التشريحي",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Dermatology & Venereology",
                                          text_ar:
                                            "طب الأمراض الجلدية والتناسلية",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Programme Timeline",
                                    header_text_ar: "الجدول الزمني",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "dda-table-container",
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "overflow-x-auto",
                                          children: [
                                            {
                                              _id: "table1",
                                              type: "table",
                                              classname:
                                                "dda-table w-full min-w-[650px]",
                                              children: [
                                                {
                                                  _id: "table_body",
                                                  type: "tableItems",
                                                  type_identifier: "tbody",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Registration Opens",
                                                              text_ar:
                                                                "فتح باب التسجيل",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "January",
                                                              text_ar: "يناير",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Registration Closes",
                                                              text_ar:
                                                                "إغلاق باب التسجيل",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "March",
                                                              text_ar: "مارس",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Multiple Mini Interviews (MMI)",
                                                              text_ar:
                                                                "المقابلات المتعددة القصيرة MMI",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "May",
                                                              text_ar: "مايو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Speciality Interviews",
                                                              text_ar:
                                                                "المقابلات التخصصية",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "May - June",
                                                              text_ar:
                                                                "مايو-يونيو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Matching Process",
                                                              text_ar:
                                                                "إجراءات المطابقة",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "June",
                                                              text_ar: "يونيو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Announcement of Accepted Candidates",
                                                              text_ar:
                                                                "الإعلان عن أسماء المقبولين",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "July - August",
                                                              text_ar:
                                                                "يوليو- أغسطس",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Start of Academic Year",
                                                              text_ar:
                                                                "بداية العام الأكاديمي",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "October",
                                                              text_ar: "أكتوبر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Eligibility Criteria",
                                    header_text_ar: "معايير القبول",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Academic Criteria",
                                      text_ar: "المعايير الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Applicants must be graduates of medical schools listed under the World Health Organization (WHO).",
                                          text_ar:
                                            "الحصول على درجة البكالوريوس في الطب والجراحة، أو ما يعادلها من إحدى كليات الطب المدرجة في قائمة منظمة الصحة العالمية (WHO).",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "A certificate of completion for the internship year with a minimum training duration of 12 months is required. The applicant must have successfully passed the final examinations of the MBBS/MD programme before commencing the internship year. This is a fundamental requirement. This requirement is essential for obtaining licensure and must be fulfilled to ensure eligibility for enrolment in the programme.",
                                          text_ar:
                                            "شهادة إتمام التدريب لسنة الامتياز، على ألا تقل مدة التدريب عن 12 شهر. ويشترط أن يكون المتقدم قد اجتاز بنجاح الامتحانات النهائية لبرنامج MBBS/MD قبل بدء سنة الامتياز. ويُعد هذا الشرط مطلبًا أساسياً للحصول على الترخيص، ويجب استيفاؤه لضمان أهلية الالتحاق بالبرنامج.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Applicants must successfully pass the Emirates Medical Residency Entrance Examination (EMREE).",
                                          text_ar:
                                            "اجتياز اختبار القبول في برنامج الإقامة الطبية في الإمارات (EMREE) بنجاح.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "An Educational Credential Evaluation (ECE) certificate is required for graduates who obtained their degree outside the United Arab Emirates in order to obtain a standardised GPA via ",
                                          text_ar:
                                            "شهادة (ECE) للخريجين الحاصلين على درجة علمية خارج دولة الإمارات العربية المتحدة، للحصول على معدل تراكمي قياسي عن طريق ،",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "http://www.ece.org",
                                              text_ar: "(http://www.ece.org)",
                                              classname:
                                                "hover:underline text-primary",
                                              href: "http://www.ece.org",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: " Graduates from the UAE must submit their final cumulative GPA.",
                                              text_ar:
                                                "وعلى خريجي دولة الإمارات تقديم المعدل التراكمي النهائي.",
                                              classname: "body mb-4 inline",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Candidates must not have been out of clinical practice for more than 12 months at any point (excluding national service for UAE nationals or disruptions caused by the COVID-19 pandemic).",
                                          text_ar:
                                            "يجب ألا يكون المرشحون قد انقطعوا عن الممارسة السريرية لأكثر من 24 شهرًا في أي وقت (باستثناء الخدمة الوطنية لمواطني دولة الإمارات العربية المتحدة)، أو الانقطاع بسبب جائحة كوفيد-19).",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Those who obtained their bachelor’s degree or completed their internship year outside the United Arab Emirates must provide the following: A notarised English translation of documents originally in a language other than Arabic or English",
                                          text_ar:
                                            "ينبغي على الحاصلين على شهادة درجة البكالوريوس، أو سنة الامتياز من خارج دولة الإمارات العربية المتحدة، توفير التالي: ترجمة إنجليزية موثقة للوثائق الأصلية الصادرة بلغة غير العربية أو الإنجليزية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Accepted applicants will be required to join the programme as full-time trainees, and simultaneous enrolment in more than one postgraduate programme will not be permitted.",
                                          text_ar:
                                            "سيتعين على المتقدمين المقبولين، الالتحاق بالبرنامج كمتدربين بدوام كامل، ولن يُسمح بالجمع بين أكثر من برنامج دراسات عليا في الوقت نفسه.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Final admission to the programme is conditional upon the successful completion of the licensing procedures by the Dubai Health Authority (DHA).",
                                          text_ar:
                                            "كما أن الالتحاق النهائي بالبرنامج مشروط بإتمام إجراءات الترخيص بنجاح من قبل هيئة الصحة بدبي (DHA).",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "English Language Criteria",
                                    header_text_ar: "معايير اللغة الإنجليزية",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "IELTS Academic",
                                      text_ar: "أيلتس أكاديمي:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Overall score of 6",
                                          text_ar: "درجة 6 أو أكثر.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "TOEFL iBT",
                                      text_ar: "توفل TOEFL iBT:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Minimum score of 80",
                                          text_ar: "80 درجة أو أكثر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "PBT is not accepted",
                                          text_ar: "لا يُقبل اختبار PBT",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "EmSAT – English:",
                                      text_ar: "امسات إنجليزي:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Achievement of 1525 or above.",
                                          text_ar: "1525أو أكثر.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Note:",
                                      text_ar: "ملاحظة:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Applicants are exempt from the English language certificate validity requirement if they graduated from an educational institution within the UAE, or if, in the case of institutions outside the UAE, they provide an official letter from the university confirming that English was the language of instruction for their academic program.",
                                      text_ar:
                                        "يتم إعفاء المتقدمين من شرط صلاحية شهادة اللغة الإنجليزية، في حال تخرجهم من مؤسسة تعليمية داخل الدولة أو إرفاق خطاب رسمي من الجامعة يُؤكد أن لغة التدريس في البرنامج الأكاديمي كانت الإنجليزية للمؤسسات التعليمية خارج الدولة.",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Portfolio Criteria",
                                    header_text_ar: "معايير الإنجازات",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research Activities",
                                          text_ar: "الأنشطة البحثية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Writing a proposal, collecting data, analysing data, writing a manuscript, case study, etc.",
                                                  text_ar:
                                                    "أمثلة: إعداد مقترح بحثي، جمع البيانات، تحليل البيانات، كتابة مخطوطة بحثية، دراسة حالة، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place since entering medical/dental school (ensure the date is indicated on the letter).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون النشاطات قد أُنجزت منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الخطاب).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publications",
                                          text_ar: "النشر العلمي",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Must be published in a peer-reviewed journal. It may be the same entry as the research activity.",
                                                  text_ar:
                                                    "الأهلية: يجب أن يكون النشر في مجلة علمية مُحكّمة. يمكن أن يكون النشر هو نفسه النشاط البحثي.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Abstracts, theses, or draft manuscripts.",
                                                  text_ar:
                                                    "غير مقبول: الملخصات، ورسائل الماجستير أو البكالوريوس، أو المسودات غير المنشورة.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place after entering medical or dental school (ensure the date is clearly stated).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن يكون النشر قد تم منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Presentation at a Scientific Event",
                                          text_ar: "العرض في فعالية علمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Conference, symposium, workshop, etc.",
                                                  text_ar:
                                                    "أمثلة: مؤتمر، ندوة، ورشة عمل، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Must be health-related.",
                                                  text_ar:
                                                    "الأهلية: يجب أن تكون الفعالية مرتبطة بالصحة.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Certificates of attendance, or presentations given during academic days or grand rounds at the university.",
                                                  text_ar:
                                                    "غير مقبول: شهادات الحضور أو العروض المقدمة، خلال الأيام الأكاديمية أو الجولات الطبية في الجامعة.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place after entering medical or dental school (ensure the date is clearly stated on the certificate).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن يكون النشاط قد تم منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary Social/ Community Activities",
                                          text_ar:
                                            "الأنشطة التطوعية الاجتماعية/المجتمعية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Participating in, organising, or speaking at a community engagement event. Must be health-related, such as health awareness campaigns.",
                                                  text_ar:
                                                    "أمثلة: المشاركة في تنظيم أو إلقاء كلمة في فعالية مجتمعية، على أن تكون ذات صلة بالصحة، مثل حملات التوعية الصحية.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Activities organised or supervised by universities, official health associations, or government-licensed organisations.",
                                                  text_ar:
                                                    "الأهلية: الأنشطة المنظمة أو المشرفة عليها الجامعات، والجمعيات الصحية الرسمية، أو الجهات المرخّصة حكومياً.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Target Audience: Activities aimed at the general public.",
                                                  text_ar:
                                                    "الفئة المستهدفة: الأنشطة الموجهة لعامة الجمهور.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Activities conducted at the university for fellow students, volunteering to organise a conference, or assisting in workshops.",
                                                  text_ar:
                                                    "غير مقبول: الأنشطة داخل الجامعة الموجهة للطلبة، أو التطوع في تنظيم المؤتمرات أو ورش العمل.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place after entering medical or dental school (ensure the date is clearly stated on the certificate or letter). ",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون النشاطات قد أُنجزت منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة/الخطاب).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Skill Enhancement Courses",
                                          text_ar: "دورات تطوير المهارات",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Basic Life Support, Advanced Life Support, Point-of-Care Ultrasound Certificate (POCUS), leadership, quality improvement, etc.",
                                                  text_ar:
                                                    "أمثلة: الإنعاش القلبي الرئوي الأساسي، والإنعاش القلبي الرئوي المتقدم، وشهادة الموجات فوق الصوتية عند نقطة الرعاية (POCUS)، والقيادة، والجودة، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Online courses are accepted.",
                                                  text_ar:
                                                    "الأهلية: تُقبل الدورات عبر الإنترنت.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Certificates of completion for entrance examinations or preparatory courses.",
                                                  text_ar:
                                                    "غير مقبول: شهادات إتمام دورات اختبارات القبول أو الدورات التحضيرية.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place since entering medical/dental school (ensure the date is indicated on the certificate).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون الدورة قد أُنجزت منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic Awards",
                                          text_ar: "الجوائز الأكاديمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Dean’s List, Best Paper, Best Research, Best Presentation, etc.",
                                                  text_ar:
                                                    "أمثلة: قائمة العميد، أفضل ورقة بحثية، أفضل بحث، أفضل عرض تقديمي، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Must relate to academic or research achievements.",
                                                  text_ar:
                                                    "الأهلية: يجب أن تكون مرتبطة بإنجازات أكاديمية أو بحثية.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Photographs of physical awards and graduation certificates indicating honours are not considered.",
                                                  text_ar:
                                                    "غير مقبول: صور الجوائز المادية، وشهادات التخرج، التي تتضمن مرتبة الشرف.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The award must have been obtained since entering medical/dental school (ensure the date is indicated on the certificate/letter). ",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون الجائزة قد حُصِل عليها منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة/الخطاب).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Extra-Curricular Activities",
                                          text_ar: "أنشطة اللاصفية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Clinical attachment, summer placement, teaching, membership of councils within the university, etc.",
                                                  text_ar:
                                                    "أمثلة: التدريب السريري، التدريب الصيفي، التدريس، عضوية المجالس داخل الجامعة، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place since entering medical/dental school (ensure the date is indicated on the certificate/letter).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون النشاطات قد أُنجزت منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة/الخطاب).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Required Documents",
                                    header_text_ar: "المستندات المطلوبة",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "The online application form is the official and only means to apply for any of our Graduate Medical Education programmes.",
                                          text_ar:
                                            "نموذج الطلب الإلكتروني، هو الوسيلة الرسمية والوحيدة، للتقديم لأيٍّ من برامج الدراسات العليا الطبية لدينا.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "All application documents must be submitted online.",
                                          text_ar:
                                            "يجب تقديم جميع وثائق الطلب إلكترونيًا.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Candidates must ensure that all required documents are correctly attached in their designated fields.",
                                          text_ar:
                                            "يجب على المرشحين التأكد من إرفاق جميع المستندات المطلوبة بشكل صحيح في الحقول المخصصة لها.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Missing or incorrectly attached documents will result in disqualification of the application.",
                                          text_ar:
                                            "سيؤدي عدم إرفاق أي مستندات أو إرفاقها بشكل غير صحيح إلى استبعاد طلبك.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Candidates must ensure all required documents are prepared prior to submission, as applications cannot be returned for portfolio edits once submitted.",
                                          text_ar:
                                            "يجب على المتقدمين التأكد من تجهيز جميع المستندات المطلوبة قبل تقديم الطلب، حيث لا يمكن إعادة الطلبات لإجراء تعديلات على الملف بعد إرسالها.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Identification Documents",
                                    header_text_ar: "المستندات الشخصية",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Recent coloured photograph",
                                          text_ar: "صورة شخصية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Valid passport copy",
                                          text_ar:
                                            "صورة من جواز السفر ساري المفعول.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Emirates ID card (if applicable)",
                                          text_ar:
                                            "صورة من الهوية الإماراتية سارية المفعول إن وجدت.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Family Book (UAE nationals only) / Mother’s Family Book (for children of UAE national mothers) / Valid Marsoom letter (for Marsoom holders only)",
                                          text_ar:
                                            "صورة من خلاصة القيد للمواطنين/ خلاصة قيد الأم (لأبناء المواطنات) /صورة من المرسوم ساري الصلاحية لحاملي المراسيم فقط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Residency permit (if applicable)",
                                          text_ar: "صورة من التأشيرة.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Academic Documents",
                                    header_text_ar: "المستندات الأكاديمية",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Undergraduate Degree Certificate: A notarised English translation is required for documents originally in a language other than Arabic or English.",
                                          text_ar:
                                            "شهادة البكالوريوس: في حال كانت الشهادة صادرة بلغة غير العربية أو الإنجليزية، يجب إرفاق ترجمة موثقة إلى اللغة الإنجليزية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Undergraduate Academic Transcript: A notarised English translation is required for documents originally in a language other than Arabic or English.",
                                          text_ar:
                                            "السجل الأكاديمي لمرحلة البكالوريوس:  في حال كان السجل الأكاديمي بلغة غير العربية أو الإنجليزية، يجب إرفاق ترجمة موثقة إلى اللغة الإنجليزية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Internship Certificate: If the certificate is not yet available, please upload a letter from the institution confirming your enrolment and the expected date of completion. The completion date must be prior to the beginning of the academic year.",
                                          text_ar:
                                            "شهادة الامتياز:  في حال عدم توفر الشهادة بعد، يجب رفع خطاب من المؤسسة، يؤكد التسجيل في البرنامج مع تحديد تاريخ متوقع لإتمامه. يجب أن يكون تاريخ الإتمام قبل بداية العام الأكاديمي.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Results of the English proficiency test: As per the published criteria.",
                                          text_ar:
                                            "نتائج اختبار إتقان اللغة الإنجليزية وفقًا للمعايير المنشورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Results of the Emirates Medical Residency Entrance Examination (EMREE)",
                                          text_ar:
                                            "نتائج اختبار القبول لبرنامج الإقامة الطبية (EMREE)",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Curriculum Vitae",
                                          text_ar: "السيرة الذاتية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Educational Credential Evaluators (ECE) – General with Grade Average Candidates who graduated outside the UAE are required to have their transcripts evaluated and obtain a standard GPA from Educational Credential Evaluators (ECE). This ECE GPA equivalent will be used for shortlisting applications.",
                                          text_ar:
                                            "تقييم المؤهلات التعليمية (ECE) يتعين على المرشحين الذين تخرجوا من خارج دولة الإمارات، تقييم سجلاتهم الأكاديمية والحصول على معدل تراكمي موحّد من خلال خدمة تقييم المؤهلات التعليمية (ECE) ، وسيتم استخدام المعدل التراكمي المكافئ الصادر عن (ECE) ، عند إعداد القائمة المختصرة للطلبات.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Provide a Primary Source Verification (PSV) report for all certificates. For more information, please refer to: ",
                                          text_ar:
                                            "توفير تقرير التحقق من المصدر الأساسي (PSV) لجميع الشهادات. لمزيد من المعلومات يرجى مراجعة الرابط ",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "https://dha.dfgateway.com/",
                                              text_ar:
                                                "(https://dha.dfgateway.com/)",
                                              classname:
                                                "hover:underline text-primary",
                                              href: "https://dha.dfgateway.com/",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Proof of completion or exemption from National Service for male UAE nationals.",
                                          text_ar:
                                            "ما يثبت الانتهاء من الخدمة الوطنية او الاعفاء للمواطنين الذكور.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "No Objection Letter (NOC) from the employer to join the full-time training programme (if the applicant is currently employed).",
                                          text_ar:
                                            "خطاب عدم ممانعة من جهة العمل للالتحاق بالبرنامج التدريبي بدوام كامل (في حال كان المتقدم على رأس عمله).",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Portfolio Documents",
                                    header_text_ar: "مستندات الإنجازات",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Research Activity",
                                      text_ar: "النشاط البحثي",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "IRB Approval Letter (if available)",
                                          text_ar:
                                            "خطاب موافقة لجنة أخلاقيات البحث (IRB) – إن وُجد.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research Proposal",
                                          text_ar: "مقترح البحث.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publication in a peer-reviewed journal",
                                          text_ar:
                                            "النشر في مجلة علمية مُحكَّمة:",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Link to article",
                                          text_ar: "رابط المقال.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Copy of the published manuscript.",
                                          text_ar: "نسخة من المخطوطة المنشورة",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Abstracts and thesis dissertations are not accepted.",
                                          text_ar:
                                            "لا تُقبل الملخصات أو رسائل الماجستير/البكالوريوس.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Presentation at a Scientific Event",
                                      text_ar: "العرض في فعالية علمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of participation as a presenter (oral or poster presentation).",
                                          text_ar:
                                            "شهادة مشاركة كمقدّم عرض (شفوي أو عرض ملصق).",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Voluntary Social/Community Activities",
                                      text_ar:
                                        "الأنشطة التطوعية الاجتماعية/المجتمعية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Must be health-related activities, such as health awareness campaigns.",
                                          text_ar:
                                            "يجب أن تكون أنشطة متعلقة بالصحة مثل حملات التوعية الصحية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of participation or official letter from the organiser confirming your role.",
                                          text_ar:
                                            "تقبل شهادة مشاركة، أو خطاب رسمي من الجهة المنظمة يؤكد دورك.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates issued by  .",
                                          text_ar:
                                            "o	تُقبل الشهادات الصادرة من ",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "volunteers.ae",
                                              text_ar: "volunteers.ae",
                                              classname:
                                                "hover:underline text-primary",
                                              href: "http://www.volunteers.ae",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: " and Wellness on Wheels are accepted",
                                              text_ar: " وWellness on Wheels.",
                                              classname: "body mb-4 inline",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Maximum of two activities.",
                                          text_ar: "يقدم بحد أقصى نشاطين.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Skill Enhancement Courses",
                                      text_ar: "دورات تطوير المهارات",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of attendance or completion.",
                                          text_ar: "شهادة حضور أو إتمام.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Maximum of two courses.",
                                          text_ar: "يقدم بحد أقصى دورتين.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Academic Awards",
                                      text_ar: "الجوائز الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates of academic achievement/award or official letter from the university.",
                                          text_ar:
                                            "تُقبل شهادات الإنجازات/الجوائز الأكاديمية أو خطاب رسمي من الجامعة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of excellence/merit for outstanding performance in a university course is accepted.",
                                          text_ar:
                                            "تُقبل شهادة التميز/الاستحقاق، للأداء المتميز في مقرر جامعي.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Extra-Curricular Activities",
                                      text_ar: "الأنشطة اللاصفية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate or official letter from the relevant institute.",
                                          text_ar:
                                            "شهادة أو خطاب رسمي من المؤسسة المعنية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Maximum of two activities.",
                                          text_ar: "تُقدم بحد أقصى دورتين.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Note:",
                                      text_ar: "ملاحظات:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "If the certificate is in a language other than English or Arabic, a notarised translation must be attached.",
                                          text_ar:
                                            "في حال كانت الشهادة بلغة غير الإنجليزية أو العربية، يجب إرفاق ترجمة موثقة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates with handwritten names will not be accepted.",
                                          text_ar:
                                            "الشهادات التي تحمل أسماء مكتوبة بخط اليد لن تُقبل.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Admission Procedures",
                                    header_text_ar: "إجراءات القبول",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "An application will be considered complete once all required documents have been successfully submitted through the online portal and the application fee paid.",
                                      text_ar:
                                        "يُعتبر طلب التقديم مكتملًا عند رفع جميع المستندات المطلوبة بنجاح عبر البوابة الإلكترونية، وتسديد رسوم التقديم.",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "The selection process will include the following four phases: ",
                                      text_ar:
                                        "تشمل عملية الاختيار، أربع مراحل رئيسية على النحو التالي:",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Phase 1: Shortlisting (50%)",
                                      text_ar:
                                        "المرحلة الأولى: التصفية الأولية (50%(",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "All complete applications will be reviewed and scored by the  concerned section in Medical Education & Research Department according to the following criteria:",
                                      text_ar:
                                        "سيتم مراجعة جميع الطلبات المكتملة، وتقييمها من قبل القسم المعني في إدارة التعليم الطبي، وفقًا للمعايير التالية:",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "GPA: 35%",
                                          text_ar: "المعدل التراكمي 35%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Residency Entrance Examination: 35%",
                                          text_ar:
                                            "نتيجة اختبار القبول لبرنامج الإقامة 35%. سيتم احتسابه بناءً على الدرجة، والترتيب المئوي، وعدد المحاولات.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Portfolio: 30%",
                                          text_ar: "ملف الإنجاز 30%.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Portfolio Evaluation (30 points)",
                                      text_ar:
                                        "تقييم الملف الشخصي بحد أقصى 30 نقطة:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research activity – 4 points",
                                          text_ar: "النشاط البحثي – 4 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publication – 6 points",
                                          text_ar: "النشر العلمي – 6 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Presentation at a scientific event – 4 points",
                                          text_ar:
                                            "العرض في فعالية علمية – 4 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary social/community activities (maximum two activities) – 2 points each",
                                          text_ar:
                                            "الأنشطة التطوعية (الاجتماعية/المجتمعية) -بحد أقصى نشاطين – نقطتان لكل نشاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Skill enhancement courses (maximum two courses) – 2 points each",
                                          text_ar:
                                            "الدورات التدريبية لتطوير المهارات بحد أقصى دورتين – نقطتان لكل دورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Extra-curricular activities (maximum two courses) – 2 points each",
                                          text_ar:
                                            "الأنشطة اللاصفية (بحد أقصى نشاطي) نقطتان لكل نشاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic awards – 4 points",
                                          text_ar:
                                            "الجوائز الأكاديمية – 4 نقاط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Phase 2: Multiple Mini Interviews (MMI) (30%)",
                                      text_ar:
                                        "المرحلة الثانية: المقابلات المتعددة القصيرةMMI    30%",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Qualified shortlisted candidates will be invited via email for on-site Multiple Mini Interviews. MMI and unsuccessful candidates will be notified at that time with a regret notice.",
                                          text_ar:
                                            "سيتم دعوة المرشحين المؤهلين ضمن قائمة التصفية النهائية، عبر البريد الإلكتروني لإجراء المقابلات القصيرة المتعددة (MMI) ، بينما سيتم إخطار المرشحين غير المقبولين في ذلك الوقت برسالة اعتذار.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "This process results in an overall score for each applicant that reflects their non-cognitive skills, such as communication skills, professionalism, and moral judgement.",
                                          text_ar:
                                            "تؤدي هذه العملية إلى الحصول على مجموع نقاط شامل لكل متقدم، يعكس مهاراته غير المعرفية، مثل مهارات التواصل، والاحترافية، والحكم الأخلاقي",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragaph",
                                      size: "normal",
                                      text: "The interview scenarios are designed to assess non-cognitive competencies essential in the field of medicine, such as: ",
                                      text_ar:
                                        "تصميم السيناريوهات في المقابلة. يهدف إلى اختبار الكفاءات غير المعرفية، التي تُعد أساسية في مجال الطب، مثل: ",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Communication skills",
                                          text_ar: "مهارات التواصل.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Problem-solving",
                                          text_ar: "حل المشكلات.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Empathy",
                                          text_ar: "التعاطف.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Moral/ethical reasoning",
                                          text_ar: "التفكير الأخلاقي/المعنوي.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Decision-making",
                                          text_ar: "اتخاذ القرار.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Phase 3: Specialty Interview (20%)",
                                      text_ar:
                                        "المرحلة الثالثة: المقابلة التخصصية 20%",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Candidates will be shortlisted based on Phase 1 and Phase 2 scores and invited to the Specialty Interviews. Unsuccessful candidates will be notified at that time with a regret notice.",
                                      text_ar:
                                        "سيتم ترشيح المتقدمين بناءً على نتائج المرحلتين الأولى والثانية، ودعوتهم لإجراء المقابلات التخصصية، بينما سيتم إخطار المتقدمين غير المقبولين في ذلك الوقت برسالة اعتذار.",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Phase 4: Ranking & Offering",
                                      text_ar:
                                        "المرحلة الرابعة: الترتيب وإعلان القبول",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Candidates who complete the Specialty Interview will be ranked based on the following: 50% shortlisting score, 30% MMI score, and 20% specialty interview score. Accordingly, they will be informed via email of their admission decision after the Cross Match. ",
                                      text_ar:
                                        "سيتم تصنيف المتقدمين الذين أنهوا المقابلة التخصصية، بناءً على النسب التالية: 50% من درجة التصفية الأولية، و30% من درجة المقابلات القصيرة المتعددة (MMI)، و20% من درجة المقابلة التخصصية. وبناءً على ذلك، سيتم إبلاغهم بقرار القبول عبر البريد الإلكتروني، بعد عملية المطابقة النهائية (Cross Match)",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Cross Match",
                                      text_ar:
                                        "عملية المطابقة النهائية. (Cross Match)",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Cross Match is an important step in the selection process that involves comparing accepted candidates across health authorities and entities in the United Arab Emirates (UAE) that provide training programmes. When a candidate is shortlisted and ranked by two or more of these entities, they are contacted and given the opportunity to select their preferred entity for training. Once the candidate confirms their preference, the other authorities promptly remove the candidate’s name from their respective lists. This meticulous process is designed to guarantee that UAE graduates are afforded a fair opportunity to secure a training place at an early stage in the process.",
                                      text_ar:
                                        "تُعد عملية المطابقة النهائية (Cross Match) ، خطوة مهمة في اختيار المتدربين، حيث تتضمن مقارنة المرشحين المقبولين بين الجهات والهيئات الصحية في دولة الإمارات العربية المتحدة، التي تقدم برامج تدريبية. <br /> عندما يتم ترشيح المتقدم وتصنيفه، من قبل جهتين أو أكثر من هذه الجهات، يتم التواصل معه لإتاحة الفرصة له لاختيار الجهة المفضلة لديه للتدريب. وبمجرد أن يؤكد المتقدم اختياره، تقوم الجهات الأخرى على الفور بحذف اسمه من قوائمها. <br /> تم تصميم هذه العملية الدقيقة، لضمان منح خريجي دولة الإمارات فرصة عادلة للحصول على مقعد تدريبي في مرحلة مبكرة من إجراءات القبول.",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Application Fee:",
                                      text_ar: "رسوم تقديم الطلب:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "630 AED non-refundable application and processing fee.",
                                      text_ar:
                                        "630درهماً رسوم تقـــديم ومراجعة الطلب غير مستردة",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "To register for the residency training programme during the registration period, please click on the following link: ",
                                          text_ar:
                                            "للتسجيل في برنامج التدريب (الإقامة) خلال فترة التسجيل اضغط على الرابط التالي: ",
                                          classname:
                                            "body text-onSurfaceVarient inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "Click here to apply",
                                          text_ar: "اضغط هنا للتقديم",
                                          classname:
                                            "hover:underline text-primary underlined inline",
                                          href: "https://mawaheb.dha.gov.ae/admin/servicesByCategory/3",
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      ],
                                    },

                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "For further enquiries or in case of any technical issues, please contact us through the following channels:",
                                      text_ar:
                                        "لمزيد من الاستفسارات، أو في حال وجود أي مشكلات تقنية، يُرجى التواصل عبر القنوات التالية:",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Email: ",
                                          text_ar: "البريد الإلكتروني: ",
                                          classname:
                                            "body text-onSurfaceVariant inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: " info@dha.gov.ae",
                                          text_ar: " info@dha.gov.ae",
                                          classname: "text-primary inline",
                                          href: "mailto::info@dha.gov.ae",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Contact no: ",
                                          text_ar: "الهاتف: ",
                                          classname:
                                            "body text-onSurfaceVariant inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "800342",
                                          text_ar: "800342",
                                          classname: "text-primary inline",
                                          href: "tel:+971800342",
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname: "",
                          children: [
                            {
                              _id: "block2",
                              type: "tabcontent",
                              isShow_title: false,
                              linker: "medical_control",
                              linker_ar: "medical_control",
                              title: "Fellowship programme",
                              title_ar: "برنامج الزمالة",
                              size: "h2",
                              classname: "dda-table-container",
                              children: [
                                {
                                  _id: "block1",
                                  type: "div",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Fellowship programmes in the private healthcare sector of the Emirate of Dubai, under the supervision of the Dubai Health Authority, offer advanced training for physicians holding a specialty certificate (residency). The aim is to enhance their skills, deepen their expertise in highly specialised fields, and prepare them to assume leadership roles in healthcare. Fellows train under the guidance of distinguished experts and specialists, with extensive opportunities to engage in diverse clinical experiences that enrich their professional competencies. These programmes are designed to keep pace with the rapid developments in the healthcare sector and to prepare medical professionals capable of achieving excellence and success in their careers.",
                                      text_ar:
                                        "توفر برامج الزمالة في القطاع الصحي الخاص بإمارة دبي، بإشراف هيئة الصحة بدبي، تدريبًا متقدمًا موجّهًا للأطباء الحاصلين على شهادة الاختصاص (الإقامة)، بهدف تنمية مهاراتهم وتعميق خبراتهم في تخصصات دقيقة، وتأهيلهم لتولي أدوار قيادية في مجال الرعاية الصحية. ويتم تدريب أطباء الزمالة تحت إشراف نخبة من الخبراء والمختصين، مع إتاحة فرص واسعة لخوض تجارب سريرية متنوعة تثري كفاءاتهم المهنية. وقد تم تصميم هذه البرامج لمواكبة التطورات السريعة في القطاع الصحي، وإعداد كوادر طبية قادرة على تحقيق التميز والنجاح في مسيرتهم المهنية.",
                                      classname: "body mb-4",
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Programme Summery",
                                        header_text_ar: "نبذه عن البرامج",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "list-decimal list-inside space-y-3 text-onSurfaceVariant  *:mb-3 lg:!pe-4",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Reproductive Medicine",
                                              text_ar:
                                                "طب الإخصاب والمساعدة على الحمل",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Addiction medicine",
                                              text_ar: "علاج الإدمان",
                                              classname: "",
                                            },
                                          ],
                                        },
                                      ],
                                    },

                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Programme Timeline",
                                        header_text_ar: "الجدول الزمني",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "dda-table-container",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "overflow-x-auto",
                                              children: [
                                                {
                                                  _id: "table1",
                                                  type: "table",
                                                  classname:
                                                    "dda-table w-full min-w-[650px]",
                                                  children: [
                                                    {
                                                      _id: "table_body",
                                                      type: "tableItems",
                                                      type_identifier: "tbody",
                                                      classname: "body",
                                                      children: [
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Registration Opens",
                                                                  text_ar:
                                                                    "فتح باب التسجيل",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "January",
                                                                  text_ar:
                                                                    "يناير",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Registration Closes",
                                                                  text_ar:
                                                                    "إغلاق باب التسجيل",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "March",
                                                                  text_ar:
                                                                    "مارس",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Speciality Interviews",
                                                                  text_ar:
                                                                    "المقابلات التخصصية",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "May",
                                                                  text_ar:
                                                                    "مايو",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Matching Process",
                                                                  text_ar:
                                                                    "إجراءات المطابقة",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "June",
                                                                  text_ar:
                                                                    "يونيو",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Announcement of Accepted Candidates",
                                                                  text_ar:
                                                                    "الإعلان عن أسماء المقبولين",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "August",
                                                                  text_ar:
                                                                    "أغسطس",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Start of Academic Year",
                                                                  text_ar:
                                                                    "بداية العام الأكاديمي",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "October",
                                                                  text_ar:
                                                                    "أكتوبر",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Acceptance Criteria",
                                        header_text_ar: "معايير القبول",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h3",
                                          text: "Academic Criteria",
                                          text_ar: "المعايير الأكاديمية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Candidates must be board-certified at Tier One or Tier Two level to be considered for the Fellowship programme.",
                                              text_ar:
                                                "يجب أن يكون المرشح حاصلاً على شهادة البورد من المستوى الأول أو المستوى الثاني ليتم النظر في قبوله ببرنامج الزمالة.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Candidates must be board-certified in their main specialty by the beginning of the programme academic year.",
                                              text_ar:
                                                "يشترط الحصول على شهادة البورد في التخصص الرئيسي قبل بداية السنة الأكاديمية للبرنامج.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Typically, candidates should not have been out of clinical practice for more than 24 months at any point (excluding national service for UAE nationals or interruptions due to COVID-19).",
                                              text_ar:
                                                "يجب ألا يكون المرشح قد انقطع عن الممارسة السريرية لأكثر من 24 شهرًا في أي وقت (باستثناء الخدمة الوطنية لمواطني دولة الإمارات)، أو الانقطاع بسبب جائحة كوفيد-19).",
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Note: ",
                                          text_ar: "ملاحظة: ",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Admitted candidates must have passed the clinical board examination (OSCE) of their main specialty in order to enrol in the fellowship programme.",
                                              text_ar:
                                                "يجب على المرشحين المقبولين اجتياز امتحان البورد السريري (OSCE) للتخصص الرئيسي، من أجل الالتحاق ببرنامج الزمالة.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Candidates will join the programme as full-time trainees. Concurrent enrolment in more than one postgraduate programme is not permitted.",
                                              text_ar:
                                                "سينضم المرشحون إلى البرنامج كمتدربين بدوام كامل، ولن يُسمح بالجمع بين أكثر من برنامج دراسات عليا في آن واحد.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Enrollment in the programme is subject to successful completion of the Dubai Health Authority (DHA) licensing process.",
                                              text_ar:
                                                "يشترط الالتحاق بالبرنامج استكمال إجراءات الترخيص بنجاح من هيئة الصحة بدبي (DHA).",
                                              classname: "",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "English Criteria",
                                        header_text_ar: "معايير اللغة",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "For candidates who completed their residency in non-English-speaking health systems, one of the following English proficiency exams or their equivalent is required: ",
                                          text_ar:
                                            "للمرشحين الذين أتمّوا برنامج الإقامة في أنظمة صحية لا تعتمد اللغة الإنجليزية، يشترط تقديم أحد اختبارات الكفاءة في اللغة الإنجليزية التالية أو ما يعادلها: ",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "IELTS Academic",
                                          text_ar: "IELTS Academic",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Overall score of 6",
                                              text_ar: "معدل عام لا يقل عن 6.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "A single certificate must be submitted; combined scores are not accepted",
                                              text_ar:
                                                "يجب تقديم شهادة واحدة فقط؛ ولن تُقبل الدرجات المجمّعة.",
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "TOEFL iBT",
                                          text_ar: "TOEFL iBT",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Minimum score of 80",
                                              text_ar: "حد أدنى 80 درجة.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "PBT is not accepted",
                                              text_ar:
                                                "لن يتم قبول اختبار الـ PBT.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `‘My Best Scores’ will not be considered for admission purposes`,
                                              text_ar: `لن تؤخذ نتائج "My Best Scores" في الاعتبار لأغراض القبول.`,
                                              classname: "",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Required Documents",
                                        header_text_ar: "المستندات المطلوبة",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Identification Documents",
                                          text_ar: "المستندات الشخصية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Recent coloured photo (high-resolution format)",
                                              text_ar:
                                                "صورة شخصية ملونة حديثة (بجودة عالية).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Valid passport copy (for UAE nationals, please include the Ethbara page as well)",
                                              text_ar:
                                                "نسخة من جواز السفر ساري المفعول (للمواطنين الإماراتيين تُرفق أيضًا صفحة الإثبات).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Emirates ID card (if applicable)",
                                              text_ar:
                                                "بطاقة الهوية الإماراتية (إن وجدت).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Family Book (UAE nationals only) / Mother’s Family Book (for children of UAE national mothers)",
                                              text_ar:
                                                "خلاصة القيد (للمواطنين الإماراتيين فقط) / خلاصة قيد الأم (لأبناء المواطنات).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Valid Marsoom letter (for Marsoom holders only)",
                                              text_ar:
                                                "رسالة مرسوم سارية (لحاملي المرسوم فقط).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Residency permit (if applicable)",
                                              text_ar:
                                                "تصريح الإقامة (إن وجد).",
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Academic Documents",
                                          text_ar: "المستندات الأكاديمية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Copy of Board Certificate if available, or a Certificate of Completion of an accredited residency programme",
                                              text_ar:
                                                "نسخة من شهادة البورد (إن وجدت) أو شهادة إتمام برنامج الإقامة المعتمد.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Transcript from the training centre or Programme Director (if available)",
                                              text_ar:
                                                "كشف درجات من مركز التدريب، أو من مدير البرنامج (إن وجد).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Results of English Proficiency Test (attained within the last 2 years), if applicable`,
                                              text_ar: `نتيجة اختبار الكفاءة في اللغة الإنجليزية (تم الحصول عليها خلال آخر سنتين) – إن وجدت.`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Two recommendation letters (each dated within the last year)`,
                                              text_ar: `2 خطاب توصية يجب أن يكون مؤرخًا خلال أقل من سنة).`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Copy of curriculum vitae`,
                                              text_ar: `نسخة من السيرة الذاتية.`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Valid professional licence`,
                                              text_ar: `ترخيص مهني ساري المفعول.`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Employment letter (if applicable)`,
                                              text_ar: `خطاب عمل (إن وجد).`,
                                              classname: "",
                                            },

                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `No Objection Letter from employer to join the training programme as full-time (if applicable).`,
                                              text_ar: `خطاب عدم ممانعة من جهة العمل للالتحاق بالبرنامج التدريبي بدوام كامل (إن وجد).`,
                                              classname: "",
                                            },

                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Undergraduate Degree Certificate. A notarised English translation of documents originally in a language other than Arabic or English is required.`,
                                              text_ar: `شهادة البكالوريوس. (يشترط تقديم ترجمة موثقة باللغة الإنجليزية إذا كانت الوثائق الأصلية بلغة غير العربية أو الإنجليزية).`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Undergraduate Academic Transcript. A notarised English translation of documents originally in a language other than Arabic or English is required.`,
                                              text_ar: `كشف الدرجات لمرحلة البكالوريوس. (يشترط تقديم ترجمة موثقة باللغة الإنجليزية إذا كانت الوثائق الأصلية بلغة غير العربية أو الإنجليزية).`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Internship Certificate`,
                                              text_ar: `شهادة الامتياز.`,
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Note: ",
                                          text_ar: "ملاحظة: ",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Candidates must be board-certified at Tier One or Tier Two level to be considered for the Fellowship programme.",
                                          text_ar:
                                            "يجب أن يكون المرشح حاصلاً على شهادة البورد من المستوى الأول أو المستوى الثاني، ليتم النظر في قبوله في برنامج الزمالة.",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Selection Process",
                                        header_text_ar: "إجرءات القبول",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "An application will be considered complete once all required documents are successfully submitted through the online portal and the application fee is paid. The selection process will include the following three phases: ",
                                          text_ar:
                                            "سيُعتبر الطلب مكتملاً عند تقديم جميع المستندات المطلوبة بنجاح عبر البوابة الإلكترونية، وسداد رسوم التقديم. وتشمل عملية الاختيار المراحل الثلاث التالية: ",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Phase 1: Shortlisting",
                                          text_ar:
                                            "المرحلة الأولى: التصفية الأولية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "All completed applications will be reviewed and scored according to the following criteria: ",
                                          text_ar:
                                            "سيتم مراجعة جميع الطلبات المكتملة وتقييمها وفقًا لما يلي: ",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Years since medical school completion (including internship)",
                                              text_ar:
                                                "عدد السنوات منذ التخرج من كلية الطب (بما في ذلك سنة الامتياز).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Letters of recommendation",
                                              text_ar: "خطابات التوصية.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Curriculum vitae (CV)",
                                              text_ar: "السيرة الذاتية.",
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Phase 2: Specialty Interview",
                                          text_ar:
                                            "المرحلة الثانية: المقابلة التخصصية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Qualified shortlisted candidates will be invited via email for on-site specialty interviews. Unsuccessful candidates will be notified at that time with a regret letter.",
                                          text_ar:
                                            "سيتم دعوة المرشحين المؤهلين ضمن قائمة التصفية النهائية، عبر البريد الإلكتروني لإجراء المقابلات التخصصية في بينما سيتم إخطار المرشحين غير المقبولين في ذلك الوقت برسالة اعتذار.",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Phase 3: Ranking & Offering",
                                          text_ar:
                                            "المرحلة الثالثة: التصنيف وتقديم العروض",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Candidates who complete the specialty interviews will be ranked based on the interview outcome. <br /> Accordingly, they will be informed via email of their admission decision after the Cross Match.",
                                          text_ar:
                                            "سيتم تصنيف المتقدمين الذين أنهوا المقابلة التخصصية، بناءً على نتائج هذه المقابلة. وبناءً على ذلك، سيتم إبلاغهم بقرار القبول عبر البريد الإلكتروني بعد عملية المطابقة النهائية (Cross Match).",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Application Fee: ",
                                          text_ar: "رسوم تقديم الطلب: ",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "AED 630 – non-refundable application and review fee.",
                                          text_ar:
                                            "630درهماً رسوم تقـــديم ومراجعة الطلب غير مستردة.",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "div",
                                          classname:
                                            "body text-onSurfaceVariant",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: "To register for the residency training programme during the registration period, please click on the following link: ",
                                              text_ar:
                                                "للتسجيل في برنامج التدريب (الإقامة)، خلال فترة التسجيل اضغط على الرابط التالي: ",
                                              classname:
                                                "body text-onSurfaceVariant inline",
                                            },
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "Click here to apply",
                                              text_ar: "اضغط هنا للتقديم",
                                              classname:
                                                "hover:underline text-primary underlined inline",
                                              href: "https://mawaheb.dha.gov.ae/admin/servicesByCategory/3",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                          ],
                                        },

                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "For further enquiries or in case of any technical issues, please contact us through the following channels:",
                                          text_ar:
                                            "لمزيد من الاستفسارات، أو في حال وجود أي مشكلات تقنية، يُرجى التواصل عبر القنوات التالية:",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "div",
                                          classname:
                                            "body text-onSurfaceVariant",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: "Email: ",
                                              text_ar: "البريد الإلكتروني: ",
                                              classname:
                                                "body text-onSurfaceVariant inline",
                                            },
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: " info@dha.gov.ae",
                                              text_ar: " info@dha.gov.ae",
                                              classname: "text-primary inline",
                                              href: "mailto::info@dha.gov.ae",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "div",
                                          classname:
                                            "body text-onSurfaceVariant",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: "Contact no: ",
                                              text_ar: "الهاتف: ",
                                              classname:
                                                "body text-onSurfaceVariant inline",
                                            },
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "800342",
                                              text_ar: "800342",
                                              classname: "text-primary inline",
                                              href: "tel:+971800342",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Sponsorship Programme Medicine & Science",
              title_ar: "برنامج الرعاية الدراسية (طب وعلوم)",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: "The Dubai Health Authority offers a scholarship programme dedicated to Emirati students, including high school graduates and university students, with the aim of supporting their studies in health-related disciplines within the United Arab Emirates.",
                  text_ar:
                    "تُقدِّم هيئة الصحة بدبي برنامجًا للمنح الدراسية، مخصصًا للطلبة المواطنين من خريجي الثانوية العامة وطلبة الجامعات، بهدف دعم دراستهم في التخصصات الصحية داخل دولة الإمارات العربية المتحدة.",
                  classname: "md:!my-4 my-2 Medium text-onSurfaceVariant",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: "The programme aims to empower and qualify national cadres in vital health fields, in alignment with the needs of the healthcare sector in the Emirate.",
                  text_ar:
                    "يهدف البرنامج إلى تمكين الكوادر الوطنية، وتأهيلها في المجالات الصحية الحيوية، بما يواكب احتياجات القطاع الصحي في الإمارة.",
                  classname: "md:!my-4 my-2 Medium text-onSurfaceVariant",
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",
                    header_text: "Timeline: ",
                    header_text_ar: "الجدول الزمني: ",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "dda-table-container",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "overflow-x-auto",
                          children: [
                            {
                              _id: "table1",
                              type: "table",
                              classname: "dda-table w-full min-w-[650px]",
                              children: [
                                {
                                  _id: "table_body",
                                  type: "tableItems",
                                  type_identifier: "tbody",
                                  classname: "body",
                                  children: [
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Registration Opens",
                                              text_ar: "فتح باب التسجيل",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "1st May",
                                              text_ar: "1 مايو",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Registration Closes",
                                              text_ar: "إغلاق باب التسجيل",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "31st May",
                                              text_ar: "31 مايو",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Personal Interviews",
                                              text_ar: "المقابلات الشخصية",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "July",
                                              text_ar: "يوليو",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Announcement of Accepted Candidates and Contract Signing",
                                              text_ar:
                                                "الإعلان عن أسماء المقبولين وتوقيع العقود",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "August",
                                              text_ar: "أغسطس",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Start of Academic Year",
                                              text_ar: "بداية العام الأكاديمي",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "August – September",
                                              text_ar: "أغسطس-سبتمبر",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",
                    header_text: "The Approved Health Specialisations: ",
                    header_text_ar: "التخصصات الصحية المعتمدة: ",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Medicine and Surgery",
                          text_ar: "الطب والجراحة",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Para Medical, which includes: Laboratories, Radiology, Pharmacy, Physiotherapy, Nutrition, Public Health, Psychology, Biomedical Engineering",
                          text_ar:
                            "الطب المساند: المختبرات، والأشعة، والصيدلة، والعلاج الطبيعي، والتغذية، والصحة العامة، وعلم النفس، والهندسة الطبية الحيوية.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Technical Specialties, including but not limited to: Optometry, Speech & Hearing, Anaesthesia Technologist, Respiratory Therapist, Ultrasound Technician (Ultrasonographic)",
                          text_ar:
                            "التخصصات الفنية على سبيل المثال لا الحصر: تصحيح البصر، والنطق والسمع، وتقني تخدير، وتقني المعالجة التنفسية، وتقني تخطيط الصدى.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Nursing and Midwifery",
                          text_ar: "التمـريض والقبالة",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",

                    header_text: "Eligibility Criteria",
                    header_text_ar: "شروط التقديم",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "The applicant must be a UAE national (holding a valid Khulasat Al-Qaid).",
                          text_ar:
                            "أن يكون المتقدم من مواطني دولة الإمارات العربية المتحدة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "The applicant must be a high school graduate and meet the required percentage for the specialisation, applicable to high school graduates: ",
                          text_ar:
                            "إذا كان المتقدم طالباً خريج الثانوية العامة بالنسبة المئوية المطلوبة للتخصص، لخريجي الثانوية العامة",
                          classname: "",
                          children: [
                            {
                              _id: "block3",
                              type: "div",
                              classname: "mx-3",
                              children: [
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "ul",
                                  classname:
                                    "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "li",
                                      text: "Medicine and Surgery: 90%",
                                      text_ar: "الطب والجراحة 90%.",
                                      classname: "",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "li",
                                      text: "Para Medical: 80%",
                                      text_ar: "الطب المساند80 %.",
                                      classname: "",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "li",
                                      text: "Nursing and Midwifery: 80%",
                                      text_ar: "التمـريض والقبالة 80%.",
                                      classname: "",
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "If the applicant is a university student, they must have a cumulative GPA of no less than 2.5.",
                          text_ar:
                            "إذا كان المتقدم طالباً جامعياً يجب أن يكون حاصلاً على معدل تراكمي لا يقل عن GPA 2.5  ",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "High school certificates must be no older than 2 years for females and 3 years for males (for students who have paused their studies)",
                          text_ar:
                            "أن لا يكون قد مضى على شهادة الثانوية العامة، مدة سنتين للإناث وثلاث سنوات للذكور (للطلاب المتوقفين عن الدراسة).",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "The applicant must have received academic admission from a recognised institution in the UAE.",
                          text_ar:
                            "الحصول على القبول الأكاديمي من الجهة الأكاديمية (جامعة، كلية)، معتمدة من التعليم العالي في دولة الإمارات العربية المتحدة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "The applicant must be medically fit.",
                          text_ar: "أن يكون المتقدم لائقاً صحياً.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Males must have completed National Service or provide a valid certificate of postponement or exemption.",
                          text_ar:
                            "أن يكون المتقدم قد انتهى من متطلبات الخدمة الوطنية، أو إبراز شهادة سارية المفعول تفيد بتأجيل الدورة أو الإعفاء منها (للذكور فقط).",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",

                    header_text: "Required Documents:",
                    header_text_ar: "المستندات المطلوبة",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h4",
                      text: "Identification Documents",
                      text_ar: "المستندات الشخصية",
                      classname: "body text-primary",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Recent personal photo.",
                          text_ar: "صورة شخصية حديثة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Copy of a valid Emirates ID card (both sides).",
                          text_ar:
                            "صورة عن بطاقة الهوية الإماراتية من الجهتين سارية المفعول.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Copy of the birth certificate.",
                          text_ar: "صورة شهادة الميلاد.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Copy of a valid passport, including the unified number page.",
                          text_ar:
                            "صورة عن جواز السفر ساري المفعول، مع صورة من صفحة الرقم الموحد.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Copy of the full family book.",
                          text_ar: "صورة عن خلاصة القيد كاملة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Recent Police Clearance Certificate.",
                          text_ar:
                            "شهادة حسن السيرة والسلوك، صادرة من الشرطة (حديثة).",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",

                    header_text: "Academic Documents",
                    header_text_ar: "المسندات الأكاديمية",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "High School Certificate, if issued within the country, certified by the Ministry of Education or by the Knowledge and Human Development Authority (KHDA).",
                          text_ar:
                            "شهادة الثانوية العامة إذا كانت صادرة في الدولة، ومصدقة من وزارة التربية والتعليم، أو مصدقة من هيئة المعرفة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Letter of preliminary or final university acceptance issued by the university.",
                          text_ar:
                            "رسالة بالقبول المبدئي/ النهائي الجامعي، صادر من الجامعة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Certified copy of the university cumulative average (transcript), if the applicant is affiliated with an academic institution.",
                          text_ar:
                            "صورة مصدقة من المعدل التراكمي الجامعي (Transcript) ، إذا كان المتقدم منتسباً لإحدى المؤسسات الأكاديمية.",
                          classname: "",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: "Benefits: ",
                      text_ar: "المميزات",
                      classname: "body",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Full coverage of tuition fees.",
                          text_ar: "تغطية كامل الرسوم الدراسة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Monthly allowance.",
                          text_ar: "مكافأة شهرية.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "One-time allowance for a computer during the sponsorship period.",
                          text_ar: "بدل حاسب آلي لمرة واحدة خلال مدة الرعاية.",
                          classname: "",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "div",
                      classname: "body text-onSurfaceVariant",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "To register for the sponsorship programme in Medicine and Sciences during the registration period, please click the following link: ",
                          text_ar:
                            "للتسجيل في برنامج طب وعلوم خلال فترة التسجيل اضغط على الرابط التالي: ",
                          classname: "body text-onSurfaceVarient inline",
                        },
                        {
                          _id: "block3",
                          type: "linking",
                          text: "Click here to apply",
                          text_ar: "اضغط هنا للتقديم",
                          classname:
                            "hover:underline text-primary underlined inline",
                          href: "https://mawaheb.dha.gov.ae/admin/servicesByCategory/3",
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h4",
                      text: "For further enquiries or in case of any technical issues, please contact us through the following channels: ",
                      text_ar:
                        "لمزيد من الاستفسارات، أو في حال وجود أي مشكلات تقنية، يُرجى التواصل عبر القنوات التالية: ",
                      classname: "body text-primary",
                    },
                    {
                      _id: "block3",
                      type: "div",
                      classname: "body text-onSurfaceVariant",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Email: ",
                          text_ar: "البريد الإلكتروني: ",
                          classname: "body text-onSurfaceVariant inline",
                        },
                        {
                          _id: "block3",
                          type: "linking",
                          text: " info@dha.gov.ae",
                          text_ar: " info@dha.gov.ae",
                          classname: "text-primary inline",
                          href: "mailto::info@dha.gov.ae",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "div",
                      classname: "body text-onSurfaceVariant",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Contact no: ",
                          text_ar: "الهاتف: ",
                          classname: "body text-onSurfaceVariant inline",
                        },
                        {
                          _id: "block3",
                          type: "linking",
                          text: "800342",
                          text_ar: "800342",
                          classname: "text-primary inline",
                          href: "tel:+971800342",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],

  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Medical Education",
      icon: "home",
      url: "/medicalEducationAndResearch/medicalEducation",
    },
    {
      text: "medical_education", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/medicalEducationAndResearch/medicalEducation",
    },
  ],
};
const RendererJSONS = {
  _id: "mypage",
  title: "Medical Education",
  title_ar: "Medical Education",
  slug: "about-us",
  layout: "default",
  metaTitle: "Medical Education",
  metaDescription: "Medical Education",
  metaKeywords: "",
  seoImageUrl: "",
  blocks: [
    {
      _id: "f8f88ba2-505c-48d3-969a-49eb26863aeb",
      type: "dda-breadcrumb",
      breadCrumb_item: [
        { text: "Home", icon: "home", url: "/" },
        {
          text: "Medical Education",
          text_ar: "Medical EducationAR",
          icon: "home",
          url: "/medicalEducationAndResearch/medicalEducation",
        },
        {
          text: "medical_education", //linker text to identify which linker to use
          useLinker: true,
          icon: "menu_book",
          url: "/medicalEducationAndResearch/medicalEducation",
        },
      ],
    },
    {
      _id: "block1",
      type: "div",
      classname: "container",
      children: [
        {
          _id: "block3",
          type: "heading",
          size: "h2",
          text: "Medical Education",
          text_ar: "التعليم الطبي",
          classname: "md:!my-4 my-2 Medium text-primary",
        },
        {
          _id: "block3",
          type: "paragraph",
          size: "normal",
          text: "At the Dubai Health Authority, we are committed to delivering advanced, accredited internship, residency, and fellowship programmes that meet the needs of the national medical workforce and support their professional growth in response to the rising demand for specialised healthcare professionals. <br /> Our programmes follow well-established international standards, creating a modern and stimulating educational environment that equips trainees to become competent, healthcare practitioners. They are aligned with nationally and internationally recognised training frameworks, including the National Institute for Health Specialties (NIHS), the Accreditation Council for Graduate Medical Education (ACGME), and the Arab Board of Health Specialisations (ABHS). <br /> We emphasise competency-based training through a structured approach that integrates research, clinical simulation, and soft skills development.  The training process is further supported effective progress tracking, programme evaluation, and continuous quality assurance for medical education at the Authority.",
          text_ar:
            "في هيئة الصحة بدبي، نحرص على توفير برامج تدريبية متقدمة ومعتمدة في مجالي الامتياز والإقامة والزمالة، تلبي احتياجات الكوادر الطبية الوطنية، وتدعم تطورها المهني، في ظل الطلب المتزايد على الكفاءات الصحية المتخصصة. <br /> تعتمد برامجنا على معايير عالمية راسخة، وتركّز على بناء بيئة تعليمية حديثة ومحفّزة، تُعزز من قدرات الأطباء المتدربين، ليصبحوا ممارسين صحيين مؤهلين. تم تصميم البرامج وفقاً لأطر تدريبية معتمدة دولياً ومحلياً، من: المعهد الوطني للتخصصات الصحية NIHS، والمجلس الأمريكي للتعليم العالي ACGME، والمجلس العربي للاختصاصات الصحية، حيث تستند هذه البرامج إلى مبدأ التدريب المبني على الكفاءة، ضمن منهجية منظمة ومتكاملة، تشمل: البحث العلمي، والمحاكاة السريرية، وتطوير المهارات الشخصية. <br /> كما يتم دعم العملية التدريبية، من خلال متابعة تقدم المتدربين، وتقييم فعالية البرامج، وضمان جودة مخرجات التعليم الطبي المستمر في الهيئة.",
          classname: "md:!my-4 my-2 Medium text-onSurfaceVariant",
        },
        {
          _id: "block1",
          type: "dda-tabs",
          linker: "medical_education", //for dynamic breadcrumbs
          linker_ar: "medical_education", //for dynamic breadcrumbs
          view: "primary-card",
          props: {
            type: "text",
            hover_style: "dda-tab-underline-filled",
            custom_class: "mb-5",
            component_mode: "",
            button_id: "button",
            aria_label: "tabs",
            onclick: "alert()",
            button_name: "button",
            button_name_ar: "button",
          },
          children: [
            {
              _id: "block2",
              type: "tabcontent",
              title: "Dubai Residency Training Programme",
              title_ar: "برنامج دبي التدريبي للتخصصات الطبية",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [
                {
                  _id: "block1",
                  type: "div",
                  classname: "lg:flex gap-5",
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-1/5",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname:
                            "lg:overflow-y-none overflow-y-auto lg:max-h-none max-h-[250px]",
                          children: [
                            {
                              _id: "block100",
                              type: "dda-tabs",
                              view: "primary-card",
                              linker: "medical_control",
                              linker_ar: "medical_control",
                              props: {
                                type: "text",
                                hover_style: "dda-tab-underline-filled",
                                custom_class: "",
                                component_mode: "",
                                button_id: "button",
                                aria_label: "tabs",
                                onclick: "alert()",
                                tab_type: "dda-vertical-tab",
                                button_name: "button",
                                button_name_ar: "button",
                              },
                              children: [
                                {
                                  title: "Internship Programme",
                                  title_ar: "برنامج الامتياز",
                                },
                                {
                                  title: "Residency Programme",
                                  title_ar: "برنامج الإقامة",
                                },
                                {
                                  title: "Fellowship programme",
                                  title_ar: "برنامج الزمالة",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      _id: "block1",
                      type: "div",
                      classname: "lg:w-4/5",
                      children: [
                        {
                          _id: "block2",
                          type: "tabcontent",
                          isShow_title: false,
                          linker: "medical_control",
                          linker_ar: "medical_control",
                          title: "Internship Programme",
                          title_ar: "برنامج الامتياز",
                          size: "h2",
                          classname: "dda-table-container",
                          children: [
                            {
                              _id: "block1",
                              type: "div",
                              classname: "",
                              children: [
                                {
                                  _id: "block3",
                                  type: "paragraph",
                                  size: "normal",
                                  text: "As part of the Dubai Health Authority’s strategy to support the healthcare workforce, the Internship Programme offers a one-year clinical training opportunity for graduates of nationally and internationally recognised medical and dental schools. The programme aims to facilitate the transition from academic education to practical application under the supervision of consultants across various specialties, thereby enhancing clinical skills and ensuring continuity of patient care. <br /> Our programmes provide aspiring physicians and dentists with valuable hands-on experience, the opportunity to refine their clinical competencies, and the chance to work alongside distinguished faculty members in a supportive environment. Interns are exposed to a wide range of specialties and clinical settings, enabling them to explore their interests and build a solid foundation for a successful career in healthcare.",
                                  text_ar:
                                    "انطلاقاً من استراتيجية هيئة الصحة بدبي في دعم الكوادر الصحية، يوفر برنامج الامتياز تدريباً عملياً لمدة عام لخريجي كليات الطب البشري، وطب الأسنان المعترف بها محلياً ودولياً، بهدف تأهيلهم للانتقال من التعليم الأكاديمي إلى التطبيق العملي تحت إشراف استشاريين في مختلف التخصصات، بما يعزز مهاراتهم السريرية، ويضمن استمرارية الرعاية الطبية. وتتيح برامجنا للأطباء الطموحين فرصة اكتساب خبرة عملية قيّمة، وصقل مهاراتهم السريرية، والعمل جنباً إلى جنب مع أعضاء هيئة تدريس مرموقين في بيئة داعمة. كما يُتاح للمتدربين في كل من الطب وطب الأسنان، استكشاف مجموعة متنوعة من التخصصات والبيئات السريرية، مما يساعدهم على تحديد اهتماماتهم وبناء أسس قوية لمسيرة مهنية ناجحة في مجال الرعاية الصحية.",
                                  classname: "body mb-4",
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Medical Internship",
                                    header_text_ar: "الامتياز في الطب العام",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Programme Summery",
                                      text_ar: "نبذه عن البرنامج",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Duration: 12 months",
                                          text_ar: "المدة: 12 شهراً.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Training Capacity: 145 seats",
                                          text_ar:
                                            "السعة التدريبية: 145 مقعداً تدريبياً.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Accreditation: National Institute for Health Specialties",
                                          text_ar:
                                            "الاعتماد: المعهد الوطني للتخصصات الصحية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Training Sites: 17 training sites accredited by DHA.",
                                          text_ar:
                                            "المراكز التدريبية: 17 مستشفى معتمد من قبل هيئة الصحة في دبي",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text:
                                      "Academic Curriculum for Medical Internship",
                                    header_text_ar:
                                      "المنهج الأكاديمي للطب العام",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "dda-table-container",
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "overflow-x-auto",
                                          children: [
                                            {
                                              _id: "table1",
                                              type: "table",
                                              classname:
                                                "dda-table w-full min-w-[650px]",
                                              children: [
                                                {
                                                  id: "table_header",
                                                  type: "tableItems",
                                                  type_identifier: "thead",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "rounded-xl",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "Department",
                                                          text_ar: "الأقسام",
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "Specialty",
                                                          text_ar: "التخصص",
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "Training Duration",
                                                          text_ar:
                                                            "مدة التدريب",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "table_body",
                                                  type: "tableItems",
                                                  type_identifier: "tbody",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          colSpan: "",
                                                          rowSpan: "4",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Medical Divisions",
                                                              text_ar: "الطبية",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Internal Medicine",
                                                              text_ar:
                                                                "الطب الباطني",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "2 months",
                                                              text_ar: "شهرين",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Paediatrics",
                                                              text_ar:
                                                                "طب الأطفال",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "2 months",
                                                              text_ar: "شهرين",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Psychiatry",
                                                              text_ar:
                                                                "الطب النفسي",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1 month",
                                                              text_ar: "شهر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Family Medicine",
                                                              text_ar:
                                                                "طب الأسرة",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1 month",
                                                              text_ar: "شهر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          colSpan: "",
                                                          rowSpan: "3",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Surgical Divisions",
                                                              text_ar:
                                                                "الأقسام الجراحية",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "General Surgery",
                                                              text_ar:
                                                                "الجراحة العامة",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "2 months",
                                                              text_ar: "شهرين",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Obstetrics and Gynaecology",
                                                              text_ar:
                                                                "التوليد وأمراض النساء",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1 month",
                                                              text_ar: "شهر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Emergency",
                                                              text_ar:
                                                                "طب الطوارئ",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1 month",
                                                              text_ar: "شهر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          colSpan: "2",
                                                          rowSpan: "",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Elective",
                                                              text_ar:
                                                                "اختياري",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "3 Months in various specialties",
                                                              text_ar:
                                                                "3 شهور في تخصصات مختلفة",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Dental Internship",
                                    header_text_ar: "الامتياز في طب الاسنان",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Programme Summery",
                                      text_ar: "نبذه عن البرنامج",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Duration: 12 months",
                                          text_ar: "المدة: 12 شهراً.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Training Capacity: 145 seats",
                                          text_ar:
                                            "السعة التدريبية: 145 مقعداً تدريبياً.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Training Sites: 7 training sites accredited by DHA.",
                                          text_ar:
                                            "المراكز التدريبية: 7 منشئات صحية مرخصة من قبل هيئة الصحة معتمدة كمركز تدريبي لبرنامج الامتياز",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text:
                                      "Academic Curriculum for Dental Internship",
                                    header_text_ar:
                                      "المنهج الأكاديمي لطب الأسنان",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "dda-table-container",
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "overflow-x-auto",
                                          children: [
                                            {
                                              _id: "table1",
                                              type: "table",
                                              classname:
                                                "dda-table w-full min-w-[650px]",
                                              children: [
                                                {
                                                  id: "table_header",
                                                  type: "tableItems",
                                                  type_identifier: "thead",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "rounded-xl",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "#",
                                                          text_ar: "#",
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "th",
                                                          classname:
                                                            "Bold body",
                                                          text: "Specialty",
                                                          text_ar: "التخصص",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  _id: "table_body",
                                                  type: "tableItems",
                                                  type_identifier: "tbody",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "1",
                                                              text_ar: "1",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Endodontics",
                                                              text_ar:
                                                                "علاج جذور الأسنان (الاندودونتكس)",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "2",
                                                              text_ar: "2",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Orthodontics",
                                                              text_ar:
                                                                "تقويم الأسنان",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "3",
                                                              text_ar: "3",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Gum Disease",
                                                              text_ar:
                                                                "أمراض اللثة",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "4",
                                                              text_ar: "4",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Dental Implants (Prosthodontics)",
                                                              text_ar:
                                                                "التركيبات السنية (الاستعاضة السنية)",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "5",
                                                              text_ar: "5",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Paediatric Dentistry",
                                                              text_ar:
                                                                "طب أسنان الأطفال",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "6",
                                                              text_ar: "6",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Oral and Maxillofacial Surgery",
                                                              text_ar:
                                                                "جراحة الفم والوجه والفكين",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "7",
                                                              text_ar: "7",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "General Dentistry",
                                                              text_ar:
                                                                "عيادة طب الأسنان العام",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Programme timetable:",
                                    header_text_ar: "الجدول الزمني",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "dda-table-container",
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "overflow-x-auto",
                                          children: [
                                            {
                                              _id: "table1",
                                              type: "table",
                                              classname:
                                                "dda-table w-full min-w-[650px]",
                                              children: [
                                                {
                                                  _id: "table_body",
                                                  type: "tableItems",
                                                  type_identifier: "tbody",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Online Registration Opens",
                                                              text_ar:
                                                                "فتح باب التسجيل",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "February",
                                                              text_ar: "فبراير",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Registration Closes",
                                                              text_ar:
                                                                "إغلاق باب التسجيل",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "March",
                                                              text_ar: "مارس",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Interviews",
                                                              text_ar:
                                                                "المقابلات الشخصية",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "May",
                                                              text_ar: "مايو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Cross Match",
                                                              text_ar:
                                                                "التنسيق والمطابقة",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "June",
                                                              text_ar: "يونيو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Announcement of Acceptance Lists",
                                                              text_ar:
                                                                "الإعلان عن أسماء المقبولين",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Medical Internship – July Dental Internship – August",
                                                              text_ar:
                                                                "الطب البشري -يوليوطب الأسنان -أغسطس",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Commencement",
                                                              text_ar:
                                                                "بداية العام الأكاديمي",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Medical Internship: August Dental Internship: September",
                                                              text_ar:
                                                                "الطب البشري -أغسطس طب الأسنان -سبتمبر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Acceptance Criteria",
                                    header_text_ar: "معايير القبول",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Academic Criteria",
                                      text_ar: "المعايير الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Qualification – Bachelor’s degree or equivalent in Medicine or Dentistry from a recognized college listed in the WHO Directory of Approved Health Institutions.",
                                          text_ar:
                                            "شهادة بكالوريوس أو ما يعادلها في الطب أو طب الأسنان، من كلية معترف بها ومدرجة ضمن دليل منظمة الصحة العالمية (WHO)، للمؤسسات الصحية المعتمدة، بالإضافة إلى السجل الدراسي، موضحاً التقييم النهائي للمعدل التراكمي GPA، للطلاب الدارسين في دولة الإمارات العربية المتحدة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Graduation Timeline – Candidates should be within two years of graduating from medical or dental school.",
                                          text_ar:
                                            "يجب أن يكون المرشحون، قد تخرجوا من كلية الطب/طب الأسنان خلال عامين.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Medical Internship Only – IFOM Clinical Science Examination results are preferable.",
                                          text_ar:
                                            "يُفضل تقديم نتائج اختبار IFOM Clinical Science، وينطبق ذلك على برنامج الامتياز الطبي فقط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "International Graduates – For degrees awarded outside the UAE, an Educational Credential Evaluators (ECE) – General with Grade Average evaluation is required to standardize GPA. More information: ",
                                          text_ar:
                                            "الحصول على تقييم (ECE)، للخريجين الحاصلين على درجة علمية من خارج دولة الإمارات العربية المتحدة، للحصول على معدل تراكمي قياسي ",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "www.ece.org.",
                                              text_ar: "(http://www.ece.org)",
                                              classname:
                                                "hover:underline text-primary",
                                              href: "http://www.ece.org",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "English Language Proficiency",
                                    header_text_ar: "معايير اللغة الإنجليزية",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h6",
                                      text: "IELTS Academic:",
                                      text_ar: "أيلتس أكاديمي:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Minimum overall score: 6.0",
                                          text_ar: "درجة 6 أو أكثر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "A single test report is required; combined scores will not be accepted. ",
                                          text_ar:
                                            "يجب تقديم شهادة واحدة فقط، ولا تُقبل الدرجات المجمعة.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h6",
                                      text: "TOEFL iBT:",
                                      text_ar: "توفل TOEFL iBT:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Minimum score: 80",
                                          text_ar: "80 درجة أو أكثر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Paper-based TOEFL (PBT) is not accepted",
                                          text_ar: "لا يُقبل اختبار PBT.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h6",
                                      text: "EmSAT – English:",
                                      text_ar: "امسات إنجليزي:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Minimum score: 1525",
                                          text_ar: "1525أو أكثر.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Note:",
                                      text_ar: "ملاحظة:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Applicants are exempt from the English language certificate validity requirement. if they graduated from an educational institution within the UAE, or if, in the case of institutions outside the UAE, they provide an official letter from the university confirming that English was the language of instruction for their academic program.",
                                      text_ar:
                                        "يتم إعفاء المتقدمين من شرط صلاحية شهادة اللغة الإنجليزية، في حال تخرجهم من مؤسسة تعليمية داخل الدولة أو إرفاق خطاب رسمي من الجامعة يُؤكد أن لغة التدريس في البرنامج الأكاديمي كانت الإنجليزية للمؤسسات التعليمية خارج الدولة.",
                                      classname: "body mb-4",
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Portfolio Criteria",
                                    header_text_ar: "معايير الإنجازات",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "IFOM Clinical Science Exam",
                                          text_ar:
                                            "اختبار العلوم السريرية - IFOM Clinical Science Exam",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: For Medical Internship candidates only.",
                                                      text_ar:
                                                        "شروط الأهلية: مخصص فقط لمرشحي برنامج الامتياز الطبي.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted: Results released after the application submission deadline.",
                                                      text_ar:
                                                        "غير مقبول: النتائج التي تصدر بعد الموعد النهائي، لتقديم الطلبات لن تُقبل.",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research Activity",
                                          text_ar: "النشاط البحثي",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Examples: Writing a proposal, collecting data, analysing data, writing a manuscript, case study, etc.",
                                                      text_ar:
                                                        "أمثلة: كتابة مقترح بحثي، جمع البيانات، تحليل البيانات، كتابة مخطوطة، دراسة حالة، وغيرها.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: Must have occurred since entering medical or dental school (date must be indicated on the certificate).",
                                                      text_ar:
                                                        "الصلاحية: يجب أن يكون النشاط قد تم منذ الالتحاق بكلية الطب، أو طب الأسنان (يُشترط أن يكون تاريخ النشاط موضحًا في الشهادة).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publications",
                                          text_ar: "المنشورات العلمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Must be in a peer-reviewed journal (can be the same entry as the research activity).",
                                                      text_ar:
                                                        "شروط الأهلية: يجب أن تكون المنشورات في مجلة علمية مُحكمة. يمكن أن تكون نفس المنشورات ضمن النشاط البحثي.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted: Abstracts, thesis studies, or draft manuscripts.",
                                                      text_ar:
                                                        "الصلاحية: يجب أن تكون المنشورات قد تمت منذ الالتحاق بكلية الطب، أو طب الأسنان (يُشترط أن يكون التاريخ موضحًا).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Presentation at a Scientific Event",
                                          text_ar: "تقديم عرض في فعالية علمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Conference, symposium, workshop, etc.",
                                                  text_ar:
                                                    "أمثلة: مؤتمر، ندوة، ورشة عمل، إلخ.",
                                                  classname:
                                                    "text-onSurfaceVariant body",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-inside space-y-3 list-disc body",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Must be health-related",
                                                      text_ar:
                                                        "شروط الأهلية: يجب أن تكون الفعالية ذات صلة بالمجال الصحي.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted: Attendance certificates and presentations given during academic days or grand rounds at the university.",
                                                      text_ar:
                                                        "غير مقبول: شهادات الحضور، أو العروض المقدمة ضمن أيام أكاديمية أو جلسات داخل الجامعة.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: Must have occurred since entering medical or dental school (date must be indicated on the certificate).",
                                                      text_ar:
                                                        "الصلاحية: يجب أن يكون النشاط قد تم منذ الالتحاق بكلية الطب، أو طب الأسنان (مع ضرورة وجود التاريخ في الشهادة).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary Social / Community Activities",
                                          text_ar:
                                            "الأنشطة التطوعية الاجتماعية / المجتمعية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Examples: Participating in, organising, or speaking at a community engagement event. The activity must be health-related, such as health awareness campaigns.",
                                                      text_ar:
                                                        "أمثلة: المشاركة في تنظيم أو التحدث في فعالية مجتمعية توعوية صحية مثل حملات التوعية.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Activities must be organised or supervised by universities, official health associations, or government-licensed organisations.",
                                                      text_ar:
                                                        "شروط الأهلية: يجب أن تكون الأنشطة منظمة أو تحت إشراف الجامعات، جمعيات صحية رسمية، أو جهات حكومية مرخصة.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Target Audience: General public.",
                                                      text_ar:
                                                        "الفئة المستهدفة: عامة المجتمع.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: The activity must have taken place since entering medical/dental school, and the certificate/letter must indicate the date.",
                                                      text_ar:
                                                        "الصلاحية: يجب أن يكون النشاط قد تم منذ الالتحاق بكلية الطب، أو طب الأسنان (ويجب توضيح التاريخ في الشهادة أو الخطاب المرفق).",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted:",
                                                      text_ar: "غير مقبول: ",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "block1",
                                                          type: "div",
                                                          classname: "px-3",
                                                          children: [
                                                            {
                                                              _id: "block3",
                                                              type: "list",
                                                              type_identifier:
                                                                "ul",
                                                              classname:
                                                                "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                              children: [
                                                                {
                                                                  _id: "block3",
                                                                  type: "list",
                                                                  type_identifier:
                                                                    "li",
                                                                  text: "Activities conducted at the university for fellow students.",
                                                                  text_ar:
                                                                    "الأنشطة التي تُقام داخل الجامعة لزملاء الطلبة غير مقبولة.",
                                                                  classname: "",
                                                                },
                                                                {
                                                                  _id: "block3",
                                                                  type: "list",
                                                                  type_identifier:
                                                                    "li",
                                                                  text: "Volunteering to organise a conference or a workshop.",
                                                                  text_ar:
                                                                    "كما أن التطوع في تنظيم مؤتمر أو ورشة غير معتمد.",
                                                                  classname: "",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Skill Enhancement Courses",
                                          text_ar: "دورات تطوير المهارات",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Examples: Basic Life Support, Advanced Life Support, Point-of-Care Ultrasound Certificate (POCUS), Leadership, Quality, etc.",
                                                      text_ar:
                                                        "أمثلة: الإنعاش القلبي الأساسي (BLS)، الإنعاش القلبي المتقدم (ALS)، شهادة الموجات فوق الصوتية على نقطة الرعاية (POCUS)، القيادة، الجودة، وغيرها.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Online courses are accepted.",
                                                      text_ar:
                                                        "شروط الأهلية: يتم قبول الدورات الإلكترونية.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted: Certificates of completion for entrance examinations or preparatory courses.",
                                                      text_ar:
                                                        "غير مقبول: شهادات إتمام لدورات تحضيرية لاختبارات القبول.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: The course must have been completed since entering medical/dental school, and the certificate must indicate the date. ",
                                                      text_ar:
                                                        "الصلاحية: يجب أن تكون الدورة قد أُخذت بعد الالتحاق بكلية الطب، أو طب الأسنان (ويجب توضيح التاريخ بالشهادة).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic Awards",
                                          text_ar: "الجوائز الأكاديمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "px-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "list",
                                                  type_identifier: "ul",
                                                  classname:
                                                    "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                  children: [
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Examples: Dean’s List, Best Paper, Best Research, Best Presentation, etc.",
                                                      text_ar:
                                                        "أمثلة: قائمة العميد، أفضل ورقة بحثية، أفضل بحث، أفضل عرض تقديمي، إلخ.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Eligibility: Must be related to academic or research achievements.",
                                                      text_ar:
                                                        "شروط الأهلية: يجب أن تكون متعلقة بإنجاز أكاديمي أو بحثي.",
                                                      classname: "",
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Not Accepted:",
                                                      text_ar: "غير مقبول:",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "block1",
                                                          type: "div",
                                                          classname: "px-3",
                                                          children: [
                                                            {
                                                              _id: "block3",
                                                              type: "list",
                                                              type_identifier:
                                                                "ul",
                                                              classname:
                                                                "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                                              children: [
                                                                {
                                                                  _id: "block3",
                                                                  type: "list",
                                                                  type_identifier:
                                                                    "li",
                                                                  text: "Photographs of physical awards.",
                                                                  text_ar:
                                                                    "صور الجوائز الفعلية.",
                                                                  classname: "",
                                                                },
                                                                {
                                                                  _id: "block3",
                                                                  type: "list",
                                                                  type_identifier:
                                                                    "li",
                                                                  text: "Graduation certificates indicating honours.",
                                                                  text_ar:
                                                                    "شهادات التخرج، التي تشير إلى مرتبة الشرف لا تُحتسب.",
                                                                  classname: "",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "block3",
                                                      type: "list",
                                                      type_identifier: "li",
                                                      text: "Validity: The award must have been received since entering medical/dental school, and the certificate/letter must indicate the date.",
                                                      text_ar:
                                                        "الصلاحية: يجب أن تكون الجائزة قد حصل عليها الطالب بعد دخوله كلية الطب، أو طب الأسنان (ويُشترط وجود التاريخ في الشهادة أو الخطاب).",
                                                      classname: "",
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Documents Required",
                                    header_text_ar: "المستندات المطلوبة",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Identification Documents",
                                      text_ar: "المستندات الشخصية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Valid passport copy.",
                                          text_ar: "نسخة من جواز السفر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Emirates ID card (if applicable).",
                                          text_ar:
                                            "صورة من الهوية الإماراتية سارية المفعول إن وجدت.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Family Book (UAE nationals only) / Mother’s Family Book (for children of UAE national mothers).",
                                          text_ar:
                                            "صورة من خلاصة القيد لمواطني دولة الإمارات / خلاصة قيد الأم (لأبناء المواطنات) / المرسوم لحاملي المراسيم.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Residency permit (if applicable).",
                                          text_ar: "صورة من التأشيرة. إن وجدت.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Academic Documents",
                                      text_ar: "المستندات الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Undergraduate degree certificate. If the certificate has not yet been issued, a letter of enrolment confirming the expected completion date will suffice.",
                                          text_ar:
                                            "شهادة البكالوريوس: في حال لم تصدر الشهادة بعد، يُقبل خطاب إثبات تسجيل من الجامعة يوضح تاريخ التخرج المتوقع.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Undergraduate academic transcript. A notarised English translation is required for documents originally issued in a language other than Arabic or English.",
                                          text_ar:
                                            "السجل الأكاديمي (كشف الدرجات): يجب تقديم ترجمة قانونية باللغة الإنجليزية لأي مستندات صادرة بلغة غير العربية أو الإنجليزية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Results of an English proficiency test (attained within the last two years) – if applicable.",
                                          text_ar:
                                            "نتائج اختبار كفاءة اللغة الإنجليزية (صادرة خلال آخر سنتين) – إن كان ذلك مطلوبًا.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Copy of curriculum vitae.",
                                          text_ar: "السيرة الذاتية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "ECE evaluation is required for graduates who obtained their degree outside the United Arab Emirates.",
                                          text_ar:
                                            "تقييم (ECE) للخريجين الحاصلين على درجة علمية خارج دولة الإمارات العربية المتحدة،",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Note:",
                                      text_ar: "ملاحظات:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "px-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "For applicants with a degree awarded outside the UAE, Educational Credential Evaluators (ECE) – General with Grade Average evaluation is required to evaluate the transcripts and establish a standard GPA ",
                                              text_ar:
                                                "-للمتقدمين الحاصلين على شهادة جامعية من خارج دولة الإمارات العربية المتحدة، يجب تقديم تقييم رسمي للسجل الأكاديمي من ECE  ",
                                              classname: "",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "linking",
                                                  text: "(www.ece.org).",
                                                  text_ar: "(www.ece.org)",
                                                  classname:
                                                    "hover:underline text-primary",
                                                  href: "http://www.ece.org",
                                                  target: "_blank",
                                                  rel: "noopener noreferrer",
                                                },
                                                {
                                                  _id: "block3",
                                                  size: "normal",
                                                  type: "paragraph",
                                                  text: "",
                                                  text_ar:
                                                    "– فئة 'General with Grade Average'.",
                                                  classname: "",
                                                },
                                              ],
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "This GPA will be used when shortlisting applicants.",
                                              text_ar:
                                                "يُستخدم هذا المعدل التراكمي الموحد (GPA) لأغراض المفاضلة بين المتقدمين أثناء مرحلة الاختيار.",
                                              classname: "",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Portfolio Documents",
                                      text_ar: "مستندات الإنجازات",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Candidates must ensure that all required documents (where applicable) are prepared prior to submission.",
                                          text_ar:
                                            "يجب على المتقدمين التأكد من تجهيز كافة الوثائق المطلوبة (عند الاقتضاء) قبل التقديم.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Research Activity",
                                      text_ar: "النشاط البحثي",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "IRB approval letter (if available).",
                                          text_ar:
                                            "خطاب موافقة لجنة الأخلاقيات (IRB) – إن وُجد.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research proposal.",
                                          text_ar: "المقترح البحثي.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Publication in a Peer-Reviewed Journal",
                                      text_ar: "النشر في مجلة علمية محكّمة",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Link to the article.",
                                          text_ar: "رابط المقال.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Copy of the published manuscript.",
                                          text_ar: "نسخة من المخطوطة المنشورة.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Presentation in a Scientific Event",
                                      text_ar: "العرض في فعالية علمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of participation as a presenter (oral or poster presentation).",
                                          text_ar:
                                            "شهادة مشاركة كمقدم (عرض شفهي أو ملصق علمي",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Voluntary Social/Community Activities",
                                      text_ar: "الأنشطة التطوعية المجتمعية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of participation.",
                                          text_ar: "شهادة مشاركة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates issued by volunteers.ae and Wellness on Wheels are accepted.",
                                          text_ar:
                                            "تُقبل الشهادات الصادرة من volunteers.ae و Wellness on Wheels.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "A maximum of two activities may be submitted.",
                                          text_ar: "يُقبل حد أقصى نشاطين فقط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Skill Enhancement Courses",
                                      text_ar: "دورات تطوير المهارات",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of attendance or completion.",
                                          text_ar:
                                            "شهادة حضور أو إتمام الدورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "A maximum of two courses may be submitted.",
                                          text_ar: "يُقبل حد أقصى دورتين فقط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Academic Awards",
                                      text_ar: "الجوائز الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates of academic achievements or awards",
                                          text_ar:
                                            "شهادات الإنجاز الأكاديمي أو الجوائز.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Note:",
                                      text_ar: "ملاحظات:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "If the certificate is in a language other than English or Arabic, a notarised translation must be attached.",
                                          text_ar:
                                            "إذا كانت الشهادة بلغة غير الإنجليزية أو العربية، يجب إرفاق ترجمة موثقة.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Selection Process",
                                    header_text_ar: "إجراءات القبول",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "All complete applications will be reviewed by the Admissions Committee.",
                                          text_ar:
                                            "سيتم مراجعة جميع الطلبات المكتملة من قبل لجنة القبول.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "An application will be considered complete once all required documents are successfully submitted through the online portal and the application fee is paid.",
                                          text_ar:
                                            "يُعتبر الطلب مكتملًا عند رفع جميع المستندات المطلوبة بنجاح، عبر البوابة الإلكترونية وتسديد رسوم التقديم.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "The committee will consider all aspects of your application, including your GPA and other academic and scholarly activities listed on your CV. ",
                                          text_ar:
                                            "تأخذ اللجنة بعين الاعتبار جميع جوانب الطلب، بما في ذلك المعدل التراكمي (GPA)، إلى جانب الأنشطة الأكاديمية والعلمية الأخرى المدرجة في السيرة الذاتية.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text:
                                      "Medical Internship - Shortlisting Process",
                                    header_text_ar:
                                      "آلية تقييم طلب الامتياز الطبي",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "GPA: 50%",
                                          text_ar: "المعدل التراكمي GPA: 50%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Interview: 30%",
                                          text_ar: "المقابلات الشخصية: 30%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Portfolio: 20%",
                                          text_ar:
                                            "ملف الإنجازات Portfolio: 20%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Medical Internship Portfolio Evaluation",
                                          text_ar:
                                            "تقييم ملف الإنجازات لامتياز الطبي.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "The portfolio will be evaluated according to the following criteria: ",
                                      text_ar:
                                        "سيتم تقييم ملف الإنجاز وفقًا للمعايير التالية:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "IFOM Part 2 :",
                                      text_ar: "اختبار IFOM الجزء الثاني:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "1 point (if score <40)",
                                          text_ar:
                                            "1 نقطة إذا كانت الدرجة أقل من 40.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "2 points (if score is 41–80)",
                                          text_ar:
                                            "2 نقطتان إذا كانت الدرجة بين 41 و80.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "3 points (if score ≥81)",
                                          text_ar:
                                            "3 نقاط إذا كانت الدرجة 81 أو أكثر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research activity – 4 points",
                                          text_ar: "النشاط البحثي: 4 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publication – 7 points",
                                          text_ar: "المنشورات العلمية: 7 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary social/community activities (max two) - 4 points each",
                                          text_ar:
                                            "الأنشطة التطوعية المجتمعية (بحد أقصى نشاطين): 4 نقاط لكل نشاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Skill enhancement courses (max two) - 4 Points each",
                                          text_ar:
                                            "دورات تطوير المهارات (بحد أقصى دورتين): 4 نقاط لكل دورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic Awards - 6 Points",
                                          text_ar:
                                            "الجوائز الأكاديمية: 6 نقاط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text:
                                      "Dental Internship – Shortlisting Process",
                                    header_text_ar:
                                      "آلية تقييم ملف الامتياز (طب الأسنان)",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "GPA: 50%",
                                          text_ar: "المعدل التراكمي GPA: 50%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Interview: 30%",
                                          text_ar: "المقابلات الشخصية: 30%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Portfolio: 20%",
                                          text_ar:
                                            "ملف الإنجازات Portfolio: .20%",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Dental Internship Portfolio Evaluation",
                                          text_ar:
                                            "تقييم ملف الإنجازات لامتياز طب الأسنان",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "The portfolio will be evaluated according to the following criteria: ",
                                      text_ar:
                                        "سيتم تقييم ملف الإنجاز وفقًا للمعايير التالية:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research activity – 2 points",
                                          text_ar: "النشاط البحثي: 2 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publication – 4 points)",
                                          text_ar: "المنشورات العلمية: 4 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Presentation in a scientific event – 2 points",
                                          text_ar:
                                            "تقديم عرض في فعالية علمية: 2 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary social/community activities (max two) - 2 points each",
                                          text_ar:
                                            "الأنشطة التطوعية المجتمعية (بحد أقصى نشاطين): 2 نقاط لكل نشاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Extra-curricular courses (max two) - 2 points each",
                                          text_ar:
                                            "دورات تطوير المهارات (بحد أقصى دورتين): 2 نقاط لكل دورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic Awards - 4 points",
                                          text_ar:
                                            "الجوائز الأكاديمية: 4 نقاط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "After the application deadline, candidates will be notified.",
                                      text_ar:
                                        "بعد انقضاء الموعد النهائي للتقديم، سيتم إخطار المتقدمين بنتائج التقييم.",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Ranking will be based on merit; Accordingly, candidates will be informed via email of their admission decision Cross Match",
                                      text_ar:
                                        "سيتم تحديد الترتيب النهائي، استنادًا إلى الجدارة، وعليه سيتم إخطار المتقدمين بقرار القبول عبر البريد الإلكتروني، بعد إتمام عملية المطابقة (Cross Match).",
                                      classname: "body text-primary",
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Fees",
                                    header_text_ar: "الرسوم",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Registration and review fees:",
                                      text_ar: "رسوم تقديم ومراجعة الطلب:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "AED 220 for processing the application (non-refundable).",
                                          text_ar:
                                            "220درهماً رسوم تقـــديم الطلب. (غير مستردة)",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h3",
                                      text: "Training fees: ",
                                      text_ar: "رسوم التدريب:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "For Medical: 30,000 dirhams",
                                          text_ar: "للطب العام 30,000 درهم.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "For Dental: subject to the training hospital’s fees",
                                          text_ar:
                                            "طب الأسنان بناء على المركز التدريبي وقد تختلف حسب المستشفى التدريبي.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "For further enquiries or in case of any technical issues, please contact us through the following channels:",
                                      text_ar:
                                        "لمزيد من الاستفسارات، أو في حال وجود أي مشكلات تقنية، يُرجى التواصل عبر القنوات التالية:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Email: ",
                                          text_ar: "البريد الإلكتروني: ",
                                          classname:
                                            "body text-onSurfaceVariant inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: " info@dha.gov.ae",
                                          text_ar: " info@dha.gov.ae",
                                          classname: "text-primary inline",
                                          href: "mailto::info@dha.gov.ae",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Contact no: ",
                                          text_ar: "الهاتف: ",
                                          classname:
                                            "body text-onSurfaceVariant inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "800342",
                                          text_ar: "800342",
                                          classname: "text-primary inline",
                                          href: "tel:+971800342",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "To register for the Internship Training Programme during the registration period, please click on the following link: ",
                                          text_ar:
                                            "للتسجيل في برنامج الامتياز خلال فترة التسجيل، اضغط على الرابط التالي: ",
                                          classname:
                                            "body text-onSurfaceVarient inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "Click here to apply",
                                          text_ar: "اضغط هنا للتقديم",
                                          classname:
                                            "hover:underline text-primary underlined inline",
                                          href: "https://mawaheb.dha.gov.ae/admin/servicesByCategory/3",
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname: "",
                          children: [
                            {
                              _id: "block2",
                              type: "tabcontent",
                              isShow_title: false,
                              linker: "medical_control",
                              linker_ar: "medical_control",
                              title: "Residency Programme",
                              title_ar: "برنامج الإقامة",
                              size: "h2",
                              classname: "dda-table-container",
                              children: [
                                {
                                  _id: "block1",
                                  type: "div",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "The medical residency programmes in the private healthcare sector of the Emirate of Dubai, under the supervision of the Dubai Health Authority,  offer ambitious physicians a distinguished opportunity to gain advanced clinical training, enhance their professional skills, and acquire diverse hands-on experience across various specialties  Accredited by local and international accreditation bodies such as the Arab Board of Health Specializations, the National Institute for Health Specialties, and the American Council for Graduation Medical Education International ACGME-I. Under the guidance of experienced consultants and in state-of-the-art medical facilities the training duration ranges between 4 to 5 years, depending on the specialty., residents undergo a structured, competency-based training program designed to gradually prepare them for independent clinical practice. These diverse and accredited programs aim to develop a new generation of healthcare leaders.",
                                      text_ar:
                                        "تقدم برامج الإقامة الطبية في القطاع الصحي الخاص بإمارة دبي، تحت إشراف هيئة الصحة بدبي، فرصة مميزة للأطباء الطموحين لاكتساب تدريب سريري متقدم، وتنمية مهاراتهم المهنية، والحصول على خبرة عملية متنوعة في مختلف التخصصات الصحية المعهد الوطني للاختصاصات الصحية والمجلس الأمريكي للتعليم العالي وبإشراف استشاريين ذوي خبرة، وفي مرافق طبية حديثة، تتراوح مدة التدريب بين 4 الى 5 سنوات بحسب التخصص، يخضع الأطباء المقيمون لبرنامج تدريبي منظم قائم على الكفاءة. ويهدف إلى تأهيلهم تدريجيًا للممارسة السريرية المستقلة. وتعمل هذه البرامج المتنوعة والمعتمدة على إعداد جيل جديد من قادة الرعاية الصحية.",
                                      classname: "body mb-4",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Accredited Medical Specialties in Private Hospitals Licensed and accredited as a training center by the Dubai Health Authority in the Emirate of Dubai:",
                                      text_ar:
                                        "التخصصات الطبية المعتمدة في المستشفيات الخاصة  المرخصة والمعتمدة كمركز تدريبي من قبل هيئة الصحة في امارة دبي:",
                                      classname: "body mb-4 text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Pediatrics",
                                          text_ar: "طب الأطفال",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Family Medicine",
                                          text_ar: "طب الأسرة",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Internal Medicine",
                                          text_ar: "الطب الباطني",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "General Surgery",
                                          text_ar: "الجراحة العامة",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Obstetrics & Gynaecology",
                                          text_ar: "طب النساء والولادة ",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Orthopedics & Trauma",
                                          text_ar: "طب الحوادث والكسور ",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Emergency Medicine",
                                          text_ar: "طب الطوارئ",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Anaesthesiology & Critical Care",
                                          text_ar:
                                            "طب التخدير والعناية المركزة",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Anatomical Pathology",
                                          text_ar: "طب علم الأمراض التشريحي",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Dermatology & Venereology",
                                          text_ar:
                                            "طب الأمراض الجلدية والتناسلية",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Programme Timeline",
                                    header_text_ar: "الجدول الزمني",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block1",
                                      type: "div",
                                      classname: "dda-table-container",
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "overflow-x-auto",
                                          children: [
                                            {
                                              _id: "table1",
                                              type: "table",
                                              classname:
                                                "dda-table w-full min-w-[650px]",
                                              children: [
                                                {
                                                  _id: "table_body",
                                                  type: "tableItems",
                                                  type_identifier: "tbody",
                                                  classname: "body",
                                                  children: [
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Registration Opens",
                                                              text_ar:
                                                                "فتح باب التسجيل",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "January",
                                                              text_ar: "يناير",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Registration Closes",
                                                              text_ar:
                                                                "إغلاق باب التسجيل",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "March",
                                                              text_ar: "مارس",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Multiple Mini Interviews (MMI)",
                                                              text_ar:
                                                                "المقابلات المتعددة القصيرة MMI",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "May",
                                                              text_ar: "مايو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Speciality Interviews",
                                                              text_ar:
                                                                "المقابلات التخصصية",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "May - June",
                                                              text_ar:
                                                                "مايو-يونيو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Matching Process",
                                                              text_ar:
                                                                "إجراءات المطابقة",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "June",
                                                              text_ar: "يونيو",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Announcement of Accepted Candidates",
                                                              text_ar:
                                                                "الإعلان عن أسماء المقبولين",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "July - August",
                                                              text_ar:
                                                                "يوليو- أغسطس",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      _id: "tableTR",
                                                      type: "tableItems",
                                                      type_identifier: "tr",
                                                      classname: "",
                                                      children: [
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname:
                                                            "border-r border-gray-300",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "Start of Academic Year",
                                                              text_ar:
                                                                "بداية العام الأكاديمي",
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTH",
                                                          type: "tableItems",
                                                          type_identifier: "td",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "paragraph",
                                                              size: "normal",
                                                              classname: "",
                                                              text: "October",
                                                              text_ar: "أكتوبر",
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Eligibility Criteria",
                                    header_text_ar: "معايير القبول",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Academic Criteria",
                                      text_ar: "المعايير الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Applicants must be graduates of medical schools listed under the World Health Organization (WHO).",
                                          text_ar:
                                            "الحصول على درجة البكالوريوس في الطب والجراحة، أو ما يعادلها من إحدى كليات الطب المدرجة في قائمة منظمة الصحة العالمية (WHO).",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "A certificate of completion for the internship year with a minimum training duration of 12 months is required. The applicant must have successfully passed the final examinations of the MBBS/MD programme before commencing the internship year. This is a fundamental requirement. This requirement is essential for obtaining licensure and must be fulfilled to ensure eligibility for enrolment in the programme.",
                                          text_ar:
                                            "شهادة إتمام التدريب لسنة الامتياز، على ألا تقل مدة التدريب عن 12 شهر. ويشترط أن يكون المتقدم قد اجتاز بنجاح الامتحانات النهائية لبرنامج MBBS/MD قبل بدء سنة الامتياز. ويُعد هذا الشرط مطلبًا أساسياً للحصول على الترخيص، ويجب استيفاؤه لضمان أهلية الالتحاق بالبرنامج.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Applicants must successfully pass the Emirates Medical Residency Entrance Examination (EMREE).",
                                          text_ar:
                                            "اجتياز اختبار القبول في برنامج الإقامة الطبية في الإمارات (EMREE) بنجاح.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "An Educational Credential Evaluation (ECE) certificate is required for graduates who obtained their degree outside the United Arab Emirates in order to obtain a standardised GPA via ",
                                          text_ar:
                                            "شهادة (ECE) للخريجين الحاصلين على درجة علمية خارج دولة الإمارات العربية المتحدة، للحصول على معدل تراكمي قياسي عن طريق ،",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "http://www.ece.org",
                                              text_ar: "(http://www.ece.org)",
                                              classname:
                                                "hover:underline text-primary",
                                              href: "http://www.ece.org",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: " Graduates from the UAE must submit their final cumulative GPA.",
                                              text_ar:
                                                "وعلى خريجي دولة الإمارات تقديم المعدل التراكمي النهائي.",
                                              classname: "body mb-4 inline",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Candidates must not have been out of clinical practice for more than 12 months at any point (excluding national service for UAE nationals or disruptions caused by the COVID-19 pandemic).",
                                          text_ar:
                                            "يجب ألا يكون المرشحون قد انقطعوا عن الممارسة السريرية لأكثر من 24 شهرًا في أي وقت (باستثناء الخدمة الوطنية لمواطني دولة الإمارات العربية المتحدة)، أو الانقطاع بسبب جائحة كوفيد-19).",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Those who obtained their bachelor’s degree or completed their internship year outside the United Arab Emirates must provide the following: A notarised English translation of documents originally in a language other than Arabic or English",
                                          text_ar:
                                            "ينبغي على الحاصلين على شهادة درجة البكالوريوس، أو سنة الامتياز من خارج دولة الإمارات العربية المتحدة، توفير التالي: ترجمة إنجليزية موثقة للوثائق الأصلية الصادرة بلغة غير العربية أو الإنجليزية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Accepted applicants will be required to join the programme as full-time trainees, and simultaneous enrolment in more than one postgraduate programme will not be permitted.",
                                          text_ar:
                                            "سيتعين على المتقدمين المقبولين، الالتحاق بالبرنامج كمتدربين بدوام كامل، ولن يُسمح بالجمع بين أكثر من برنامج دراسات عليا في الوقت نفسه.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Final admission to the programme is conditional upon the successful completion of the licensing procedures by the Dubai Health Authority (DHA).",
                                          text_ar:
                                            "كما أن الالتحاق النهائي بالبرنامج مشروط بإتمام إجراءات الترخيص بنجاح من قبل هيئة الصحة بدبي (DHA).",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "English Language Criteria",
                                    header_text_ar: "معايير اللغة الإنجليزية",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "IELTS Academic",
                                      text_ar: "أيلتس أكاديمي:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Overall score of 6",
                                          text_ar: "درجة 6 أو أكثر.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "TOEFL iBT",
                                      text_ar: "توفل TOEFL iBT:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Minimum score of 80",
                                          text_ar: "80 درجة أو أكثر.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "PBT is not accepted",
                                          text_ar: "لا يُقبل اختبار PBT",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "EmSAT – English:",
                                      text_ar: "امسات إنجليزي:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Achievement of 1525 or above.",
                                          text_ar: "1525أو أكثر.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Note:",
                                      text_ar: "ملاحظة:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Applicants are exempt from the English language certificate validity requirement if they graduated from an educational institution within the UAE, or if, in the case of institutions outside the UAE, they provide an official letter from the university confirming that English was the language of instruction for their academic program.",
                                      text_ar:
                                        "يتم إعفاء المتقدمين من شرط صلاحية شهادة اللغة الإنجليزية، في حال تخرجهم من مؤسسة تعليمية داخل الدولة أو إرفاق خطاب رسمي من الجامعة يُؤكد أن لغة التدريس في البرنامج الأكاديمي كانت الإنجليزية للمؤسسات التعليمية خارج الدولة.",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Portfolio Criteria",
                                    header_text_ar: "معايير الإنجازات",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research Activities",
                                          text_ar: "الأنشطة البحثية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Writing a proposal, collecting data, analysing data, writing a manuscript, case study, etc.",
                                                  text_ar:
                                                    "أمثلة: إعداد مقترح بحثي، جمع البيانات، تحليل البيانات، كتابة مخطوطة بحثية، دراسة حالة، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place since entering medical/dental school (ensure the date is indicated on the letter).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون النشاطات قد أُنجزت منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الخطاب).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publications",
                                          text_ar: "النشر العلمي",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Must be published in a peer-reviewed journal. It may be the same entry as the research activity.",
                                                  text_ar:
                                                    "الأهلية: يجب أن يكون النشر في مجلة علمية مُحكّمة. يمكن أن يكون النشر هو نفسه النشاط البحثي.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Abstracts, theses, or draft manuscripts.",
                                                  text_ar:
                                                    "غير مقبول: الملخصات، ورسائل الماجستير أو البكالوريوس، أو المسودات غير المنشورة.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place after entering medical or dental school (ensure the date is clearly stated).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن يكون النشر قد تم منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Presentation at a Scientific Event",
                                          text_ar: "العرض في فعالية علمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Conference, symposium, workshop, etc.",
                                                  text_ar:
                                                    "أمثلة: مؤتمر، ندوة، ورشة عمل، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Must be health-related.",
                                                  text_ar:
                                                    "الأهلية: يجب أن تكون الفعالية مرتبطة بالصحة.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Certificates of attendance, or presentations given during academic days or grand rounds at the university.",
                                                  text_ar:
                                                    "غير مقبول: شهادات الحضور أو العروض المقدمة، خلال الأيام الأكاديمية أو الجولات الطبية في الجامعة.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place after entering medical or dental school (ensure the date is clearly stated on the certificate).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن يكون النشاط قد تم منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary Social/ Community Activities",
                                          text_ar:
                                            "الأنشطة التطوعية الاجتماعية/المجتمعية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Participating in, organising, or speaking at a community engagement event. Must be health-related, such as health awareness campaigns.",
                                                  text_ar:
                                                    "أمثلة: المشاركة في تنظيم أو إلقاء كلمة في فعالية مجتمعية، على أن تكون ذات صلة بالصحة، مثل حملات التوعية الصحية.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Activities organised or supervised by universities, official health associations, or government-licensed organisations.",
                                                  text_ar:
                                                    "الأهلية: الأنشطة المنظمة أو المشرفة عليها الجامعات، والجمعيات الصحية الرسمية، أو الجهات المرخّصة حكومياً.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Target Audience: Activities aimed at the general public.",
                                                  text_ar:
                                                    "الفئة المستهدفة: الأنشطة الموجهة لعامة الجمهور.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Activities conducted at the university for fellow students, volunteering to organise a conference, or assisting in workshops.",
                                                  text_ar:
                                                    "غير مقبول: الأنشطة داخل الجامعة الموجهة للطلبة، أو التطوع في تنظيم المؤتمرات أو ورش العمل.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place after entering medical or dental school (ensure the date is clearly stated on the certificate or letter). ",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون النشاطات قد أُنجزت منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة/الخطاب).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Skill Enhancement Courses",
                                          text_ar: "دورات تطوير المهارات",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Basic Life Support, Advanced Life Support, Point-of-Care Ultrasound Certificate (POCUS), leadership, quality improvement, etc.",
                                                  text_ar:
                                                    "أمثلة: الإنعاش القلبي الرئوي الأساسي، والإنعاش القلبي الرئوي المتقدم، وشهادة الموجات فوق الصوتية عند نقطة الرعاية (POCUS)، والقيادة، والجودة، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Online courses are accepted.",
                                                  text_ar:
                                                    "الأهلية: تُقبل الدورات عبر الإنترنت.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Certificates of completion for entrance examinations or preparatory courses.",
                                                  text_ar:
                                                    "غير مقبول: شهادات إتمام دورات اختبارات القبول أو الدورات التحضيرية.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place since entering medical/dental school (ensure the date is indicated on the certificate).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون الدورة قد أُنجزت منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic Awards",
                                          text_ar: "الجوائز الأكاديمية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Dean’s List, Best Paper, Best Research, Best Presentation, etc.",
                                                  text_ar:
                                                    "أمثلة: قائمة العميد، أفضل ورقة بحثية، أفضل بحث، أفضل عرض تقديمي، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Eligibility: Must relate to academic or research achievements.",
                                                  text_ar:
                                                    "الأهلية: يجب أن تكون مرتبطة بإنجازات أكاديمية أو بحثية.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },

                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Not Accepted: Photographs of physical awards and graduation certificates indicating honours are not considered.",
                                                  text_ar:
                                                    "غير مقبول: صور الجوائز المادية، وشهادات التخرج، التي تتضمن مرتبة الشرف.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The award must have been obtained since entering medical/dental school (ensure the date is indicated on the certificate/letter). ",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون الجائزة قد حُصِل عليها منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة/الخطاب).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Extra-Curricular Activities",
                                          text_ar: "أنشطة اللاصفية",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block2",
                                              type: "div",
                                              classname: "mx-3",
                                              children: [
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Examples: Clinical attachment, summer placement, teaching, membership of councils within the university, etc.",
                                                  text_ar:
                                                    "أمثلة: التدريب السريري، التدريب الصيفي، التدريس، عضوية المجالس داخل الجامعة، إلخ.",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                                {
                                                  _id: "block3",
                                                  type: "paragraph",
                                                  size: "normal",
                                                  text: "Validity: The activity must have taken place since entering medical/dental school (ensure the date is indicated on the certificate/letter).",
                                                  text_ar:
                                                    "الصلاحية: يجب أن تكون النشاطات قد أُنجزت منذ الالتحاق بكلية الطب/طب الأسنان (مع التأكد من ذكر التاريخ في الشهادة/الخطاب).",
                                                  classname:
                                                    "body text-onSurfaceVariant",
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Required Documents",
                                    header_text_ar: "المستندات المطلوبة",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "The online application form is the official and only means to apply for any of our Graduate Medical Education programmes.",
                                          text_ar:
                                            "نموذج الطلب الإلكتروني، هو الوسيلة الرسمية والوحيدة، للتقديم لأيٍّ من برامج الدراسات العليا الطبية لدينا.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "All application documents must be submitted online.",
                                          text_ar:
                                            "يجب تقديم جميع وثائق الطلب إلكترونيًا.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Candidates must ensure that all required documents are correctly attached in their designated fields.",
                                          text_ar:
                                            "يجب على المرشحين التأكد من إرفاق جميع المستندات المطلوبة بشكل صحيح في الحقول المخصصة لها.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Missing or incorrectly attached documents will result in disqualification of the application.",
                                          text_ar:
                                            "سيؤدي عدم إرفاق أي مستندات أو إرفاقها بشكل غير صحيح إلى استبعاد طلبك.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Candidates must ensure all required documents are prepared prior to submission, as applications cannot be returned for portfolio edits once submitted.",
                                          text_ar:
                                            "يجب على المتقدمين التأكد من تجهيز جميع المستندات المطلوبة قبل تقديم الطلب، حيث لا يمكن إعادة الطلبات لإجراء تعديلات على الملف بعد إرسالها.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Identification Documents",
                                    header_text_ar: "المستندات الشخصية",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Recent coloured photograph",
                                          text_ar: "صورة شخصية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Valid passport copy",
                                          text_ar:
                                            "صورة من جواز السفر ساري المفعول.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Emirates ID card (if applicable)",
                                          text_ar:
                                            "صورة من الهوية الإماراتية سارية المفعول إن وجدت.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Family Book (UAE nationals only) / Mother’s Family Book (for children of UAE national mothers) / Valid Marsoom letter (for Marsoom holders only)",
                                          text_ar:
                                            "صورة من خلاصة القيد للمواطنين/ خلاصة قيد الأم (لأبناء المواطنات) /صورة من المرسوم ساري الصلاحية لحاملي المراسيم فقط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Residency permit (if applicable)",
                                          text_ar: "صورة من التأشيرة.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Academic Documents",
                                    header_text_ar: "المستندات الأكاديمية",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Undergraduate Degree Certificate: A notarised English translation is required for documents originally in a language other than Arabic or English.",
                                          text_ar:
                                            "شهادة البكالوريوس: في حال كانت الشهادة صادرة بلغة غير العربية أو الإنجليزية، يجب إرفاق ترجمة موثقة إلى اللغة الإنجليزية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Undergraduate Academic Transcript: A notarised English translation is required for documents originally in a language other than Arabic or English.",
                                          text_ar:
                                            "السجل الأكاديمي لمرحلة البكالوريوس:  في حال كان السجل الأكاديمي بلغة غير العربية أو الإنجليزية، يجب إرفاق ترجمة موثقة إلى اللغة الإنجليزية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Internship Certificate: If the certificate is not yet available, please upload a letter from the institution confirming your enrolment and the expected date of completion. The completion date must be prior to the beginning of the academic year.",
                                          text_ar:
                                            "شهادة الامتياز:  في حال عدم توفر الشهادة بعد، يجب رفع خطاب من المؤسسة، يؤكد التسجيل في البرنامج مع تحديد تاريخ متوقع لإتمامه. يجب أن يكون تاريخ الإتمام قبل بداية العام الأكاديمي.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Results of the English proficiency test: As per the published criteria.",
                                          text_ar:
                                            "نتائج اختبار إتقان اللغة الإنجليزية وفقًا للمعايير المنشورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Results of the Emirates Medical Residency Entrance Examination (EMREE)",
                                          text_ar:
                                            "نتائج اختبار القبول لبرنامج الإقامة الطبية (EMREE)",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Curriculum Vitae",
                                          text_ar: "السيرة الذاتية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Educational Credential Evaluators (ECE) – General with Grade Average Candidates who graduated outside the UAE are required to have their transcripts evaluated and obtain a standard GPA from Educational Credential Evaluators (ECE). This ECE GPA equivalent will be used for shortlisting applications.",
                                          text_ar:
                                            "تقييم المؤهلات التعليمية (ECE) يتعين على المرشحين الذين تخرجوا من خارج دولة الإمارات، تقييم سجلاتهم الأكاديمية والحصول على معدل تراكمي موحّد من خلال خدمة تقييم المؤهلات التعليمية (ECE) ، وسيتم استخدام المعدل التراكمي المكافئ الصادر عن (ECE) ، عند إعداد القائمة المختصرة للطلبات.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Provide a Primary Source Verification (PSV) report for all certificates. For more information, please refer to: ",
                                          text_ar:
                                            "توفير تقرير التحقق من المصدر الأساسي (PSV) لجميع الشهادات. لمزيد من المعلومات يرجى مراجعة الرابط ",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "https://dha.dfgateway.com/",
                                              text_ar:
                                                "(https://dha.dfgateway.com/)",
                                              classname:
                                                "hover:underline text-primary",
                                              href: "https://dha.dfgateway.com/",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Proof of completion or exemption from National Service for male UAE nationals.",
                                          text_ar:
                                            "ما يثبت الانتهاء من الخدمة الوطنية او الاعفاء للمواطنين الذكور.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "No Objection Letter (NOC) from the employer to join the full-time training programme (if the applicant is currently employed).",
                                          text_ar:
                                            "خطاب عدم ممانعة من جهة العمل للالتحاق بالبرنامج التدريبي بدوام كامل (في حال كان المتقدم على رأس عمله).",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Portfolio Documents",
                                    header_text_ar: "مستندات الإنجازات",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Research Activity",
                                      text_ar: "النشاط البحثي",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "IRB Approval Letter (if available)",
                                          text_ar:
                                            "خطاب موافقة لجنة أخلاقيات البحث (IRB) – إن وُجد.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research Proposal",
                                          text_ar: "مقترح البحث.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publication in a peer-reviewed journal",
                                          text_ar:
                                            "النشر في مجلة علمية مُحكَّمة:",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Link to article",
                                          text_ar: "رابط المقال.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Copy of the published manuscript.",
                                          text_ar: "نسخة من المخطوطة المنشورة",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Abstracts and thesis dissertations are not accepted.",
                                          text_ar:
                                            "لا تُقبل الملخصات أو رسائل الماجستير/البكالوريوس.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Presentation at a Scientific Event",
                                      text_ar: "العرض في فعالية علمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of participation as a presenter (oral or poster presentation).",
                                          text_ar:
                                            "شهادة مشاركة كمقدّم عرض (شفوي أو عرض ملصق).",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Voluntary Social/Community Activities",
                                      text_ar:
                                        "الأنشطة التطوعية الاجتماعية/المجتمعية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Must be health-related activities, such as health awareness campaigns.",
                                          text_ar:
                                            "يجب أن تكون أنشطة متعلقة بالصحة مثل حملات التوعية الصحية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of participation or official letter from the organiser confirming your role.",
                                          text_ar:
                                            "تقبل شهادة مشاركة، أو خطاب رسمي من الجهة المنظمة يؤكد دورك.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates issued by  .",
                                          text_ar:
                                            "o	تُقبل الشهادات الصادرة من ",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "volunteers.ae",
                                              text_ar: "volunteers.ae",
                                              classname:
                                                "hover:underline text-primary",
                                              href: "http://www.volunteers.ae",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: " and Wellness on Wheels are accepted",
                                              text_ar: " وWellness on Wheels.",
                                              classname: "body mb-4 inline",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Maximum of two activities.",
                                          text_ar: "يقدم بحد أقصى نشاطين.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Skill Enhancement Courses",
                                      text_ar: "دورات تطوير المهارات",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of attendance or completion.",
                                          text_ar: "شهادة حضور أو إتمام.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Maximum of two courses.",
                                          text_ar: "يقدم بحد أقصى دورتين.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Academic Awards",
                                      text_ar: "الجوائز الأكاديمية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates of academic achievement/award or official letter from the university.",
                                          text_ar:
                                            "تُقبل شهادات الإنجازات/الجوائز الأكاديمية أو خطاب رسمي من الجامعة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate of excellence/merit for outstanding performance in a university course is accepted.",
                                          text_ar:
                                            "تُقبل شهادة التميز/الاستحقاق، للأداء المتميز في مقرر جامعي.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Extra-Curricular Activities",
                                      text_ar: "الأنشطة اللاصفية",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificate or official letter from the relevant institute.",
                                          text_ar:
                                            "شهادة أو خطاب رسمي من المؤسسة المعنية.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Maximum of two activities.",
                                          text_ar: "تُقدم بحد أقصى دورتين.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Note:",
                                      text_ar: "ملاحظات:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "If the certificate is in a language other than English or Arabic, a notarised translation must be attached.",
                                          text_ar:
                                            "في حال كانت الشهادة بلغة غير الإنجليزية أو العربية، يجب إرفاق ترجمة موثقة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Certificates with handwritten names will not be accepted.",
                                          text_ar:
                                            "الشهادات التي تحمل أسماء مكتوبة بخط اليد لن تُقبل.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  _id: "block3",
                                  type: "dda-accordion",
                                  props: {
                                    design: "bg-border",
                                    accordion_icon_class:
                                      "material-icons  material-symbols-outlined",
                                    accordion_icon_text: "",
                                    accordion_icon_text_ar: "",
                                    header_text: "Admission Procedures",
                                    header_text_ar: "إجراءات القبول",
                                    sub_title: "",
                                    sub_title_ar: "",
                                    link_button_text: "",
                                    link_button_text_ar: "",
                                    custom_class: "my-4",
                                    component_mode: "",
                                  },
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "An application will be considered complete once all required documents have been successfully submitted through the online portal and the application fee paid.",
                                      text_ar:
                                        "يُعتبر طلب التقديم مكتملًا عند رفع جميع المستندات المطلوبة بنجاح عبر البوابة الإلكترونية، وتسديد رسوم التقديم.",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "The selection process will include the following four phases: ",
                                      text_ar:
                                        "تشمل عملية الاختيار، أربع مراحل رئيسية على النحو التالي:",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Phase 1: Shortlisting (50%)",
                                      text_ar:
                                        "المرحلة الأولى: التصفية الأولية (50%(",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "All complete applications will be reviewed and scored by the  concerned section in Medical Education & Research Department according to the following criteria:",
                                      text_ar:
                                        "سيتم مراجعة جميع الطلبات المكتملة، وتقييمها من قبل القسم المعني في إدارة التعليم الطبي، وفقًا للمعايير التالية:",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "GPA: 35%",
                                          text_ar: "المعدل التراكمي 35%.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Residency Entrance Examination: 35%",
                                          text_ar:
                                            "نتيجة اختبار القبول لبرنامج الإقامة 35%. سيتم احتسابه بناءً على الدرجة، والترتيب المئوي، وعدد المحاولات.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Portfolio: 30%",
                                          text_ar: "ملف الإنجاز 30%.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Portfolio Evaluation (30 points)",
                                      text_ar:
                                        "تقييم الملف الشخصي بحد أقصى 30 نقطة:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Research activity – 4 points",
                                          text_ar: "النشاط البحثي – 4 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Publication – 6 points",
                                          text_ar: "النشر العلمي – 6 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Presentation at a scientific event – 4 points",
                                          text_ar:
                                            "العرض في فعالية علمية – 4 نقاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Voluntary social/community activities (maximum two activities) – 2 points each",
                                          text_ar:
                                            "الأنشطة التطوعية (الاجتماعية/المجتمعية) -بحد أقصى نشاطين – نقطتان لكل نشاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Skill enhancement courses (maximum two courses) – 2 points each",
                                          text_ar:
                                            "الدورات التدريبية لتطوير المهارات بحد أقصى دورتين – نقطتان لكل دورة.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Extra-curricular activities (maximum two courses) – 2 points each",
                                          text_ar:
                                            "الأنشطة اللاصفية (بحد أقصى نشاطي) نقطتان لكل نشاط.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Academic awards – 4 points",
                                          text_ar:
                                            "الجوائز الأكاديمية – 4 نقاط.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Phase 2: Multiple Mini Interviews (MMI) (30%)",
                                      text_ar:
                                        "المرحلة الثانية: المقابلات المتعددة القصيرةMMI    30%",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Qualified shortlisted candidates will be invited via email for on-site Multiple Mini Interviews. MMI and unsuccessful candidates will be notified at that time with a regret notice.",
                                          text_ar:
                                            "سيتم دعوة المرشحين المؤهلين ضمن قائمة التصفية النهائية، عبر البريد الإلكتروني لإجراء المقابلات القصيرة المتعددة (MMI) ، بينما سيتم إخطار المرشحين غير المقبولين في ذلك الوقت برسالة اعتذار.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "This process results in an overall score for each applicant that reflects their non-cognitive skills, such as communication skills, professionalism, and moral judgement.",
                                          text_ar:
                                            "تؤدي هذه العملية إلى الحصول على مجموع نقاط شامل لكل متقدم، يعكس مهاراته غير المعرفية، مثل مهارات التواصل، والاحترافية، والحكم الأخلاقي",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragaph",
                                      size: "normal",
                                      text: "The interview scenarios are designed to assess non-cognitive competencies essential in the field of medicine, such as: ",
                                      text_ar:
                                        "تصميم السيناريوهات في المقابلة. يهدف إلى اختبار الكفاءات غير المعرفية، التي تُعد أساسية في مجال الطب، مثل: ",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "ul",
                                      classname:
                                        "text-onSurfaceVariant list-inside space-y-3 list-disc body mb-3",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Communication skills",
                                          text_ar: "مهارات التواصل.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Problem-solving",
                                          text_ar: "حل المشكلات.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Empathy",
                                          text_ar: "التعاطف.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Moral/ethical reasoning",
                                          text_ar: "التفكير الأخلاقي/المعنوي.",
                                          classname: "",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "li",
                                          text: "Decision-making",
                                          text_ar: "اتخاذ القرار.",
                                          classname: "",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Phase 3: Specialty Interview (20%)",
                                      text_ar:
                                        "المرحلة الثالثة: المقابلة التخصصية 20%",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Candidates will be shortlisted based on Phase 1 and Phase 2 scores and invited to the Specialty Interviews. Unsuccessful candidates will be notified at that time with a regret notice.",
                                      text_ar:
                                        "سيتم ترشيح المتقدمين بناءً على نتائج المرحلتين الأولى والثانية، ودعوتهم لإجراء المقابلات التخصصية، بينما سيتم إخطار المتقدمين غير المقبولين في ذلك الوقت برسالة اعتذار.",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Phase 4: Ranking & Offering",
                                      text_ar:
                                        "المرحلة الرابعة: الترتيب وإعلان القبول",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Candidates who complete the Specialty Interview will be ranked based on the following: 50% shortlisting score, 30% MMI score, and 20% specialty interview score. Accordingly, they will be informed via email of their admission decision after the Cross Match. ",
                                      text_ar:
                                        "سيتم تصنيف المتقدمين الذين أنهوا المقابلة التخصصية، بناءً على النسب التالية: 50% من درجة التصفية الأولية، و30% من درجة المقابلات القصيرة المتعددة (MMI)، و20% من درجة المقابلة التخصصية. وبناءً على ذلك، سيتم إبلاغهم بقرار القبول عبر البريد الإلكتروني، بعد عملية المطابقة النهائية (Cross Match)",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Cross Match",
                                      text_ar:
                                        "عملية المطابقة النهائية. (Cross Match)",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Cross Match is an important step in the selection process that involves comparing accepted candidates across health authorities and entities in the United Arab Emirates (UAE) that provide training programmes. When a candidate is shortlisted and ranked by two or more of these entities, they are contacted and given the opportunity to select their preferred entity for training. Once the candidate confirms their preference, the other authorities promptly remove the candidate’s name from their respective lists. This meticulous process is designed to guarantee that UAE graduates are afforded a fair opportunity to secure a training place at an early stage in the process.",
                                      text_ar:
                                        "تُعد عملية المطابقة النهائية (Cross Match) ، خطوة مهمة في اختيار المتدربين، حيث تتضمن مقارنة المرشحين المقبولين بين الجهات والهيئات الصحية في دولة الإمارات العربية المتحدة، التي تقدم برامج تدريبية. <br /> عندما يتم ترشيح المتقدم وتصنيفه، من قبل جهتين أو أكثر من هذه الجهات، يتم التواصل معه لإتاحة الفرصة له لاختيار الجهة المفضلة لديه للتدريب. وبمجرد أن يؤكد المتقدم اختياره، تقوم الجهات الأخرى على الفور بحذف اسمه من قوائمها. <br /> تم تصميم هذه العملية الدقيقة، لضمان منح خريجي دولة الإمارات فرصة عادلة للحصول على مقعد تدريبي في مرحلة مبكرة من إجراءات القبول.",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "heading",
                                      size: "h4",
                                      text: "Application Fee:",
                                      text_ar: "رسوم تقديم الطلب:",
                                      classname: "body text-primary",
                                    },
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "630 AED non-refundable application and processing fee.",
                                      text_ar:
                                        "630درهماً رسوم تقـــديم ومراجعة الطلب غير مستردة",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "To register for the residency training programme during the registration period, please click on the following link: ",
                                          text_ar:
                                            "للتسجيل في برنامج التدريب (الإقامة) خلال فترة التسجيل اضغط على الرابط التالي: ",
                                          classname:
                                            "body text-onSurfaceVarient inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "Click here to apply",
                                          text_ar: "اضغط هنا للتقديم",
                                          classname:
                                            "hover:underline text-primary underlined inline",
                                          href: "https://mawaheb.dha.gov.ae/admin/servicesByCategory/3",
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      ],
                                    },

                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "For further enquiries or in case of any technical issues, please contact us through the following channels:",
                                      text_ar:
                                        "لمزيد من الاستفسارات، أو في حال وجود أي مشكلات تقنية، يُرجى التواصل عبر القنوات التالية:",
                                      classname: "body text-onSurfaceVariant",
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Email: ",
                                          text_ar: "البريد الإلكتروني: ",
                                          classname:
                                            "body text-onSurfaceVariant inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: " info@dha.gov.ae",
                                          text_ar: " info@dha.gov.ae",
                                          classname: "text-primary inline",
                                          href: "mailto::info@dha.gov.ae",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "div",
                                      classname: "body text-onSurfaceVariant",
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Contact no: ",
                                          text_ar: "الهاتف: ",
                                          classname:
                                            "body text-onSurfaceVariant inline",
                                        },
                                        {
                                          _id: "block3",
                                          type: "linking",
                                          text: "800342",
                                          text_ar: "800342",
                                          classname: "text-primary inline",
                                          href: "tel:+971800342",
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block1",
                          type: "div",
                          classname: "",
                          children: [
                            {
                              _id: "block2",
                              type: "tabcontent",
                              isShow_title: false,
                              linker: "medical_control",
                              linker_ar: "medical_control",
                              title: "Fellowship programme",
                              title_ar: "برنامج الزمالة",
                              size: "h2",
                              classname: "dda-table-container",
                              children: [
                                {
                                  _id: "block1",
                                  type: "div",
                                  classname: "",
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "paragraph",
                                      size: "normal",
                                      text: "Fellowship programmes in the private healthcare sector of the Emirate of Dubai, under the supervision of the Dubai Health Authority, offer advanced training for physicians holding a specialty certificate (residency). The aim is to enhance their skills, deepen their expertise in highly specialised fields, and prepare them to assume leadership roles in healthcare. Fellows train under the guidance of distinguished experts and specialists, with extensive opportunities to engage in diverse clinical experiences that enrich their professional competencies. These programmes are designed to keep pace with the rapid developments in the healthcare sector and to prepare medical professionals capable of achieving excellence and success in their careers.",
                                      text_ar:
                                        "توفر برامج الزمالة في القطاع الصحي الخاص بإمارة دبي، بإشراف هيئة الصحة بدبي، تدريبًا متقدمًا موجّهًا للأطباء الحاصلين على شهادة الاختصاص (الإقامة)، بهدف تنمية مهاراتهم وتعميق خبراتهم في تخصصات دقيقة، وتأهيلهم لتولي أدوار قيادية في مجال الرعاية الصحية. ويتم تدريب أطباء الزمالة تحت إشراف نخبة من الخبراء والمختصين، مع إتاحة فرص واسعة لخوض تجارب سريرية متنوعة تثري كفاءاتهم المهنية. وقد تم تصميم هذه البرامج لمواكبة التطورات السريعة في القطاع الصحي، وإعداد كوادر طبية قادرة على تحقيق التميز والنجاح في مسيرتهم المهنية.",
                                      classname: "body mb-4",
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Programme Summery",
                                        header_text_ar: "نبذه عن البرامج",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "list-decimal list-inside space-y-3 text-onSurfaceVariant  *:mb-3 lg:!pe-4",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Reproductive Medicine",
                                              text_ar:
                                                "طب الإخصاب والمساعدة على الحمل",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Addiction medicine",
                                              text_ar: "علاج الإدمان",
                                              classname: "",
                                            },
                                          ],
                                        },
                                      ],
                                    },

                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Programme Timeline",
                                        header_text_ar: "الجدول الزمني",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block1",
                                          type: "div",
                                          classname: "dda-table-container",
                                          children: [
                                            {
                                              _id: "block1",
                                              type: "div",
                                              classname: "overflow-x-auto",
                                              children: [
                                                {
                                                  _id: "table1",
                                                  type: "table",
                                                  classname:
                                                    "dda-table w-full min-w-[650px]",
                                                  children: [
                                                    {
                                                      _id: "table_body",
                                                      type: "tableItems",
                                                      type_identifier: "tbody",
                                                      classname: "body",
                                                      children: [
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Registration Opens",
                                                                  text_ar:
                                                                    "فتح باب التسجيل",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "January",
                                                                  text_ar:
                                                                    "يناير",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Registration Closes",
                                                                  text_ar:
                                                                    "إغلاق باب التسجيل",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "March",
                                                                  text_ar:
                                                                    "مارس",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Speciality Interviews",
                                                                  text_ar:
                                                                    "المقابلات التخصصية",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "May",
                                                                  text_ar:
                                                                    "مايو",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Matching Process",
                                                                  text_ar:
                                                                    "إجراءات المطابقة",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "June",
                                                                  text_ar:
                                                                    "يونيو",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Announcement of Accepted Candidates",
                                                                  text_ar:
                                                                    "الإعلان عن أسماء المقبولين",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "August",
                                                                  text_ar:
                                                                    "أغسطس",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                        {
                                                          _id: "tableTR",
                                                          type: "tableItems",
                                                          type_identifier: "tr",
                                                          classname: "",
                                                          children: [
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname:
                                                                "border-r border-gray-300",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "Start of Academic Year",
                                                                  text_ar:
                                                                    "بداية العام الأكاديمي",
                                                                },
                                                              ],
                                                            },
                                                            {
                                                              _id: "tableTH",
                                                              type: "tableItems",
                                                              type_identifier:
                                                                "td",
                                                              classname: "",
                                                              children: [
                                                                {
                                                                  _id: "tableTH",
                                                                  type: "paragraph",
                                                                  size: "normal",
                                                                  classname: "",
                                                                  text: "October",
                                                                  text_ar:
                                                                    "أكتوبر",
                                                                },
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Acceptance Criteria",
                                        header_text_ar: "معايير القبول",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h3",
                                          text: "Academic Criteria",
                                          text_ar: "المعايير الأكاديمية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Candidates must be board-certified at Tier One or Tier Two level to be considered for the Fellowship programme.",
                                              text_ar:
                                                "يجب أن يكون المرشح حاصلاً على شهادة البورد من المستوى الأول أو المستوى الثاني ليتم النظر في قبوله ببرنامج الزمالة.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Candidates must be board-certified in their main specialty by the beginning of the programme academic year.",
                                              text_ar:
                                                "يشترط الحصول على شهادة البورد في التخصص الرئيسي قبل بداية السنة الأكاديمية للبرنامج.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Typically, candidates should not have been out of clinical practice for more than 24 months at any point (excluding national service for UAE nationals or interruptions due to COVID-19).",
                                              text_ar:
                                                "يجب ألا يكون المرشح قد انقطع عن الممارسة السريرية لأكثر من 24 شهرًا في أي وقت (باستثناء الخدمة الوطنية لمواطني دولة الإمارات)، أو الانقطاع بسبب جائحة كوفيد-19).",
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Note: ",
                                          text_ar: "ملاحظة: ",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Admitted candidates must have passed the clinical board examination (OSCE) of their main specialty in order to enrol in the fellowship programme.",
                                              text_ar:
                                                "يجب على المرشحين المقبولين اجتياز امتحان البورد السريري (OSCE) للتخصص الرئيسي، من أجل الالتحاق ببرنامج الزمالة.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Candidates will join the programme as full-time trainees. Concurrent enrolment in more than one postgraduate programme is not permitted.",
                                              text_ar:
                                                "سينضم المرشحون إلى البرنامج كمتدربين بدوام كامل، ولن يُسمح بالجمع بين أكثر من برنامج دراسات عليا في آن واحد.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Enrollment in the programme is subject to successful completion of the Dubai Health Authority (DHA) licensing process.",
                                              text_ar:
                                                "يشترط الالتحاق بالبرنامج استكمال إجراءات الترخيص بنجاح من هيئة الصحة بدبي (DHA).",
                                              classname: "",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "English Criteria",
                                        header_text_ar: "معايير اللغة",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "For candidates who completed their residency in non-English-speaking health systems, one of the following English proficiency exams or their equivalent is required: ",
                                          text_ar:
                                            "للمرشحين الذين أتمّوا برنامج الإقامة في أنظمة صحية لا تعتمد اللغة الإنجليزية، يشترط تقديم أحد اختبارات الكفاءة في اللغة الإنجليزية التالية أو ما يعادلها: ",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "IELTS Academic",
                                          text_ar: "IELTS Academic",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Overall score of 6",
                                              text_ar: "معدل عام لا يقل عن 6.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "A single certificate must be submitted; combined scores are not accepted",
                                              text_ar:
                                                "يجب تقديم شهادة واحدة فقط؛ ولن تُقبل الدرجات المجمّعة.",
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "TOEFL iBT",
                                          text_ar: "TOEFL iBT",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Minimum score of 80",
                                              text_ar: "حد أدنى 80 درجة.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "PBT is not accepted",
                                              text_ar:
                                                "لن يتم قبول اختبار الـ PBT.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `‘My Best Scores’ will not be considered for admission purposes`,
                                              text_ar: `لن تؤخذ نتائج "My Best Scores" في الاعتبار لأغراض القبول.`,
                                              classname: "",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Required Documents",
                                        header_text_ar: "المستندات المطلوبة",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Identification Documents",
                                          text_ar: "المستندات الشخصية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Recent coloured photo (high-resolution format)",
                                              text_ar:
                                                "صورة شخصية ملونة حديثة (بجودة عالية).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Valid passport copy (for UAE nationals, please include the Ethbara page as well)",
                                              text_ar:
                                                "نسخة من جواز السفر ساري المفعول (للمواطنين الإماراتيين تُرفق أيضًا صفحة الإثبات).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Emirates ID card (if applicable)",
                                              text_ar:
                                                "بطاقة الهوية الإماراتية (إن وجدت).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Family Book (UAE nationals only) / Mother’s Family Book (for children of UAE national mothers)",
                                              text_ar:
                                                "خلاصة القيد (للمواطنين الإماراتيين فقط) / خلاصة قيد الأم (لأبناء المواطنات).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Valid Marsoom letter (for Marsoom holders only)",
                                              text_ar:
                                                "رسالة مرسوم سارية (لحاملي المرسوم فقط).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Residency permit (if applicable)",
                                              text_ar:
                                                "تصريح الإقامة (إن وجد).",
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Academic Documents",
                                          text_ar: "المستندات الأكاديمية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Copy of Board Certificate if available, or a Certificate of Completion of an accredited residency programme",
                                              text_ar:
                                                "نسخة من شهادة البورد (إن وجدت) أو شهادة إتمام برنامج الإقامة المعتمد.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Transcript from the training centre or Programme Director (if available)",
                                              text_ar:
                                                "كشف درجات من مركز التدريب، أو من مدير البرنامج (إن وجد).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Results of English Proficiency Test (attained within the last 2 years), if applicable`,
                                              text_ar: `نتيجة اختبار الكفاءة في اللغة الإنجليزية (تم الحصول عليها خلال آخر سنتين) – إن وجدت.`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Two recommendation letters (each dated within the last year)`,
                                              text_ar: `2 خطاب توصية يجب أن يكون مؤرخًا خلال أقل من سنة).`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Copy of curriculum vitae`,
                                              text_ar: `نسخة من السيرة الذاتية.`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Valid professional licence`,
                                              text_ar: `ترخيص مهني ساري المفعول.`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Employment letter (if applicable)`,
                                              text_ar: `خطاب عمل (إن وجد).`,
                                              classname: "",
                                            },

                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `No Objection Letter from employer to join the training programme as full-time (if applicable).`,
                                              text_ar: `خطاب عدم ممانعة من جهة العمل للالتحاق بالبرنامج التدريبي بدوام كامل (إن وجد).`,
                                              classname: "",
                                            },

                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Undergraduate Degree Certificate. A notarised English translation of documents originally in a language other than Arabic or English is required.`,
                                              text_ar: `شهادة البكالوريوس. (يشترط تقديم ترجمة موثقة باللغة الإنجليزية إذا كانت الوثائق الأصلية بلغة غير العربية أو الإنجليزية).`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Undergraduate Academic Transcript. A notarised English translation of documents originally in a language other than Arabic or English is required.`,
                                              text_ar: `كشف الدرجات لمرحلة البكالوريوس. (يشترط تقديم ترجمة موثقة باللغة الإنجليزية إذا كانت الوثائق الأصلية بلغة غير العربية أو الإنجليزية).`,
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: `Internship Certificate`,
                                              text_ar: `شهادة الامتياز.`,
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Note: ",
                                          text_ar: "ملاحظة: ",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Candidates must be board-certified at Tier One or Tier Two level to be considered for the Fellowship programme.",
                                          text_ar:
                                            "يجب أن يكون المرشح حاصلاً على شهادة البورد من المستوى الأول أو المستوى الثاني، ليتم النظر في قبوله في برنامج الزمالة.",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                      ],
                                    },
                                    {
                                      _id: "block3",
                                      type: "dda-accordion",
                                      props: {
                                        design: "bg-border",
                                        accordion_icon_class:
                                          "material-icons  material-symbols-outlined",
                                        accordion_icon_text: "",
                                        accordion_icon_text_ar: "",
                                        header_text: "Selection Process",
                                        header_text_ar: "إجرءات القبول",
                                        sub_title: "",
                                        sub_title_ar: "",
                                        link_button_text: "",
                                        link_button_text_ar: "",
                                        custom_class: "my-4",
                                        component_mode: "",
                                      },
                                      children: [
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "An application will be considered complete once all required documents are successfully submitted through the online portal and the application fee is paid. The selection process will include the following three phases: ",
                                          text_ar:
                                            "سيُعتبر الطلب مكتملاً عند تقديم جميع المستندات المطلوبة بنجاح عبر البوابة الإلكترونية، وسداد رسوم التقديم. وتشمل عملية الاختيار المراحل الثلاث التالية: ",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Phase 1: Shortlisting",
                                          text_ar:
                                            "المرحلة الأولى: التصفية الأولية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "All completed applications will be reviewed and scored according to the following criteria: ",
                                          text_ar:
                                            "سيتم مراجعة جميع الطلبات المكتملة وتقييمها وفقًا لما يلي: ",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "list",
                                          type_identifier: "ul",
                                          classname:
                                            "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Years since medical school completion (including internship)",
                                              text_ar:
                                                "عدد السنوات منذ التخرج من كلية الطب (بما في ذلك سنة الامتياز).",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Letters of recommendation",
                                              text_ar: "خطابات التوصية.",
                                              classname: "",
                                            },
                                            {
                                              _id: "block3",
                                              type: "list",
                                              type_identifier: "li",
                                              text: "Curriculum vitae (CV)",
                                              text_ar: "السيرة الذاتية.",
                                              classname: "",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Phase 2: Specialty Interview",
                                          text_ar:
                                            "المرحلة الثانية: المقابلة التخصصية",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Qualified shortlisted candidates will be invited via email for on-site specialty interviews. Unsuccessful candidates will be notified at that time with a regret letter.",
                                          text_ar:
                                            "سيتم دعوة المرشحين المؤهلين ضمن قائمة التصفية النهائية، عبر البريد الإلكتروني لإجراء المقابلات التخصصية في بينما سيتم إخطار المرشحين غير المقبولين في ذلك الوقت برسالة اعتذار.",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Phase 3: Ranking & Offering",
                                          text_ar:
                                            "المرحلة الثالثة: التصنيف وتقديم العروض",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "Candidates who complete the specialty interviews will be ranked based on the interview outcome. <br /> Accordingly, they will be informed via email of their admission decision after the Cross Match.",
                                          text_ar:
                                            "سيتم تصنيف المتقدمين الذين أنهوا المقابلة التخصصية، بناءً على نتائج هذه المقابلة. وبناءً على ذلك، سيتم إبلاغهم بقرار القبول عبر البريد الإلكتروني بعد عملية المطابقة النهائية (Cross Match).",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "heading",
                                          size: "h4",
                                          text: "Application Fee: ",
                                          text_ar: "رسوم تقديم الطلب: ",
                                          classname: "body text-primary",
                                        },
                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "AED 630 – non-refundable application and review fee.",
                                          text_ar:
                                            "630درهماً رسوم تقـــديم ومراجعة الطلب غير مستردة.",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "div",
                                          classname:
                                            "body text-onSurfaceVariant",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: "To register for the residency training programme during the registration period, please click on the following link: ",
                                              text_ar:
                                                "للتسجيل في برنامج التدريب (الإقامة)، خلال فترة التسجيل اضغط على الرابط التالي: ",
                                              classname:
                                                "body text-onSurfaceVariant inline",
                                            },
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "Click here to apply",
                                              text_ar: "اضغط هنا للتقديم",
                                              classname:
                                                "hover:underline text-primary underlined inline",
                                              href: "https://mawaheb.dha.gov.ae/admin/servicesByCategory/3",
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                          ],
                                        },

                                        {
                                          _id: "block3",
                                          type: "paragraph",
                                          size: "normal",
                                          text: "For further enquiries or in case of any technical issues, please contact us through the following channels:",
                                          text_ar:
                                            "لمزيد من الاستفسارات، أو في حال وجود أي مشكلات تقنية، يُرجى التواصل عبر القنوات التالية:",
                                          classname:
                                            "body text-onSurfaceVariant",
                                        },
                                        {
                                          _id: "block3",
                                          type: "div",
                                          classname:
                                            "body text-onSurfaceVariant",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: "Email: ",
                                              text_ar: "البريد الإلكتروني: ",
                                              classname:
                                                "body text-onSurfaceVariant inline",
                                            },
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: " info@dha.gov.ae",
                                              text_ar: " info@dha.gov.ae",
                                              classname: "text-primary inline",
                                              href: "mailto::info@dha.gov.ae",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "block3",
                                          type: "div",
                                          classname:
                                            "body text-onSurfaceVariant",
                                          children: [
                                            {
                                              _id: "block3",
                                              type: "paragraph",
                                              size: "normal",
                                              text: "Contact no: ",
                                              text_ar: "الهاتف: ",
                                              classname:
                                                "body text-onSurfaceVariant inline",
                                            },
                                            {
                                              _id: "block3",
                                              type: "linking",
                                              text: "800342",
                                              text_ar: "800342",
                                              classname: "text-primary inline",
                                              href: "tel:+971800342",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              _id: "block2",
              type: "tabcontent",
              title: "Sponsorship Programme Medicine & Science",
              title_ar: "برنامج الرعاية الدراسية (طب وعلوم)",
              isShow_title: false,
              size: "h2",
              classname: "dda-table-container",
              children: [
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: "The Dubai Health Authority offers a scholarship programme dedicated to Emirati students, including high school graduates and university students, with the aim of supporting their studies in health-related disciplines within the United Arab Emirates.",
                  text_ar:
                    "تُقدِّم هيئة الصحة بدبي برنامجًا للمنح الدراسية، مخصصًا للطلبة المواطنين من خريجي الثانوية العامة وطلبة الجامعات، بهدف دعم دراستهم في التخصصات الصحية داخل دولة الإمارات العربية المتحدة.",
                  classname: "md:!my-4 my-2 Medium text-onSurfaceVariant",
                },
                {
                  _id: "block3",
                  type: "paragraph",
                  size: "normal",
                  text: "The programme aims to empower and qualify national cadres in vital health fields, in alignment with the needs of the healthcare sector in the Emirate.",
                  text_ar:
                    "يهدف البرنامج إلى تمكين الكوادر الوطنية، وتأهيلها في المجالات الصحية الحيوية، بما يواكب احتياجات القطاع الصحي في الإمارة.",
                  classname: "md:!my-4 my-2 Medium text-onSurfaceVariant",
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",
                    header_text: "Timeline: ",
                    header_text_ar: "الجدول الزمني: ",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block1",
                      type: "div",
                      classname: "dda-table-container",
                      children: [
                        {
                          _id: "block1",
                          type: "div",
                          classname: "overflow-x-auto",
                          children: [
                            {
                              _id: "table1",
                              type: "table",
                              classname: "dda-table w-full min-w-[650px]",
                              children: [
                                {
                                  _id: "table_body",
                                  type: "tableItems",
                                  type_identifier: "tbody",
                                  classname: "body",
                                  children: [
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Registration Opens",
                                              text_ar: "فتح باب التسجيل",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "1st May",
                                              text_ar: "1 مايو",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Registration Closes",
                                              text_ar: "إغلاق باب التسجيل",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "31st May",
                                              text_ar: "31 مايو",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Personal Interviews",
                                              text_ar: "المقابلات الشخصية",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "July",
                                              text_ar: "يوليو",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Announcement of Accepted Candidates and Contract Signing",
                                              text_ar:
                                                "الإعلان عن أسماء المقبولين وتوقيع العقود",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "August",
                                              text_ar: "أغسطس",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      _id: "tableTR",
                                      type: "tableItems",
                                      type_identifier: "tr",
                                      classname: "",
                                      children: [
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "border-r border-gray-300",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "Start of Academic Year",
                                              text_ar: "بداية العام الأكاديمي",
                                            },
                                          ],
                                        },
                                        {
                                          _id: "tableTH",
                                          type: "tableItems",
                                          type_identifier: "td",
                                          classname: "",
                                          children: [
                                            {
                                              _id: "tableTH",
                                              type: "paragraph",
                                              size: "normal",
                                              classname: "",
                                              text: "August – September",
                                              text_ar: "أغسطس-سبتمبر",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",
                    header_text: "The Approved Health Specialisations: ",
                    header_text_ar: "التخصصات الصحية المعتمدة: ",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Medicine and Surgery",
                          text_ar: "الطب والجراحة",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Para Medical, which includes: Laboratories, Radiology, Pharmacy, Physiotherapy, Nutrition, Public Health, Psychology, Biomedical Engineering",
                          text_ar:
                            "الطب المساند: المختبرات، والأشعة، والصيدلة، والعلاج الطبيعي، والتغذية، والصحة العامة، وعلم النفس، والهندسة الطبية الحيوية.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Technical Specialties, including but not limited to: Optometry, Speech & Hearing, Anaesthesia Technologist, Respiratory Therapist, Ultrasound Technician (Ultrasonographic)",
                          text_ar:
                            "التخصصات الفنية على سبيل المثال لا الحصر: تصحيح البصر، والنطق والسمع، وتقني تخدير، وتقني المعالجة التنفسية، وتقني تخطيط الصدى.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Nursing and Midwifery",
                          text_ar: "التمـريض والقبالة",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",

                    header_text: "Eligibility Criteria",
                    header_text_ar: "شروط التقديم",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "The applicant must be a UAE national (holding a valid Khulasat Al-Qaid).",
                          text_ar:
                            "أن يكون المتقدم من مواطني دولة الإمارات العربية المتحدة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "The applicant must be a high school graduate and meet the required percentage for the specialisation, applicable to high school graduates: ",
                          text_ar:
                            "إذا كان المتقدم طالباً خريج الثانوية العامة بالنسبة المئوية المطلوبة للتخصص، لخريجي الثانوية العامة",
                          classname: "",
                          children: [
                            {
                              _id: "block3",
                              type: "div",
                              classname: "mx-3",
                              children: [
                                {
                                  _id: "block3",
                                  type: "list",
                                  type_identifier: "ul",
                                  classname:
                                    "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                                  children: [
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "li",
                                      text: "Medicine and Surgery: 90%",
                                      text_ar: "الطب والجراحة 90%.",
                                      classname: "",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "li",
                                      text: "Para Medical: 80%",
                                      text_ar: "الطب المساند80 %.",
                                      classname: "",
                                    },
                                    {
                                      _id: "block3",
                                      type: "list",
                                      type_identifier: "li",
                                      text: "Nursing and Midwifery: 80%",
                                      text_ar: "التمـريض والقبالة 80%.",
                                      classname: "",
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "If the applicant is a university student, they must have a cumulative GPA of no less than 2.5.",
                          text_ar:
                            "إذا كان المتقدم طالباً جامعياً يجب أن يكون حاصلاً على معدل تراكمي لا يقل عن GPA 2.5  ",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "High school certificates must be no older than 2 years for females and 3 years for males (for students who have paused their studies)",
                          text_ar:
                            "أن لا يكون قد مضى على شهادة الثانوية العامة، مدة سنتين للإناث وثلاث سنوات للذكور (للطلاب المتوقفين عن الدراسة).",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "The applicant must have received academic admission from a recognised institution in the UAE.",
                          text_ar:
                            "الحصول على القبول الأكاديمي من الجهة الأكاديمية (جامعة، كلية)، معتمدة من التعليم العالي في دولة الإمارات العربية المتحدة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "The applicant must be medically fit.",
                          text_ar: "أن يكون المتقدم لائقاً صحياً.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Males must have completed National Service or provide a valid certificate of postponement or exemption.",
                          text_ar:
                            "أن يكون المتقدم قد انتهى من متطلبات الخدمة الوطنية، أو إبراز شهادة سارية المفعول تفيد بتأجيل الدورة أو الإعفاء منها (للذكور فقط).",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",

                    header_text: "Required Documents:",
                    header_text_ar: "المستندات المطلوبة",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h4",
                      text: "Identification Documents",
                      text_ar: "المستندات الشخصية",
                      classname: "body text-primary",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Recent personal photo.",
                          text_ar: "صورة شخصية حديثة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Copy of a valid Emirates ID card (both sides).",
                          text_ar:
                            "صورة عن بطاقة الهوية الإماراتية من الجهتين سارية المفعول.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Copy of the birth certificate.",
                          text_ar: "صورة شهادة الميلاد.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Copy of a valid passport, including the unified number page.",
                          text_ar:
                            "صورة عن جواز السفر ساري المفعول، مع صورة من صفحة الرقم الموحد.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Copy of the full family book.",
                          text_ar: "صورة عن خلاصة القيد كاملة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Recent Police Clearance Certificate.",
                          text_ar:
                            "شهادة حسن السيرة والسلوك، صادرة من الشرطة (حديثة).",
                          classname: "",
                        },
                      ],
                    },
                  ],
                },
                {
                  _id: "block3",
                  type: "dda-accordion",
                  props: {
                    design: "bg-border",
                    accordion_icon_class:
                      "material-icons  material-symbols-outlined",
                    accordion_icon_text: "",
                    accordion_icon_text_ar: "",

                    header_text: "Academic Documents",
                    header_text_ar: "المسندات الأكاديمية",
                    sub_title: "",
                    sub_title_ar: "",
                    link_button_text: "",
                    link_button_text_ar: "",
                    custom_class: "my-4",
                    component_mode: "",
                  },
                  children: [
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-decimal list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "High School Certificate, if issued within the country, certified by the Ministry of Education or by the Knowledge and Human Development Authority (KHDA).",
                          text_ar:
                            "شهادة الثانوية العامة إذا كانت صادرة في الدولة، ومصدقة من وزارة التربية والتعليم، أو مصدقة من هيئة المعرفة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Letter of preliminary or final university acceptance issued by the university.",
                          text_ar:
                            "رسالة بالقبول المبدئي/ النهائي الجامعي، صادر من الجامعة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Certified copy of the university cumulative average (transcript), if the applicant is affiliated with an academic institution.",
                          text_ar:
                            "صورة مصدقة من المعدل التراكمي الجامعي (Transcript) ، إذا كان المتقدم منتسباً لإحدى المؤسسات الأكاديمية.",
                          classname: "",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "paragraph",
                      size: "normal",
                      text: "Benefits: ",
                      text_ar: "المميزات",
                      classname: "body",
                    },
                    {
                      _id: "block3",
                      type: "list",
                      type_identifier: "ul",
                      classname:
                        "text-onSurfaceVariant list-disc list-inside space-y-3 body",
                      children: [
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Full coverage of tuition fees.",
                          text_ar: "تغطية كامل الرسوم الدراسة.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "Monthly allowance.",
                          text_ar: "مكافأة شهرية.",
                          classname: "",
                        },
                        {
                          _id: "block3",
                          type: "list",
                          type_identifier: "li",
                          text: "One-time allowance for a computer during the sponsorship period.",
                          text_ar: "بدل حاسب آلي لمرة واحدة خلال مدة الرعاية.",
                          classname: "",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "div",
                      classname: "body text-onSurfaceVariant",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "To register for the sponsorship programme in Medicine and Sciences during the registration period, please click the following link: ",
                          text_ar:
                            "للتسجيل في برنامج طب وعلوم خلال فترة التسجيل اضغط على الرابط التالي: ",
                          classname: "body text-onSurfaceVarient inline",
                        },
                        {
                          _id: "block3",
                          type: "linking",
                          text: "Click here to apply",
                          text_ar: "اضغط هنا للتقديم",
                          classname:
                            "hover:underline text-primary underlined inline",
                          href: "https://mawaheb.dha.gov.ae/admin/servicesByCategory/3",
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "heading",
                      size: "h4",
                      text: "For further enquiries or in case of any technical issues, please contact us through the following channels: ",
                      text_ar:
                        "لمزيد من الاستفسارات، أو في حال وجود أي مشكلات تقنية، يُرجى التواصل عبر القنوات التالية: ",
                      classname: "body text-primary",
                    },
                    {
                      _id: "block3",
                      type: "div",
                      classname: "body text-onSurfaceVariant",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Email: ",
                          text_ar: "البريد الإلكتروني: ",
                          classname: "body text-onSurfaceVariant inline",
                        },
                        {
                          _id: "block3",
                          type: "linking",
                          text: " info@dha.gov.ae",
                          text_ar: " info@dha.gov.ae",
                          classname: "text-primary inline",
                          href: "mailto::info@dha.gov.ae",
                        },
                      ],
                    },
                    {
                      _id: "block3",
                      type: "div",
                      classname: "body text-onSurfaceVariant",
                      children: [
                        {
                          _id: "block3",
                          type: "paragraph",
                          size: "normal",
                          text: "Contact no: ",
                          text_ar: "الهاتف: ",
                          classname: "body text-onSurfaceVariant inline",
                        },
                        {
                          _id: "block3",
                          type: "linking",
                          text: "800342",
                          text_ar: "800342",
                          classname: "text-primary inline",
                          href: "tel:+971800342",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],

  breadcrumbs: [
    { text: "Home", icon: "home", url: "/" },
    {
      text: "Medical Education",
      icon: "home",
      url: "/medicalEducationAndResearch/medicalEducation",
    },
    {
      text: "medical_education", //linker text to identify which linker to use
      useLinker: true,
      icon: "menu_book",
      url: "/medicalEducationAndResearch/medicalEducation",
    },
  ],
};
